
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c49"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c49"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hcepo", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $c84ebbe33d4a7e6c$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureMessage", function () { return $c84ebbe33d4a7e6c$export$45654777c133ae80; });
$parcel$export(module.exports, "captureEvent", function () { return $c84ebbe33d4a7e6c$export$1462b974fdcf6ba2; });
$parcel$export(module.exports, "configureScope", function () { return $c84ebbe33d4a7e6c$export$99d44f04437e9cb8; });
$parcel$export(module.exports, "addBreadcrumb", function () { return $c84ebbe33d4a7e6c$export$efda9a273d7a036d; });
$parcel$export(module.exports, "setContext", function () { return $c84ebbe33d4a7e6c$export$2f04de43fe27971a; });
$parcel$export(module.exports, "setExtras", function () { return $c84ebbe33d4a7e6c$export$bb4922da0dd51b92; });
$parcel$export(module.exports, "setExtra", function () { return $c84ebbe33d4a7e6c$export$8e8e7789d42ed61d; });
$parcel$export(module.exports, "setTags", function () { return $c84ebbe33d4a7e6c$export$74a8fb34822092e6; });
$parcel$export(module.exports, "setTag", function () { return $c84ebbe33d4a7e6c$export$a37d07ee78eb4569; });
$parcel$export(module.exports, "setUser", function () { return $c84ebbe33d4a7e6c$export$8b6bb3dd62a01be2; });
$parcel$export(module.exports, "withScope", function () { return $c84ebbe33d4a7e6c$export$ec58d9285c204497; });
$parcel$export(module.exports, "withIsolationScope", function () { return $c84ebbe33d4a7e6c$export$9a4fed82c350c2bd; });
$parcel$export(module.exports, "withActiveSpan", function () { return $c84ebbe33d4a7e6c$export$e57ac09b143d92a2; });
$parcel$export(module.exports, "startTransaction", function () { return $c84ebbe33d4a7e6c$export$e262da7ae6480481; });
$parcel$export(module.exports, "getCurrentScope", function () { return $c84ebbe33d4a7e6c$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "getClient", function () { return $c84ebbe33d4a7e6c$export$6bb76d6eba7e258c; });
$parcel$export(module.exports, "flush", function () { return $c84ebbe33d4a7e6c$export$4909b86c8034bf73; });
$parcel$export(module.exports, "close", function () { return $c84ebbe33d4a7e6c$export$8360e631d277ea4d; });
$parcel$export(module.exports, "lastEventId", function () { return $c84ebbe33d4a7e6c$export$5d4e9fd7fac8e617; });
$parcel$export(module.exports, "isInitialized", function () { return $c84ebbe33d4a7e6c$export$3f95c6f800b78024; });
$parcel$export(module.exports, "startSession", function () { return $c84ebbe33d4a7e6c$export$c0d84948cecf78d8; });
$parcel$export(module.exports, "endSession", function () { return $c84ebbe33d4a7e6c$export$17a5be43989a0bc1; });
$parcel$export(module.exports, "captureSession", function () { return $c84ebbe33d4a7e6c$export$667e7b4d445d566b; });

var $lNVQ9 = parcelRequire("lNVQ9");
var $jPeZ4 = parcelRequire("jPeZ4");
var $7p8hL = parcelRequire("7p8hL");
var $iGf0k = parcelRequire("iGf0k");
var $iJH3x = parcelRequire("iJH3x");

var $kNF8J = parcelRequire("kNF8J");

var $fB2fA = parcelRequire("fB2fA");

var $fxUGN = parcelRequire("fxUGN");

var $e4zhx = parcelRequire("e4zhx");

var $5XnTz = parcelRequire("5XnTz");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $c84ebbe33d4a7e6c$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $fxUGN.getCurrentHub)().captureException(exception, (0, $5XnTz.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $c84ebbe33d4a7e6c$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $fxUGN.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $c84ebbe33d4a7e6c$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $fxUGN.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $c84ebbe33d4a7e6c$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $fxUGN.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $c84ebbe33d4a7e6c$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $fxUGN.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $c84ebbe33d4a7e6c$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $fxUGN.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $c84ebbe33d4a7e6c$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $fxUGN.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $c84ebbe33d4a7e6c$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $fxUGN.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $c84ebbe33d4a7e6c$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $fxUGN.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $c84ebbe33d4a7e6c$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $fxUGN.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $c84ebbe33d4a7e6c$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $fxUGN.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $c84ebbe33d4a7e6c$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $fxUGN.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $c84ebbe33d4a7e6c$export$9a4fed82c350c2bd(callback) {
    return (0, $fxUGN.runWithAsyncContext)(()=>{
        return callback((0, $fxUGN.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $c84ebbe33d4a7e6c$export$e57ac09b143d92a2(span, callback) {
    return $c84ebbe33d4a7e6c$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $c84ebbe33d4a7e6c$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $fxUGN.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $c84ebbe33d4a7e6c$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $c84ebbe33d4a7e6c$export$c7be4b0125a10cba();
    const client = $c84ebbe33d4a7e6c$export$6bb76d6eba7e258c();
    if (!client) (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $iJH3x.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $c84ebbe33d4a7e6c$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $c84ebbe33d4a7e6c$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $iGf0k.timestampInSeconds)();
    function finishCheckIn(status) {
        $c84ebbe33d4a7e6c$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $iGf0k.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn('error');
        throw e;
    }
    if ((0, $jPeZ4.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn('ok');
    }, ()=>{
        finishCheckIn('error');
    });
    else finishCheckIn('ok');
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $c84ebbe33d4a7e6c$export$4909b86c8034bf73(timeout) {
    const client = $c84ebbe33d4a7e6c$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $c84ebbe33d4a7e6c$export$8360e631d277ea4d(timeout) {
    const client = $c84ebbe33d4a7e6c$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $c84ebbe33d4a7e6c$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $fxUGN.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $c84ebbe33d4a7e6c$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $fxUGN.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $c84ebbe33d4a7e6c$export$3f95c6f800b78024() {
    return !!$c84ebbe33d4a7e6c$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $c84ebbe33d4a7e6c$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $fxUGN.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $c84ebbe33d4a7e6c$export$c0d84948cecf78d8(context) {
    const client = $c84ebbe33d4a7e6c$export$6bb76d6eba7e258c();
    const isolationScope = (0, $fxUGN.getIsolationScope)();
    const currentScope = $c84ebbe33d4a7e6c$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $kNF8J.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $lNVQ9.GLOBAL_OBJ).navigator || {};
    const session = (0, $e4zhx.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $e4zhx.updateSession)(currentSession, {
        status: 'exited'
    });
    $c84ebbe33d4a7e6c$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $c84ebbe33d4a7e6c$export$17a5be43989a0bc1() {
    const isolationScope = (0, $fxUGN.getIsolationScope)();
    const currentScope = $c84ebbe33d4a7e6c$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $e4zhx.closeSession)(session);
    $c84ebbe33d4a7e6c$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $c84ebbe33d4a7e6c$var$_sendSessionUpdate() {
    const isolationScope = (0, $fxUGN.getIsolationScope)();
    const currentScope = $c84ebbe33d4a7e6c$export$c7be4b0125a10cba();
    const client = $c84ebbe33d4a7e6c$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $c84ebbe33d4a7e6c$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $c84ebbe33d4a7e6c$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $c84ebbe33d4a7e6c$var$_sendSessionUpdate();
}

});
parcelRegister("lNVQ9", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $fdfb0a727947e40b$export$f1a6cdb1459e81d1; });
$parcel$export(module.exports, "getGlobalObject", function () { return $fdfb0a727947e40b$export$256479dc0cea61c4; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $fdfb0a727947e40b$export$7e223ec222791509; });
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $fdfb0a727947e40b$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $fdfb0a727947e40b$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $fdfb0a727947e40b$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $fdfb0a727947e40b$var$isGlobalObj(window) || typeof self == 'object' && $fdfb0a727947e40b$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $fdfb0a727947e40b$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $fdfb0a727947e40b$export$256479dc0cea61c4() {
    return $fdfb0a727947e40b$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $fdfb0a727947e40b$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $fdfb0a727947e40b$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});

parcelRegister("jPeZ4", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $e6ee673aafa8fdf7$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $e6ee673aafa8fdf7$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $e6ee673aafa8fdf7$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $e6ee673aafa8fdf7$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $e6ee673aafa8fdf7$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $e6ee673aafa8fdf7$export$844ec244b1367d54; });
$parcel$export(module.exports, "isParameterizedString", function () { return $e6ee673aafa8fdf7$export$dbcbffa59149b824; });
$parcel$export(module.exports, "isPrimitive", function () { return $e6ee673aafa8fdf7$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $e6ee673aafa8fdf7$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $e6ee673aafa8fdf7$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $e6ee673aafa8fdf7$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $e6ee673aafa8fdf7$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $e6ee673aafa8fdf7$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $e6ee673aafa8fdf7$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isNaN", function () { return $e6ee673aafa8fdf7$export$c9f5652083b8129d; });
$parcel$export(module.exports, "isVueViewModel", function () { return $e6ee673aafa8fdf7$export$7916fad0ebc23f48; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $e6ee673aafa8fdf7$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$e6127cc7fe7395c3(wat) {
    switch($e6ee673aafa8fdf7$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $e6ee673aafa8fdf7$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$var$isBuiltin(wat, className) {
    return $e6ee673aafa8fdf7$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$9f9636d330b71954(wat) {
    return $e6ee673aafa8fdf7$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$ef9e2056653f0c8e(wat) {
    return $e6ee673aafa8fdf7$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$12e869b2a583f783(wat) {
    return $e6ee673aafa8fdf7$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$844ec244b1367d54(wat) {
    return $e6ee673aafa8fdf7$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$c3825b437cbdea5c(wat) {
    return wat === null || $e6ee673aafa8fdf7$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$53b83ca8eaab0383(wat) {
    return $e6ee673aafa8fdf7$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $e6ee673aafa8fdf7$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $e6ee673aafa8fdf7$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$49841c62b9eff15(wat) {
    return $e6ee673aafa8fdf7$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $e6ee673aafa8fdf7$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$bc2894c7158efbac(wat) {
    return $e6ee673aafa8fdf7$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e6ee673aafa8fdf7$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("7p8hL", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return $56414b82335a4971$export$2a2b1d2252a69ecb; });
$parcel$export(module.exports, "originalConsoleMethods", function () { return $56414b82335a4971$export$77c4ce905194557b; });
$parcel$export(module.exports, "consoleSandbox", function () { return $56414b82335a4971$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $56414b82335a4971$export$af88d00dbe7f521; });

var $aY8mH = parcelRequire("aY8mH");

var $lNVQ9 = parcelRequire("lNVQ9");
/** Prefix for logging strings */ const $56414b82335a4971$var$PREFIX = 'Sentry Logger ';
const $56414b82335a4971$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $56414b82335a4971$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $56414b82335a4971$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $lNVQ9.GLOBAL_OBJ))) return callback();
    const console = (0, $lNVQ9.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($56414b82335a4971$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $56414b82335a4971$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $56414b82335a4971$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $aY8mH.DEBUG_BUILD) $56414b82335a4971$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $56414b82335a4971$export$cda52e2a8927a2ca(()=>{
                (0, $lNVQ9.GLOBAL_OBJ).console[name](`${$56414b82335a4971$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $56414b82335a4971$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $56414b82335a4971$export$af88d00dbe7f521 = $56414b82335a4971$var$makeLogger();

});
parcelRegister("aY8mH", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $7fc5ff1878f804ef$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $7fc5ff1878f804ef$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});


parcelRegister("iGf0k", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return $d997c9cd0e0ba837$export$7740643b9eeaf0c4; });
$parcel$export(module.exports, "timestampInSeconds", function () { return $d997c9cd0e0ba837$export$ee52dced521e3e18; });
$parcel$export(module.exports, "browserPerformanceTimeOrigin", function () { return $d997c9cd0e0ba837$export$baf075a948ffc0bf; });

var $lNVQ9 = parcelRequire("lNVQ9");
const $d997c9cd0e0ba837$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $d997c9cd0e0ba837$export$7740643b9eeaf0c4() {
    return Date.now() / $d997c9cd0e0ba837$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $d997c9cd0e0ba837$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $lNVQ9.GLOBAL_OBJ);
    if (!performance || !performance.now) return $d997c9cd0e0ba837$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $d997c9cd0e0ba837$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $d997c9cd0e0ba837$export$ee52dced521e3e18 = $d997c9cd0e0ba837$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $d997c9cd0e0ba837$export$c5907b5a8838db13 = $d997c9cd0e0ba837$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $d997c9cd0e0ba837$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $d997c9cd0e0ba837$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $lNVQ9.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $d997c9cd0e0ba837$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $d997c9cd0e0ba837$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            $d997c9cd0e0ba837$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $d997c9cd0e0ba837$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();

});

parcelRegister("iJH3x", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $da3dd405dd9de941$export$19f53698e68b2496; });
$parcel$export(module.exports, "getEventDescription", function () { return $da3dd405dd9de941$export$4157119e2b157127; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return $da3dd405dd9de941$export$f26508487bf83ee7; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $da3dd405dd9de941$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "addContextToFrame", function () { return $da3dd405dd9de941$export$ec2291bfc64632f0; });
$parcel$export(module.exports, "checkOrSetAlreadyCaught", function () { return $da3dd405dd9de941$export$6de4ffac6a2f1098; });
$parcel$export(module.exports, "arrayify", function () { return $da3dd405dd9de941$export$3131421a7d01b4fb; });

var $aajbp = parcelRequire("aajbp");

var $bMiqE = parcelRequire("bMiqE");

var $lNVQ9 = parcelRequire("lNVQ9");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $da3dd405dd9de941$export$19f53698e68b2496() {
    const gbl = (0, $lNVQ9.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $da3dd405dd9de941$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $da3dd405dd9de941$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $da3dd405dd9de941$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $da3dd405dd9de941$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $da3dd405dd9de941$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $da3dd405dd9de941$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $da3dd405dd9de941$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $da3dd405dd9de941$export$d364f2020ab30578(input) {
    const match = input.match($da3dd405dd9de941$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $da3dd405dd9de941$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $bMiqE.snipLine)(line, 0));
    frame.context_line = (0, $bMiqE.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $bMiqE.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $da3dd405dd9de941$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $aajbp.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $da3dd405dd9de941$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("aajbp", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $7669b7e736cbe888$export$9563e054e6f787fb; });
$parcel$export(module.exports, "markFunctionWrapped", function () { return $7669b7e736cbe888$export$5c1499e2e5d010ae; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $7669b7e736cbe888$export$e73679ffaf56810e; });
$parcel$export(module.exports, "getOriginalFunction", function () { return $7669b7e736cbe888$export$e6cc1e135e2092e5; });
$parcel$export(module.exports, "urlEncode", function () { return $7669b7e736cbe888$export$9ef804feabbcbaf1; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $7669b7e736cbe888$export$62ff257738bf57f5; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $7669b7e736cbe888$export$b0244d5063c0b61b; });
$parcel$export(module.exports, "dropUndefinedKeys", function () { return $7669b7e736cbe888$export$d25f2688db1bb433; });

var $04wr6 = parcelRequire("04wr6");

var $aY8mH = parcelRequire("aY8mH");

var $jPeZ4 = parcelRequire("jPeZ4");

var $7p8hL = parcelRequire("7p8hL");

var $bMiqE = parcelRequire("bMiqE");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $7669b7e736cbe888$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $7669b7e736cbe888$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $7669b7e736cbe888$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $aY8mH.DEBUG_BUILD) && (0, $7p8hL.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $7669b7e736cbe888$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $7669b7e736cbe888$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $7669b7e736cbe888$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $7669b7e736cbe888$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $7669b7e736cbe888$export$62ff257738bf57f5(value) {
    if ((0, $jPeZ4.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$7669b7e736cbe888$var$getOwnProperties(value)
    };
    else if ((0, $jPeZ4.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $7669b7e736cbe888$var$serializeEventTarget(value.target),
            currentTarget: $7669b7e736cbe888$var$serializeEventTarget(value.currentTarget),
            ...$7669b7e736cbe888$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $jPeZ4.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $7669b7e736cbe888$var$serializeEventTarget(target) {
    try {
        return (0, $jPeZ4.isElement)(target) ? (0, $04wr6.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $7669b7e736cbe888$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $7669b7e736cbe888$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($7669b7e736cbe888$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $bMiqE.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $bMiqE.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $7669b7e736cbe888$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $7669b7e736cbe888$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $7669b7e736cbe888$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($7669b7e736cbe888$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $7669b7e736cbe888$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($7669b7e736cbe888$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $7669b7e736cbe888$var$isPojo(input) {
    if (!(0, $jPeZ4.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $7669b7e736cbe888$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $jPeZ4.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("04wr6", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $00d988f9c8458ac3$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getLocationHref", function () { return $00d988f9c8458ac3$export$1cfafeee2987818b; });
$parcel$export(module.exports, "getDomElement", function () { return $00d988f9c8458ac3$export$c660c1f3ab49225c; });
$parcel$export(module.exports, "getComponentName", function () { return $00d988f9c8458ac3$export$26727cfcc4d7e0fc; });

var $jPeZ4 = parcelRequire("jPeZ4");

var $lNVQ9 = parcelRequire("lNVQ9");
// eslint-disable-next-line deprecation/deprecation
const $00d988f9c8458ac3$var$WINDOW = (0, $lNVQ9.getGlobalObject)();
const $00d988f9c8458ac3$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $00d988f9c8458ac3$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $00d988f9c8458ac3$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $00d988f9c8458ac3$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $00d988f9c8458ac3$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($00d988f9c8458ac3$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $jPeZ4.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $00d988f9c8458ac3$export$1cfafeee2987818b() {
    try {
        return $00d988f9c8458ac3$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $00d988f9c8458ac3$export$c660c1f3ab49225c(selector) {
    if ($00d988f9c8458ac3$var$WINDOW.document && $00d988f9c8458ac3$var$WINDOW.document.querySelector) return $00d988f9c8458ac3$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $00d988f9c8458ac3$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$00d988f9c8458ac3$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRegister("bMiqE", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $8932790146efca4b$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $8932790146efca4b$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $8932790146efca4b$export$465e9d514283d4fd; });
$parcel$export(module.exports, "stringMatchesSomePattern", function () { return $8932790146efca4b$export$a7a5ec66062ea5d; });

var $jPeZ4 = parcelRequire("jPeZ4");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $8932790146efca4b$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $8932790146efca4b$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8932790146efca4b$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $jPeZ4.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $8932790146efca4b$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $jPeZ4.isString)(value)) return false;
    if ((0, $jPeZ4.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $jPeZ4.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $8932790146efca4b$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$8932790146efca4b$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("kNF8J", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $f2484bc1af2beef2$export$849dbeeeda01ae98; });
const $f2484bc1af2beef2$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("fB2fA", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $b5ac0e92c8e8cfe8$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b5ac0e92c8e8cfe8$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("fxUGN", function(module, exports) {

$parcel$export(module.exports, "Hub", function () { return $b515e967128040df$export$8c41bb232f1008b1; });
$parcel$export(module.exports, "makeMain", function () { return $b515e967128040df$export$4188a14ad302d1bc; });
$parcel$export(module.exports, "getMainCarrier", function () { return $b515e967128040df$export$19eade501500c6c1; });
$parcel$export(module.exports, "getHubFromCarrier", function () { return $b515e967128040df$export$bfa8a924a84a76b7; });
$parcel$export(module.exports, "getCurrentHub", function () { return $b515e967128040df$export$a07cdf6544bbd7c; });
$parcel$export(module.exports, "getIsolationScope", function () { return $b515e967128040df$export$68f3af03034c9e90; });
$parcel$export(module.exports, "runWithAsyncContext", function () { return $b515e967128040df$export$70d775fb1f267027; });

var $7p8hL = parcelRequire("7p8hL");
var $iGf0k = parcelRequire("iGf0k");
var $lNVQ9 = parcelRequire("lNVQ9");
var $jPeZ4 = parcelRequire("jPeZ4");
var $iJH3x = parcelRequire("iJH3x");

var $kNF8J = parcelRequire("kNF8J");

var $fB2fA = parcelRequire("fB2fA");

var $2W3Nl = parcelRequire("2W3Nl");

var $e4zhx = parcelRequire("e4zhx");

var $fIs9O = parcelRequire("fIs9O");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $b515e967128040df$export$24a86ef7798177e4 = parseFloat((0, $fIs9O.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $b515e967128040df$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $b515e967128040df$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $b515e967128040df$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $2W3Nl.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $2W3Nl.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $jPeZ4.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $iJH3x.uuid4)();
        const syntheticException = new Error('Sentry syntheticException');
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $iJH3x.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $iJH3x.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $b515e967128040df$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $iGf0k.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $7p8hL.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $b515e967128040df$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $b515e967128040df$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);
        if ((0, $fB2fA.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $7p8hL.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $7p8hL.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $e4zhx.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $kNF8J.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $lNVQ9.GLOBAL_OBJ).navigator || {};
        const session = (0, $e4zhx.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === 'ok') (0, $e4zhx.updateSession)(currentSession, {
            status: 'exited'
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $b515e967128040df$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $b515e967128040df$export$19eade501500c6c1() {
    (0, $lNVQ9.GLOBAL_OBJ).__SENTRY__ = (0, $lNVQ9.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $lNVQ9.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $b515e967128040df$export$4188a14ad302d1bc(hub) {
    const registry = $b515e967128040df$export$19eade501500c6c1();
    const oldHub = $b515e967128040df$export$bfa8a924a84a76b7(registry);
    $b515e967128040df$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $b515e967128040df$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $b515e967128040df$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $b515e967128040df$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $b515e967128040df$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $b515e967128040df$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $b515e967128040df$var$getGlobalHub(registry = $b515e967128040df$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$b515e967128040df$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $b515e967128040df$export$bfa8a924a84a76b7(registry).isOlderThan($b515e967128040df$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $b515e967128040df$export$849f05434e95d2f2(registry, new $b515e967128040df$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $b515e967128040df$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $b515e967128040df$export$236689a79f5aa020(carrier, parent = $b515e967128040df$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$b515e967128040df$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $b515e967128040df$export$bfa8a924a84a76b7(carrier).isOlderThan($b515e967128040df$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $b515e967128040df$export$849f05434e95d2f2(carrier, new $b515e967128040df$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $b515e967128040df$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $b515e967128040df$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $b515e967128040df$export$70d775fb1f267027(callback, options = {}) {
    const registry = $b515e967128040df$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $b515e967128040df$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $b515e967128040df$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $lNVQ9.getGlobalSingleton)('hub', ()=>new $b515e967128040df$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $b515e967128040df$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("2W3Nl", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $2233f125d7bebf60$export$775b6bb06e53a214; });
$parcel$export(module.exports, "getGlobalScope", function () { return $2233f125d7bebf60$export$aa55d5ab8e05984f; });

var $iGf0k = parcelRequire("iGf0k");
var $jPeZ4 = parcelRequire("jPeZ4");
var $7p8hL = parcelRequire("7p8hL");
var $iJH3x = parcelRequire("iJH3x");

var $jXhtG = parcelRequire("jXhtG");

var $e4zhx = parcelRequire("e4zhx");

var $6Moko = parcelRequire("6Moko");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $2233f125d7bebf60$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $2233f125d7bebf60$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $2233f125d7bebf60$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $2233f125d7bebf60$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $2233f125d7bebf60$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $2233f125d7bebf60$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $e4zhx.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $2233f125d7bebf60$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $jPeZ4.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $2233f125d7bebf60$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $2233f125d7bebf60$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $iGf0k.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $6Moko.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $jXhtG.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $jXhtG.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $iJH3x.uuid4)();
        if (!this._client) {
            (0, $7p8hL.logger).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $iJH3x.uuid4)();
        if (!this._client) {
            (0, $7p8hL.logger).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $iJH3x.uuid4)();
        if (!this._client) {
            (0, $7p8hL.logger).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $2233f125d7bebf60$export$aa55d5ab8e05984f() {
    if (!$2233f125d7bebf60$var$globalScope) $2233f125d7bebf60$var$globalScope = new $2233f125d7bebf60$export$775b6bb06e53a214();
    return $2233f125d7bebf60$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $2233f125d7bebf60$export$c83048efd17527d6(scope) {
    $2233f125d7bebf60$var$globalScope = scope;
}
function $2233f125d7bebf60$var$generatePropagationContext() {
    return {
        traceId: (0, $iJH3x.uuid4)(),
        spanId: (0, $iJH3x.uuid4)().substring(16)
    };
}

});
parcelRegister("jXhtG", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventProcessors", function () { return $e87115bd731ce6b2$export$3c4238858b85e8ac; });
$parcel$export(module.exports, "addGlobalEventProcessor", function () { return $e87115bd731ce6b2$export$8e4e25f54d456511; });
$parcel$export(module.exports, "notifyEventProcessors", function () { return $e87115bd731ce6b2$export$bf2a096c3e883e79; });

var $lNVQ9 = parcelRequire("lNVQ9");
var $jPeZ4 = parcelRequire("jPeZ4");
var $7p8hL = parcelRequire("7p8hL");
var $amxcu = parcelRequire("amxcu");

var $fB2fA = parcelRequire("fB2fA");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $e87115bd731ce6b2$export$3c4238858b85e8ac() {
    return (0, $lNVQ9.getGlobalSingleton)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $e87115bd731ce6b2$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $e87115bd731ce6b2$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $e87115bd731ce6b2$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $amxcu.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $fB2fA.DEBUG_BUILD) && processor.id && result === null && (0, $7p8hL.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $jPeZ4.isThenable)(result)) result.then((final)=>$e87115bd731ce6b2$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $e87115bd731ce6b2$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("amxcu", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", function () { return $78b5b660bf84b8fb$export$1fda8aa4d135f8aa; });
$parcel$export(module.exports, "SyncPromise", function () { return $78b5b660bf84b8fb$export$6f292d4960313241; });
$parcel$export(module.exports, "rejectedSyncPromise", function () { return $78b5b660bf84b8fb$export$78e43115b553f358; });

var $jPeZ4 = parcelRequire("jPeZ4");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $78b5b660bf84b8fb$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($78b5b660bf84b8fb$var$States || ($78b5b660bf84b8fb$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $78b5b660bf84b8fb$export$1fda8aa4d135f8aa(value) {
    return new $78b5b660bf84b8fb$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $78b5b660bf84b8fb$export$78e43115b553f358(reason) {
    return new $78b5b660bf84b8fb$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $78b5b660bf84b8fb$export$6f292d4960313241 {
    constructor(executor){
        $78b5b660bf84b8fb$export$6f292d4960313241.prototype.__init.call(this);
        $78b5b660bf84b8fb$export$6f292d4960313241.prototype.__init2.call(this);
        $78b5b660bf84b8fb$export$6f292d4960313241.prototype.__init3.call(this);
        $78b5b660bf84b8fb$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $78b5b660bf84b8fb$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $78b5b660bf84b8fb$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $78b5b660bf84b8fb$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($78b5b660bf84b8fb$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($78b5b660bf84b8fb$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $78b5b660bf84b8fb$var$States.PENDING) return;
            if ((0, $jPeZ4.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $78b5b660bf84b8fb$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $78b5b660bf84b8fb$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $78b5b660bf84b8fb$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("e4zhx", function(module, exports) {

$parcel$export(module.exports, "makeSession", function () { return $a3eccea17ef3455c$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $a3eccea17ef3455c$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $a3eccea17ef3455c$export$56521d9ba90f62ee; });

var $aajbp = parcelRequire("aajbp");
var $iGf0k = parcelRequire("iGf0k");
var $iJH3x = parcelRequire("iJH3x");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $a3eccea17ef3455c$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $iGf0k.timestampInSeconds)();
    const session = {
        sid: (0, $iJH3x.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$a3eccea17ef3455c$var$sessionToJSON(session)
    };
    if (context) $a3eccea17ef3455c$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $a3eccea17ef3455c$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $iGf0k.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $iJH3x.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $a3eccea17ef3455c$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $a3eccea17ef3455c$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $a3eccea17ef3455c$var$sessionToJSON(session) {
    return (0, $aajbp.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("6Moko", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", function () { return $0146192ca4e06701$export$43988bc651a80216; });
$parcel$export(module.exports, "mergeScopeData", function () { return $0146192ca4e06701$export$25ac7e259a513db4; });

var $iJH3x = parcelRequire("iJH3x");
var $aajbp = parcelRequire("aajbp");

var $2Grcj = parcelRequire("2Grcj");

var $7oVpT = parcelRequire("7oVpT");

var $4RP7L = parcelRequire("4RP7L");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $0146192ca4e06701$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $0146192ca4e06701$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $0146192ca4e06701$var$applySpanToEvent(event, span);
    $0146192ca4e06701$var$applyFingerprintToEvent(event, fingerprint);
    $0146192ca4e06701$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $0146192ca4e06701$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $0146192ca4e06701$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $0146192ca4e06701$export$b1a120a2871faa46(data, 'extra', extra);
    $0146192ca4e06701$export$b1a120a2871faa46(data, 'tags', tags);
    $0146192ca4e06701$export$b1a120a2871faa46(data, 'user', user);
    $0146192ca4e06701$export$b1a120a2871faa46(data, 'contexts', contexts);
    $0146192ca4e06701$export$b1a120a2871faa46(data, 'sdkProcessingMetadata', sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $0146192ca4e06701$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $0146192ca4e06701$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $aajbp.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $aajbp.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $aajbp.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $aajbp.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $0146192ca4e06701$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $0146192ca4e06701$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $0146192ca4e06701$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $4RP7L.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $7oVpT.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $2Grcj.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $4RP7L.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $0146192ca4e06701$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $iJH3x.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("2Grcj", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromClient", function () { return $1f4499e04745e139$export$366bad00d6815eed; });
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", function () { return $1f4499e04745e139$export$a117f995597e25df; });

var $aajbp = parcelRequire("aajbp");

var $kNF8J = parcelRequire("kNF8J");

var $hcepo = parcelRequire("hcepo");

var $7oVpT = parcelRequire("7oVpT");

var $4RP7L = parcelRequire("4RP7L");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $1f4499e04745e139$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $aajbp.dropUndefinedKeys)({
        environment: options.environment || (0, $kNF8J.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $1f4499e04745e139$export$a117f995597e25df(span) {
    const client = (0, $hcepo.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $1f4499e04745e139$export$366bad00d6815eed((0, $4RP7L.spanToJSON)(span).trace_id || '', client, (0, $hcepo.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $7oVpT.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $4RP7L.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== 'url') dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $4RP7L.spanIsSampled)(txn));
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}

});
parcelRegister("7oVpT", function(module, exports) {

$parcel$export(module.exports, "getRootSpan", function () { return $563750088b1823ba$export$c4c6a79b1260ca1b; });
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $563750088b1823ba$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});

parcelRegister("4RP7L", function(module, exports) {

$parcel$export(module.exports, "TRACE_FLAG_NONE", function () { return $38b3c4e0cbc28389$export$208d5b368507fb8b; });
$parcel$export(module.exports, "TRACE_FLAG_SAMPLED", function () { return $38b3c4e0cbc28389$export$eb571cd9b5d98de8; });
$parcel$export(module.exports, "spanToTraceContext", function () { return $38b3c4e0cbc28389$export$46c6fbd1d265ebf0; });
$parcel$export(module.exports, "spanToJSON", function () { return $38b3c4e0cbc28389$export$92d8c23565496537; });
$parcel$export(module.exports, "spanToTraceHeader", function () { return $38b3c4e0cbc28389$export$7e9f8ae9e4a328ab; });
$parcel$export(module.exports, "spanIsSampled", function () { return $38b3c4e0cbc28389$export$5caecac1caaf3a71; });
$parcel$export(module.exports, "spanTimeInputToSeconds", function () { return $38b3c4e0cbc28389$export$3f7581298f56c6d7; });

var $aajbp = parcelRequire("aajbp");
var $6jMr3 = parcelRequire("6jMr3");
var $iGf0k = parcelRequire("iGf0k");
// These are aligned with OpenTelemetry trace flags
const $38b3c4e0cbc28389$export$208d5b368507fb8b = 0x0;
const $38b3c4e0cbc28389$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $38b3c4e0cbc28389$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $38b3c4e0cbc28389$export$92d8c23565496537(span);
    return (0, $aajbp.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $38b3c4e0cbc28389$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $38b3c4e0cbc28389$export$5caecac1caaf3a71(span);
    return (0, $6jMr3.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $38b3c4e0cbc28389$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $38b3c4e0cbc28389$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $38b3c4e0cbc28389$var$ensureTimestampInSeconds(input.getTime());
    return (0, $iGf0k.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $38b3c4e0cbc28389$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $38b3c4e0cbc28389$export$92d8c23565496537(span) {
    if ($38b3c4e0cbc28389$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === 'function') // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $38b3c4e0cbc28389$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $38b3c4e0cbc28389$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $38b3c4e0cbc28389$export$eb571cd9b5d98de8);
}

});
parcelRegister("6jMr3", function(module, exports) {

$parcel$export(module.exports, "extractTraceparentData", function () { return $499a16ae6432059e$export$8e9a29865c0a1226; });
$parcel$export(module.exports, "tracingContextFromHeaders", function () { return $499a16ae6432059e$export$ca5c066532785b6e; });
$parcel$export(module.exports, "propagationContextFromHeaders", function () { return $499a16ae6432059e$export$261f383d16a93e39; });
$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $499a16ae6432059e$export$f35d907436da45cf; });

var $9dJTa = parcelRequire("9dJTa");

var $iJH3x = parcelRequire("iJH3x");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $499a16ae6432059e$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $499a16ae6432059e$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($499a16ae6432059e$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $499a16ae6432059e$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $499a16ae6432059e$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $9dJTa.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $iJH3x.uuid4)(),
            spanId: (0, $iJH3x.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $iJH3x.uuid4)(),
            parentSpanId: parentSpanId || (0, $iJH3x.uuid4)().substring(16),
            spanId: (0, $iJH3x.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $499a16ae6432059e$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $499a16ae6432059e$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $9dJTa.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $iJH3x.uuid4)(),
        spanId: (0, $iJH3x.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $iJH3x.uuid4)(),
        parentSpanId: parentSpanId || (0, $iJH3x.uuid4)().substring(16),
        spanId: (0, $iJH3x.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $499a16ae6432059e$export$f35d907436da45cf(traceId = (0, $iJH3x.uuid4)(), spanId = (0, $iJH3x.uuid4)().substring(16), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("9dJTa", function(module, exports) {

$parcel$export(module.exports, "BAGGAGE_HEADER_NAME", function () { return $6b68ec80a732e936$export$9ca9946bd449ac06; });
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $6b68ec80a732e936$export$5b96ee2c8421f107; });
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", function () { return $6b68ec80a732e936$export$56766feef403f365; });

var $aY8mH = parcelRequire("aY8mH");

var $jPeZ4 = parcelRequire("jPeZ4");

var $7p8hL = parcelRequire("7p8hL");
const $6b68ec80a732e936$export$9ca9946bd449ac06 = 'baggage';
const $6b68ec80a732e936$export$6e69537d67fa20f = 'sentry-';
const $6b68ec80a732e936$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $6b68ec80a732e936$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $6b68ec80a732e936$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $jPeZ4.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $6b68ec80a732e936$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $6b68ec80a732e936$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($6b68ec80a732e936$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($6b68ec80a732e936$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $6b68ec80a732e936$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$6b68ec80a732e936$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $6b68ec80a732e936$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $6b68ec80a732e936$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $6b68ec80a732e936$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $6b68ec80a732e936$export$bdd844ddb2def819) {
            (0, $aY8mH.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});






parcelRegister("fIs9O", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $b710ce850dd5d8ac$export$31499a9cd224b78c; });
const $b710ce850dd5d8ac$export$31499a9cd224b78c = '7.120.4';

});


parcelRegister("5XnTz", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", function () { return $4564ff902648190c$export$2d67fb380bd11267; });
$parcel$export(module.exports, "parseEventHintOrCaptureContext", function () { return $4564ff902648190c$export$76b5f966996d1653; });

var $iJH3x = parcelRequire("iJH3x");
var $iGf0k = parcelRequire("iGf0k");
var $lNVQ9 = parcelRequire("lNVQ9");
var $5vnYi = parcelRequire("5vnYi");
var $bMiqE = parcelRequire("bMiqE");

var $kNF8J = parcelRequire("kNF8J");

var $jXhtG = parcelRequire("jXhtG");

var $2W3Nl = parcelRequire("2W3Nl");

var $6Moko = parcelRequire("6Moko");

var $4RP7L = parcelRequire("4RP7L");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $4564ff902648190c$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $iJH3x.uuid4)(),
        timestamp: event.timestamp || (0, $iGf0k.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $4564ff902648190c$var$applyClientOptions(prepared, options);
    $4564ff902648190c$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $4564ff902648190c$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $4564ff902648190c$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $iJH3x.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $2W3Nl.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $6Moko.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $6Moko.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $6Moko.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $jXhtG.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $jXhtG.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $4564ff902648190c$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $4564ff902648190c$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $4564ff902648190c$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $kNF8J.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $bMiqE.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $bMiqE.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $bMiqE.truncate)(request.url, maxValueLength);
}
const $4564ff902648190c$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $4564ff902648190c$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $lNVQ9.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $4564ff902648190c$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $4564ff902648190c$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $4564ff902648190c$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $4564ff902648190c$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $4564ff902648190c$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $5vnYi.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $5vnYi.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $5vnYi.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $5vnYi.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $5vnYi.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $4RP7L.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $5vnYi.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $4564ff902648190c$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $2W3Nl.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $4564ff902648190c$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($4564ff902648190c$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($4564ff902648190c$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $4564ff902648190c$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $2W3Nl.Scope) || typeof hint === 'function';
}
const $4564ff902648190c$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $4564ff902648190c$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$4564ff902648190c$var$captureContextKeys.includes(key));
}

});
parcelRegister("5vnYi", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $402271403d2a143f$export$a3295358bff77e; });
$parcel$export(module.exports, "normalizeToSize", function () { return $402271403d2a143f$export$23fbbb20bed71033; });

var $jPeZ4 = parcelRequire("jPeZ4");

var $eKRqJ = parcelRequire("eKRqJ");

var $aajbp = parcelRequire("aajbp");

var $kEJYx = parcelRequire("kEJYx");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $402271403d2a143f$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $402271403d2a143f$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $402271403d2a143f$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $402271403d2a143f$export$a3295358bff77e(object, depth);
    if ($402271403d2a143f$var$jsonSize(normalized) > maxSize) return $402271403d2a143f$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $402271403d2a143f$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $eKRqJ.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $jPeZ4.isNaN)(value)) return value;
    const stringified = $402271403d2a143f$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $402271403d2a143f$export$588732934346abbf('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $aajbp.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $402271403d2a143f$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $402271403d2a143f$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $jPeZ4.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $jPeZ4.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return `[Function: ${(0, $kEJYx.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $402271403d2a143f$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $402271403d2a143f$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $402271403d2a143f$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $402271403d2a143f$var$jsonSize(value) {
    return $402271403d2a143f$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $402271403d2a143f$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}

});
parcelRegister("eKRqJ", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", function () { return $abdeceb456a49826$export$8115b0b78e956ab3; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $abdeceb456a49826$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("kEJYx", function(module, exports) {

$parcel$export(module.exports, "createStackParser", function () { return $f09b34d7784ccad9$export$a5739666fb2d03d4; });
$parcel$export(module.exports, "stackParserFromStackParserOptions", function () { return $f09b34d7784ccad9$export$1d5cf88b347146d4; });
$parcel$export(module.exports, "getFunctionName", function () { return $f09b34d7784ccad9$export$aad197c7121a6651; });

var $9usNZ = parcelRequire("9usNZ");
const $f09b34d7784ccad9$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $f09b34d7784ccad9$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $f09b34d7784ccad9$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $f09b34d7784ccad9$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $f09b34d7784ccad9$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($f09b34d7784ccad9$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $f09b34d7784ccad9$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $f09b34d7784ccad9$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $f09b34d7784ccad9$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $f09b34d7784ccad9$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $f09b34d7784ccad9$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($f09b34d7784ccad9$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($f09b34d7784ccad9$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    }
    return localStack.slice(0, $f09b34d7784ccad9$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        }));
}
const $f09b34d7784ccad9$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $f09b34d7784ccad9$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $f09b34d7784ccad9$var$defaultFunctionName;
        return fn.name || $f09b34d7784ccad9$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $f09b34d7784ccad9$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $f09b34d7784ccad9$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $9usNZ.node)(getModule)
    ];
}

});
parcelRegister("9usNZ", function(module, exports) {

$parcel$export(module.exports, "node", function () { return $6e8d4284125ab5ec$export$35059013cd4a06db; });
/**
 * Does this filename look like it's part of the app code?
 */ function $6e8d4284125ab5ec$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith('/') && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes('node_modules/');
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $6e8d4284125ab5ec$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === 'native';
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $6e8d4284125ab5ec$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});





parcelRegister("huK8b", function(module, exports) {

$parcel$export(module.exports, "BaseClient", function () { return $cbc905a8d0f56eed$export$4f22f74eddb7716a; });
$parcel$export(module.exports, "addEventProcessor", function () { return $cbc905a8d0f56eed$export$9aac0b9f77928fbf; });

var $2pR2a = parcelRequire("2pR2a");
var $iJH3x = parcelRequire("iJH3x");
var $jPeZ4 = parcelRequire("jPeZ4");
var $7p8hL = parcelRequire("7p8hL");
var $i8Xwi = parcelRequire("i8Xwi");
var $amxcu = parcelRequire("amxcu");
var $1BeOm = parcelRequire("1BeOm");

var $eua5O = parcelRequire("eua5O");

var $fB2fA = parcelRequire("fB2fA");

var $16rrK = parcelRequire("16rrK");

var $hcepo = parcelRequire("hcepo");

var $fxUGN = parcelRequire("fxUGN");

var $genhe = parcelRequire("genhe");

var $9vL5z = parcelRequire("9vL5z");

var $e4zhx = parcelRequire("e4zhx");

var $2Grcj = parcelRequire("2Grcj");

var $5XnTz = parcelRequire("5XnTz");
const $cbc905a8d0f56eed$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $cbc905a8d0f56eed$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $i8Xwi.makeDsn)(options.dsn);
        else (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $eua5O.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $iJH3x.checkOrSetAlreadyCaught)(exception)) {
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log($cbc905a8d0f56eed$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $jPeZ4.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $jPeZ4.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $iJH3x.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log($cbc905a8d0f56eed$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === 'string')) (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $e4zhx.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $amxcu.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $genhe.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $genhe.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $16rrK.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $2pR2a.addItemToEnvelope)(env, (0, $2pR2a.createAttachmentEnvelopeItem)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $16rrK.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === 'number' ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $9vL5z.createMetricEnvelope)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $genhe.setupIntegrations)(this, integrations);
        (0, $genhe.afterSetupIntegrations)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $e4zhx.updateSession)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $amxcu.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $fxUGN.getIsolationScope)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        return (0, $5XnTz.prepareEvent)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $2Grcj.getDynamicSamplingContextFromClient)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $fB2fA.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === 'log') (0, $7p8hL.logger).log(sentryError.message);
                else (0, $7p8hL.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $cbc905a8d0f56eed$var$isTransactionEvent(event);
        const isError = $cbc905a8d0f56eed$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $amxcu.rejectedSyncPromise)(new (0, $1BeOm.SentryError)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $1BeOm.SentryError)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $cbc905a8d0f56eed$var$processBeforeSend(options, prepared, hint);
            return $cbc905a8d0f56eed$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw new (0, $1BeOm.SentryError)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $1BeOm.SentryError)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $1BeOm.SentryError)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).error('Error while sending event:', reason);
        });
        else (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).error('Transport disabled');
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $cbc905a8d0f56eed$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $jPeZ4.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $jPeZ4.isPlainObject)(event) && event !== null) throw new (0, $1BeOm.SentryError)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $1BeOm.SentryError)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $jPeZ4.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $1BeOm.SentryError)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $cbc905a8d0f56eed$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($cbc905a8d0f56eed$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($cbc905a8d0f56eed$var$isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            const spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                spanCountBeforeProcessing: spanCountBefore
            };
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function $cbc905a8d0f56eed$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $cbc905a8d0f56eed$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $cbc905a8d0f56eed$export$9aac0b9f77928fbf(callback) {
    const client = (0, $hcepo.getClient)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}

});
parcelRegister("2pR2a", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", function () { return $1c270dff4e81b546$export$f93f7f385160c44e; });
$parcel$export(module.exports, "addItemToEnvelope", function () { return $1c270dff4e81b546$export$d650323442802f6f; });
$parcel$export(module.exports, "forEachEnvelopeItem", function () { return $1c270dff4e81b546$export$c56c55acf0136fd3; });
$parcel$export(module.exports, "envelopeContainsItemType", function () { return $1c270dff4e81b546$export$604a45d95a155e2b; });
$parcel$export(module.exports, "serializeEnvelope", function () { return $1c270dff4e81b546$export$32f9b428425aac85; });
$parcel$export(module.exports, "parseEnvelope", function () { return $1c270dff4e81b546$export$3338d0c7b6e17a2b; });
$parcel$export(module.exports, "createAttachmentEnvelopeItem", function () { return $1c270dff4e81b546$export$d8fc80952cc31fa4; });
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", function () { return $1c270dff4e81b546$export$b11169581eeaf237; });
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", function () { return $1c270dff4e81b546$export$d369f3b2758f6743; });
$parcel$export(module.exports, "createEventEnvelopeHeaders", function () { return $1c270dff4e81b546$export$92b6093782fe661b; });

var $i8Xwi = parcelRequire("i8Xwi");

var $5vnYi = parcelRequire("5vnYi");

var $aajbp = parcelRequire("aajbp");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $1c270dff4e81b546$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $1c270dff4e81b546$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $1c270dff4e81b546$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $1c270dff4e81b546$export$604a45d95a155e2b(envelope, types) {
    return $1c270dff4e81b546$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $1c270dff4e81b546$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $1c270dff4e81b546$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $1c270dff4e81b546$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === 'string' ? $1c270dff4e81b546$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $5vnYi.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $1c270dff4e81b546$var$concatBuffers(parts);
}
function $1c270dff4e81b546$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $1c270dff4e81b546$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $1c270dff4e81b546$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === 'string' ? $1c270dff4e81b546$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $aajbp.dropUndefinedKeys)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $1c270dff4e81b546$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $1c270dff4e81b546$export$b11169581eeaf237(type) {
    return $1c270dff4e81b546$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $1c270dff4e81b546$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $1c270dff4e81b546$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $i8Xwi.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $aajbp.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}

});
parcelRegister("i8Xwi", function(module, exports) {

$parcel$export(module.exports, "dsnToString", function () { return $d35724bfe3f83ca5$export$44d472fbb931a776; });
$parcel$export(module.exports, "dsnFromString", function () { return $d35724bfe3f83ca5$export$b892860177f70a30; });
$parcel$export(module.exports, "makeDsn", function () { return $d35724bfe3f83ca5$export$128827c3562ec0cb; });

var $aY8mH = parcelRequire("aY8mH");

var $7p8hL = parcelRequire("7p8hL");
/** Regular expression used to parse a Dsn. */ const $d35724bfe3f83ca5$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $d35724bfe3f83ca5$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $d35724bfe3f83ca5$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $d35724bfe3f83ca5$export$b892860177f70a30(str) {
    const match = $d35724bfe3f83ca5$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $7p8hL.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $d35724bfe3f83ca5$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $d35724bfe3f83ca5$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $d35724bfe3f83ca5$var$validateDsn(dsn) {
    if (!(0, $aY8mH.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $7p8hL.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $7p8hL.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$d35724bfe3f83ca5$var$isValidProtocol(protocol)) {
        (0, $7p8hL.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $7p8hL.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $d35724bfe3f83ca5$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $d35724bfe3f83ca5$export$b892860177f70a30(from) : $d35724bfe3f83ca5$var$dsnFromComponents(from);
    if (!components || !$d35724bfe3f83ca5$var$validateDsn(components)) return undefined;
    return components;
}

});


parcelRegister("1BeOm", function(module, exports) {

$parcel$export(module.exports, "SentryError", function () { return $12a4bc613f21a53c$export$5949942ba2a7c0e2; });
/** An error emitted by Sentry SDKs and related utilities. */ class $12a4bc613f21a53c$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}

});

parcelRegister("eua5O", function(module, exports) {

$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", function () { return $a8bbb23d93bee0b3$export$9964600bfe84e6a3; });
$parcel$export(module.exports, "getReportDialogEndpoint", function () { return $a8bbb23d93bee0b3$export$671c7ed8e40a7a57; });

var $i8Xwi = parcelRequire("i8Xwi");
var $aajbp = parcelRequire("aajbp");
const $a8bbb23d93bee0b3$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $a8bbb23d93bee0b3$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $a8bbb23d93bee0b3$var$_getIngestEndpoint(dsn) {
    return `${$a8bbb23d93bee0b3$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $a8bbb23d93bee0b3$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $aajbp.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $a8bbb23d93bee0b3$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $a8bbb23d93bee0b3$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$a8bbb23d93bee0b3$var$_getIngestEndpoint(dsn)}?${$a8bbb23d93bee0b3$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $a8bbb23d93bee0b3$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $i8Xwi.makeDsn)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$a8bbb23d93bee0b3$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $i8Xwi.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});

parcelRegister("16rrK", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", function () { return $0cdba44744836c2f$export$124b03c077baa2f3; });
$parcel$export(module.exports, "createEventEnvelope", function () { return $0cdba44744836c2f$export$c31057337a18010f; });

var $2pR2a = parcelRequire("2pR2a");
var $i8Xwi = parcelRequire("i8Xwi");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $0cdba44744836c2f$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $0cdba44744836c2f$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $2pR2a.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $i8Xwi.dsnToString)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $2pR2a.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $0cdba44744836c2f$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $2pR2a.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $0cdba44744836c2f$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $2pR2a.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $2pR2a.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}

});

parcelRegister("genhe", function(module, exports) {

$parcel$export(module.exports, "getIntegrationsToSetup", function () { return $bd10027c43dd945c$export$68bc4c01ab8ae766; });
$parcel$export(module.exports, "setupIntegrations", function () { return $bd10027c43dd945c$export$51abed9797baa598; });
$parcel$export(module.exports, "setupIntegration", function () { return $bd10027c43dd945c$export$e7390a03b70a6f2f; });
$parcel$export(module.exports, "afterSetupIntegrations", function () { return $bd10027c43dd945c$export$35abcfd71227c6ca; });
$parcel$export(module.exports, "addIntegration", function () { return $bd10027c43dd945c$export$2d8f5188773bcddd; });
$parcel$export(module.exports, "convertIntegrationFnToClass", function () { return $bd10027c43dd945c$export$afa219bf23651160; });
$parcel$export(module.exports, "defineIntegration", function () { return $bd10027c43dd945c$export$2323046b9414659f; });

var $iJH3x = parcelRequire("iJH3x");
var $7p8hL = parcelRequire("7p8hL");

var $fB2fA = parcelRequire("fB2fA");

var $jXhtG = parcelRequire("jXhtG");

var $hcepo = parcelRequire("hcepo");

var $fxUGN = parcelRequire("fxUGN");
const $bd10027c43dd945c$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $bd10027c43dd945c$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $bd10027c43dd945c$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') integrations = (0, $iJH3x.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $bd10027c43dd945c$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $bd10027c43dd945c$var$findIndex(finalIntegrations, (integration)=>integration.name === 'Debug');
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $bd10027c43dd945c$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $bd10027c43dd945c$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $bd10027c43dd945c$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $bd10027c43dd945c$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($bd10027c43dd945c$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $jXhtG.addGlobalEventProcessor), (0, $fxUGN.getCurrentHub));
        $bd10027c43dd945c$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = (event, hint)=>callback(event, hint, client);
        processor.id = integration.name;
        client.addEventProcessor(processor);
    }
    (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $bd10027c43dd945c$export$2d8f5188773bcddd(integration) {
    const client = (0, $hcepo.getClient)();
    if (!client || !client.addIntegration) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $bd10027c43dd945c$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $bd10027c43dd945c$export$afa219bf23651160(name, fn) {
    const ConvertedIntegration = function ConvertedIntegration(...args) {
        return fn(...args);
    };
    ConvertedIntegration.id = name;
    return ConvertedIntegration;
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $bd10027c43dd945c$export$2323046b9414659f(fn) {
    return fn;
}

});

parcelRegister("9vL5z", function(module, exports) {

$parcel$export(module.exports, "createMetricEnvelope", function () { return $6ecb892daa9f5151$export$f23eb96e33154901; });

var $2pR2a = parcelRequire("2pR2a");
var $i8Xwi = parcelRequire("i8Xwi");

var $lsJ5g = parcelRequire("lsJ5g");
/**
 * Create envelope from a metric aggregate.
 */ function $6ecb892daa9f5151$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $i8Xwi.dsnToString)(dsn);
    const item = $6ecb892daa9f5151$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $2pR2a.createEnvelope)(headers, [
        item
    ]);
}
function $6ecb892daa9f5151$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $lsJ5g.serializeMetricBuckets)(metricBucketItems);
    const metricHeaders = {
        type: 'statsd',
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}

});
parcelRegister("lsJ5g", function(module, exports) {

$parcel$export(module.exports, "getBucketKey", function () { return $f9ff2f384e51ee2d$export$b8bd8c4dffa5aa2d; });
$parcel$export(module.exports, "simpleHash", function () { return $f9ff2f384e51ee2d$export$b211ce59c0ea1cfb; });
$parcel$export(module.exports, "serializeMetricBuckets", function () { return $f9ff2f384e51ee2d$export$66decd709db01dc8; });
$parcel$export(module.exports, "sanitizeUnit", function () { return $f9ff2f384e51ee2d$export$2d8c9911396bbf5f; });
$parcel$export(module.exports, "sanitizeMetricKey", function () { return $f9ff2f384e51ee2d$export$d3b3167f2ebbcecc; });
$parcel$export(module.exports, "sanitizeTags", function () { return $f9ff2f384e51ee2d$export$ae49af12dbdf2477; });

var $aajbp = parcelRequire("aajbp");
/**
 * Generate bucket key from metric properties.
 */ function $f9ff2f384e51ee2d$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $aajbp.dropUndefinedKeys)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $f9ff2f384e51ee2d$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $f9ff2f384e51ee2d$export$66decd709db01dc8(metricBucketItems) {
    let out = '';
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(',')}` : '';
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $f9ff2f384e51ee2d$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, '_');
}
/** Sanitizes metric keys */ function $f9ff2f384e51ee2d$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, '_');
}
function $f9ff2f384e51ee2d$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, '');
}
const $f9ff2f384e51ee2d$var$tagValueReplacements = [
    [
        '\n',
        '\\n'
    ],
    [
        '\r',
        '\\r'
    ],
    [
        '\t',
        '\\t'
    ],
    [
        '\\',
        '\\\\'
    ],
    [
        '|',
        "\\u{7c}"
    ],
    [
        ',',
        "\\u{2c}"
    ]
];
function $f9ff2f384e51ee2d$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $f9ff2f384e51ee2d$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $f9ff2f384e51ee2d$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $f9ff2f384e51ee2d$var$getCharOrReplacement(char), '');
}
/**
 * Sanitizes tags.
 */ function $f9ff2f384e51ee2d$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $f9ff2f384e51ee2d$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $f9ff2f384e51ee2d$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}

});



parcelRegister("jEn5j", function(module, exports) {

$parcel$export(module.exports, "startIdleTransaction", function () { return $e4e3a8e3e2634574$export$479dbd817e392a4f; });
$parcel$export(module.exports, "addTracingExtensions", function () { return $e4e3a8e3e2634574$export$653d0ef2bad9cdf9; });

var $7p8hL = parcelRequire("7p8hL");

var $fB2fA = parcelRequire("fB2fA");

var $fxUGN = parcelRequire("fxUGN");

var $4RP7L = parcelRequire("4RP7L");

var $1xsEw = parcelRequire("1xsEw");

var $k6xPV = parcelRequire("k6xPV");

var $g05qq = parcelRequire("g05qq");

var $dmE4i = parcelRequire("dmE4i");
/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function $e4e3a8e3e2634574$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        'sentry-trace': (0, $4RP7L.spanToTraceHeader)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $e4e3a8e3e2634574$var$_startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || 'sentry';
    const transactionInstrumenter = transactionContext.instrumenter || 'sentry';
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $dmE4i.Transaction)(transactionContext, this);
    transaction = (0, $g05qq.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $e4e3a8e3e2634574$export$479dbd817e392a4f(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $k6xPV.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $g05qq.sampleTransaction)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $e4e3a8e3e2634574$export$653d0ef2bad9cdf9() {
    const carrier = (0, $fxUGN.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $e4e3a8e3e2634574$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $e4e3a8e3e2634574$var$traceHeaders;
    (0, $1xsEw.registerErrorInstrumentation)();
}

});
parcelRegister("1xsEw", function(module, exports) {

$parcel$export(module.exports, "registerErrorInstrumentation", function () { return $11ef1955fda5cb01$export$637857c1d87b640c; });

var $gHATr = parcelRequire("gHATr");
var $a5k97 = parcelRequire("a5k97");
var $7p8hL = parcelRequire("7p8hL");

var $fB2fA = parcelRequire("fB2fA");

var $7flMU = parcelRequire("7flMU");
let $11ef1955fda5cb01$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $11ef1955fda5cb01$export$637857c1d87b640c() {
    if ($11ef1955fda5cb01$var$errorsInstrumented) return;
    $11ef1955fda5cb01$var$errorsInstrumented = true;
    (0, $gHATr.addGlobalErrorInstrumentationHandler)($11ef1955fda5cb01$var$errorCallback);
    (0, $a5k97.addGlobalUnhandledRejectionInstrumentationHandler)($11ef1955fda5cb01$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $11ef1955fda5cb01$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $7flMU.getActiveTransaction)();
    if (activeTransaction) {
        const status = 'internal_error';
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$11ef1955fda5cb01$var$errorCallback.tag = 'sentry_tracingErrorCallback';

});
parcelRegister("gHATr", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", function () { return $c28d47b27d6ca1cc$export$55b5c3ba2194f0c6; });

var $lNVQ9 = parcelRequire("lNVQ9");

var $7P0P8 = parcelRequire("7P0P8");
let $c28d47b27d6ca1cc$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c28d47b27d6ca1cc$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $7P0P8.addHandler)(type, handler);
    (0, $7P0P8.maybeInstrument)(type, $c28d47b27d6ca1cc$var$instrumentError);
}
function $c28d47b27d6ca1cc$var$instrumentError() {
    $c28d47b27d6ca1cc$var$_oldOnErrorHandler = (0, $lNVQ9.GLOBAL_OBJ).onerror;
    (0, $lNVQ9.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $7P0P8.triggerHandlers)('error', handlerData);
        if ($c28d47b27d6ca1cc$var$_oldOnErrorHandler && !$c28d47b27d6ca1cc$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $c28d47b27d6ca1cc$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $lNVQ9.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});
parcelRegister("7P0P8", function(module, exports) {

$parcel$export(module.exports, "addHandler", function () { return $5b1def6d87c54391$export$a4e09611e30da72e; });
$parcel$export(module.exports, "maybeInstrument", function () { return $5b1def6d87c54391$export$e18d6c5462c01368; });
$parcel$export(module.exports, "triggerHandlers", function () { return $5b1def6d87c54391$export$b18c893e424d3127; });

var $aY8mH = parcelRequire("aY8mH");

var $7p8hL = parcelRequire("7p8hL");

var $kEJYx = parcelRequire("kEJYx");
// We keep the handlers globally
const $5b1def6d87c54391$var$handlers = {};
const $5b1def6d87c54391$var$instrumented = {};
/** Add a handler function. */ function $5b1def6d87c54391$export$a4e09611e30da72e(type, handler) {
    $5b1def6d87c54391$var$handlers[type] = $5b1def6d87c54391$var$handlers[type] || [];
    $5b1def6d87c54391$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $5b1def6d87c54391$export$b17eab759a1cb5fe() {
    Object.keys($5b1def6d87c54391$var$handlers).forEach((key)=>{
        $5b1def6d87c54391$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $5b1def6d87c54391$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$5b1def6d87c54391$var$instrumented[type]) {
        instrumentFn();
        $5b1def6d87c54391$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $5b1def6d87c54391$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $5b1def6d87c54391$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $aY8mH.DEBUG_BUILD) && (0, $7p8hL.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $kEJYx.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("a5k97", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", function () { return $7579ff9df4211b1b$export$8bf4fc6858821a4e; });

var $lNVQ9 = parcelRequire("lNVQ9");

var $7P0P8 = parcelRequire("7P0P8");
let $7579ff9df4211b1b$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7579ff9df4211b1b$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $7P0P8.addHandler)(type, handler);
    (0, $7P0P8.maybeInstrument)(type, $7579ff9df4211b1b$var$instrumentUnhandledRejection);
}
function $7579ff9df4211b1b$var$instrumentUnhandledRejection() {
    $7579ff9df4211b1b$var$_oldOnUnhandledRejectionHandler = (0, $lNVQ9.GLOBAL_OBJ).onunhandledrejection;
    (0, $lNVQ9.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $7P0P8.triggerHandlers)('unhandledrejection', handlerData);
        if ($7579ff9df4211b1b$var$_oldOnUnhandledRejectionHandler && !$7579ff9df4211b1b$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $7579ff9df4211b1b$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $lNVQ9.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("7flMU", function(module, exports) {

$parcel$export(module.exports, "getActiveTransaction", function () { return $546ad5ba9b4ef3c7$export$a7feb32fdd923295; });
$parcel$export(module.exports, "extractTraceparentData", function () { return $546ad5ba9b4ef3c7$export$8e9a29865c0a1226; });

var $6jMr3 = parcelRequire("6jMr3");

var $fxUGN = parcelRequire("fxUGN");
/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $546ad5ba9b4ef3c7$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $fxUGN.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $546ad5ba9b4ef3c7$export$8e9a29865c0a1226 = (0, $6jMr3.extractTraceparentData);

});


parcelRegister("k6xPV", function(module, exports) {

$parcel$export(module.exports, "TRACING_DEFAULTS", function () { return $ea2e9d667fef2991$export$809a2b7987fd5306; });
$parcel$export(module.exports, "IdleTransaction", function () { return $ea2e9d667fef2991$export$b279e6bd7040371f; });

var $7p8hL = parcelRequire("7p8hL");
var $iGf0k = parcelRequire("iGf0k");

var $fB2fA = parcelRequire("fB2fA");

var $4RP7L = parcelRequire("4RP7L");

var $5mTXR = parcelRequire("5mTXR");

var $dmE4i = parcelRequire("dmE4i");
const $ea2e9d667fef2991$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $ea2e9d667fef2991$var$FINISH_REASON_TAG = 'finishReason';
const $ea2e9d667fef2991$var$IDLE_TRANSACTION_FINISH_REASONS = [
    'heartbeatFailed',
    'idleTimeout',
    'documentHidden',
    'finalTimeout',
    'externalFinish',
    'cancelled'
];
/**
 * @inheritDoc
 */ class $ea2e9d667fef2991$export$370d6113c18ba86c extends (0, $5mTXR.SpanRecorder) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $4RP7L.spanToJSON)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $ea2e9d667fef2991$export$b279e6bd7040371f extends (0, $dmE4i.Transaction) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $ea2e9d667fef2991$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $ea2e9d667fef2991$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $ea2e9d667fef2991$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $ea2e9d667fef2991$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus('deadline_exceeded');
                this._finishReason = $ea2e9d667fef2991$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $4RP7L.spanTimeInputToSeconds)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === 'ui.action.click') this.setAttribute($ea2e9d667fef2991$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $fB2fA.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
            (0, $7p8hL.logger).log('[Tracing] finishing IdleTransaction', new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $4RP7L.spanToJSON)(span).timestamp) {
                    span.setStatus('cancelled');
                    span.end(endTimestampInS);
                    (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $4RP7L.spanToJSON)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $fB2fA.DEBUG_BUILD) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $7p8hL.logger).log('[Tracing] discarding Span since it happened after Transaction was finished', stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $7p8hL.logger).log('[Tracing] discarding Span since it finished after Transaction final timeout', stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log('[Tracing] flushing IdleTransaction');
        } else (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log('[Tracing] No active IdleTransaction');
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $ea2e9d667fef2991$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log('Starting heartbeat');
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $ea2e9d667fef2991$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log('[Tracing] Received finish signal for idle transaction.');
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $ea2e9d667fef2991$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $iGf0k.timestampInSeconds)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $ea2e9d667fef2991$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join('');
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log('[Tracing] Transaction finished because of no change for 3 heart beats');
                this.setStatus('deadline_exceeded');
                this._finishReason = $ea2e9d667fef2991$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}

});
parcelRegister("5mTXR", function(module, exports) {

$parcel$export(module.exports, "SpanRecorder", function () { return $3e8a6b35cd55fe76$export$10c95c129cd0d4fe; });
$parcel$export(module.exports, "Span", function () { return $3e8a6b35cd55fe76$export$5f1714a13ed34c01; });

var $aajbp = parcelRequire("aajbp");
var $7p8hL = parcelRequire("7p8hL");
var $iGf0k = parcelRequire("iGf0k");
var $iJH3x = parcelRequire("iJH3x");

var $fB2fA = parcelRequire("fB2fA");

var $cmAk3 = parcelRequire("cmAk3");

var $kuS4l = parcelRequire("kuS4l");

var $7oVpT = parcelRequire("7oVpT");

var $4RP7L = parcelRequire("4RP7L");

var $bMwjP = parcelRequire("bMwjP");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $3e8a6b35cd55fe76$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $3e8a6b35cd55fe76$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $iJH3x.uuid4)();
        this._spanId = spanContext.spanId || (0, $iJH3x.uuid4)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $iGf0k.timestampInSeconds)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || 'sentry';
        this._attributes = {};
        this.setAttributes({
            [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanContext.origin || 'manual',
            [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || '';
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_OP];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_OP), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $4RP7L.TRACE_FLAG_SAMPLED) : (0, $4RP7L.TRACE_FLAG_NONE)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $3e8a6b35cd55fe76$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $7oVpT.getRootSpan)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $fB2fA.DEBUG_BUILD) && rootSpan) {
            const opStr = spanContext && spanContext.op || '< unknown op >';
            const nameStr = (0, $4RP7L.spanToJSON)(childSpan).description || '< unknown name >';
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $7p8hL.logger).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $bMwjP.setHttpStatus)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === 'ok';
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $7oVpT.getRootSpan)(this);
        if ((0, $fB2fA.DEBUG_BUILD) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $7p8hL.logger).log(logMessage.replace('Starting', 'Finishing'));
        }
        this._endTime = (0, $4RP7L.spanTimeInputToSeconds)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $4RP7L.spanToTraceHeader)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $aajbp.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $4RP7L.spanToTraceContext)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $aajbp.dropUndefinedKeys)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            _metrics_summary: (0, $cmAk3.getMetricSummaryJsonForSpan)(this),
            profile_id: this._attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}

});
parcelRegister("cmAk3", function(module, exports) {

$parcel$export(module.exports, "getMetricSummaryJsonForSpan", function () { return $9003b6fbb48e37a6$export$2e7205e45c58797d; });
$parcel$export(module.exports, "updateMetricSummaryOnActiveSpan", function () { return $9003b6fbb48e37a6$export$aefd1a302602f922; });

var $aajbp = parcelRequire("aajbp");




var $mtWu0 = parcelRequire("mtWu0");
/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $9003b6fbb48e37a6$var$SPAN_METRIC_SUMMARY;
function $9003b6fbb48e37a6$var$getMetricStorageForSpan(span) {
    return $9003b6fbb48e37a6$var$SPAN_METRIC_SUMMARY ? $9003b6fbb48e37a6$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $9003b6fbb48e37a6$export$2e7205e45c58797d(span) {
    const storage = $9003b6fbb48e37a6$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $aajbp.dropUndefinedKeys)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $9003b6fbb48e37a6$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $mtWu0.getActiveSpan)();
    if (span) {
        const storage = $9003b6fbb48e37a6$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$9003b6fbb48e37a6$var$SPAN_METRIC_SUMMARY) $9003b6fbb48e37a6$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $9003b6fbb48e37a6$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}

});
parcelRegister("mtWu0", function(module, exports) {

$parcel$export(module.exports, "trace", function () { return $04394819c9fca2e2$export$357889f174732d38; });
$parcel$export(module.exports, "startSpan", function () { return $04394819c9fca2e2$export$a1bd95187356f372; });
$parcel$export(module.exports, "startSpanManual", function () { return $04394819c9fca2e2$export$c10292ad04b92aea; });
$parcel$export(module.exports, "startInactiveSpan", function () { return $04394819c9fca2e2$export$63dbba021a6b4047; });
$parcel$export(module.exports, "getActiveSpan", function () { return $04394819c9fca2e2$export$1be426a8e585c83e; });
$parcel$export(module.exports, "continueTrace", function () { return $04394819c9fca2e2$export$d2ee9b39b25437b3; });
$parcel$export(module.exports, "getCapturedScopesOnSpan", function () { return $04394819c9fca2e2$export$c08fbc656a245d03; });

var $aajbp = parcelRequire("aajbp");
var $7p8hL = parcelRequire("7p8hL");
var $6jMr3 = parcelRequire("6jMr3");

var $fB2fA = parcelRequire("fB2fA");

var $fxUGN = parcelRequire("fxUGN");

var $4RP7L = parcelRequire("4RP7L");



var $2Grcj = parcelRequire("2Grcj");

var $hcepo = parcelRequire("hcepo");

var $beBC9 = parcelRequire("beBC9");

var $2aCxe = parcelRequire("2aCxe");
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $04394819c9fca2e2$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $fxUGN.getCurrentHub)();
    const scope = (0, $hcepo.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $04394819c9fca2e2$var$normalizeContext(context);
    const activeSpan = $04394819c9fca2e2$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $beBC9.handleCallbackErrors)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus('internal_error');
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $04394819c9fca2e2$export$a1bd95187356f372(context, callback) {
    const spanContext = $04394819c9fca2e2$var$normalizeContext(context);
    return (0, $fxUGN.runWithAsyncContext)(()=>{
        return (0, $hcepo.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $fxUGN.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $04394819c9fca2e2$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $beBC9.handleCallbackErrors)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $4RP7L.spanToJSON)(activeSpan);
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $04394819c9fca2e2$export$cb9e396e6b90b703 = $04394819c9fca2e2$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $04394819c9fca2e2$export$c10292ad04b92aea(context, callback) {
    const spanContext = $04394819c9fca2e2$var$normalizeContext(context);
    return (0, $fxUGN.runWithAsyncContext)(()=>{
        return (0, $hcepo.withScope)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $fxUGN.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $04394819c9fca2e2$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $beBC9.handleCallbackErrors)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $4RP7L.spanToJSON)(activeSpan);
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $04394819c9fca2e2$export$63dbba021a6b4047(context) {
    if (!(0, $2aCxe.hasTracingEnabled)()) return undefined;
    const spanContext = $04394819c9fca2e2$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $fxUGN.getCurrentHub)();
    const parentSpan = context.scope ? context.scope.getSpan() : $04394819c9fca2e2$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $hcepo.getCurrentScope)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $04394819c9fca2e2$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $04394819c9fca2e2$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $hcepo.getCurrentScope)().getSpan();
}
const $04394819c9fca2e2$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $hcepo.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $6jMr3.tracingContextFromHeaders)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $fB2fA.DEBUG_BUILD) && traceparentData) (0, $7p8hL.logger).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $aajbp.dropUndefinedKeys)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $fxUGN.runWithAsyncContext)(()=>{
        return callback(transactionContext);
    });
};
function $04394819c9fca2e2$var$createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $2aCxe.hasTracingEnabled)()) return undefined;
    const isolationScope = (0, $fxUGN.getIsolationScope)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $2Grcj.getDynamicSamplingContextFromSpan)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $4RP7L.spanIsSampled)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $04394819c9fca2e2$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $04394819c9fca2e2$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $4RP7L.spanTimeInputToSeconds)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $04394819c9fca2e2$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $04394819c9fca2e2$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
function $04394819c9fca2e2$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $aajbp.addNonEnumerableProperty)(span, $04394819c9fca2e2$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $aajbp.addNonEnumerableProperty)(span, $04394819c9fca2e2$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $04394819c9fca2e2$export$c08fbc656a245d03(span) {
    return {
        scope: span[$04394819c9fca2e2$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$04394819c9fca2e2$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});
parcelRegister("beBC9", function(module, exports) {

$parcel$export(module.exports, "handleCallbackErrors", function () { return $82de2df3e42e6522$export$18ce21a8b7efd7e9; });

var $jPeZ4 = parcelRequire("jPeZ4");
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $82de2df3e42e6522$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $82de2df3e42e6522$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $82de2df3e42e6522$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $jPeZ4.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}

});

parcelRegister("2aCxe", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", function () { return $194a682d594ef3a5$export$5008da00b1b6dee6; });

var $hcepo = parcelRequire("hcepo");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $194a682d594ef3a5$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const client = (0, $hcepo.getClient)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}

});



parcelRegister("kuS4l", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function () { return $eec08cf4a9d1f728$export$d7a7d984b0791405; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function () { return $eec08cf4a9d1f728$export$ccfe0a40627cc34b; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function () { return $eec08cf4a9d1f728$export$1a413bd9a88fdb09; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function () { return $eec08cf4a9d1f728$export$cca8dd30f57f805e; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function () { return $eec08cf4a9d1f728$export$1efec95406bbe327; });
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $eec08cf4a9d1f728$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $eec08cf4a9d1f728$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $eec08cf4a9d1f728$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $eec08cf4a9d1f728$export$cca8dd30f57f805e = 'sentry.origin';
/**
 * The id of the profile that this span occured in.
 */ const $eec08cf4a9d1f728$export$1efec95406bbe327 = 'profile_id';

});

parcelRegister("bMwjP", function(module, exports) {

$parcel$export(module.exports, "getSpanStatusFromHttpCode", function () { return $893d3f3f26c160d8$export$5fd4dc48a2131589; });
$parcel$export(module.exports, "spanStatusfromHttpCode", function () { return $893d3f3f26c160d8$export$ac65c70d78fcdb55; });
$parcel$export(module.exports, "setHttpStatus", function () { return $893d3f3f26c160d8$export$2ad6630ec8164254; });
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $893d3f3f26c160d8$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = 'ok';
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = 'deadline_exceeded';
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = 'unauthenticated';
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = 'permission_denied';
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = 'not_found';
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = 'resource_exhausted';
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = 'invalid_argument';
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = 'unimplemented';
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = 'unavailable';
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = 'internal_error';
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = 'unknown_error';
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = 'cancelled';
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = 'already_exists';
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = 'failed_precondition';
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = 'aborted';
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = 'out_of_range';
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = 'data_loss';
    SpanStatus["DataLoss"] = DataLoss;
})($893d3f3f26c160d8$export$beb8e6a823e89c5d || ($893d3f3f26c160d8$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $893d3f3f26c160d8$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return 'ok';
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission_denied';
        case 404:
            return 'not_found';
        case 409:
            return 'already_exists';
        case 413:
            return 'failed_precondition';
        case 429:
            return 'resource_exhausted';
        default:
            return 'invalid_argument';
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline_exceeded';
        default:
            return 'internal_error';
    }
    return 'unknown_error';
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $893d3f3f26c160d8$export$ac65c70d78fcdb55 = $893d3f3f26c160d8$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $893d3f3f26c160d8$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag('http.status_code', String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData('http.response.status_code', httpStatus);
    const spanStatus = $893d3f3f26c160d8$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== 'unknown_error') span.setStatus(spanStatus);
}

});


parcelRegister("dmE4i", function(module, exports) {

$parcel$export(module.exports, "Transaction", function () { return $9bac6924de9644f4$export$febc5573c75cefb0; });

var $aajbp = parcelRequire("aajbp");
var $7p8hL = parcelRequire("7p8hL");

var $fB2fA = parcelRequire("fB2fA");

var $fxUGN = parcelRequire("fxUGN");

var $cmAk3 = parcelRequire("cmAk3");

var $kuS4l = parcelRequire("kuS4l");

var $4RP7L = parcelRequire("4RP7L");

var $2Grcj = parcelRequire("2Grcj");

var $5mTXR = parcelRequire("5mTXR");

var $mtWu0 = parcelRequire("mtWu0");
/** JSDoc */ class $9bac6924de9644f4$export$febc5573c75cefb0 extends (0, $5mTXR.Span) {
    /**
   * The reference to the current hub.
   */ // eslint-disable-next-line deprecation/deprecation
    // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $fxUGN.getCurrentHub)();
        this._name = transactionContext.name || '';
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: 'custom',
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] && {
                source: this._attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]
            },
            ...this._attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] && {
                sampleRate: this._attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = 'custom') {
        this._name = name;
        this.setAttribute((0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $5mTXR.SpanRecorder)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = '') {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $4RP7L.spanTimeInputToSeconds)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $aajbp.dropUndefinedKeys)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || '';
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $2Grcj.getDynamicSamplingContextFromSpan)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
    setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts['profile'] !== undefined) return this._contexts['profile'].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit('finishTransaction', this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            if (client) client.recordDroppedEvent('sample_rate', 'transaction');
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $4RP7L.spanToJSON)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $4RP7L.spanToJSON)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $mtWu0.getCapturedScopesOnSpan)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $4RP7L.spanToTraceContext)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $aajbp.dropUndefinedKeys)({
                    dynamicSamplingContext: (0, $2Grcj.getDynamicSamplingContextFromSpan)(this)
                })
            },
            _metrics_summary: (0, $cmAk3.getMetricSummaryJsonForSpan)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}

});


parcelRegister("g05qq", function(module, exports) {

$parcel$export(module.exports, "sampleTransaction", function () { return $ba60dac5bdaeb625$export$b3258c3993bc9b71; });
$parcel$export(module.exports, "isValidSampleRate", function () { return $ba60dac5bdaeb625$export$2603c8d332a51c42; });

var $jPeZ4 = parcelRequire("jPeZ4");
var $7p8hL = parcelRequire("7p8hL");

var $fB2fA = parcelRequire("fB2fA");

var $kuS4l = parcelRequire("kuS4l");

var $2aCxe = parcelRequire("2aCxe");

var $4RP7L = parcelRequire("4RP7L");
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $ba60dac5bdaeb625$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $2aCxe.hasTracingEnabled)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$ba60dac5bdaeb625$export$2603c8d332a51c42(sampleRate)) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn('[Tracing] Discarding transaction because of invalid sample rate.');
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $fB2fA.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
    (0, $7p8hL.logger).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $4RP7L.spanToJSON)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $ba60dac5bdaeb625$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $jPeZ4.isNaN)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}

});


parcelRegister("kcgw9", function(module, exports) {

$parcel$export(module.exports, "createTransport", function () { return $eb41bdb1959aeb17$export$d09f50d9ab7f7b69; });

var $2pR2a = parcelRequire("2pR2a");
var $3iBML = parcelRequire("3iBML");
var $7p8hL = parcelRequire("7p8hL");
var $5JTUi = parcelRequire("5JTUi");
var $amxcu = parcelRequire("amxcu");
var $1BeOm = parcelRequire("1BeOm");

var $fB2fA = parcelRequire("fB2fA");
const $eb41bdb1959aeb17$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $eb41bdb1959aeb17$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $5JTUi.makePromiseBuffer)(options.bufferSize || $eb41bdb1959aeb17$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $2pR2a.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $2pR2a.envelopeItemTypeToDataCategory)(type);
            if ((0, $3iBML.isRateLimited)(rateLimits, dataCategory)) {
                const event = $eb41bdb1959aeb17$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $amxcu.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $2pR2a.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $2pR2a.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                const event = $eb41bdb1959aeb17$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $2pR2a.envelopeItemTypeToDataCategory)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $2pR2a.serializeEnvelope)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $3iBML.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $1BeOm.SentryError)) {
                (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $amxcu.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $eb41bdb1959aeb17$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}

});
parcelRegister("3iBML", function(module, exports) {

$parcel$export(module.exports, "parseRetryAfterHeader", function () { return $26705cf24c573ca3$export$615352e17ed7741; });
$parcel$export(module.exports, "isRateLimited", function () { return $26705cf24c573ca3$export$6c91fec22056810a; });
$parcel$export(module.exports, "updateRateLimits", function () { return $26705cf24c573ca3$export$699aff705e0d49d4; });
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $26705cf24c573ca3$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $26705cf24c573ca3$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $26705cf24c573ca3$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $26705cf24c573ca3$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $26705cf24c573ca3$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $26705cf24c573ca3$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $26705cf24c573ca3$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $26705cf24c573ca3$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});

parcelRegister("5JTUi", function(module, exports) {

$parcel$export(module.exports, "makePromiseBuffer", function () { return $42dc85ac8fbeb3b6$export$85a4f67f852183e6; });

var $1BeOm = parcelRequire("1BeOm");

var $amxcu = parcelRequire("amxcu");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $42dc85ac8fbeb3b6$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $amxcu.rejectedSyncPromise)(new (0, $1BeOm.SentryError)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $amxcu.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $amxcu.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});


parcelRegister("5Bu1f", function(module, exports) {

$parcel$export(module.exports, "functionToStringIntegration", function () { return $4147b1a48574d3e2$export$7918117e9202e4fb; });
$parcel$export(module.exports, "FunctionToString", function () { return $4147b1a48574d3e2$export$da4704525c20ae79; });

var $aajbp = parcelRequire("aajbp");

var $hcepo = parcelRequire("hcepo");

var $genhe = parcelRequire("genhe");
let $4147b1a48574d3e2$var$originalFunctionToString;
const $4147b1a48574d3e2$var$INTEGRATION_NAME = 'FunctionToString';
const $4147b1a48574d3e2$var$SETUP_CLIENTS = new WeakMap();
const $4147b1a48574d3e2$var$_functionToStringIntegration = ()=>{
    return {
        name: $4147b1a48574d3e2$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $4147b1a48574d3e2$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $aajbp.getOriginalFunction)(this);
                    const context = $4147b1a48574d3e2$var$SETUP_CLIENTS.has((0, $hcepo.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $4147b1a48574d3e2$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $4147b1a48574d3e2$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $4147b1a48574d3e2$export$7918117e9202e4fb = (0, $genhe.defineIntegration)($4147b1a48574d3e2$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $4147b1a48574d3e2$export$da4704525c20ae79 = (0, $genhe.convertIntegrationFnToClass)($4147b1a48574d3e2$var$INTEGRATION_NAME, $4147b1a48574d3e2$export$7918117e9202e4fb);

});

parcelRegister("cCK0h", function(module, exports) {

$parcel$export(module.exports, "inboundFiltersIntegration", function () { return $930cb7fdff5cd696$export$cb3c5c2ceb9818ba; });
$parcel$export(module.exports, "InboundFilters", function () { return $930cb7fdff5cd696$export$2ffbb5359dcc6be4; });

var $iJH3x = parcelRequire("iJH3x");
var $7p8hL = parcelRequire("7p8hL");
var $bMiqE = parcelRequire("bMiqE");

var $fB2fA = parcelRequire("fB2fA");

var $genhe = parcelRequire("genhe");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $930cb7fdff5cd696$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $930cb7fdff5cd696$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $930cb7fdff5cd696$var$INTEGRATION_NAME = 'InboundFilters';
const $930cb7fdff5cd696$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $930cb7fdff5cd696$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $930cb7fdff5cd696$var$_mergeOptions(options, clientOptions);
            return $930cb7fdff5cd696$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $930cb7fdff5cd696$export$cb3c5c2ceb9818ba = (0, $genhe.defineIntegration)($930cb7fdff5cd696$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $930cb7fdff5cd696$export$2ffbb5359dcc6be4 = (0, $genhe.convertIntegrationFnToClass)($930cb7fdff5cd696$var$INTEGRATION_NAME, $930cb7fdff5cd696$export$cb3c5c2ceb9818ba);
function $930cb7fdff5cd696$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $930cb7fdff5cd696$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $930cb7fdff5cd696$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $930cb7fdff5cd696$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $930cb7fdff5cd696$var$_isSentryError(event)) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $iJH3x.getEventDescription)(event)}`);
        return true;
    }
    if ($930cb7fdff5cd696$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $iJH3x.getEventDescription)(event)}`);
        return true;
    }
    if ($930cb7fdff5cd696$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $iJH3x.getEventDescription)(event)}`);
        return true;
    }
    if ($930cb7fdff5cd696$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $iJH3x.getEventDescription)(event)}.\nUrl: ${$930cb7fdff5cd696$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$930cb7fdff5cd696$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $iJH3x.getEventDescription)(event)}.\nUrl: ${$930cb7fdff5cd696$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $930cb7fdff5cd696$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $930cb7fdff5cd696$var$_getPossibleEventMessages(event).some((message)=>(0, $bMiqE.stringMatchesSomePattern)(message, ignoreErrors));
}
function $930cb7fdff5cd696$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $bMiqE.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $930cb7fdff5cd696$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $930cb7fdff5cd696$var$_getEventFilterUrl(event);
    return !url ? false : (0, $bMiqE.stringMatchesSomePattern)(url, denyUrls);
}
function $930cb7fdff5cd696$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $930cb7fdff5cd696$var$_getEventFilterUrl(event);
    return !url ? true : (0, $bMiqE.stringMatchesSomePattern)(url, allowUrls);
}
function $930cb7fdff5cd696$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $fB2fA.DEBUG_BUILD) && possibleMessages.length === 0) (0, $7p8hL.logger).error(`Could not extract message for event ${(0, $iJH3x.getEventDescription)(event)}`);
    return possibleMessages;
}
function $930cb7fdff5cd696$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $930cb7fdff5cd696$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $930cb7fdff5cd696$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $930cb7fdff5cd696$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $fB2fA.DEBUG_BUILD) && (0, $7p8hL.logger).error(`Cannot extract url for event ${(0, $iJH3x.getEventDescription)(event)}`);
        return null;
    }
}

});

parcelRegister("g6vjT", function(module, exports) {

$parcel$export(module.exports, "setMeasurement", function () { return $bb9580602b83b405$export$7cc31b475d33a706; });

var $7flMU = parcelRequire("7flMU");
/**
 * Adds a measurement to the current active transaction.
 */ function $bb9580602b83b405$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $7flMU.getActiveTransaction)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}

});

parcelRegister("dKXuR", function(module, exports) {

$parcel$export(module.exports, "initAndBind", function () { return $a03db910823c75f8$export$5333c3f1c58d9bc1; });
$parcel$export(module.exports, "setCurrentClient", function () { return $a03db910823c75f8$export$ecb76f41d43c0e43; });

var $7p8hL = parcelRequire("7p8hL");

var $fB2fA = parcelRequire("fB2fA");

var $hcepo = parcelRequire("hcepo");

var $fxUGN = parcelRequire("fxUGN");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $a03db910823c75f8$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $fB2fA.DEBUG_BUILD) (0, $7p8hL.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $7p8hL.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $hcepo.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $a03db910823c75f8$export$ecb76f41d43c0e43(client);
    $a03db910823c75f8$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $a03db910823c75f8$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $fxUGN.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $a03db910823c75f8$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}

});

parcelRegister("3U98K", function(module, exports) {

$parcel$export(module.exports, "createSpanEnvelope", function () { return $2d7db119720b7a5c$export$19a0081d4b39d77; });

var $2pR2a = parcelRequire("2pR2a");
var $i8Xwi = parcelRequire("i8Xwi");
/**
 * Create envelope from Span item.
 */ function $2d7db119720b7a5c$export$19a0081d4b39d77(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $i8Xwi.dsnToString)(dsn);
    const items = spans.map($2d7db119720b7a5c$var$createSpanItem);
    return (0, $2pR2a.createEnvelope)(headers, items);
}
function $2d7db119720b7a5c$var$createSpanItem(span) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        span
    ];
}

});

parcelRegister("djmte", function(module, exports) {

$parcel$export(module.exports, "isSentryRequestUrl", function () { return $9b0e7ae41199fe5a$export$d92e61f5600202af; });
/**
 * Checks whether given url points to Sentry server
 * @param url url to verify
 *
 * TODO(v8): Remove Hub fallback type
 */ // eslint-disable-next-line deprecation/deprecation
function $9b0e7ae41199fe5a$export$d92e61f5600202af(url, hubOrClient) {
    const client = hubOrClient && $9b0e7ae41199fe5a$var$isHub(hubOrClient) ? hubOrClient.getClient() : hubOrClient;
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return $9b0e7ae41199fe5a$var$checkDsn(url, dsn) || $9b0e7ae41199fe5a$var$checkTunnel(url, tunnel);
}
function $9b0e7ae41199fe5a$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $9b0e7ae41199fe5a$var$removeTrailingSlash(url) === $9b0e7ae41199fe5a$var$removeTrailingSlash(tunnel);
}
function $9b0e7ae41199fe5a$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $9b0e7ae41199fe5a$var$removeTrailingSlash(str) {
    return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}
// eslint-disable-next-line deprecation/deprecation
function $9b0e7ae41199fe5a$var$isHub(hubOrClient) {
    // eslint-disable-next-line deprecation/deprecation
    return hubOrClient.getClient !== undefined;
}

});

parcelRegister("5M0hM", function(module, exports) {

$parcel$export(module.exports, "applySdkMetadata", function () { return $4341a82d22959d45$export$b9f95b027256052c; });

var $fIs9O = parcelRequire("fIs9O");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $4341a82d22959d45$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $fIs9O.SDK_VERSION)
            })),
        version: (0, $fIs9O.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRegister("2pzm3", function(module, exports) {

$parcel$export(module.exports, "applyAggregateErrorsToEvent", function () { return $1c19574953c1d061$export$b91c38ed7d8ae9b2; });

var $jPeZ4 = parcelRequire("jPeZ4");

var $bMiqE = parcelRequire("bMiqE");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $1c19574953c1d061$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $jPeZ4.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $1c19574953c1d061$var$truncateAggregateExceptions($1c19574953c1d061$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $1c19574953c1d061$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $jPeZ4.isInstanceOf)(error[key], Error)) {
        $1c19574953c1d061$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $1c19574953c1d061$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $1c19574953c1d061$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $jPeZ4.isInstanceOf)(childError, Error)) {
            $1c19574953c1d061$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $1c19574953c1d061$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $1c19574953c1d061$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $1c19574953c1d061$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $1c19574953c1d061$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $1c19574953c1d061$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $bMiqE.truncate)(exception.value, maxValueLength);
        return exception;
    });
}

});

parcelRegister("d9NWo", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $9942dad0ef640f5d$export$56d8a8a25bd48b81; });
$parcel$export(module.exports, "shouldIgnoreOnError", function () { return $9942dad0ef640f5d$export$b79738ab10c590b2; });
$parcel$export(module.exports, "wrap", function () { return $9942dad0ef640f5d$export$4997ffc0176396a6; });


var $hcepo = parcelRequire("hcepo");

var $iJH3x = parcelRequire("iJH3x");
var $aajbp = parcelRequire("aajbp");
var $lNVQ9 = parcelRequire("lNVQ9");
const $9942dad0ef640f5d$export$56d8a8a25bd48b81 = (0, $lNVQ9.GLOBAL_OBJ);
let $9942dad0ef640f5d$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $9942dad0ef640f5d$export$b79738ab10c590b2() {
    return $9942dad0ef640f5d$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $9942dad0ef640f5d$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $9942dad0ef640f5d$var$ignoreOnError++;
    setTimeout(()=>{
        $9942dad0ef640f5d$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $9942dad0ef640f5d$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $aajbp.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$9942dad0ef640f5d$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $9942dad0ef640f5d$export$1265a142ff5ba165();
            (0, $hcepo.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $iJH3x.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $iJH3x.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $hcepo.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $aajbp.markFunctionWrapped)(sentryWrapped, fn);
    (0, $aajbp.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}

});

parcelRegister("lCly9", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", function () { return $fbcddcf0484b7dc1$export$1df9218a526d318d; });

var $5M0hM = parcelRequire("5M0hM");
var $huK8b = parcelRequire("huK8b");

var $jf1xd = parcelRequire("jf1xd");
var $i8Xwi = parcelRequire("i8Xwi");
var $f2UY0 = parcelRequire("f2UY0");
var $7p8hL = parcelRequire("7p8hL");

var $e2xQm = parcelRequire("e2xQm");

var $4JUzU = parcelRequire("4JUzU");

var $d9NWo = parcelRequire("d9NWo");

var $C3Qws = parcelRequire("C3Qws");
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $fbcddcf0484b7dc1$export$1df9218a526d318d extends (0, $huK8b.BaseClient) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $d9NWo.WINDOW).SENTRY_SDK_SOURCE || (0, $f2UY0.getSDKSource)();
        (0, $5M0hM.applySdkMetadata)(options, 'browser', [
            'browser'
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $d9NWo.WINDOW).document) (0, $d9NWo.WINDOW).document.addEventListener('visibilitychange', ()=>{
            if ((0, $d9NWo.WINDOW).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $4JUzU.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = 'info', hint) {
        return (0, $4JUzU.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $C3Qws.createUserFeedbackEnvelope)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).log('Sending outcomes:', outcomes);
        const envelope = (0, $jf1xd.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $i8Xwi.dsnToString)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}

});
parcelRegister("jf1xd", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", function () { return $e0209bd3c4210a90$export$f3b9ed77c03eeb00; });

var $2pR2a = parcelRequire("2pR2a");

var $iGf0k = parcelRequire("iGf0k");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $e0209bd3c4210a90$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $iGf0k.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $2pR2a.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("f2UY0", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $af433b59a7df7d87$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $af433b59a7df7d87$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $af433b59a7df7d87$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $af433b59a7df7d87$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRegister("e2xQm", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $a38b8136690a07eb$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $a38b8136690a07eb$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("4JUzU", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", function () { return $373740a2b504e6a7$export$a6c2d27607295951; });
$parcel$export(module.exports, "eventFromException", function () { return $373740a2b504e6a7$export$ea3ec7e569b823fc; });
$parcel$export(module.exports, "eventFromUnknownInput", function () { return $373740a2b504e6a7$export$9dd56ed1ef0c3420; });
$parcel$export(module.exports, "eventFromMessage", function () { return $373740a2b504e6a7$export$5425b53185d13d6c; });

var $hcepo = parcelRequire("hcepo");

var $iJH3x = parcelRequire("iJH3x");
var $aajbp = parcelRequire("aajbp");
var $jPeZ4 = parcelRequire("jPeZ4");
var $5vnYi = parcelRequire("5vnYi");
var $amxcu = parcelRequire("amxcu");
/**
 * This function creates an exception from a JavaScript Error
 */ function $373740a2b504e6a7$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $373740a2b504e6a7$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $373740a2b504e6a7$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
/**
 * @hidden
 */ function $373740a2b504e6a7$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $hcepo.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $jPeZ4.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $373740a2b504e6a7$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $5vnYi.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $373740a2b504e6a7$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $373740a2b504e6a7$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $373740a2b504e6a7$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $373740a2b504e6a7$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const popSize = $373740a2b504e6a7$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $373740a2b504e6a7$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $373740a2b504e6a7$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($373740a2b504e6a7$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $373740a2b504e6a7$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $373740a2b504e6a7$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $373740a2b504e6a7$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $iJH3x.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $amxcu.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $373740a2b504e6a7$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $373740a2b504e6a7$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $amxcu.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $373740a2b504e6a7$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $jPeZ4.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $373740a2b504e6a7$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $jPeZ4.isDOMError)(exception) || (0, $jPeZ4.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $373740a2b504e6a7$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $jPeZ4.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $373740a2b504e6a7$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $iJH3x.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $jPeZ4.isError)(exception)) // we have a real Error object, do nothing
    return $373740a2b504e6a7$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $jPeZ4.isPlainObject)(exception) || (0, $jPeZ4.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $373740a2b504e6a7$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $iJH3x.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $373740a2b504e6a7$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $iJH3x.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $iJH3x.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $373740a2b504e6a7$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $373740a2b504e6a7$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $jPeZ4.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $373740a2b504e6a7$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $aajbp.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $jPeZ4.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $jPeZ4.isEvent)(exception)) {
        const className = $373740a2b504e6a7$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $373740a2b504e6a7$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}

});

parcelRegister("C3Qws", function(module, exports) {

$parcel$export(module.exports, "createUserFeedbackEnvelope", function () { return $0726887ccb9f8c5b$export$24a4dfcb686ee5bf; });

var $2pR2a = parcelRequire("2pR2a");
var $i8Xwi = parcelRequire("i8Xwi");
/**
 * Creates an envelope from a user feedback.
 */ function $0726887ccb9f8c5b$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $i8Xwi.dsnToString)(dsn)
        }
    };
    const item = $0726887ccb9f8c5b$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $2pR2a.createEnvelope)(headers, [
        item
    ]);
}
function $0726887ccb9f8c5b$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}

});


parcelRegister("2dhpd", function(module, exports) {

$parcel$export(module.exports, "makeFetchTransport", function () { return $19ca4c0e6dec818d$export$b2311068c46d7cc8; });

var $kcgw9 = parcelRequire("kcgw9");

var $amxcu = parcelRequire("amxcu");

var $3kGHd = parcelRequire("3kGHd");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $19ca4c0e6dec818d$export$b2311068c46d7cc8(options, nativeFetch = (0, $3kGHd.getNativeFetchImplementation)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $3kGHd.clearCachedFetchImplementation)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $amxcu.rejectedSyncPromise)(e);
        }
    }
    return (0, $kcgw9.createTransport)(options, makeRequest);
}

});
parcelRegister("3kGHd", function(module, exports) {

$parcel$export(module.exports, "getNativeFetchImplementation", function () { return $26d45be3ebe158ef$export$8be2119ce08e3379; });
$parcel$export(module.exports, "clearCachedFetchImplementation", function () { return $26d45be3ebe158ef$export$d499686d2dd738c6; });

var $37Ut6 = parcelRequire("37Ut6");
var $7p8hL = parcelRequire("7p8hL");

var $e2xQm = parcelRequire("e2xQm");

var $d9NWo = parcelRequire("d9NWo");
let $26d45be3ebe158ef$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $26d45be3ebe158ef$export$8be2119ce08e3379() {
    if ($26d45be3ebe158ef$var$cachedFetchImpl) return $26d45be3ebe158ef$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $37Ut6.isNativeFetch)((0, $d9NWo.WINDOW).fetch)) return $26d45be3ebe158ef$var$cachedFetchImpl = (0, $d9NWo.WINDOW).fetch.bind((0, $d9NWo.WINDOW));
    const document = (0, $d9NWo.WINDOW).document;
    let fetchImpl = (0, $d9NWo.WINDOW).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $26d45be3ebe158ef$var$cachedFetchImpl = fetchImpl.bind((0, $d9NWo.WINDOW));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $26d45be3ebe158ef$export$d499686d2dd738c6() {
    $26d45be3ebe158ef$var$cachedFetchImpl = undefined;
}

});
parcelRegister("37Ut6", function(module, exports) {

$parcel$export(module.exports, "supportsFetch", function () { return $246dd40315c38dfa$export$edf3cb81fd7d2a3e; });
$parcel$export(module.exports, "isNativeFetch", function () { return $246dd40315c38dfa$export$18cf36ed71d733e7; });
$parcel$export(module.exports, "supportsNativeFetch", function () { return $246dd40315c38dfa$export$c82d238e23c40b21; });
$parcel$export(module.exports, "supportsReportingObserver", function () { return $246dd40315c38dfa$export$531055a6c684a70a; });

var $aY8mH = parcelRequire("aY8mH");

var $7p8hL = parcelRequire("7p8hL");

var $lNVQ9 = parcelRequire("lNVQ9");
// eslint-disable-next-line deprecation/deprecation
const $246dd40315c38dfa$var$WINDOW = (0, $lNVQ9.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $246dd40315c38dfa$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $246dd40315c38dfa$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $246dd40315c38dfa$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $246dd40315c38dfa$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $246dd40315c38dfa$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $246dd40315c38dfa$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $246dd40315c38dfa$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$246dd40315c38dfa$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($246dd40315c38dfa$export$18cf36ed71d733e7($246dd40315c38dfa$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $246dd40315c38dfa$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $246dd40315c38dfa$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $aY8mH.DEBUG_BUILD) && (0, $7p8hL.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $246dd40315c38dfa$export$531055a6c684a70a() {
    return 'ReportingObserver' in $246dd40315c38dfa$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $246dd40315c38dfa$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$246dd40315c38dfa$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}

});



parcelRegister("cqNDo", function(module, exports) {

$parcel$export(module.exports, "makeXHRTransport", function () { return $90ce6a199ec29c5e$export$5e1441cee30d5a39; });

var $kcgw9 = parcelRequire("kcgw9");

var $amxcu = parcelRequire("amxcu");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $90ce6a199ec29c5e$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $90ce6a199ec29c5e$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $amxcu.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $90ce6a199ec29c5e$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $kcgw9.createTransport)(options, makeRequest);
}

});

parcelRegister("jkCYa", function(module, exports) {

$parcel$export(module.exports, "chromeStackLineParser", function () { return $e12e1d1a91689b2d$export$263a749fff749872; });
$parcel$export(module.exports, "geckoStackLineParser", function () { return $e12e1d1a91689b2d$export$cdba47a5dd2804d; });
$parcel$export(module.exports, "winjsStackLineParser", function () { return $e12e1d1a91689b2d$export$179460296da408e8; });
$parcel$export(module.exports, "opera10StackLineParser", function () { return $e12e1d1a91689b2d$export$f892b52c880ffc7a; });
$parcel$export(module.exports, "opera11StackLineParser", function () { return $e12e1d1a91689b2d$export$af11af13f09fb0dc; });
$parcel$export(module.exports, "defaultStackLineParsers", function () { return $e12e1d1a91689b2d$export$7197c0fe6554c079; });
$parcel$export(module.exports, "defaultStackParser", function () { return $e12e1d1a91689b2d$export$2b2b997d81bf3907; });

var $kEJYx = parcelRequire("kEJYx");
// global reference to slice
const $e12e1d1a91689b2d$var$UNKNOWN_FUNCTION = '?';
const $e12e1d1a91689b2d$var$OPERA10_PRIORITY = 10;
const $e12e1d1a91689b2d$var$OPERA11_PRIORITY = 20;
const $e12e1d1a91689b2d$var$CHROME_PRIORITY = 30;
const $e12e1d1a91689b2d$var$WINJS_PRIORITY = 40;
const $e12e1d1a91689b2d$var$GECKO_PRIORITY = 50;
function $e12e1d1a91689b2d$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $e12e1d1a91689b2d$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $e12e1d1a91689b2d$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $e12e1d1a91689b2d$var$chromeStackParserFn = (line)=>{
    const parts = $e12e1d1a91689b2d$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $e12e1d1a91689b2d$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $e12e1d1a91689b2d$var$extractSafariExtensionDetails(parts[1] || $e12e1d1a91689b2d$var$UNKNOWN_FUNCTION, parts[2]);
        return $e12e1d1a91689b2d$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $e12e1d1a91689b2d$export$263a749fff749872 = [
    $e12e1d1a91689b2d$var$CHROME_PRIORITY,
    $e12e1d1a91689b2d$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $e12e1d1a91689b2d$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $e12e1d1a91689b2d$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $e12e1d1a91689b2d$var$gecko = (line)=>{
    const parts = $e12e1d1a91689b2d$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $e12e1d1a91689b2d$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $e12e1d1a91689b2d$var$UNKNOWN_FUNCTION;
        [func, filename] = $e12e1d1a91689b2d$var$extractSafariExtensionDetails(func, filename);
        return $e12e1d1a91689b2d$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $e12e1d1a91689b2d$export$cdba47a5dd2804d = [
    $e12e1d1a91689b2d$var$GECKO_PRIORITY,
    $e12e1d1a91689b2d$var$gecko
];
const $e12e1d1a91689b2d$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $e12e1d1a91689b2d$var$winjs = (line)=>{
    const parts = $e12e1d1a91689b2d$var$winjsRegex.exec(line);
    return parts ? $e12e1d1a91689b2d$var$createFrame(parts[2], parts[1] || $e12e1d1a91689b2d$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $e12e1d1a91689b2d$export$179460296da408e8 = [
    $e12e1d1a91689b2d$var$WINJS_PRIORITY,
    $e12e1d1a91689b2d$var$winjs
];
const $e12e1d1a91689b2d$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $e12e1d1a91689b2d$var$opera10 = (line)=>{
    const parts = $e12e1d1a91689b2d$var$opera10Regex.exec(line);
    return parts ? $e12e1d1a91689b2d$var$createFrame(parts[2], parts[3] || $e12e1d1a91689b2d$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $e12e1d1a91689b2d$export$f892b52c880ffc7a = [
    $e12e1d1a91689b2d$var$OPERA10_PRIORITY,
    $e12e1d1a91689b2d$var$opera10
];
const $e12e1d1a91689b2d$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $e12e1d1a91689b2d$var$opera11 = (line)=>{
    const parts = $e12e1d1a91689b2d$var$opera11Regex.exec(line);
    return parts ? $e12e1d1a91689b2d$var$createFrame(parts[5], parts[3] || parts[4] || $e12e1d1a91689b2d$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $e12e1d1a91689b2d$export$af11af13f09fb0dc = [
    $e12e1d1a91689b2d$var$OPERA11_PRIORITY,
    $e12e1d1a91689b2d$var$opera11
];
const $e12e1d1a91689b2d$export$7197c0fe6554c079 = [
    $e12e1d1a91689b2d$export$263a749fff749872,
    $e12e1d1a91689b2d$export$cdba47a5dd2804d,
    $e12e1d1a91689b2d$export$179460296da408e8
];
const $e12e1d1a91689b2d$export$2b2b997d81bf3907 = (0, $kEJYx.createStackParser)(...$e12e1d1a91689b2d$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $e12e1d1a91689b2d$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $e12e1d1a91689b2d$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("cet0p", function(module, exports) {

$parcel$export(module.exports, "defaultIntegrations", function () { return $8e7d4ac45300dbf7$export$5ef831fccfce35e5; });
$parcel$export(module.exports, "getDefaultIntegrations", function () { return $8e7d4ac45300dbf7$export$5783b2920b1d62b9; });
$parcel$export(module.exports, "init", function () { return $8e7d4ac45300dbf7$export$2cd8252107eb640b; });
$parcel$export(module.exports, "showReportDialog", function () { return $8e7d4ac45300dbf7$export$3a8fd680da42627b; });
$parcel$export(module.exports, "forceLoad", function () { return $8e7d4ac45300dbf7$export$a3f323d81eede727; });
$parcel$export(module.exports, "onLoad", function () { return $8e7d4ac45300dbf7$export$4e4d8b287d028b6b; });
$parcel$export(module.exports, "wrap", function () { return $8e7d4ac45300dbf7$export$4997ffc0176396a6; });
$parcel$export(module.exports, "captureUserFeedback", function () { return $8e7d4ac45300dbf7$export$88cefaf72d1e58a3; });

var $hcepo = parcelRequire("hcepo");
var $5Bu1f = parcelRequire("5Bu1f");
var $fxUGN = parcelRequire("fxUGN");
var $genhe = parcelRequire("genhe");
var $eua5O = parcelRequire("eua5O");
var $cCK0h = parcelRequire("cCK0h");
var $dKXuR = parcelRequire("dKXuR");

var $hFlB3 = parcelRequire("hFlB3");
var $7p8hL = parcelRequire("7p8hL");
var $kEJYx = parcelRequire("kEJYx");
var $37Ut6 = parcelRequire("37Ut6");

var $lCly9 = parcelRequire("lCly9");

var $e2xQm = parcelRequire("e2xQm");

var $d9NWo = parcelRequire("d9NWo");

var $53mM0 = parcelRequire("53mM0");

var $gxQnK = parcelRequire("gxQnK");

var $i26WM = parcelRequire("i26WM");

var $39bVV = parcelRequire("39bVV");

var $gb6W3 = parcelRequire("gb6W3");

var $aLmV4 = parcelRequire("aLmV4");

var $jkCYa = parcelRequire("jkCYa");

var $2dhpd = parcelRequire("2dhpd");

var $cqNDo = parcelRequire("cqNDo");
/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $8e7d4ac45300dbf7$export$5ef831fccfce35e5 = [
    (0, $cCK0h.inboundFiltersIntegration)(),
    (0, $5Bu1f.functionToStringIntegration)(),
    (0, $aLmV4.browserApiErrorsIntegration)(),
    (0, $53mM0.breadcrumbsIntegration)(),
    (0, $i26WM.globalHandlersIntegration)(),
    (0, $gb6W3.linkedErrorsIntegration)(),
    (0, $gxQnK.dedupeIntegration)(),
    (0, $39bVV.httpContextIntegration)()
];
/** Get the default integrations for the browser SDK. */ function $8e7d4ac45300dbf7$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$8e7d4ac45300dbf7$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $8e7d4ac45300dbf7$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $8e7d4ac45300dbf7$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $d9NWo.WINDOW).SENTRY_RELEASE && (0, $d9NWo.WINDOW).SENTRY_RELEASE.id) options.release = (0, $d9NWo.WINDOW).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $kEJYx.stackParserFromStackParserOptions)(options.stackParser || (0, $jkCYa.defaultStackParser)),
        integrations: (0, $genhe.getIntegrationsToSetup)(options),
        transport: options.transport || ((0, $37Ut6.supportsFetch)() ? (0, $2dhpd.makeFetchTransport) : (0, $cqNDo.makeXHRTransport))
    };
    (0, $dKXuR.initAndBind)((0, $lCly9.BrowserClient), clientOptions);
    if (options.autoSessionTracking) $8e7d4ac45300dbf7$var$startSessionTracking();
}
const $8e7d4ac45300dbf7$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $fxUGN.getCurrentHub)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $d9NWo.WINDOW).document) {
        (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).error('Global document not defined in showReportDialog call');
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $d9NWo.WINDOW).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $eua5O.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $d9NWo.WINDOW).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $d9NWo.WINDOW).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $d9NWo.WINDOW).document.head || (0, $d9NWo.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).error('Not injecting report dialog. No injection point found in HTML');
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $8e7d4ac45300dbf7$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $8e7d4ac45300dbf7$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8e7d4ac45300dbf7$export$4997ffc0176396a6(fn) {
    return (0, $d9NWo.wrap)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $8e7d4ac45300dbf7$var$startSessionTracking() {
    if (typeof (0, $d9NWo.WINDOW).document === 'undefined') {
        (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $hcepo.startSession)({
        ignoreDuration: true
    });
    (0, $hcepo.captureSession)();
    // We want to create a session for every navigation as well
    (0, $hFlB3.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $hcepo.startSession)({
                ignoreDuration: true
            });
            (0, $hcepo.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $8e7d4ac45300dbf7$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $hcepo.getClient)();
    if (client) client.captureUserFeedback(feedback);
}

});
parcelRegister("hFlB3", function(module, exports) {

$parcel$export(module.exports, "addHistoryInstrumentationHandler", function () { return $cdc704aaa9377f16$export$3f18c56c58114e75; });

var $aajbp = parcelRequire("aajbp");



var $lNVQ9 = parcelRequire("lNVQ9");

var $3iOb8 = parcelRequire("3iOb8");

var $7P0P8 = parcelRequire("7P0P8");
const $cdc704aaa9377f16$var$WINDOW = (0, $lNVQ9.GLOBAL_OBJ);
let $cdc704aaa9377f16$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $cdc704aaa9377f16$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $7P0P8.addHandler)(type, handler);
    (0, $7P0P8.maybeInstrument)(type, $cdc704aaa9377f16$var$instrumentHistory);
}
function $cdc704aaa9377f16$var$instrumentHistory() {
    if (!(0, $3iOb8.supportsHistory)()) return;
    const oldOnPopState = $cdc704aaa9377f16$var$WINDOW.onpopstate;
    $cdc704aaa9377f16$var$WINDOW.onpopstate = function(...args) {
        const to = $cdc704aaa9377f16$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $cdc704aaa9377f16$var$lastHref;
        $cdc704aaa9377f16$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $7P0P8.triggerHandlers)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $cdc704aaa9377f16$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $cdc704aaa9377f16$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $7P0P8.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $aajbp.fill)($cdc704aaa9377f16$var$WINDOW.history, 'pushState', historyReplacementFunction);
    (0, $aajbp.fill)($cdc704aaa9377f16$var$WINDOW.history, 'replaceState', historyReplacementFunction);
}

});
parcelRegister("3iOb8", function(module, exports) {

$parcel$export(module.exports, "supportsHistory", function () { return $2679f9f0423ee05b$export$67fc34576016d6ec; });

var $lNVQ9 = parcelRequire("lNVQ9");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $2679f9f0423ee05b$var$WINDOW = (0, $lNVQ9.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $2679f9f0423ee05b$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $2679f9f0423ee05b$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = 'history' in $2679f9f0423ee05b$var$WINDOW && !!$2679f9f0423ee05b$var$WINDOW.history.pushState && !!$2679f9f0423ee05b$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("53mM0", function(module, exports) {

$parcel$export(module.exports, "breadcrumbsIntegration", function () { return $3adee5e1618f5578$export$c079d904b326663a; });
$parcel$export(module.exports, "Breadcrumbs", function () { return $3adee5e1618f5578$export$2dc68d50d56fbbd; });

var $hcepo = parcelRequire("hcepo");
var $genhe = parcelRequire("genhe");

var $lemS8 = parcelRequire("lemS8");
var $8EmCv = parcelRequire("8EmCv");
var $dQVMO = parcelRequire("dQVMO");
var $hFlB3 = parcelRequire("hFlB3");
var $jOCzY = parcelRequire("jOCzY");
var $04wr6 = parcelRequire("04wr6");
var $iJH3x = parcelRequire("iJH3x");
var $7p8hL = parcelRequire("7p8hL");
var $bn8Da = parcelRequire("bn8Da");
var $bMiqE = parcelRequire("bMiqE");
var $9b8s0 = parcelRequire("9b8s0");

var $e2xQm = parcelRequire("e2xQm");

var $d9NWo = parcelRequire("d9NWo");
/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $3adee5e1618f5578$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $3adee5e1618f5578$var$INTEGRATION_NAME = 'Breadcrumbs';
const $3adee5e1618f5578$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $3adee5e1618f5578$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $8EmCv.addConsoleInstrumentationHandler)($3adee5e1618f5578$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $lemS8.addClickKeypressInstrumentationHandler)($3adee5e1618f5578$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $jOCzY.addXhrInstrumentationHandler)($3adee5e1618f5578$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $dQVMO.addFetchInstrumentationHandler)($3adee5e1618f5578$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $hFlB3.addHistoryInstrumentationHandler)($3adee5e1618f5578$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on('beforeSendEvent', $3adee5e1618f5578$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $3adee5e1618f5578$export$c079d904b326663a = (0, $genhe.defineIntegration)($3adee5e1618f5578$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $3adee5e1618f5578$export$2dc68d50d56fbbd = (0, $genhe.convertIntegrationFnToClass)($3adee5e1618f5578$var$INTEGRATION_NAME, $3adee5e1618f5578$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $3adee5e1618f5578$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $hcepo.getClient)() !== client) return;
        (0, $hcepo.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $iJH3x.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $3adee5e1618f5578$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $hcepo.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $3adee5e1618f5578$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$3adee5e1618f5578$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$3adee5e1618f5578$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $3adee5e1618f5578$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $3adee5e1618f5578$var$_isEvent(event) ? event.target : event;
            target = (0, $04wr6.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $04wr6.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $hcepo.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $3adee5e1618f5578$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $hcepo.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $9b8s0.severityLevelFromString)(handlerData.level),
            message: (0, $bMiqE.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $bMiqE.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $hcepo.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $3adee5e1618f5578$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $hcepo.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $jOCzY.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $hcepo.addBreadcrumb)({
            category: 'xhr',
            data: data,
            type: 'http'
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $3adee5e1618f5578$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $hcepo.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $hcepo.addBreadcrumb)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $hcepo.addBreadcrumb)({
                category: 'fetch',
                data: data,
                type: 'http'
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $3adee5e1618f5578$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $hcepo.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $bn8Da.parseUrl)((0, $d9NWo.WINDOW).location.href);
        let parsedFrom = from ? (0, $bn8Da.parseUrl)(from) : undefined;
        const parsedTo = (0, $bn8Da.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $hcepo.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $3adee5e1618f5578$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("lemS8", function(module, exports) {

$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", function () { return $f74ca5b301ab433a$export$5aeffd3db2cf9df7; });

var $iJH3x = parcelRequire("iJH3x");

var $aajbp = parcelRequire("aajbp");

var $lNVQ9 = parcelRequire("lNVQ9");

var $7P0P8 = parcelRequire("7P0P8");
const $f74ca5b301ab433a$var$WINDOW = (0, $lNVQ9.GLOBAL_OBJ);
const $f74ca5b301ab433a$var$DEBOUNCE_DURATION = 1000;
let $f74ca5b301ab433a$var$debounceTimerID;
let $f74ca5b301ab433a$var$lastCapturedEventType;
let $f74ca5b301ab433a$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $f74ca5b301ab433a$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $7P0P8.addHandler)(type, handler);
    (0, $7P0P8.maybeInstrument)(type, $f74ca5b301ab433a$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $f74ca5b301ab433a$export$3014bbf0af0e1d4a() {
    if (!$f74ca5b301ab433a$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $7P0P8.triggerHandlers).bind(null, 'dom');
    const globalDOMEventHandler = $f74ca5b301ab433a$var$makeDOMEventHandler(triggerDOMHandler, true);
    $f74ca5b301ab433a$var$WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
    $f74ca5b301ab433a$var$WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $f74ca5b301ab433a$var$WINDOW[target] && $f74ca5b301ab433a$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $aajbp.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $f74ca5b301ab433a$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $aajbp.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $f74ca5b301ab433a$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $f74ca5b301ab433a$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $f74ca5b301ab433a$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $f74ca5b301ab433a$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $f74ca5b301ab433a$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $f74ca5b301ab433a$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($f74ca5b301ab433a$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $aajbp.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $aajbp.addNonEnumerableProperty)(target, '_sentryId', (0, $iJH3x.uuid4)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$f74ca5b301ab433a$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $f74ca5b301ab433a$var$lastCapturedEventType = event.type;
            $f74ca5b301ab433a$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($f74ca5b301ab433a$var$debounceTimerID);
        $f74ca5b301ab433a$var$debounceTimerID = $f74ca5b301ab433a$var$WINDOW.setTimeout(()=>{
            $f74ca5b301ab433a$var$lastCapturedEventTargetId = undefined;
            $f74ca5b301ab433a$var$lastCapturedEventType = undefined;
        }, $f74ca5b301ab433a$var$DEBOUNCE_DURATION);
    };
}
function $f74ca5b301ab433a$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});

parcelRegister("8EmCv", function(module, exports) {

$parcel$export(module.exports, "addConsoleInstrumentationHandler", function () { return $64c39b056fdae851$export$1d6e0d073f9e6723; });

var $7p8hL = parcelRequire("7p8hL");

var $aajbp = parcelRequire("aajbp");

var $lNVQ9 = parcelRequire("lNVQ9");

var $7P0P8 = parcelRequire("7P0P8");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $64c39b056fdae851$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $7P0P8.addHandler)(type, handler);
    (0, $7P0P8.maybeInstrument)(type, $64c39b056fdae851$var$instrumentConsole);
}
function $64c39b056fdae851$var$instrumentConsole() {
    if (!('console' in (0, $lNVQ9.GLOBAL_OBJ))) return;
    (0, $7p8hL.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $lNVQ9.GLOBAL_OBJ).console)) return;
        (0, $aajbp.fill)((0, $lNVQ9.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $7p8hL.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $7P0P8.triggerHandlers)('console', handlerData);
                const log = (0, $7p8hL.originalConsoleMethods)[level];
                log && log.apply((0, $lNVQ9.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});

parcelRegister("dQVMO", function(module, exports) {

$parcel$export(module.exports, "addFetchInstrumentationHandler", function () { return $a15cf4d580b5ec36$export$f75d3c772c923df0; });

var $aajbp = parcelRequire("aajbp");

var $37Ut6 = parcelRequire("37Ut6");

var $lNVQ9 = parcelRequire("lNVQ9");

var $7P0P8 = parcelRequire("7P0P8");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $a15cf4d580b5ec36$export$f75d3c772c923df0(handler) {
    const type = 'fetch';
    (0, $7P0P8.addHandler)(type, handler);
    (0, $7P0P8.maybeInstrument)(type, $a15cf4d580b5ec36$var$instrumentFetch);
}
function $a15cf4d580b5ec36$var$instrumentFetch() {
    if (!(0, $37Ut6.supportsNativeFetch)()) return;
    (0, $aajbp.fill)((0, $lNVQ9.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $a15cf4d580b5ec36$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $7P0P8.triggerHandlers)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $lNVQ9.GLOBAL_OBJ), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $7P0P8.triggerHandlers)('fetch', finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $7P0P8.triggerHandlers)('fetch', erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $a15cf4d580b5ec36$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $a15cf4d580b5ec36$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($a15cf4d580b5ec36$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $a15cf4d580b5ec36$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $a15cf4d580b5ec36$var$getUrlFromResource(url),
            method: $a15cf4d580b5ec36$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $a15cf4d580b5ec36$var$getUrlFromResource(arg),
        method: $a15cf4d580b5ec36$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}

});

parcelRegister("jOCzY", function(module, exports) {

$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", function () { return $e6d09cd7eb7390d1$export$55b6bb1e45c6cf59; });
$parcel$export(module.exports, "addXhrInstrumentationHandler", function () { return $e6d09cd7eb7390d1$export$26ace48dd54c9aea; });

var $jPeZ4 = parcelRequire("jPeZ4");

var $aajbp = parcelRequire("aajbp");

var $lNVQ9 = parcelRequire("lNVQ9");

var $7P0P8 = parcelRequire("7P0P8");
const $e6d09cd7eb7390d1$var$WINDOW = (0, $lNVQ9.GLOBAL_OBJ);
const $e6d09cd7eb7390d1$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $e6d09cd7eb7390d1$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $7P0P8.addHandler)(type, handler);
    (0, $7P0P8.maybeInstrument)(type, $e6d09cd7eb7390d1$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $e6d09cd7eb7390d1$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$e6d09cd7eb7390d1$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $aajbp.fill)(xhrproto, 'open', function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $jPeZ4.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $e6d09cd7eb7390d1$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$e6d09cd7eb7390d1$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$e6d09cd7eb7390d1$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $7P0P8.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') (0, $aajbp.fill)(this, 'onreadystatechange', function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $aajbp.fill)(this, 'setRequestHeader', function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$e6d09cd7eb7390d1$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $jPeZ4.isString)(header) && (0, $jPeZ4.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $aajbp.fill)(xhrproto, 'send', function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$e6d09cd7eb7390d1$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $7P0P8.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $e6d09cd7eb7390d1$var$parseUrl(url) {
    if ((0, $jPeZ4.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

});

parcelRegister("bn8Da", function(module, exports) {

$parcel$export(module.exports, "parseUrl", function () { return $847889964a55ae57$export$7a5253c0f62e0150; });
$parcel$export(module.exports, "stripUrlQueryAndFragment", function () { return $847889964a55ae57$export$ce084c78234bd35; });
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $847889964a55ae57$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $847889964a55ae57$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $847889964a55ae57$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $847889964a55ae57$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

});

parcelRegister("9b8s0", function(module, exports) {

$parcel$export(module.exports, "severityLevelFromString", function () { return $6aebb2455a2de030$export$d771ef054122c30a; });
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $6aebb2455a2de030$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $6aebb2455a2de030$export$e01cef29b4327697(level) {
    return $6aebb2455a2de030$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $6aebb2455a2de030$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $6aebb2455a2de030$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}

});


parcelRegister("gxQnK", function(module, exports) {

$parcel$export(module.exports, "dedupeIntegration", function () { return $c0b85c68fb20e846$export$6d39aa44cd0c7567; });
$parcel$export(module.exports, "Dedupe", function () { return $c0b85c68fb20e846$export$688d98c249d31ad3; });

var $genhe = parcelRequire("genhe");

var $7p8hL = parcelRequire("7p8hL");

var $e2xQm = parcelRequire("e2xQm");
const $c0b85c68fb20e846$var$INTEGRATION_NAME = 'Dedupe';
const $c0b85c68fb20e846$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $c0b85c68fb20e846$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($c0b85c68fb20e846$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $c0b85c68fb20e846$export$6d39aa44cd0c7567 = (0, $genhe.defineIntegration)($c0b85c68fb20e846$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $c0b85c68fb20e846$export$688d98c249d31ad3 = (0, $genhe.convertIntegrationFnToClass)($c0b85c68fb20e846$var$INTEGRATION_NAME, $c0b85c68fb20e846$export$6d39aa44cd0c7567);
function $c0b85c68fb20e846$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($c0b85c68fb20e846$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($c0b85c68fb20e846$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $c0b85c68fb20e846$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$c0b85c68fb20e846$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$c0b85c68fb20e846$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $c0b85c68fb20e846$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $c0b85c68fb20e846$var$_getExceptionFromEvent(previousEvent);
    const currentException = $c0b85c68fb20e846$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$c0b85c68fb20e846$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$c0b85c68fb20e846$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $c0b85c68fb20e846$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $c0b85c68fb20e846$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $c0b85c68fb20e846$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $c0b85c68fb20e846$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $c0b85c68fb20e846$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $c0b85c68fb20e846$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

});

parcelRegister("i26WM", function(module, exports) {

$parcel$export(module.exports, "globalHandlersIntegration", function () { return $d20dcd72502269a1$export$66acc70e8cf2b71a; });
$parcel$export(module.exports, "GlobalHandlers", function () { return $d20dcd72502269a1$export$204155decbc90e5a; });

var $hcepo = parcelRequire("hcepo");
var $genhe = parcelRequire("genhe");

var $gHATr = parcelRequire("gHATr");
var $a5k97 = parcelRequire("a5k97");
var $04wr6 = parcelRequire("04wr6");
var $jPeZ4 = parcelRequire("jPeZ4");
var $7p8hL = parcelRequire("7p8hL");

var $e2xQm = parcelRequire("e2xQm");

var $4JUzU = parcelRequire("4JUzU");

var $d9NWo = parcelRequire("d9NWo");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $d20dcd72502269a1$var$INTEGRATION_NAME = 'GlobalHandlers';
const $d20dcd72502269a1$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $d20dcd72502269a1$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $d20dcd72502269a1$var$_installGlobalOnErrorHandler(client);
                $d20dcd72502269a1$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $d20dcd72502269a1$var$_installGlobalOnUnhandledRejectionHandler(client);
                $d20dcd72502269a1$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $d20dcd72502269a1$export$66acc70e8cf2b71a = (0, $genhe.defineIntegration)($d20dcd72502269a1$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $d20dcd72502269a1$export$204155decbc90e5a = (0, $genhe.convertIntegrationFnToClass)($d20dcd72502269a1$var$INTEGRATION_NAME, $d20dcd72502269a1$export$66acc70e8cf2b71a);
function $d20dcd72502269a1$var$_installGlobalOnErrorHandler(client) {
    (0, $gHATr.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $d20dcd72502269a1$var$getOptions();
        if ((0, $hcepo.getClient)() !== client || (0, $d9NWo.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $jPeZ4.isString)(msg) ? $d20dcd72502269a1$var$_eventFromIncompleteOnError(msg, url, line, column) : $d20dcd72502269a1$var$_enhanceEventWithInitialFrame((0, $4JUzU.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $hcepo.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $d20dcd72502269a1$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $a5k97.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $d20dcd72502269a1$var$getOptions();
        if ((0, $hcepo.getClient)() !== client || (0, $d9NWo.shouldIgnoreOnError)()) return;
        const error = $d20dcd72502269a1$var$_getUnhandledRejectionError(e);
        const event = (0, $jPeZ4.isPrimitive)(error) ? $d20dcd72502269a1$var$_eventFromRejectionWithPrimitive(error) : (0, $4JUzU.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $hcepo.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $d20dcd72502269a1$var$_getUnhandledRejectionError(error) {
    if ((0, $jPeZ4.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) return e.reason;
        else if ('detail' in e && 'reason' in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $d20dcd72502269a1$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d20dcd72502269a1$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $jPeZ4.isErrorEvent)(msg) ? msg.message : msg;
    let name = 'Error';
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $d20dcd72502269a1$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d20dcd72502269a1$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $jPeZ4.isString)(url) && url.length > 0 ? url : (0, $04wr6.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $d20dcd72502269a1$var$globalHandlerLog(type) {
    (0, $e2xQm.DEBUG_BUILD) && (0, $7p8hL.logger).log(`Global Handler attached: ${type}`);
}
function $d20dcd72502269a1$var$getOptions() {
    const client = (0, $hcepo.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});

parcelRegister("39bVV", function(module, exports) {

$parcel$export(module.exports, "httpContextIntegration", function () { return $24ab78124df306f6$export$1378794447170364; });
$parcel$export(module.exports, "HttpContext", function () { return $24ab78124df306f6$export$5d2ee9a544b09a94; });

var $genhe = parcelRequire("genhe");

var $d9NWo = parcelRequire("d9NWo");
const $24ab78124df306f6$var$INTEGRATION_NAME = 'HttpContext';
const $24ab78124df306f6$var$_httpContextIntegration = ()=>{
    return {
        name: $24ab78124df306f6$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $d9NWo.WINDOW).navigator && !(0, $d9NWo.WINDOW).location && !(0, $d9NWo.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $d9NWo.WINDOW).location && (0, $d9NWo.WINDOW).location.href;
            const { referrer: referrer } = (0, $d9NWo.WINDOW).document || {};
            const { userAgent: userAgent } = (0, $d9NWo.WINDOW).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $24ab78124df306f6$export$1378794447170364 = (0, $genhe.defineIntegration)($24ab78124df306f6$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $24ab78124df306f6$export$5d2ee9a544b09a94 = (0, $genhe.convertIntegrationFnToClass)($24ab78124df306f6$var$INTEGRATION_NAME, $24ab78124df306f6$export$1378794447170364);

});

parcelRegister("gb6W3", function(module, exports) {

$parcel$export(module.exports, "linkedErrorsIntegration", function () { return $bc730da7572b6e3e$export$ebabb00eb7f3a395; });
$parcel$export(module.exports, "LinkedErrors", function () { return $bc730da7572b6e3e$export$8d1e60aaf616fb4f; });

var $genhe = parcelRequire("genhe");

var $2pzm3 = parcelRequire("2pzm3");

var $4JUzU = parcelRequire("4JUzU");
const $bc730da7572b6e3e$var$DEFAULT_KEY = 'cause';
const $bc730da7572b6e3e$var$DEFAULT_LIMIT = 5;
const $bc730da7572b6e3e$var$INTEGRATION_NAME = 'LinkedErrors';
const $bc730da7572b6e3e$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $bc730da7572b6e3e$var$DEFAULT_LIMIT;
    const key = options.key || $bc730da7572b6e3e$var$DEFAULT_KEY;
    return {
        name: $bc730da7572b6e3e$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $2pzm3.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $4JUzU.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $bc730da7572b6e3e$export$ebabb00eb7f3a395 = (0, $genhe.defineIntegration)($bc730da7572b6e3e$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $bc730da7572b6e3e$export$8d1e60aaf616fb4f = (0, $genhe.convertIntegrationFnToClass)($bc730da7572b6e3e$var$INTEGRATION_NAME, $bc730da7572b6e3e$export$ebabb00eb7f3a395);

});

parcelRegister("aLmV4", function(module, exports) {

$parcel$export(module.exports, "browserApiErrorsIntegration", function () { return $7d60127fc5245572$export$59bfe9f1c76150e; });
$parcel$export(module.exports, "TryCatch", function () { return $7d60127fc5245572$export$f1a018517668e6d3; });

var $genhe = parcelRequire("genhe");

var $aajbp = parcelRequire("aajbp");
var $kEJYx = parcelRequire("kEJYx");

var $d9NWo = parcelRequire("d9NWo");
const $7d60127fc5245572$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $7d60127fc5245572$var$INTEGRATION_NAME = 'TryCatch';
const $7d60127fc5245572$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $7d60127fc5245572$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $aajbp.fill)((0, $d9NWo.WINDOW), 'setTimeout', $7d60127fc5245572$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $aajbp.fill)((0, $d9NWo.WINDOW), 'setInterval', $7d60127fc5245572$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $aajbp.fill)((0, $d9NWo.WINDOW), 'requestAnimationFrame', $7d60127fc5245572$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $d9NWo.WINDOW)) (0, $aajbp.fill)(XMLHttpRequest.prototype, 'send', $7d60127fc5245572$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $7d60127fc5245572$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($7d60127fc5245572$var$_wrapEventTarget);
            }
        }
    };
};
const $7d60127fc5245572$export$59bfe9f1c76150e = (0, $genhe.defineIntegration)($7d60127fc5245572$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $7d60127fc5245572$export$f1a018517668e6d3 = (0, $genhe.convertIntegrationFnToClass)($7d60127fc5245572$var$INTEGRATION_NAME, $7d60127fc5245572$export$59bfe9f1c76150e);
function $7d60127fc5245572$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $d9NWo.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $kEJYx.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7d60127fc5245572$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $d9NWo.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $kEJYx.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $7d60127fc5245572$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $aajbp.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $kEJYx.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $aajbp.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $kEJYx.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $d9NWo.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $7d60127fc5245572$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $d9NWo.WINDOW);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $aajbp.fill)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $d9NWo.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $kEJYx.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $d9NWo.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $kEJYx.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $aajbp.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});


parcelRegister("am4Ss", function(module, exports) {

$parcel$export(module.exports, "internalReplayIntegration", function () { return $789fbdfdf9798b8b$export$2832a2ae028f5e28; });
$parcel$export(module.exports, "InternalReplay", function () { return $789fbdfdf9798b8b$export$6b59b88de1ff9cb7; });
$parcel$export(module.exports, "internalGetReplay", function () { return $789fbdfdf9798b8b$export$81cc0d0f72285d1; });

var $hvuDy = parcelRequire("hvuDy");
var $fF2BR = parcelRequire("fF2BR");
var $lemS8 = parcelRequire("lemS8");
var $dQVMO = parcelRequire("dQVMO");
var $hFlB3 = parcelRequire("hFlB3");
var $jOCzY = parcelRequire("jOCzY");
var $iGf0k = parcelRequire("iGf0k");
var $7p8hL = parcelRequire("7p8hL");
var $2pR2a = parcelRequire("2pR2a");
var $aajbp = parcelRequire("aajbp");
var $lNVQ9 = parcelRequire("lNVQ9");
var $04wr6 = parcelRequire("04wr6");
var $kVwzp = parcelRequire("kVwzp");
var $3iBML = parcelRequire("3iBML");
var $5vnYi = parcelRequire("5vnYi");
var $bMiqE = parcelRequire("bMiqE");
var $iJH3x = parcelRequire("iJH3x");

var $hcepo = parcelRequire("hcepo");
var $huK8b = parcelRequire("huK8b");
var $fxUGN = parcelRequire("fxUGN");
var $djmte = parcelRequire("djmte");
var $5XnTz = parcelRequire("5XnTz");
var $kuS4l = parcelRequire("kuS4l");
var $4RP7L = parcelRequire("4RP7L");

var $aiNal = parcelRequire("aiNal");
// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $789fbdfdf9798b8b$var$WINDOW = (0, $lNVQ9.GLOBAL_OBJ);
const $789fbdfdf9798b8b$var$REPLAY_SESSION_KEY = 'sentryReplaySession';
const $789fbdfdf9798b8b$var$REPLAY_EVENT_NAME = 'replay_event';
const $789fbdfdf9798b8b$var$UNABLE_TO_SEND_REPLAY = 'Unable to send Replay';
// The idle limit for a session after which recording is paused.
const $789fbdfdf9798b8b$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $789fbdfdf9798b8b$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $789fbdfdf9798b8b$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $789fbdfdf9798b8b$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $789fbdfdf9798b8b$var$BUFFER_CHECKOUT_TIME = 60000;
const $789fbdfdf9798b8b$var$RETRY_BASE_INTERVAL = 5000;
const $789fbdfdf9798b8b$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $789fbdfdf9798b8b$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $789fbdfdf9798b8b$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $789fbdfdf9798b8b$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $789fbdfdf9798b8b$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $789fbdfdf9798b8b$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $789fbdfdf9798b8b$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $789fbdfdf9798b8b$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $789fbdfdf9798b8b$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
function $789fbdfdf9798b8b$var$_nullishCoalesce$1(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
function $789fbdfdf9798b8b$var$_optionalChain$5(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var $789fbdfdf9798b8b$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($789fbdfdf9798b8b$var$NodeType$1 || ($789fbdfdf9798b8b$var$NodeType$1 = {}));
function $789fbdfdf9798b8b$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $789fbdfdf9798b8b$var$isShadowRoot(n) {
    const host = $789fbdfdf9798b8b$var$_optionalChain$5([
        n,
        'optionalAccess',
        (_)=>_.host
    ]);
    return Boolean($789fbdfdf9798b8b$var$_optionalChain$5([
        host,
        'optionalAccess',
        (_2)=>_2.shadowRoot
    ]) === n);
}
function $789fbdfdf9798b8b$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === '[object ShadowRoot]';
}
function $789fbdfdf9798b8b$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(' background-clip: text;') && !cssText.includes(' -webkit-background-clip: text;')) cssText = cssText.replace(' background-clip: text;', ' -webkit-background-clip: text; background-clip: text;');
    return cssText;
}
function $789fbdfdf9798b8b$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        '@import',
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === '') statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(' ') + ';';
}
function $789fbdfdf9798b8b$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $789fbdfdf9798b8b$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $789fbdfdf9798b8b$var$stringifyRule).join('')) : null;
    } catch (error) {
        return null;
    }
}
function $789fbdfdf9798b8b$var$stringifyRule(rule) {
    let importStringified;
    if ($789fbdfdf9798b8b$var$isCSSImportRule(rule)) try {
        importStringified = $789fbdfdf9798b8b$var$stringifyStylesheet(rule.styleSheet) || $789fbdfdf9798b8b$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($789fbdfdf9798b8b$var$isCSSStyleRule(rule) && rule.selectorText.includes(':')) return $789fbdfdf9798b8b$var$fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function $789fbdfdf9798b8b$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, '$1\\$2');
}
function $789fbdfdf9798b8b$var$isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function $789fbdfdf9798b8b$var$isCSSStyleRule(rule) {
    return 'selectorText' in rule;
}
class $789fbdfdf9798b8b$var$Mirror {
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        if (!n) return -1;
        const id = $789fbdfdf9798b8b$var$_optionalChain$5([
            this,
            'access',
            (_3)=>_3.getMeta,
            'call',
            (_4)=>_4(n),
            'optionalAccess',
            (_5)=>_5.id
        ]);
        return $789fbdfdf9798b8b$var$_nullishCoalesce$1(id, ()=>-1);
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function $789fbdfdf9798b8b$var$createMirror() {
    return new $789fbdfdf9798b8b$var$Mirror();
}
function $789fbdfdf9798b8b$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === 'OPTION') tagName = 'SELECT';
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === 'password' || tagName === 'INPUT' && !type && maskInputOptions['text']);
}
function $789fbdfdf9798b8b$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || '';
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return '*'.repeat(text.length);
}
function $789fbdfdf9798b8b$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $789fbdfdf9798b8b$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $789fbdfdf9798b8b$var$ORIGINAL_ATTRIBUTE_NAME = '__rrweb_original__';
function $789fbdfdf9798b8b$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext('2d');
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $789fbdfdf9798b8b$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$789fbdfdf9798b8b$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $789fbdfdf9798b8b$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute('data-rr-is-password') ? 'password' : type ? $789fbdfdf9798b8b$var$toLowerCase(type) : null;
}
function $789fbdfdf9798b8b$var$getInputValue(el, tagName, type) {
    if (tagName === 'INPUT' && (type === 'radio' || type === 'checkbox')) return el.getAttribute('value') || '';
    return el.value;
}
let $789fbdfdf9798b8b$var$_id = 1;
const $789fbdfdf9798b8b$var$tagNameRegex = new RegExp('[^a-z0-9-_:]');
const $789fbdfdf9798b8b$var$IGNORED_NODE = -2;
function $789fbdfdf9798b8b$var$genId() {
    return $789fbdfdf9798b8b$var$_id++;
}
function $789fbdfdf9798b8b$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return 'form';
    const processedTagName = $789fbdfdf9798b8b$var$toLowerCase(element.tagName);
    if ($789fbdfdf9798b8b$var$tagNameRegex.test(processedTagName)) return 'div';
    return processedTagName;
}
function $789fbdfdf9798b8b$var$extractOrigin(url) {
    let origin = '';
    if (url.indexOf('//') > -1) origin = url.split('/').slice(0, 3).join('/');
    else origin = url.split('/')[0];
    origin = origin.split('?')[0];
    return origin;
}
let $789fbdfdf9798b8b$var$canvasService;
let $789fbdfdf9798b8b$var$canvasCtx;
const $789fbdfdf9798b8b$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $789fbdfdf9798b8b$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $789fbdfdf9798b8b$var$URL_WWW_MATCH = /^www\..*/i;
const $789fbdfdf9798b8b$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $789fbdfdf9798b8b$var$absoluteToStylesheet(cssText, href) {
    return (cssText || '').replace($789fbdfdf9798b8b$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || '';
        if (!filePath) return origin;
        if ($789fbdfdf9798b8b$var$URL_PROTOCOL_MATCH.test(filePath) || $789fbdfdf9798b8b$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($789fbdfdf9798b8b$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === '/') return `url(${maybeQuote}${$789fbdfdf9798b8b$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split('/');
        const parts = filePath.split('/');
        stack.pop();
        for (const part of parts){
            if (part === '.') continue;
            else if (part === '..') stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join('/')}${maybeQuote})`;
    });
}
const $789fbdfdf9798b8b$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $789fbdfdf9798b8b$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $789fbdfdf9798b8b$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === '') return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return '';
    }
    const output = [];
    while(true){
        collectCharacters($789fbdfdf9798b8b$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($789fbdfdf9798b8b$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ',') {
            url = $789fbdfdf9798b8b$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = '';
            url = $789fbdfdf9798b8b$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === '') {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ',') {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === '(') inParens = true;
                } else if (c === ')') inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(', ');
}
function $789fbdfdf9798b8b$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === '') return attributeValue;
    const a = doc.createElement('a');
    a.href = attributeValue;
    return a.href;
}
function $789fbdfdf9798b8b$var$isSVGElement(el) {
    return Boolean(el.tagName === 'svg' || el.ownerSVGElement);
}
function $789fbdfdf9798b8b$var$getHref() {
    const a = document.createElement('a');
    a.href = '';
    return a.href;
}
function $789fbdfdf9798b8b$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === 'src' || name === 'href' && !(tagName === 'use' && value[0] === '#')) return $789fbdfdf9798b8b$var$absoluteToDoc(doc, value);
    else if (name === 'xlink:href' && value[0] !== '#') return $789fbdfdf9798b8b$var$absoluteToDoc(doc, value);
    else if (name === 'background' && (tagName === 'table' || tagName === 'td' || tagName === 'th')) return $789fbdfdf9798b8b$var$absoluteToDoc(doc, value);
    else if (name === 'srcset') return $789fbdfdf9798b8b$var$getAbsoluteSrcsetString(doc, value);
    else if (name === 'style') return $789fbdfdf9798b8b$var$absoluteToStylesheet(value, $789fbdfdf9798b8b$var$getHref());
    else if (tagName === 'object' && name === 'data') return $789fbdfdf9798b8b$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === 'function') return maskAttributeFn(name, value, element);
    return value;
}
function $789fbdfdf9798b8b$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === 'video' || tagName === 'audio') && name === 'autoplay';
}
function $789fbdfdf9798b8b$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === 'string') {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $789fbdfdf9798b8b$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $789fbdfdf9798b8b$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $789fbdfdf9798b8b$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $789fbdfdf9798b8b$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === 'string') {
                    if (el.matches(`.${className}`)) return true;
                } else if ($789fbdfdf9798b8b$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
function $789fbdfdf9798b8b$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === 'INPUT') {
            const autocomplete = el.getAttribute('autocomplete');
            const disallowedAutocompleteValues = [
                'current-password',
                'new-password',
                'cc-number',
                'cc-exp',
                'cc-exp-month',
                'cc-exp-year',
                'cc-csc'
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $789fbdfdf9798b8b$var$distanceToMatch(el, $789fbdfdf9798b8b$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $789fbdfdf9798b8b$var$distanceToMatch(el, $789fbdfdf9798b8b$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $789fbdfdf9798b8b$var$distanceToMatch(el, $789fbdfdf9798b8b$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $789fbdfdf9798b8b$var$distanceToMatch(el, $789fbdfdf9798b8b$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $789fbdfdf9798b8b$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== 'complete') {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener('load', ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = 'about:blank';
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === '') {
        setTimeout(listener, 0);
        return iframeEl.addEventListener('load', listener);
    }
    iframeEl.addEventListener('load', listener);
}
function $789fbdfdf9798b8b$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener('load', ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $789fbdfdf9798b8b$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $789fbdfdf9798b8b$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== 'CSS1Compat') return {
                type: $789fbdfdf9798b8b$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $789fbdfdf9798b8b$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $789fbdfdf9798b8b$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $789fbdfdf9798b8b$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n.TEXT_NODE:
            return $789fbdfdf9798b8b$var$serializeTextNode(n, {
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $789fbdfdf9798b8b$var$NodeType$1.CDATA,
                textContent: '',
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $789fbdfdf9798b8b$var$NodeType$1.Comment,
                textContent: n.textContent || '',
                rootId: rootId
            };
        default:
            return false;
    }
}
function $789fbdfdf9798b8b$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $789fbdfdf9798b8b$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === 'STYLE' ? true : undefined;
    const isScript = parentTagName === 'SCRIPT' ? true : undefined;
    const isTextarea = parentTagName === 'TEXTAREA' ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ($789fbdfdf9798b8b$var$_optionalChain$5([
                n,
                'access',
                (_6)=>_6.parentNode,
                'access',
                (_7)=>_7.sheet,
                'optionalAccess',
                (_8)=>_8.cssRules
            ])) textContent = $789fbdfdf9798b8b$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $789fbdfdf9798b8b$var$absoluteToStylesheet(textContent, $789fbdfdf9798b8b$var$getHref());
    }
    if (isScript) textContent = 'SCRIPT_PLACEHOLDER';
    const forceMask = $789fbdfdf9798b8b$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, '*');
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, '*');
    if (parentTagName === 'OPTION' && textContent) {
        const isInputMasked = $789fbdfdf9798b8b$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $789fbdfdf9798b8b$var$maskInputValue({
            isMasked: $789fbdfdf9798b8b$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $789fbdfdf9798b8b$var$NodeType$1.Text,
        textContent: textContent || '',
        isStyle: isStyle,
        rootId: rootId
    };
}
function $789fbdfdf9798b8b$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector } = options;
    const needBlock = $789fbdfdf9798b8b$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $789fbdfdf9798b8b$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (attr.name && !$789fbdfdf9798b8b$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $789fbdfdf9798b8b$var$transformAttribute(doc, tagName, $789fbdfdf9798b8b$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
    if (tagName === 'link' && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $789fbdfdf9798b8b$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = $789fbdfdf9798b8b$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === 'style' && n.sheet && !(n.innerText || n.textContent || '').trim().length) {
        const cssText = $789fbdfdf9798b8b$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = $789fbdfdf9798b8b$var$absoluteToStylesheet(cssText, $789fbdfdf9798b8b$var$getHref());
    }
    if (tagName === 'input' || tagName === 'textarea' || tagName === 'select' || tagName === 'option') {
        const el = n;
        const type = $789fbdfdf9798b8b$var$getInputType(el);
        const value = $789fbdfdf9798b8b$var$getInputValue(el, $789fbdfdf9798b8b$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== 'submit' && type !== 'button' && value) {
            const forceMask = $789fbdfdf9798b8b$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $789fbdfdf9798b8b$var$shouldMaskInput({
                type: type,
                tagName: $789fbdfdf9798b8b$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes.value = $789fbdfdf9798b8b$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes.checked = checked;
    }
    if (tagName === 'option') {
        if (n.selected && !maskInputOptions['select']) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === 'canvas' && recordCanvas) {
        if (n.__context === '2d') {
            if (!$789fbdfdf9798b8b$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!('__context' in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = document.createElement('canvas');
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === 'img' && inlineImages) {
        if (!$789fbdfdf9798b8b$var$canvasService) {
            $789fbdfdf9798b8b$var$canvasService = doc.createElement('canvas');
            $789fbdfdf9798b8b$var$canvasCtx = $789fbdfdf9798b8b$var$canvasService.getContext('2d');
        }
        const image = n;
        const oldValue = image.crossOrigin;
        image.crossOrigin = 'anonymous';
        const recordInlineImage = ()=>{
            image.removeEventListener('load', recordInlineImage);
            try {
                $789fbdfdf9798b8b$var$canvasService.width = image.naturalWidth;
                $789fbdfdf9798b8b$var$canvasService.height = image.naturalHeight;
                $789fbdfdf9798b8b$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $789fbdfdf9798b8b$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
            }
            oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute('crossorigin');
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener('load', recordInlineImage);
    }
    if (tagName === 'audio' || tagName === 'video') {
        attributes.rr_mediaState = n.paused ? 'paused' : 'played';
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === 'iframe' && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $789fbdfdf9798b8b$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $789fbdfdf9798b8b$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $789fbdfdf9798b8b$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return '';
    else return maybeAttr.toLowerCase();
}
function $789fbdfdf9798b8b$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $789fbdfdf9798b8b$var$NodeType$1.Comment) return true;
    else if (sn.type === $789fbdfdf9798b8b$var$NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === 'script' || sn.tagName === 'link' && (sn.attributes.rel === 'preload' || sn.attributes.rel === 'modulepreload') && sn.attributes.as === 'script' || sn.tagName === 'link' && sn.attributes.rel === 'prefetch' && typeof sn.attributes.href === 'string' && sn.attributes.href.endsWith('.js'))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === 'link' && sn.attributes.rel === 'shortcut icon' || sn.tagName === 'meta' && ($789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === 'application-name' || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.rel) === 'icon' || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.rel) === 'apple-touch-icon' || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.rel) === 'shortcut icon'))) return true;
        else if (sn.tagName === 'meta') {
            if (slimDOMOptions.headMetaDescKeywords && $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === 'pinterest')) return true;
            else if (slimDOMOptions.headMetaRobots && ($789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === 'robots' || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === 'googlebot' || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === 'bingbot')) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes['http-equiv'] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === 'author' || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === 'generator' || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === 'framework' || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === 'publisher' || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === 'progid' || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === 'google-site-verification' || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === 'yandex-verification' || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === 'csrf-token' || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === 'p:domain_verify' || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === 'verify-v1' || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === 'verification' || $789fbdfdf9798b8b$var$lowerIfExists(sn.attributes.name) === 'shopify-checkout-api-token')) return true;
        }
    }
    return false;
}
function $789fbdfdf9798b8b$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $789fbdfdf9798b8b$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, 'not serialized');
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($789fbdfdf9798b8b$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $789fbdfdf9798b8b$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, '').length) id = $789fbdfdf9798b8b$var$IGNORED_NODE;
    else id = $789fbdfdf9798b8b$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $789fbdfdf9798b8b$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $789fbdfdf9798b8b$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $789fbdfdf9798b8b$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $789fbdfdf9798b8b$var$NodeType$1.Document || serializedNode.type === $789fbdfdf9798b8b$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $789fbdfdf9798b8b$var$NodeType$1.Element && serializedNode.tagName === 'head') preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $789fbdfdf9798b8b$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($789fbdfdf9798b8b$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $789fbdfdf9798b8b$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $789fbdfdf9798b8b$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $789fbdfdf9798b8b$var$isShadowRoot(n.parentNode) && $789fbdfdf9798b8b$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $789fbdfdf9798b8b$var$NodeType$1.Element && serializedNode.tagName === 'iframe') $789fbdfdf9798b8b$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $789fbdfdf9798b8b$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $789fbdfdf9798b8b$var$NodeType$1.Element && serializedNode.tagName === 'link' && serializedNode.attributes.rel === 'stylesheet') $789fbdfdf9798b8b$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $789fbdfdf9798b8b$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $789fbdfdf9798b8b$var$snapshot(n, options) {
    const { mirror: mirror = new $789fbdfdf9798b8b$var$Mirror(), blockClass: blockClass = 'rr-block', blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = 'rr-mask', unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === 'all',
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $789fbdfdf9798b8b$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $789fbdfdf9798b8b$var$_optionalChain$4(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $789fbdfdf9798b8b$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $789fbdfdf9798b8b$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $789fbdfdf9798b8b$var$_mirror = {
    map: {},
    getId () {
        console.error($789fbdfdf9798b8b$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($789fbdfdf9798b8b$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($789fbdfdf9798b8b$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($789fbdfdf9798b8b$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($789fbdfdf9798b8b$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) $789fbdfdf9798b8b$var$_mirror = new Proxy($789fbdfdf9798b8b$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === 'map') console.error($789fbdfdf9798b8b$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $789fbdfdf9798b8b$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $789fbdfdf9798b8b$var$clearTimeout$1(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $789fbdfdf9798b8b$var$setTimeout$1(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $789fbdfdf9798b8b$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $789fbdfdf9798b8b$var$setTimeout$1(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$789fbdfdf9798b8b$var$hookSetter(target, key, original || {}, true);
}
function $789fbdfdf9798b8b$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
let $789fbdfdf9798b8b$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $789fbdfdf9798b8b$var$nowTimestamp = ()=>new Date().getTime();
function $789fbdfdf9798b8b$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : $789fbdfdf9798b8b$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_)=>_.documentElement,
            'access',
            (_2)=>_2.scrollLeft
        ]) || $789fbdfdf9798b8b$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_3)=>_3.body,
            'optionalAccess',
            (_4)=>_4.parentElement,
            'optionalAccess',
            (_5)=>_5.scrollLeft
        ]) || $789fbdfdf9798b8b$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_6)=>_6.body,
            'optionalAccess',
            (_7)=>_7.scrollLeft
        ]) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : $789fbdfdf9798b8b$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_8)=>_8.documentElement,
            'access',
            (_9)=>_9.scrollTop
        ]) || $789fbdfdf9798b8b$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_10)=>_10.body,
            'optionalAccess',
            (_11)=>_11.parentElement,
            'optionalAccess',
            (_12)=>_12.scrollTop
        ]) || $789fbdfdf9798b8b$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_13)=>_13.body,
            'optionalAccess',
            (_14)=>_14.scrollTop
        ]) || 0
    };
}
function $789fbdfdf9798b8b$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $789fbdfdf9798b8b$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $789fbdfdf9798b8b$var$closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function $789fbdfdf9798b8b$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $789fbdfdf9798b8b$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $789fbdfdf9798b8b$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $789fbdfdf9798b8b$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $789fbdfdf9798b8b$var$distanceToMatch(el, $789fbdfdf9798b8b$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $789fbdfdf9798b8b$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $789fbdfdf9798b8b$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $789fbdfdf9798b8b$var$IGNORED_NODE;
}
function $789fbdfdf9798b8b$var$isAncestorRemoved(target, mirror) {
    if ($789fbdfdf9798b8b$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $789fbdfdf9798b8b$var$isAncestorRemoved(target.parentNode, mirror);
}
function $789fbdfdf9798b8b$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $789fbdfdf9798b8b$var$polyfill(win = window) {
    if ('NodeList' in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ('DOMTokenList' in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError('1 argument is required');
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $789fbdfdf9798b8b$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === 'IFRAME' && mirror.getMeta(n));
}
function $789fbdfdf9798b8b$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === 'LINK' && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute('rel') === 'stylesheet' && mirror.getMeta(n));
}
function $789fbdfdf9798b8b$var$hasShadowRoot(n) {
    return Boolean($789fbdfdf9798b8b$var$_optionalChain$4([
        n,
        'optionalAccess',
        (_18)=>_18.shadowRoot
    ]));
}
class $789fbdfdf9798b8b$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        return (0, $hvuDy._nullishCoalesce)(this.styleIDMap.get(stylesheet), ()=>-1);
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $789fbdfdf9798b8b$var$getShadowHost(n) {
    let shadowHost = null;
    if ($789fbdfdf9798b8b$var$_optionalChain$4([
        n,
        'access',
        (_19)=>_19.getRootNode,
        'optionalCall',
        (_20)=>_20(),
        'optionalAccess',
        (_21)=>_21.nodeType
    ]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $789fbdfdf9798b8b$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $789fbdfdf9798b8b$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $789fbdfdf9798b8b$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $789fbdfdf9798b8b$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $789fbdfdf9798b8b$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $789fbdfdf9798b8b$var$shadowHostInDom(n);
}
const $789fbdfdf9798b8b$var$cachedImplementations = {};
function $789fbdfdf9798b8b$var$getImplementation(name) {
    const cached = $789fbdfdf9798b8b$var$cachedImplementations[name];
    if (cached) return cached;
    const document1 = window.document;
    let impl = window[name];
    if (document1 && typeof document1.createElement === 'function') try {
        const sandbox = document1.createElement('iframe');
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $789fbdfdf9798b8b$var$cachedImplementations[name] = impl.bind(window);
}
function $789fbdfdf9798b8b$var$onRequestAnimationFrame(...rest) {
    return $789fbdfdf9798b8b$var$getImplementation('requestAnimationFrame')(...rest);
}
function $789fbdfdf9798b8b$var$setTimeout$1(...rest) {
    return $789fbdfdf9798b8b$var$getImplementation('setTimeout')(...rest);
}
function $789fbdfdf9798b8b$var$clearTimeout$1(...rest) {
    return $789fbdfdf9798b8b$var$getImplementation('clearTimeout')(...rest);
}
var $789fbdfdf9798b8b$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($789fbdfdf9798b8b$var$EventType || {});
var $789fbdfdf9798b8b$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($789fbdfdf9798b8b$var$IncrementalSource || {});
var $789fbdfdf9798b8b$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($789fbdfdf9798b8b$var$MouseInteractions || {});
var $789fbdfdf9798b8b$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($789fbdfdf9798b8b$var$PointerTypes || {});
function $789fbdfdf9798b8b$var$_optionalChain$3(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $789fbdfdf9798b8b$var$isNodeInLinkedList(n) {
    return '__ln' in n;
}
class $789fbdfdf9798b8b$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error('Position outside of list range');
        let current = this.head;
        for(let index = 0; index < position; index++)current = $789fbdfdf9798b8b$var$_optionalChain$3([
            current,
            'optionalAccess',
            (_)=>_.next
        ]) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $789fbdfdf9798b8b$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $789fbdfdf9798b8b$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $789fbdfdf9798b8b$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $789fbdfdf9798b8b$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new $789fbdfdf9798b8b$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $789fbdfdf9798b8b$var$IGNORED_NODE;
                while(nextId === $789fbdfdf9798b8b$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !$789fbdfdf9798b8b$var$inDom(n)) return;
                const parentId = $789fbdfdf9798b8b$var$isShadowRoot(n.parentNode) ? this.mirror.getId($789fbdfdf9798b8b$var$getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = $789fbdfdf9798b8b$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($789fbdfdf9798b8b$var$isSerializedIframe(currentN, this.mirror)) this.iframeManager.addIframe(currentN);
                        if ($789fbdfdf9798b8b$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($789fbdfdf9798b8b$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($789fbdfdf9798b8b$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$789fbdfdf9798b8b$var$isAncestorInSet(this.droppedSet, n) && !$789fbdfdf9798b8b$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($789fbdfdf9798b8b$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === 'string') {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split('var(').length === attributes.style.split('var(').length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = new WeakMap();
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($789fbdfdf9798b8b$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case 'characterData':
                    {
                        const value = m.target.textContent;
                        if (!$789fbdfdf9798b8b$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $789fbdfdf9798b8b$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $789fbdfdf9798b8b$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, '*') : value,
                            node: m.target
                        });
                        break;
                    }
                case 'attributes':
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === 'value') {
                            const type = $789fbdfdf9798b8b$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $789fbdfdf9798b8b$var$getInputValue(target, tagName, type);
                            const isInputMasked = $789fbdfdf9798b8b$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $789fbdfdf9798b8b$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $789fbdfdf9798b8b$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($789fbdfdf9798b8b$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === 'IFRAME' && attributeName === 'src' && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) attributeName = 'rr_src';
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === 'type' && target.tagName === 'INPUT' && (m.oldValue || '').toLowerCase() === 'password') target.setAttribute('data-rr-is-password', 'true');
                        if (!$789fbdfdf9798b8b$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $789fbdfdf9798b8b$var$transformAttribute(this.doc, $789fbdfdf9798b8b$var$toLowerCase(target.tagName), $789fbdfdf9798b8b$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === 'style') {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement('span');
                                if (m.oldValue) old.setAttribute('style', m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === '') item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === '') item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case 'childList':
                    if ($789fbdfdf9798b8b$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $789fbdfdf9798b8b$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($789fbdfdf9798b8b$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $789fbdfdf9798b8b$var$isIgnored(n, this.mirror) || !$789fbdfdf9798b8b$var$isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            $789fbdfdf9798b8b$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($789fbdfdf9798b8b$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$789fbdfdf9798b8b$var$moveKey(nodeId, parentId)]) $789fbdfdf9798b8b$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $789fbdfdf9798b8b$var$isShadowRoot(m.target) && $789fbdfdf9798b8b$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if ($789fbdfdf9798b8b$var$isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$789fbdfdf9798b8b$var$moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$789fbdfdf9798b8b$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($789fbdfdf9798b8b$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
    init(options) {
        [
            'mutationCb',
            'blockClass',
            'blockSelector',
            'unblockSelector',
            'maskAllText',
            'maskTextClass',
            'unmaskTextClass',
            'maskTextSelector',
            'unmaskTextSelector',
            'inlineStylesheet',
            'maskInputOptions',
            'maskAttributeFn',
            'maskTextFn',
            'maskInputFn',
            'keepIframeSrcFn',
            'recordCanvas',
            'inlineImages',
            'slimDOMOptions',
            'dataURLOptions',
            'doc',
            'mirror',
            'iframeManager',
            'stylesheetManager',
            'shadowDomManager',
            'canvasManager',
            'processedNodeManager'
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $789fbdfdf9798b8b$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$789fbdfdf9798b8b$var$deepDelete(addsSet, childN));
}
function $789fbdfdf9798b8b$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $789fbdfdf9798b8b$var$_isParentRemoved(removes, n, mirror);
}
function $789fbdfdf9798b8b$var$_isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $789fbdfdf9798b8b$var$_isParentRemoved(removes, parentNode, mirror);
}
function $789fbdfdf9798b8b$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $789fbdfdf9798b8b$var$_isAncestorInSet(set, n);
}
function $789fbdfdf9798b8b$var$_isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $789fbdfdf9798b8b$var$_isAncestorInSet(set, parentNode);
}
let $789fbdfdf9798b8b$var$errorHandler;
function $789fbdfdf9798b8b$var$registerErrorHandler(handler) {
    $789fbdfdf9798b8b$var$errorHandler = handler;
}
function $789fbdfdf9798b8b$var$unregisterErrorHandler() {
    $789fbdfdf9798b8b$var$errorHandler = undefined;
}
const $789fbdfdf9798b8b$var$callbackWrapper = (cb)=>{
    if (!$789fbdfdf9798b8b$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($789fbdfdf9798b8b$var$errorHandler && $789fbdfdf9798b8b$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
function $789fbdfdf9798b8b$var$_optionalChain$2(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $789fbdfdf9798b8b$var$mutationBuffers = [];
function $789fbdfdf9798b8b$var$getEventTarget(event) {
    try {
        if ('composedPath' in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ('path' in event && event.path.length) return event.path[0];
    } catch (e2) {}
    return event && event.target;
}
function $789fbdfdf9798b8b$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $789fbdfdf9798b8b$var$MutationBuffer();
    $789fbdfdf9798b8b$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = $789fbdfdf9798b8b$var$_optionalChain$2([
        window,
        'optionalAccess',
        (_)=>_.Zone,
        'optionalAccess',
        (_2)=>_2.__symbol__,
        'optionalCall',
        (_3)=>_3('MutationObserver')
    ]);
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($789fbdfdf9798b8b$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $789fbdfdf9798b8b$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === 'number' ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === 'number' ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $789fbdfdf9798b8b$var$throttle$1($789fbdfdf9798b8b$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $789fbdfdf9798b8b$var$callbackWrapper($789fbdfdf9798b8b$var$throttle$1($789fbdfdf9798b8b$var$callbackWrapper((evt)=>{
        const target = $789fbdfdf9798b8b$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $789fbdfdf9798b8b$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $789fbdfdf9798b8b$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $789fbdfdf9798b8b$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== 'undefined' && evt instanceof DragEvent ? $789fbdfdf9798b8b$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $789fbdfdf9798b8b$var$IncrementalSource.MouseMove : $789fbdfdf9798b8b$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $789fbdfdf9798b8b$var$on('mousemove', updatePosition, doc),
        $789fbdfdf9798b8b$var$on('touchmove', updatePosition, doc),
        $789fbdfdf9798b8b$var$on('drag', updatePosition, doc)
    ];
    return $789fbdfdf9798b8b$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $789fbdfdf9798b8b$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $789fbdfdf9798b8b$var$getEventTarget(event);
            if ($789fbdfdf9798b8b$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ('pointerType' in event) {
                switch(event.pointerType){
                    case 'mouse':
                        pointerType = $789fbdfdf9798b8b$var$PointerTypes.Mouse;
                        break;
                    case 'touch':
                        pointerType = $789fbdfdf9798b8b$var$PointerTypes.Touch;
                        break;
                    case 'pen':
                        pointerType = $789fbdfdf9798b8b$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $789fbdfdf9798b8b$var$PointerTypes.Touch) {
                    if ($789fbdfdf9798b8b$var$MouseInteractions[eventKey] === $789fbdfdf9798b8b$var$MouseInteractions.MouseDown) thisEventKey = 'TouchStart';
                    else if ($789fbdfdf9798b8b$var$MouseInteractions[eventKey] === $789fbdfdf9798b8b$var$MouseInteractions.MouseUp) thisEventKey = 'TouchEnd';
                } else $789fbdfdf9798b8b$var$PointerTypes.Pen;
            } else if ($789fbdfdf9798b8b$var$legacy_isTouchEvent(event)) pointerType = $789fbdfdf9798b8b$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith('Touch') && pointerType === $789fbdfdf9798b8b$var$PointerTypes.Touch || thisEventKey.startsWith('Mouse') && pointerType === $789fbdfdf9798b8b$var$PointerTypes.Mouse) pointerType = null;
            } else if ($789fbdfdf9798b8b$var$MouseInteractions[eventKey] === $789fbdfdf9798b8b$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = $789fbdfdf9798b8b$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $789fbdfdf9798b8b$var$callbackWrapper(mouseInteractionCb)({
                type: $789fbdfdf9798b8b$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($789fbdfdf9798b8b$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith('_Departed') && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $789fbdfdf9798b8b$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($789fbdfdf9798b8b$var$MouseInteractions[eventKey]){
            case $789fbdfdf9798b8b$var$MouseInteractions.MouseDown:
            case $789fbdfdf9798b8b$var$MouseInteractions.MouseUp:
                eventName = eventName.replace('mouse', 'pointer');
                break;
            case $789fbdfdf9798b8b$var$MouseInteractions.TouchStart:
            case $789fbdfdf9798b8b$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($789fbdfdf9798b8b$var$on(eventName, handler, doc));
    });
    return $789fbdfdf9798b8b$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $789fbdfdf9798b8b$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $789fbdfdf9798b8b$var$callbackWrapper($789fbdfdf9798b8b$var$throttle$1($789fbdfdf9798b8b$var$callbackWrapper((evt)=>{
        const target = $789fbdfdf9798b8b$var$getEventTarget(evt);
        if (!target || $789fbdfdf9798b8b$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $789fbdfdf9798b8b$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $789fbdfdf9798b8b$var$on('scroll', updatePosition, doc);
}
function $789fbdfdf9798b8b$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $789fbdfdf9798b8b$var$callbackWrapper($789fbdfdf9798b8b$var$throttle$1($789fbdfdf9798b8b$var$callbackWrapper(()=>{
        const height = $789fbdfdf9798b8b$var$getWindowHeight();
        const width = $789fbdfdf9798b8b$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $789fbdfdf9798b8b$var$on('resize', updateDimension, win);
}
const $789fbdfdf9798b8b$var$INPUT_TAGS = [
    'INPUT',
    'TEXTAREA',
    'SELECT'
];
const $789fbdfdf9798b8b$var$lastInputValueMap = new WeakMap();
function $789fbdfdf9798b8b$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $789fbdfdf9798b8b$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $789fbdfdf9798b8b$var$toUpperCase(target.tagName);
        if (tagName === 'OPTION') target = target.parentElement;
        if (!target || !tagName || $789fbdfdf9798b8b$var$INPUT_TAGS.indexOf(tagName) < 0 || $789fbdfdf9798b8b$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $789fbdfdf9798b8b$var$getInputType(target);
        let text = $789fbdfdf9798b8b$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $789fbdfdf9798b8b$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $789fbdfdf9798b8b$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === 'radio' || type === 'checkbox') isChecked = target.checked;
        text = $789fbdfdf9798b8b$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === 'radio' && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $789fbdfdf9798b8b$var$maskInputValue({
                    isMasked: forceMask,
                    element: el,
                    value: $789fbdfdf9798b8b$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $789fbdfdf9798b8b$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $789fbdfdf9798b8b$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            $789fbdfdf9798b8b$var$callbackWrapper(inputCb)({
                ...v,
                id: id
            });
        }
    }
    const events = sampling.input === 'last' ? [
        'change'
    ] : [
        'input',
        'change'
    ];
    const handlers = events.map((eventName)=>$789fbdfdf9798b8b$var$on(eventName, $789fbdfdf9798b8b$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, 'value');
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            'checked'
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            'selectedIndex'
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            'selected'
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$789fbdfdf9798b8b$var$hookSetter(p[0], p[1], {
            set () {
                $789fbdfdf9798b8b$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $789fbdfdf9798b8b$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $789fbdfdf9798b8b$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($789fbdfdf9798b8b$var$hasNestedCSSRule('CSSGroupingRule') && childRule.parentRule instanceof CSSGroupingRule || $789fbdfdf9798b8b$var$hasNestedCSSRule('CSSMediaRule') && childRule.parentRule instanceof CSSMediaRule || $789fbdfdf9798b8b$var$hasNestedCSSRule('CSSSupportsRule') && childRule.parentRule instanceof CSSSupportsRule || $789fbdfdf9798b8b$var$hasNestedCSSRule('CSSConditionRule') && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $789fbdfdf9798b8b$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $789fbdfdf9798b8b$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $789fbdfdf9798b8b$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $789fbdfdf9798b8b$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $789fbdfdf9798b8b$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $789fbdfdf9798b8b$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $789fbdfdf9798b8b$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $789fbdfdf9798b8b$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $789fbdfdf9798b8b$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $789fbdfdf9798b8b$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($789fbdfdf9798b8b$var$canMonkeyPatchNestedCSSRule('CSSGroupingRule')) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($789fbdfdf9798b8b$var$canMonkeyPatchNestedCSSRule('CSSMediaRule')) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($789fbdfdf9798b8b$var$canMonkeyPatchNestedCSSRule('CSSConditionRule')) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($789fbdfdf9798b8b$var$canMonkeyPatchNestedCSSRule('CSSSupportsRule')) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $789fbdfdf9798b8b$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $789fbdfdf9798b8b$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$789fbdfdf9798b8b$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $789fbdfdf9798b8b$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $789fbdfdf9798b8b$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$789fbdfdf9798b8b$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $789fbdfdf9798b8b$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $789fbdfdf9798b8b$var$initAdoptedStyleSheetObserver({ mirror: mirror, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === '#document') hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === '#document' ? $789fbdfdf9798b8b$var$_optionalChain$2([
        host,
        'access',
        (_4)=>_4.defaultView,
        'optionalAccess',
        (_5)=>_5.Document
    ]) : $789fbdfdf9798b8b$var$_optionalChain$2([
        host,
        'access',
        (_6)=>_6.ownerDocument,
        'optionalAccess',
        (_7)=>_7.defaultView,
        'optionalAccess',
        (_8)=>_8.ShadowRoot
    ]);
    const originalPropertyDescriptor = $789fbdfdf9798b8b$var$_optionalChain$2([
        patchTarget,
        'optionalAccess',
        (_9)=>_9.prototype
    ]) ? Object.getOwnPropertyDescriptor($789fbdfdf9798b8b$var$_optionalChain$2([
        patchTarget,
        'optionalAccess',
        (_10)=>_10.prototype
    ]), 'adoptedStyleSheets') : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, 'adoptedStyleSheets', {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return $789fbdfdf9798b8b$var$_optionalChain$2([
                originalPropertyDescriptor,
                'access',
                (_11)=>_11.get,
                'optionalAccess',
                (_12)=>_12.call,
                'call',
                (_13)=>_13(this)
            ]);
        },
        set (sheets) {
            const result = $789fbdfdf9798b8b$var$_optionalChain$2([
                originalPropertyDescriptor,
                'access',
                (_14)=>_14.set,
                'optionalAccess',
                (_15)=>_15.call,
                'call',
                (_16)=>_16(this, sheets)
            ]);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $789fbdfdf9798b8b$var$callbackWrapper(()=>{
        Object.defineProperty(host, 'adoptedStyleSheets', {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $789fbdfdf9798b8b$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $789fbdfdf9798b8b$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $789fbdfdf9798b8b$var$getIdAndStyleId($789fbdfdf9798b8b$var$_optionalChain$2([
                thisArg,
                'access',
                (_17)=>_17.parentRule,
                'optionalAccess',
                (_18)=>_18.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $789fbdfdf9798b8b$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $789fbdfdf9798b8b$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $789fbdfdf9798b8b$var$getIdAndStyleId($789fbdfdf9798b8b$var$_optionalChain$2([
                thisArg,
                'access',
                (_19)=>_19.parentRule,
                'optionalAccess',
                (_20)=>_20.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $789fbdfdf9798b8b$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $789fbdfdf9798b8b$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $789fbdfdf9798b8b$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling, doc: doc }) {
    const handler = $789fbdfdf9798b8b$var$callbackWrapper((type)=>$789fbdfdf9798b8b$var$throttle$1($789fbdfdf9798b8b$var$callbackWrapper((event)=>{
            const target = $789fbdfdf9798b8b$var$getEventTarget(event);
            if (!target || $789fbdfdf9798b8b$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $789fbdfdf9798b8b$var$on('play', handler(0), doc),
        $789fbdfdf9798b8b$var$on('pause', handler(1), doc),
        $789fbdfdf9798b8b$var$on('seeked', handler(2), doc),
        $789fbdfdf9798b8b$var$on('volumechange', handler(3), doc),
        $789fbdfdf9798b8b$var$on('ratechange', handler(4), doc)
    ];
    return $789fbdfdf9798b8b$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $789fbdfdf9798b8b$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== 'string',
            descriptors: descriptors,
            fontSource: typeof source === 'string' ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $789fbdfdf9798b8b$var$patch(doc.fonts, 'add', function(original) {
        return function(fontFace) {
            $789fbdfdf9798b8b$var$setTimeout$1($789fbdfdf9798b8b$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $789fbdfdf9798b8b$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $789fbdfdf9798b8b$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $789fbdfdf9798b8b$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && $789fbdfdf9798b8b$var$_optionalChain$2([
            selection,
            'optionalAccess',
            (_21)=>_21.isCollapsed
        ])) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $789fbdfdf9798b8b$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $789fbdfdf9798b8b$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $789fbdfdf9798b8b$var$on('selectionchange', updateSelection);
}
function $789fbdfdf9798b8b$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $789fbdfdf9798b8b$var$patch(win.customElements, 'define', function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $789fbdfdf9798b8b$var$initObservers(o, _hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    const mutationObserver = $789fbdfdf9798b8b$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $789fbdfdf9798b8b$var$initMoveObserver(o);
    const mouseInteractionHandler = $789fbdfdf9798b8b$var$initMouseInteractionObserver(o);
    const scrollHandler = $789fbdfdf9798b8b$var$initScrollObserver(o);
    const viewportResizeHandler = $789fbdfdf9798b8b$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = $789fbdfdf9798b8b$var$initInputObserver(o);
    const mediaInteractionHandler = $789fbdfdf9798b8b$var$initMediaInteractionObserver(o);
    const styleSheetObserver = $789fbdfdf9798b8b$var$initStyleSheetObserver(o, {
        win: currentWindow
    });
    const adoptedStyleSheetObserver = $789fbdfdf9798b8b$var$initAdoptedStyleSheetObserver(o, o.doc);
    const styleDeclarationObserver = $789fbdfdf9798b8b$var$initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    const fontObserver = o.collectFonts ? $789fbdfdf9798b8b$var$initFontObserver(o) : ()=>{};
    const selectionObserver = $789fbdfdf9798b8b$var$initSelectionObserver(o);
    const customElementObserver = $789fbdfdf9798b8b$var$initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $789fbdfdf9798b8b$var$callbackWrapper(()=>{
        $789fbdfdf9798b8b$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $789fbdfdf9798b8b$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== 'undefined';
}
function $789fbdfdf9798b8b$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== 'undefined' && window[prop].prototype && 'insertRule' in window[prop].prototype && 'deleteRule' in window[prop].prototype);
}
class $789fbdfdf9798b8b$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== 'number') return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
function $789fbdfdf9798b8b$var$_optionalChain$1(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
class $789fbdfdf9798b8b$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $789fbdfdf9798b8b$var$CrossOriginIframeMirror($789fbdfdf9798b8b$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $789fbdfdf9798b8b$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $789fbdfdf9798b8b$var$CrossOriginIframeMirror($789fbdfdf9798b8b$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $789fbdfdf9798b8b$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener('message', this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        $789fbdfdf9798b8b$var$_optionalChain$1([
            this,
            'access',
            (_)=>_.loadListener,
            'optionalCall',
            (_2)=>_2(iframeEl)
        ]);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== 'rrweb' || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        switch(e.type){
            case $789fbdfdf9798b8b$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $789fbdfdf9798b8b$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $789fbdfdf9798b8b$var$EventType.Meta:
            case $789fbdfdf9798b8b$var$EventType.Load:
            case $789fbdfdf9798b8b$var$EventType.DomContentLoaded:
                return false;
            case $789fbdfdf9798b8b$var$EventType.Plugin:
                return e;
            case $789fbdfdf9798b8b$var$EventType.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    'id',
                    'parentId',
                    'previousId',
                    'nextId'
                ]);
                return e;
            case $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot:
                switch(e.data.source){
                    case $789fbdfdf9798b8b$var$IncrementalSource.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'parentId',
                                'nextId',
                                'previousId'
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'parentId',
                                'id'
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'id'
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'id'
                            ]);
                        });
                        return e;
                    case $789fbdfdf9798b8b$var$IncrementalSource.Drag:
                    case $789fbdfdf9798b8b$var$IncrementalSource.TouchMove:
                    case $789fbdfdf9798b8b$var$IncrementalSource.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                'id'
                            ]);
                        });
                        return e;
                    case $789fbdfdf9798b8b$var$IncrementalSource.ViewportResize:
                        return false;
                    case $789fbdfdf9798b8b$var$IncrementalSource.MediaInteraction:
                    case $789fbdfdf9798b8b$var$IncrementalSource.MouseInteraction:
                    case $789fbdfdf9798b8b$var$IncrementalSource.Scroll:
                    case $789fbdfdf9798b8b$var$IncrementalSource.CanvasMutation:
                    case $789fbdfdf9798b8b$var$IncrementalSource.Input:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        return e;
                    case $789fbdfdf9798b8b$var$IncrementalSource.StyleSheetRule:
                    case $789fbdfdf9798b8b$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            'styleId'
                        ]);
                        return e;
                    case $789fbdfdf9798b8b$var$IncrementalSource.Font:
                        return e;
                    case $789fbdfdf9798b8b$var$IncrementalSource.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                'start',
                                'end'
                            ]);
                        });
                        return e;
                    case $789fbdfdf9798b8b$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            'styleIds'
                        ]);
                        $789fbdfdf9798b8b$var$_optionalChain$1([
                            e,
                            'access',
                            (_3)=>_3.data,
                            'access',
                            (_4)=>_4.styles,
                            'optionalAccess',
                            (_5)=>_5.forEach,
                            'call',
                            (_6)=>_6((style)=>{
                                    this.replaceStyleIds(style, iframeEl, [
                                        'styleId'
                                    ]);
                                })
                        ]);
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== 'number') continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            'id',
            'rootId'
        ]);
        if ('childNodes' in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $789fbdfdf9798b8b$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ('childNodes' in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $789fbdfdf9798b8b$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $789fbdfdf9798b8b$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$789fbdfdf9798b8b$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        const observer = $789fbdfdf9798b8b$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($789fbdfdf9798b8b$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $789fbdfdf9798b8b$var$setTimeout$1(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($789fbdfdf9798b8b$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($789fbdfdf9798b8b$var$patch(element.prototype, 'attachShadow', function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $789fbdfdf9798b8b$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
    }
}
class $789fbdfdf9798b8b$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
}
class $789fbdfdf9798b8b$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $789fbdfdf9798b8b$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ('_cssText' in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: $789fbdfdf9798b8b$var$stringifyRule(r),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
}
class $789fbdfdf9798b8b$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
    periodicallyClear() {
        $789fbdfdf9798b8b$var$onRequestAnimationFrame(()=>{
            this.clear();
            if (this.loop) this.periodicallyClear();
        });
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    clear() {
        this.nodeMap = new WeakMap();
    }
    destroy() {
        this.loop = false;
    }
}
let $789fbdfdf9798b8b$var$wrappedEmit;
let $789fbdfdf9798b8b$var$_takeFullSnapshot;
const $789fbdfdf9798b8b$var$mirror = $789fbdfdf9798b8b$var$createMirror();
function $789fbdfdf9798b8b$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = 'rr-block', blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = 'rr-ignore', ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = 'rr-mask', unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === 'DOMContentLoaded' ? options.recordAfter : 'load', userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $789fbdfdf9798b8b$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error('emit function is required');
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $789fbdfdf9798b8b$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === 'all',
        headMetaDescKeywords: _slimDOMOptions === 'all'
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $789fbdfdf9798b8b$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    $789fbdfdf9798b8b$var$wrappedEmit = (r, isCheckout)=>{
        const e = r;
        e.timestamp = $789fbdfdf9798b8b$var$nowTimestamp();
        if ((0, $fF2BR._optionalChain)([
            $789fbdfdf9798b8b$var$mutationBuffers,
            'access',
            (_)=>_[0],
            'optionalAccess',
            (_2)=>_2.isFrozen,
            'call',
            (_3)=>_3()
        ]) && e.type !== $789fbdfdf9798b8b$var$EventType.FullSnapshot && !(e.type === $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot && e.data.source === $789fbdfdf9798b8b$var$IncrementalSource.Mutation)) $789fbdfdf9798b8b$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) (0, $fF2BR._optionalChain)([
            emit,
            'optionalCall',
            (_4)=>_4(eventProcessor(e), isCheckout)
        ]);
        else if (passEmitsToParent) {
            const message = {
                type: 'rrweb',
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, '*');
        }
        if (e.type === $789fbdfdf9798b8b$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot) {
            if (e.data.source === $789fbdfdf9798b8b$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $789fbdfdf9798b8b$var$wrappedEmit({
            type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
            data: {
                source: $789fbdfdf9798b8b$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$789fbdfdf9798b8b$var$wrappedEmit({
            type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
            data: {
                source: $789fbdfdf9798b8b$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$789fbdfdf9798b8b$var$wrappedEmit({
            type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
            data: {
                source: $789fbdfdf9798b8b$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a)=>$789fbdfdf9798b8b$var$wrappedEmit({
            type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
            data: {
                source: $789fbdfdf9798b8b$var$IncrementalSource.AdoptedStyleSheet,
                ...a
            }
        });
    const stylesheetManager = new $789fbdfdf9798b8b$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === 'boolean' && __RRWEB_EXCLUDE_IFRAME__ ? new $789fbdfdf9798b8b$var$IframeManagerNoop() : new $789fbdfdf9798b8b$var$IframeManager({
        mirror: $789fbdfdf9798b8b$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $789fbdfdf9798b8b$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $789fbdfdf9798b8b$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $789fbdfdf9798b8b$var$ProcessedNodeManager();
    const canvasManager = $789fbdfdf9798b8b$var$_getCanvasManager(getCanvasManager, {
        mirror: $789fbdfdf9798b8b$var$mirror,
        win: window,
        mutationCb: (p)=>$789fbdfdf9798b8b$var$wrappedEmit({
                type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                data: {
                    source: $789fbdfdf9798b8b$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling['canvas'],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === 'boolean' && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $789fbdfdf9798b8b$var$ShadowDomManagerNoop() : new $789fbdfdf9798b8b$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $789fbdfdf9798b8b$var$mirror
    });
    const takeFullSnapshot = (isCheckout = false)=>{
        $789fbdfdf9798b8b$var$wrappedEmit({
            type: $789fbdfdf9798b8b$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $789fbdfdf9798b8b$var$getWindowWidth(),
                height: $789fbdfdf9798b8b$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $789fbdfdf9798b8b$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $789fbdfdf9798b8b$var$snapshot(document, {
            mirror: $789fbdfdf9798b8b$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($789fbdfdf9798b8b$var$isSerializedIframe(n, $789fbdfdf9798b8b$var$mirror)) iframeManager.addIframe(n);
                if ($789fbdfdf9798b8b$var$isSerializedStylesheet(n, $789fbdfdf9798b8b$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($789fbdfdf9798b8b$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn('Failed to snapshot the document');
        $789fbdfdf9798b8b$var$wrappedEmit({
            type: $789fbdfdf9798b8b$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $789fbdfdf9798b8b$var$getWindowScroll(window)
            }
        });
        $789fbdfdf9798b8b$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $789fbdfdf9798b8b$var$mirror.getId(document));
    };
    $789fbdfdf9798b8b$var$_takeFullSnapshot = takeFullSnapshot;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $789fbdfdf9798b8b$var$callbackWrapper($789fbdfdf9798b8b$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$789fbdfdf9798b8b$var$wrappedEmit({
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$789fbdfdf9798b8b$var$wrappedEmit({
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $789fbdfdf9798b8b$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$789fbdfdf9798b8b$var$wrappedEmit({
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $789fbdfdf9798b8b$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v)=>$789fbdfdf9798b8b$var$wrappedEmit({
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $789fbdfdf9798b8b$var$IncrementalSource.Input,
                            ...v
                        }
                    }),
                mediaInteractionCb: (p)=>$789fbdfdf9798b8b$var$wrappedEmit({
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $789fbdfdf9798b8b$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r)=>$789fbdfdf9798b8b$var$wrappedEmit({
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $789fbdfdf9798b8b$var$IncrementalSource.StyleSheetRule,
                            ...r
                        }
                    }),
                styleDeclarationCb: (r)=>$789fbdfdf9798b8b$var$wrappedEmit({
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $789fbdfdf9798b8b$var$IncrementalSource.StyleDeclaration,
                            ...r
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$789fbdfdf9798b8b$var$wrappedEmit({
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $789fbdfdf9798b8b$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $789fbdfdf9798b8b$var$wrappedEmit({
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $789fbdfdf9798b8b$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c)=>{
                    $789fbdfdf9798b8b$var$wrappedEmit({
                        type: $789fbdfdf9798b8b$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $789fbdfdf9798b8b$var$IncrementalSource.CustomElement,
                            ...c
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $789fbdfdf9798b8b$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (0, $fF2BR._optionalChain)([
                    plugins,
                    'optionalAccess',
                    (_5)=>_5.filter,
                    'call',
                    (_6)=>_6((p)=>p.observer),
                    'optionalAccess',
                    (_7)=>_7.map,
                    'call',
                    (_8)=>_8((p)=>({
                                observer: p.observer,
                                options: p.options,
                                callback: (payload)=>$789fbdfdf9798b8b$var$wrappedEmit({
                                        type: $789fbdfdf9798b8b$var$EventType.Plugin,
                                        data: {
                                            plugin: p.name,
                                            payload: payload
                                        }
                                    })
                            }))
                ]) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === 'interactive' || document.readyState === 'complete') init();
        else {
            handlers.push($789fbdfdf9798b8b$var$on('DOMContentLoaded', ()=>{
                $789fbdfdf9798b8b$var$wrappedEmit({
                    type: $789fbdfdf9798b8b$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === 'DOMContentLoaded') init();
            }));
            handlers.push($789fbdfdf9798b8b$var$on('load', ()=>{
                $789fbdfdf9798b8b$var$wrappedEmit({
                    type: $789fbdfdf9798b8b$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === 'load') init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $789fbdfdf9798b8b$var$_takeFullSnapshot = undefined;
            $789fbdfdf9798b8b$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $789fbdfdf9798b8b$var$takeFullSnapshot(isCheckout) {
    if (!$789fbdfdf9798b8b$var$_takeFullSnapshot) throw new Error('please take full snapshot after start recording');
    $789fbdfdf9798b8b$var$_takeFullSnapshot(isCheckout);
}
$789fbdfdf9798b8b$var$record.mirror = $789fbdfdf9798b8b$var$mirror;
$789fbdfdf9798b8b$var$record.takeFullSnapshot = $789fbdfdf9798b8b$var$takeFullSnapshot;
function $789fbdfdf9798b8b$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $789fbdfdf9798b8b$var$CanvasManagerNoop();
    } catch (e2) {
        console.warn('Unable to initialize CanvasManager');
        return new $789fbdfdf9798b8b$var$CanvasManagerNoop();
    }
}
const $789fbdfdf9798b8b$var$ReplayEventTypeIncrementalSnapshot = 3;
const $789fbdfdf9798b8b$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $789fbdfdf9798b8b$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $789fbdfdf9798b8b$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $789fbdfdf9798b8b$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === 'sentry.transaction') return;
    if ([
        'ui.click',
        'ui.input'
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $789fbdfdf9798b8b$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: 'breadcrumb',
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $5vnYi.normalize)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === 'console';
    });
}
const $789fbdfdf9798b8b$var$INTERACTIVE_SELECTOR = 'button,a';
/** Get the closest interactive parent element, or else return the given element. */ function $789fbdfdf9798b8b$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($789fbdfdf9798b8b$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $789fbdfdf9798b8b$var$getClickTargetNode(event) {
    const target = $789fbdfdf9798b8b$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $789fbdfdf9798b8b$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $789fbdfdf9798b8b$var$getTargetNode(event) {
    if ($789fbdfdf9798b8b$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $789fbdfdf9798b8b$var$isEventWithTarget(event) {
    return typeof event === 'object' && !!event && 'target' in event;
}
let $789fbdfdf9798b8b$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $789fbdfdf9798b8b$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$789fbdfdf9798b8b$var$handlers) {
        $789fbdfdf9798b8b$var$handlers = [];
        $789fbdfdf9798b8b$var$monkeyPatchWindowOpen();
    }
    $789fbdfdf9798b8b$var$handlers.push(cb);
    return ()=>{
        const pos = $789fbdfdf9798b8b$var$handlers ? $789fbdfdf9798b8b$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $789fbdfdf9798b8b$var$handlers.splice(pos, 1);
    };
}
function $789fbdfdf9798b8b$var$monkeyPatchWindowOpen() {
    (0, $aajbp.fill)($789fbdfdf9798b8b$var$WINDOW, 'open', function(originalWindowOpen) {
        return function(...args) {
            if ($789fbdfdf9798b8b$var$handlers) try {
                $789fbdfdf9798b8b$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($789fbdfdf9798b8b$var$WINDOW, args);
        };
    });
}
/** Handle a click. */ function $789fbdfdf9798b8b$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $789fbdfdf9798b8b$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $789fbdfdf9798b8b$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $789fbdfdf9798b8b$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $789fbdfdf9798b8b$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($789fbdfdf9798b8b$var$ignoreElement(node, this._ignoreSelector) || !$789fbdfdf9798b8b$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $789fbdfdf9798b8b$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $789fbdfdf9798b8b$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $789fbdfdf9798b8b$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $789fbdfdf9798b8b$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $789fbdfdf9798b8b$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? 'mutation' : 'timeout';
            const breadcrumb = {
                type: 'default',
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: 'ui.slowClickDetected',
                data: {
                    ...clickBreadcrumb.data,
                    url: $789fbdfdf9798b8b$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: 'default',
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: 'ui.multiClick',
                data: {
                    ...clickBreadcrumb.data,
                    url: $789fbdfdf9798b8b$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = setTimeout(()=>this._checkClicks(), 1000);
    }
}
const $789fbdfdf9798b8b$var$SLOW_CLICK_TAGS = [
    'A',
    'BUTTON',
    'INPUT'
];
/** exported for tests only */ function $789fbdfdf9798b8b$var$ignoreElement(node, ignoreSelector) {
    if (!$789fbdfdf9798b8b$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === 'INPUT' && ![
        'submit',
        'button'
    ].includes(node.getAttribute('type') || '')) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === 'A' && (node.hasAttribute('download') || node.hasAttribute('target') && node.getAttribute('target') !== '_self')) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $789fbdfdf9798b8b$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === 'number' && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $789fbdfdf9798b8b$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $789fbdfdf9798b8b$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$789fbdfdf9798b8b$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if (source === $789fbdfdf9798b8b$var$IncrementalSource.Mutation) clickDetector.registerMutation(event.timestamp);
        if (source === $789fbdfdf9798b8b$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($789fbdfdf9798b8b$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $789fbdfdf9798b8b$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $789fbdfdf9798b8b$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $789fbdfdf9798b8b$var$isIncrementalEvent(event) {
    return event.type === $789fbdfdf9798b8b$var$ReplayEventTypeIncrementalSnapshot;
}
function $789fbdfdf9798b8b$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $789fbdfdf9798b8b$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $789fbdfdf9798b8b$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: 'default',
        ...breadcrumb
    };
}
var $789fbdfdf9798b8b$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($789fbdfdf9798b8b$var$NodeType || ($789fbdfdf9798b8b$var$NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $789fbdfdf9798b8b$var$ATTRIBUTES_TO_RECORD = new Set([
    'id',
    'class',
    'aria-label',
    'role',
    'name',
    'alt',
    'title',
    'data-test-id',
    'data-testid',
    'disabled',
    'aria-disabled',
    'data-sentry-component'
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $789fbdfdf9798b8b$var$getAttributesToRecord(attributes) {
    const obj = {};
    for(const key in attributes)if ($789fbdfdf9798b8b$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === 'data-testid' || key === 'data-test-id') normalizedKey = 'testId';
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $789fbdfdf9798b8b$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $789fbdfdf9798b8b$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === 'click';
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $789fbdfdf9798b8b$var$handleClick(replay.clickDetector, result, $789fbdfdf9798b8b$var$getClickTargetNode(handlerData.event));
        $789fbdfdf9798b8b$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $789fbdfdf9798b8b$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $789fbdfdf9798b8b$var$record.mirror.getId(target);
    const node = nodeId && $789fbdfdf9798b8b$var$record.mirror.getNode(nodeId);
    const meta = node && $789fbdfdf9798b8b$var$record.mirror.getMeta(node);
    const element = meta && $789fbdfdf9798b8b$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $789fbdfdf9798b8b$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(''),
                attributes: $789fbdfdf9798b8b$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $789fbdfdf9798b8b$var$handleDom(handlerData) {
    const { target: target, message: message } = $789fbdfdf9798b8b$var$getDomTarget(handlerData);
    return $789fbdfdf9798b8b$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$789fbdfdf9798b8b$var$getBaseDomBreadcrumb(target, message)
    });
}
function $789fbdfdf9798b8b$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === 'click';
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $789fbdfdf9798b8b$var$getClickTargetNode(handlerData.event) : $789fbdfdf9798b8b$var$getTargetNode(handlerData.event);
        message = (0, $04wr6.htmlTreeAsString)(target, {
            maxStringLength: 200
        }) || '<unknown>';
    } catch (e) {
        message = '<unknown>';
    }
    return {
        target: target,
        message: message
    };
}
function $789fbdfdf9798b8b$var$isElement(node) {
    return node.type === $789fbdfdf9798b8b$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $789fbdfdf9798b8b$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $789fbdfdf9798b8b$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $789fbdfdf9798b8b$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $789fbdfdf9798b8b$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $789fbdfdf9798b8b$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $04wr6.htmlTreeAsString)(target, {
        maxStringLength: 200
    }) || '<unknown>';
    const baseBreadcrumb = $789fbdfdf9798b8b$var$getBaseDomBreadcrumb(target, message);
    return $789fbdfdf9798b8b$var$createBreadcrumb({
        category: 'ui.keyDown',
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $789fbdfdf9798b8b$var$isInputElement(target) {
    return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $789fbdfdf9798b8b$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $789fbdfdf9798b8b$var$createResourceEntry,
    paint: $789fbdfdf9798b8b$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $789fbdfdf9798b8b$var$createNavigationEntry
};
/**
 * Create replay performance entries from the browser performance entries.
 */ function $789fbdfdf9798b8b$var$createPerformanceEntries(entries) {
    return entries.map($789fbdfdf9798b8b$var$createPerformanceEntry).filter(Boolean);
}
function $789fbdfdf9798b8b$var$createPerformanceEntry(entry) {
    if (!$789fbdfdf9798b8b$var$ENTRY_TYPES[entry.entryType]) return null;
    return $789fbdfdf9798b8b$var$ENTRY_TYPES[entry.entryType](entry);
}
function $789fbdfdf9798b8b$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $iGf0k.browserPerformanceTimeOrigin) || $789fbdfdf9798b8b$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $789fbdfdf9798b8b$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $789fbdfdf9798b8b$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $789fbdfdf9798b8b$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $789fbdfdf9798b8b$var$getAbsoluteTime(startTime),
        end: $789fbdfdf9798b8b$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $789fbdfdf9798b8b$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        'fetch',
        'xmlhttprequest'
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $789fbdfdf9798b8b$var$getAbsoluteTime(startTime),
        end: $789fbdfdf9798b8b$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on an LCP metric.
 */ function $789fbdfdf9798b8b$var$getLargestContentfulPaint(metric) {
    const entries = metric.entries;
    const lastEntry = entries[entries.length - 1];
    const element = lastEntry ? lastEntry.element : undefined;
    const value = metric.value;
    const end = $789fbdfdf9798b8b$var$getAbsoluteTime(value);
    const data = {
        type: 'largest-contentful-paint',
        name: 'largest-contentful-paint',
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            nodeId: element ? $789fbdfdf9798b8b$var$record.mirror.getId(element) : undefined
        }
    };
    return data;
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $789fbdfdf9798b8b$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        'navigation',
        'paint',
        'resource'
    ].forEach((type)=>{
        clearCallbacks.push((0, $aiNal.addPerformanceInstrumentationHandler)(type, onEntries));
    });
    clearCallbacks.push((0, $aiNal.addLcpInstrumentationHandler)(({ metric: metric })=>{
        replay.replayPerformanceEntries.push($789fbdfdf9798b8b$var$getLargestContentfulPaint(metric));
    }));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $789fbdfdf9798b8b$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
const $789fbdfdf9798b8b$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,a=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),s=a.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(a,n),O(a,s-8,r.d()),O(a,s-4,e),a}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(G)return G.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(let r=0,e=t.length;r<e;r++)n+=t[r].length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $789fbdfdf9798b8b$var$e() {
    const e = new Blob([
        $789fbdfdf9798b8b$var$r
    ]);
    return URL.createObjectURL(e);
}
/**
 * Log a message in debug mode, and add a breadcrumb when _experiment.traceInternals is enabled.
 */ function $789fbdfdf9798b8b$var$logInfo(message, shouldAddBreadcrumb) {
    if (!$789fbdfdf9798b8b$var$DEBUG_BUILD) return;
    (0, $7p8hL.logger).info(message);
    if (shouldAddBreadcrumb) $789fbdfdf9798b8b$var$addLogBreadcrumb(message);
}
/**
 * Log a message, and add a breadcrumb in the next tick.
 * This is necessary when the breadcrumb may be added before the replay is initialized.
 */ function $789fbdfdf9798b8b$var$logInfoNextTick(message, shouldAddBreadcrumb) {
    if (!$789fbdfdf9798b8b$var$DEBUG_BUILD) return;
    (0, $7p8hL.logger).info(message);
    if (shouldAddBreadcrumb) // Wait a tick here to avoid race conditions for some initial logs
    // which may be added before replay is initialized
    setTimeout(()=>{
        $789fbdfdf9798b8b$var$addLogBreadcrumb(message);
    }, 0);
}
function $789fbdfdf9798b8b$var$addLogBreadcrumb(message) {
    (0, $hcepo.addBreadcrumb)({
        category: 'console',
        data: {
            logger: 'replay'
        },
        level: 'info',
        message: message
    }, {
        level: 'info'
    });
}
/** This error indicates that the event buffer size exceeded the limit.. */ class $789fbdfdf9798b8b$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$789fbdfdf9798b8b$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $789fbdfdf9798b8b$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return 'sync';
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $789fbdfdf9798b8b$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $789fbdfdf9798b8b$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $789fbdfdf9798b8b$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $789fbdfdf9798b8b$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener('message', ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener('error', (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $789fbdfdf9798b8b$var$logInfo('[Replay] Destroying compression worker');
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener('message', listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).error('[Replay]', response.response);
                    reject(new Error('Error in compression worker'));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener('message', listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $789fbdfdf9798b8b$var$EventBufferCompressionWorker {
    /** @inheritdoc */ constructor(worker){
        this._worker = new $789fbdfdf9798b8b$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return 'worker';
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ addEvent(event) {
        const timestamp = $789fbdfdf9798b8b$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $789fbdfdf9798b8b$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $789fbdfdf9798b8b$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage('clear').then(null, (e)=>{
            $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).warn('[Replay] Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage('addEvent', data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage('finish');
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $789fbdfdf9798b8b$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $789fbdfdf9798b8b$var$EventBufferArray();
        this._compression = new $789fbdfdf9798b8b$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $789fbdfdf9798b8b$var$logInfo('[Replay] Failed to load the compression worker, falling back to simple buffer');
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
        } catch (error) {
            $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).warn('[Replay] Failed to add events when switching buffers.', error);
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $789fbdfdf9798b8b$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $789fbdfdf9798b8b$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $789fbdfdf9798b8b$var$logInfo('[Replay] Using simple buffer');
    return new $789fbdfdf9798b8b$var$EventBufferArray();
}
function $789fbdfdf9798b8b$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $789fbdfdf9798b8b$var$_getWorkerUrl();
        if (!workerUrl) return;
        $789fbdfdf9798b8b$var$logInfo(`[Replay] Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ''}`);
        const worker = new Worker(workerUrl);
        return new $789fbdfdf9798b8b$var$EventBufferProxy(worker);
    } catch (error) {
        $789fbdfdf9798b8b$var$logInfo('[Replay] Failed to create compression worker');
    // Fall back to use simple event buffer array
    }
}
function $789fbdfdf9798b8b$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === 'undefined' || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $789fbdfdf9798b8b$var$e();
    return '';
}
/** If sessionStorage is available. */ function $789fbdfdf9798b8b$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return 'sessionStorage' in $789fbdfdf9798b8b$var$WINDOW && !!$789fbdfdf9798b8b$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $789fbdfdf9798b8b$var$clearSession(replay) {
    $789fbdfdf9798b8b$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $789fbdfdf9798b8b$var$deleteSession() {
    if (!$789fbdfdf9798b8b$var$hasSessionStorage()) return;
    try {
        $789fbdfdf9798b8b$var$WINDOW.sessionStorage.removeItem($789fbdfdf9798b8b$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $789fbdfdf9798b8b$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Get a session with defaults & applied sampling.
 */ function $789fbdfdf9798b8b$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $iJH3x.uuid4)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Save a session to session storage.
 */ function $789fbdfdf9798b8b$var$saveSession(session) {
    if (!$789fbdfdf9798b8b$var$hasSessionStorage()) return;
    try {
        $789fbdfdf9798b8b$var$WINDOW.sessionStorage.setItem($789fbdfdf9798b8b$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $789fbdfdf9798b8b$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $789fbdfdf9798b8b$var$isSampled(sessionSampleRate) ? 'session' : allowBuffering ? 'buffer' : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $789fbdfdf9798b8b$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $789fbdfdf9798b8b$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $789fbdfdf9798b8b$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $789fbdfdf9798b8b$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $789fbdfdf9798b8b$var$fetchSession(traceInternals) {
    if (!$789fbdfdf9798b8b$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $789fbdfdf9798b8b$var$WINDOW.sessionStorage.getItem($789fbdfdf9798b8b$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $789fbdfdf9798b8b$var$logInfoNextTick('[Replay] Loading existing session', traceInternals);
        return $789fbdfdf9798b8b$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $789fbdfdf9798b8b$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $789fbdfdf9798b8b$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $789fbdfdf9798b8b$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $789fbdfdf9798b8b$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $789fbdfdf9798b8b$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$789fbdfdf9798b8b$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === 'buffer' && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $789fbdfdf9798b8b$var$loadOrCreateSession({ traceInternals: traceInternals, sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $789fbdfdf9798b8b$var$fetchSession(traceInternals);
    // No session exists yet, just create a new one
    if (!existingSession) {
        $789fbdfdf9798b8b$var$logInfoNextTick('[Replay] Creating new session', traceInternals);
        return $789fbdfdf9798b8b$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$789fbdfdf9798b8b$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $789fbdfdf9798b8b$var$logInfoNextTick('[Replay] Session in sessionStorage is expired, creating new one...');
    return $789fbdfdf9798b8b$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $789fbdfdf9798b8b$var$isCustomEvent(event) {
    return event.type === $789fbdfdf9798b8b$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $789fbdfdf9798b8b$var$addEventSync(replay, event, isCheckout) {
    if (!$789fbdfdf9798b8b$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $789fbdfdf9798b8b$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $789fbdfdf9798b8b$var$addEvent(replay, event, isCheckout) {
    if (!$789fbdfdf9798b8b$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $789fbdfdf9798b8b$var$_addEvent(replay, event, isCheckout);
}
async function $789fbdfdf9798b8b$var$_addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) return null;
    try {
        if (isCheckout && replay.recordingMode === 'buffer') replay.eventBuffer.clear();
        if (isCheckout) replay.eventBuffer.hasCheckout = true;
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $789fbdfdf9798b8b$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const reason = error && error instanceof $789fbdfdf9798b8b$var$EventBufferSizeExceededError ? 'addEventSizeExceeded' : 'addEvent';
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).error(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $hcepo.getClient)();
        if (client) client.recordDroppedEvent('internal_sdk_error', 'replay');
    }
}
/** Exported only for tests. */ function $789fbdfdf9798b8b$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $789fbdfdf9798b8b$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $789fbdfdf9798b8b$var$logInfo(`[Replay] Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`, replay.getOptions()._experiments.traceInternals);
        return false;
    }
    return true;
}
function $789fbdfdf9798b8b$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === 'function' && $789fbdfdf9798b8b$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).error('[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...', error);
        return null;
    }
    return event;
}
/** If the event is an error event */ function $789fbdfdf9798b8b$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $789fbdfdf9798b8b$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** If the event is an replay event */ function $789fbdfdf9798b8b$var$isReplayEvent(event) {
    return event.type === 'replay_event';
}
/** If the event is a feedback event */ function $789fbdfdf9798b8b$var$isFeedbackEvent(event) {
    return event.type === 'feedback';
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $789fbdfdf9798b8b$var$handleAfterSendEvent(replay) {
    // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
    // TODO (v8): remove this check as it will no longer be necessary
    const enforceStatusCode = $789fbdfdf9798b8b$var$isBaseTransportSend();
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$789fbdfdf9798b8b$var$isErrorEvent(event) && !$789fbdfdf9798b8b$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) return;
        if ($789fbdfdf9798b8b$var$isTransactionEvent(event)) {
            $789fbdfdf9798b8b$var$handleTransactionEvent(replay, event);
            return;
        }
        $789fbdfdf9798b8b$var$handleErrorEvent(replay, event);
    };
}
function $789fbdfdf9798b8b$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $789fbdfdf9798b8b$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== 'buffer' || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === 'function' && !beforeErrorSampling(event)) return;
    setTimeout(()=>{
        // Capture current event buffer as new replay
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.sendBufferedReplayOrFlush();
    });
}
function $789fbdfdf9798b8b$var$isBaseTransportSend() {
    const client = (0, $hcepo.getClient)();
    if (!client) return false;
    const transport = client.getTransport();
    if (!transport) return false;
    return transport.send.__sentry__baseTransport__ || false;
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $789fbdfdf9798b8b$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$789fbdfdf9798b8b$var$isErrorEvent(event)) return;
        $789fbdfdf9798b8b$var$handleHydrationError(replay, event);
    };
}
function $789fbdfdf9798b8b$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception && event.exception.values && event.exception.values[0].value;
    if (typeof exceptionValue !== 'string') return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    exceptionValue.match(/reactjs\.org\/docs\/error-decoder\.html\?invariant=(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $789fbdfdf9798b8b$var$createBreadcrumb({
            category: 'replay.hydrate-error'
        });
        $789fbdfdf9798b8b$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $789fbdfdf9798b8b$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    return false;
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $789fbdfdf9798b8b$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $789fbdfdf9798b8b$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: 'breadcrumb',
                payload: {
                    timestamp: event.timestamp,
                    type: 'default',
                    category: 'sentry.feedback',
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $789fbdfdf9798b8b$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== 'buffer') return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $789fbdfdf9798b8b$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $789fbdfdf9798b8b$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $789fbdfdf9798b8b$var$handleGlobalEventListener(replay, includeAfterSendEventHandling = false) {
    const afterSendHandler = includeAfterSendEventHandling ? $789fbdfdf9798b8b$var$handleAfterSendEvent(replay) : undefined;
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled
        if (!replay.isEnabled()) return event;
        if ($789fbdfdf9798b8b$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$789fbdfdf9798b8b$var$isErrorEvent(event) && !$789fbdfdf9798b8b$var$isTransactionEvent(event) && !$789fbdfdf9798b8b$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) return event;
        if ($789fbdfdf9798b8b$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $789fbdfdf9798b8b$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($789fbdfdf9798b8b$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).log('[Replay] Ignoring error from rrweb internals', event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $789fbdfdf9798b8b$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === 'session';
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        // In cases where a custom client is used that does not support the new hooks (yet),
        // we manually call this hook method here
        if (afterSendHandler) // Pretend the error had a 200 response so we always capture it
        afterSendHandler(event, {
            statusCode: 200
        });
        return event;
    }, {
        id: 'Replay'
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $789fbdfdf9798b8b$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $789fbdfdf9798b8b$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: 'performanceSpan',
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === 'string' ? Promise.resolve(null) : response;
    });
}
function $789fbdfdf9798b8b$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: 'navigation.push',
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $789fbdfdf9798b8b$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $789fbdfdf9798b8b$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $789fbdfdf9798b8b$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $789fbdfdf9798b8b$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($789fbdfdf9798b8b$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $djmte.isSentryRequestUrl)(url, (0, $hcepo.getClient)());
}
/** Add a performance entry breadcrumb */ function $789fbdfdf9798b8b$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($789fbdfdf9798b8b$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $789fbdfdf9798b8b$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** only exported for tests */ function $789fbdfdf9798b8b$var$handleFetch(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, fetchData: fetchData, response: response } = handlerData;
    if (!endTimestamp) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url } = fetchData;
    return {
        type: 'resource.fetch',
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: response ? response.status : undefined
        }
    };
}
/**
 * Returns a listener to be added to `addFetchInstrumentationHandler(listener)`.
 */ function $789fbdfdf9798b8b$var$handleFetchSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $789fbdfdf9798b8b$var$handleFetch(handlerData);
        $789fbdfdf9798b8b$var$addNetworkBreadcrumb(replay, result);
    };
}
/** only exported for tests */ function $789fbdfdf9798b8b$var$handleXhr(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, xhr: xhr } = handlerData;
    const sentryXhrData = xhr[0, $jOCzY.SENTRY_XHR_DATA_KEY];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url, status_code: statusCode } = sentryXhrData;
    if (url === undefined) return null;
    return {
        type: 'resource.xhr',
        name: url,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        data: {
            method: method,
            statusCode: statusCode
        }
    };
}
/**
 * Returns a listener to be added to `addXhrInstrumentationHandler(listener)`.
 */ function $789fbdfdf9798b8b$var$handleXhrSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $789fbdfdf9798b8b$var$handleXhr(handlerData);
        $789fbdfdf9798b8b$var$addNetworkBreadcrumb(replay, result);
    };
}
/** Get the size of a body. */ function $789fbdfdf9798b8b$var$getBodySize(body, textEncoder) {
    if (!body) return undefined;
    try {
        if (typeof body === 'string') return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $789fbdfdf9798b8b$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $789fbdfdf9798b8b$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $789fbdfdf9798b8b$var$getBodyString(body) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $789fbdfdf9798b8b$var$_serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).warn('[Replay] Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).info('[Replay] Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
/** Merge a warning into an existing network request/response. */ function $789fbdfdf9798b8b$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $789fbdfdf9798b8b$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $aajbp.dropUndefinedKeys)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $789fbdfdf9798b8b$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                'URL_SKIPPED'
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $789fbdfdf9798b8b$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $789fbdfdf9798b8b$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings && warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $789fbdfdf9798b8b$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.keys(headers).reduce((filteredHeaders, key)=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = headers[key];
        return filteredHeaders;
    }, {});
}
function $789fbdfdf9798b8b$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $789fbdfdf9798b8b$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== 'string') return {
        body: body
    };
    const exceedsSizeLimit = body.length > $789fbdfdf9798b8b$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $789fbdfdf9798b8b$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $789fbdfdf9798b8b$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                'MAYBE_JSON_TRUNCATED'
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                'TEXT_TRUNCATED'
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e3) {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $789fbdfdf9798b8b$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === '[' && last === ']' || first === '{' && last === '}';
}
/** Match an URL against a list of strings/Regex. */ function $789fbdfdf9798b8b$var$urlMatches(url, urls) {
    const fullUrl = $789fbdfdf9798b8b$var$getFullUrl(url);
    return (0, $bMiqE.stringMatchesSomePattern)(fullUrl, urls);
}
/** exported for tests */ function $789fbdfdf9798b8b$var$getFullUrl(url, baseURI = $789fbdfdf9798b8b$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith($789fbdfdf9798b8b$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith('/') && fullUrl.endsWith('/')) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $789fbdfdf9798b8b$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $789fbdfdf9798b8b$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $789fbdfdf9798b8b$var$makeNetworkReplayBreadcrumb('resource.fetch', data);
        $789fbdfdf9798b8b$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).error('[Replay] Failed to capture fetch breadcrumb', error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $789fbdfdf9798b8b$var$enrichFetchBreadcrumb(breadcrumb, hint, options) {
    const { input: input, response: response } = hint;
    const body = input ? $789fbdfdf9798b8b$var$_getFetchRequestArgBody(input) : undefined;
    const reqSize = $789fbdfdf9798b8b$var$getBodySize(body, options.textEncoder);
    const resSize = response ? $789fbdfdf9798b8b$var$parseContentLengthHeader(response.headers.get('content-length')) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $789fbdfdf9798b8b$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $789fbdfdf9798b8b$var$urlMatches(url, options.networkDetailAllowUrls) && !$789fbdfdf9798b8b$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $789fbdfdf9798b8b$var$_getRequestInfo(options, hint.input, requestBodySize) : $789fbdfdf9798b8b$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $789fbdfdf9798b8b$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $789fbdfdf9798b8b$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $789fbdfdf9798b8b$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $789fbdfdf9798b8b$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $789fbdfdf9798b8b$var$_getFetchRequestArgBody(input);
    const [bodyStr, warning] = $789fbdfdf9798b8b$var$getBodyString(requestBody);
    const data = $789fbdfdf9798b8b$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $789fbdfdf9798b8b$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $789fbdfdf9798b8b$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $789fbdfdf9798b8b$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $789fbdfdf9798b8b$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $789fbdfdf9798b8b$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $789fbdfdf9798b8b$var$_parseFetchResponseBody(response);
    const result = $789fbdfdf9798b8b$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        textEncoder: textEncoder,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $789fbdfdf9798b8b$var$mergeWarning(result, warning);
    return result;
}
function $789fbdfdf9798b8b$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $789fbdfdf9798b8b$var$getBodySize(bodyText, textEncoder) : responseBodySize;
        if (!captureDetails) return $789fbdfdf9798b8b$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $789fbdfdf9798b8b$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $789fbdfdf9798b8b$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).warn('[Replay] Failed to serialize response body', error);
        // fallback
        return $789fbdfdf9798b8b$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $789fbdfdf9798b8b$var$_parseFetchResponseBody(response) {
    const res = $789fbdfdf9798b8b$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        'BODY_PARSE_ERROR'
    ];
    try {
        const text = await $789fbdfdf9798b8b$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).warn('[Replay] Failed to get text body from response', error);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
}
function $789fbdfdf9798b8b$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== 'object') return undefined;
    return fetchArgs[1].body;
}
function $789fbdfdf9798b8b$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $789fbdfdf9798b8b$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== 'string') return $789fbdfdf9798b8b$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $789fbdfdf9798b8b$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $789fbdfdf9798b8b$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $789fbdfdf9798b8b$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $789fbdfdf9798b8b$var$getAllowedHeaders(headers, allowedHeaders);
}
function $789fbdfdf9798b8b$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).warn('[Replay] Failed to clone response body', error);
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $789fbdfdf9798b8b$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = setTimeout(()=>reject(new Error('Timeout while trying to read response body')), 500);
        $789fbdfdf9798b8b$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $789fbdfdf9798b8b$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $789fbdfdf9798b8b$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $789fbdfdf9798b8b$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $789fbdfdf9798b8b$var$makeNetworkReplayBreadcrumb('resource.xhr', data);
        $789fbdfdf9798b8b$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).error('[Replay] Failed to capture xhr breadcrumb', error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $789fbdfdf9798b8b$var$enrichXhrBreadcrumb(breadcrumb, hint, options) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $789fbdfdf9798b8b$var$getBodySize(input, options.textEncoder);
    const resSize = xhr.getResponseHeader('content-length') ? $789fbdfdf9798b8b$var$parseContentLengthHeader(xhr.getResponseHeader('content-length')) : $789fbdfdf9798b8b$var$_getBodySize(xhr.response, xhr.responseType, options.textEncoder);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $789fbdfdf9798b8b$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$789fbdfdf9798b8b$var$urlMatches(url, options.networkDetailAllowUrls) || $789fbdfdf9798b8b$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $789fbdfdf9798b8b$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $789fbdfdf9798b8b$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $jOCzY.SENTRY_XHR_DATA_KEY];
    const networkRequestHeaders = xhrInfo ? $789fbdfdf9798b8b$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $789fbdfdf9798b8b$var$getAllowedHeaders($789fbdfdf9798b8b$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? $789fbdfdf9798b8b$var$getBodyString(input) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $789fbdfdf9798b8b$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $789fbdfdf9798b8b$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $789fbdfdf9798b8b$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $789fbdfdf9798b8b$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $789fbdfdf9798b8b$var$mergeWarning(response, responseWarning) : response
    };
}
function $789fbdfdf9798b8b$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split('\r\n').reduce((acc, line)=>{
        const [key, value] = line.split(': ');
        acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function $789fbdfdf9798b8b$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $789fbdfdf9798b8b$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).warn('[Replay] Failed to get xhr response body', ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $789fbdfdf9798b8b$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === 'json' && body && typeof body === 'object') return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).warn('[Replay] Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).info('[Replay] Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
function $789fbdfdf9798b8b$var$_getBodySize(body, responseType, textEncoder) {
    try {
        const bodyStr = responseType === 'json' && body && typeof body === 'object' ? JSON.stringify(body) : body;
        return $789fbdfdf9798b8b$var$getBodySize(bodyStr, textEncoder);
    } catch (e3) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $789fbdfdf9798b8b$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $hcepo.getClient)();
    try {
        const textEncoder = new TextEncoder();
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            textEncoder: textEncoder,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client && client.on) client.on('beforeAddBreadcrumb', (breadcrumb, hint)=>$789fbdfdf9798b8b$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
        else {
            // Fallback behavior
            (0, $dQVMO.addFetchInstrumentationHandler)($789fbdfdf9798b8b$var$handleFetchSpanListener(replay));
            (0, $jOCzY.addXhrInstrumentationHandler)($789fbdfdf9798b8b$var$handleXhrSpanListener(replay));
        }
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $789fbdfdf9798b8b$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($789fbdfdf9798b8b$var$_isXhrBreadcrumb(breadcrumb) && $789fbdfdf9798b8b$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $789fbdfdf9798b8b$var$enrichXhrBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $789fbdfdf9798b8b$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($789fbdfdf9798b8b$var$_isFetchBreadcrumb(breadcrumb) && $789fbdfdf9798b8b$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $789fbdfdf9798b8b$var$enrichFetchBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $789fbdfdf9798b8b$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).warn('Error when enriching network breadcrumb');
    }
}
function $789fbdfdf9798b8b$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'xhr';
}
function $789fbdfdf9798b8b$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'fetch';
}
function $789fbdfdf9798b8b$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $789fbdfdf9798b8b$var$_isFetchHint(hint) {
    return hint && hint.response;
}
let $789fbdfdf9798b8b$var$_LAST_BREADCRUMB = null;
function $789fbdfdf9798b8b$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
const $789fbdfdf9798b8b$var$handleScopeListener = (replay)=>(scope)=>{
        if (!replay.isEnabled()) return;
        const result = $789fbdfdf9798b8b$var$handleScope(scope);
        if (!result) return;
        $789fbdfdf9798b8b$var$addBreadcrumbEvent(replay, result);
    };
/**
 * An event handler to handle scope changes.
 */ function $789fbdfdf9798b8b$var$handleScope(scope) {
    // TODO (v8): Remove this guard. This was put in place because we introduced
    // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
    // For now, we'll just return null if the method doesn't exist but we should eventually
    // get rid of this guard.
    const newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();
    // Listener can be called when breadcrumbs have not changed, so we store the
    // reference to the last crumb and only return a crumb if it has changed
    if ($789fbdfdf9798b8b$var$_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) return null;
    $789fbdfdf9798b8b$var$_LAST_BREADCRUMB = newBreadcrumb;
    if (!$789fbdfdf9798b8b$var$isBreadcrumbWithCategory(newBreadcrumb) || [
        'fetch',
        'xhr',
        'sentry.event',
        'sentry.transaction'
    ].includes(newBreadcrumb.category) || newBreadcrumb.category.startsWith('ui.')) return null;
    if (newBreadcrumb.category === 'console') return $789fbdfdf9798b8b$var$normalizeConsoleBreadcrumb(newBreadcrumb);
    return $789fbdfdf9798b8b$var$createBreadcrumb(newBreadcrumb);
}
/** exported for tests only */ function $789fbdfdf9798b8b$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $789fbdfdf9798b8b$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === 'string') {
            if (arg.length > $789fbdfdf9798b8b$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $789fbdfdf9798b8b$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === 'object') try {
            const normalizedArg = (0, $5vnYi.normalize)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $789fbdfdf9798b8b$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $789fbdfdf9798b8b$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $789fbdfdf9798b8b$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        'CONSOLE_ARG_TRUNCATED'
                    ]
                }
            } : {}
        }
    });
}
/**
 * Add global listeners that cannot be removed.
 */ function $789fbdfdf9798b8b$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const scope = (0, $hcepo.getCurrentScope)();
    const client = (0, $hcepo.getClient)();
    scope.addScopeListener($789fbdfdf9798b8b$var$handleScopeListener(replay));
    (0, $lemS8.addClickKeypressInstrumentationHandler)($789fbdfdf9798b8b$var$handleDomListener(replay));
    (0, $hFlB3.addHistoryInstrumentationHandler)($789fbdfdf9798b8b$var$handleHistorySpanListener(replay));
    $789fbdfdf9798b8b$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $789fbdfdf9798b8b$var$handleGlobalEventListener(replay, !$789fbdfdf9798b8b$var$hasHooks(client));
    if (client && client.addEventProcessor) client.addEventProcessor(eventProcessor);
    else (0, $huK8b.addEventProcessor)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if ($789fbdfdf9798b8b$var$hasHooks(client)) {
        client.on('beforeSendEvent', $789fbdfdf9798b8b$var$handleBeforeSendEvent(replay));
        client.on('afterSendEvent', $789fbdfdf9798b8b$var$handleAfterSendEvent(replay));
        client.on('createDsc', (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === 'session') {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on('startTransaction', (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We may be missing the initial startTransaction due to timing issues,
        // so we capture it on finish again.
        client.on('finishTransaction', (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We want to flush replay
        client.on('beforeSendFeedback', (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options && options.includeReplay && replay.isEnabled() && replayId) // This should never reject
            {
                if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $789fbdfdf9798b8b$var$hasHooks(client) {
    return !!(client && client.on);
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $789fbdfdf9798b8b$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($789fbdfdf9798b8b$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $789fbdfdf9798b8b$var$createMemoryEntry($789fbdfdf9798b8b$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $789fbdfdf9798b8b$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: 'memory',
        name: 'memory',
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $789fbdfdf9798b8b$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeout(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $789fbdfdf9798b8b$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).warn('[Replay] Received replay event after session expired.');
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $789fbdfdf9798b8b$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === 'buffer' && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$789fbdfdf9798b8b$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time.
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $789fbdfdf9798b8b$var$addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (replay.session && replay.session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === 'buffer' && replay.session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $789fbdfdf9798b8b$var$logInfo(`[Replay] Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`, replay.getOptions()._experiments.traceInternals);
                    replay.session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $789fbdfdf9798b8b$var$saveSession(replay.session);
                }
            }
            if (replay.recordingMode === 'session') // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $789fbdfdf9798b8b$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $789fbdfdf9798b8b$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: 'options',
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === 'worker' : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $789fbdfdf9798b8b$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $789fbdfdf9798b8b$var$addEventSync(replay, $789fbdfdf9798b8b$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $789fbdfdf9798b8b$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $2pR2a.createEnvelope)((0, $2pR2a.createEventEnvelopeHeaders)(replayEvent, (0, $2pR2a.getSdkMetadataForEnvelopeHeader)(replayEvent), tunnel, dsn), [
        [
            {
                type: 'replay_event'
            },
            replayEvent
        ],
        [
            {
                type: 'replay_recording',
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === 'string' ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $789fbdfdf9798b8b$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === 'string') payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $789fbdfdf9798b8b$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === 'object' && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    if (client.emit) client.emit('preprocessEvent', event, eventHint);
    const preparedEvent = await (0, $5XnTz.prepareEvent)(client.getOptions(), event, eventHint, scope, client, (0, $fxUGN.getIsolationScope)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || 'javascript';
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata && client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || 'sentry.javascript.unknown',
        version: version || '0.0.0'
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $789fbdfdf9798b8b$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $789fbdfdf9798b8b$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $hcepo.getClient)();
    const scope = (0, $hcepo.getCurrentScope)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return;
    const baseEvent = {
        type: $789fbdfdf9798b8b$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $789fbdfdf9798b8b$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent('event_processor', 'replay', baseEvent);
        $789fbdfdf9798b8b$var$logInfo('An event processor returned `null`, will not send event.');
        return;
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $789fbdfdf9798b8b$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($789fbdfdf9798b8b$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
    if (!response) return response;
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300)) throw new $789fbdfdf9798b8b$var$TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, $3iBML.updateRateLimits)({}, response);
    if ((0, $3iBML.isRateLimited)(rateLimits, 'replay')) throw new $789fbdfdf9798b8b$var$RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $789fbdfdf9798b8b$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $789fbdfdf9798b8b$var$RateLimitError extends Error {
    constructor(rateLimits){
        super('Rate limit hit');
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $789fbdfdf9798b8b$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $789fbdfdf9798b8b$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, options: options } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $789fbdfdf9798b8b$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $789fbdfdf9798b8b$var$TransportStatusCodeError || err instanceof $789fbdfdf9798b8b$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $hcepo.setContext)('Replays', {
            _retryCount: retryConfig.count
        });
        if ($789fbdfdf9798b8b$var$DEBUG_BUILD && options._experiments && options._experiments.captureExceptions) (0, $hcepo.captureException)(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $789fbdfdf9798b8b$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$789fbdfdf9798b8b$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            setTimeout(async ()=>{
                try {
                    await $789fbdfdf9798b8b$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $789fbdfdf9798b8b$var$THROTTLED = '__THROTTLED';
const $789fbdfdf9798b8b$var$SKIPPED = '__SKIPPED';
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $789fbdfdf9798b8b$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $789fbdfdf9798b8b$var$SKIPPED : $789fbdfdf9798b8b$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $789fbdfdf9798b8b$var$ReplayContainer {
    /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ constructor({ options: options, recordingOptions: recordingOptions }){
        $789fbdfdf9798b8b$var$ReplayContainer.prototype.__init.call(this);
        $789fbdfdf9798b8b$var$ReplayContainer.prototype.__init2.call(this);
        $789fbdfdf9798b8b$var$ReplayContainer.prototype.__init3.call(this);
        $789fbdfdf9798b8b$var$ReplayContainer.prototype.__init4.call(this);
        $789fbdfdf9798b8b$var$ReplayContainer.prototype.__init5.call(this);
        $789fbdfdf9798b8b$var$ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = 'session';
        this.timeouts = {
            sessionIdlePause: $789fbdfdf9798b8b$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $789fbdfdf9798b8b$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ''
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $789fbdfdf9798b8b$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $789fbdfdf9798b8b$var$throttle((event, isCheckout)=>$789fbdfdf9798b8b$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($789fbdfdf9798b8b$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $789fbdfdf9798b8b$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(',') : ''
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $789fbdfdf9798b8b$var$ClickDetector(this, slowClickConfig);
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        if (errorSampleRate <= 0 && sessionSampleRate <= 0) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            this._handleException(new Error('Unable to initialize and create session'));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === 'buffer' && this.session.segmentId === 0 ? 'buffer' : 'session';
        $789fbdfdf9798b8b$var$logInfoNextTick(`[Replay] Starting replay in ${this.recordingMode} mode`, this._options._experiments.traceInternals);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === 'session') throw new Error('Replay recording is already in progress');
        if (this._isEnabled && this.recordingMode === 'buffer') throw new Error('Replay buffering is in progress, call `flush()` to save the replay');
        $789fbdfdf9798b8b$var$logInfoNextTick('[Replay] Starting replay in session mode', this._options._experiments.traceInternals);
        // Required as user activity is initially set in
        // constructor, so if `start()` is called after
        // session idle expiration, a replay will not be
        // created due to an idle timeout.
        this._updateUserActivity();
        const session = $789fbdfdf9798b8b$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) throw new Error('Replay recording is already in progress');
        $789fbdfdf9798b8b$var$logInfoNextTick('[Replay] Starting replay in buffer mode', this._options._experiments.traceInternals);
        const session = $789fbdfdf9798b8b$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = 'buffer';
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $789fbdfdf9798b8b$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === 'buffer' && {
                    checkoutEveryNms: $789fbdfdf9798b8b$var$BUFFER_CHECKOUT_TIME
                },
                emit: $789fbdfdf9798b8b$var$getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler,
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this._handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $789fbdfdf9798b8b$var$logInfo(`[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ''}`, this._options._experiments.traceInternals);
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $789fbdfdf9798b8b$var$clearSession(this);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $789fbdfdf9798b8b$var$logInfo('[Replay] Pausing replay', this._options._experiments.traceInternals);
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $789fbdfdf9798b8b$var$logInfo('[Replay] Resuming replay', this._options._experiments.traceInternals);
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === 'session') return this.flushImmediate();
        const activityTime = Date.now();
        $789fbdfdf9798b8b$var$logInfo('[Replay] Converting buffer to session', this._options._experiments.traceInternals);
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === 'session') return;
        // Re-start recording in session-mode
        this.recordingMode = 'session';
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === 'buffer') return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === 'buffer') return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current sesion (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $789fbdfdf9798b8b$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === 'session') {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$789fbdfdf9798b8b$var$WINDOW.location.pathname}${$789fbdfdf9798b8b$var$WINDOW.location.hash}${$789fbdfdf9798b8b$var$WINDOW.location.search}`;
        const url = `${$789fbdfdf9798b8b$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $789fbdfdf9798b8b$var$THROTTLED) {
            const breadcrumb = $789fbdfdf9798b8b$var$createBreadcrumb({
                category: 'replay.throttled'
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$789fbdfdf9798b8b$var$addEventSync(this, {
                    type: $789fbdfdf9798b8b$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: 'breadcrumb',
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        // eslint-disable-next-line deprecation/deprecation
        const lastTransaction = this.lastTransaction || (0, $hcepo.getCurrentScope)().getTransaction();
        const attributes = lastTransaction && (0, $4RP7L.spanToJSON)(lastTransaction).data || {};
        const source = attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        if (!lastTransaction || !source || ![
            'route',
            'custom'
        ].includes(source)) return undefined;
        return (0, $4RP7L.spanToJSON)(lastTransaction).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $789fbdfdf9798b8b$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /** A wrapper to conditionally capture exceptions. */ _handleException(error) {
        $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).error('[Replay]', error);
        if ($789fbdfdf9798b8b$var$DEBUG_BUILD && this._options._experiments && this._options._experiments.captureExceptions) (0, $hcepo.captureException)(error);
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $789fbdfdf9798b8b$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($789fbdfdf9798b8b$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: 'refresh session'
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $789fbdfdf9798b8b$var$WINDOW.document.addEventListener('visibilitychange', this._handleVisibilityChange);
            $789fbdfdf9798b8b$var$WINDOW.addEventListener('blur', this._handleWindowBlur);
            $789fbdfdf9798b8b$var$WINDOW.addEventListener('focus', this._handleWindowFocus);
            $789fbdfdf9798b8b$var$WINDOW.addEventListener('keydown', this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $789fbdfdf9798b8b$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this._handleException(err);
        }
        this._performanceCleanupCallback = $789fbdfdf9798b8b$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $789fbdfdf9798b8b$var$WINDOW.document.removeEventListener('visibilitychange', this._handleVisibilityChange);
            $789fbdfdf9798b8b$var$WINDOW.removeEventListener('blur', this._handleWindowBlur);
            $789fbdfdf9798b8b$var$WINDOW.removeEventListener('focus', this._handleWindowFocus);
            $789fbdfdf9798b8b$var$WINDOW.removeEventListener('keydown', this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if ($789fbdfdf9798b8b$var$WINDOW.document.visibilityState === 'visible') this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $789fbdfdf9798b8b$var$createBreadcrumb({
                category: 'ui.blur'
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $789fbdfdf9798b8b$var$createBreadcrumb({
                category: 'ui.focus'
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            $789fbdfdf9798b8b$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $789fbdfdf9798b8b$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $789fbdfdf9798b8b$var$logInfo('[Replay] Document has become active, but session has expired');
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $789fbdfdf9798b8b$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: 'breadcrumb',
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        const performanceEntries = $789fbdfdf9798b8b$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        return Promise.all($789fbdfdf9798b8b$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).error('[Replay] No session or eventBuffer found to flush.');
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $789fbdfdf9798b8b$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accomodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error('Session is too long, not sending replay');
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $789fbdfdf9798b8b$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                options: this.getOptions(),
                timestamp: timestamp
            });
        } catch (err) {
            this._handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: 'sendReplay'
            });
            const client = (0, $hcepo.getClient)();
            if (client) client.recordDroppedEvent('send_error', 'replay');
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).error('[Replay] Attempting to finish replay event after session expired.');
                return;
            }
            if (!this.session) // should never happen, as we would have bailed out before
            return;
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this._options.maxReplayDuration + 5000;
            if (tooShort || tooLong) {
                $789fbdfdf9798b8b$var$logInfo(`[Replay] Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? 'short' : 'long'}, not sending replay.`, this._options._experiments.traceInternals);
                if (tooShort) this._debouncedFlush();
                return;
            }
            const eventBuffer = this.eventBuffer;
            if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $789fbdfdf9798b8b$var$logInfo('[Replay] Flushing initial segment without checkout.', this._options._experiments.traceInternals);
            // this._flushLock acts as a lock so that future calls to `_flush()`
            // will be blocked until this promise resolves
            if (!this._flushLock) {
                this._flushLock = this._runFlush();
                await this._flushLock;
                this._flushLock = undefined;
                return;
            }
            // Wait for previous flush to finish, then call the debounced `_flush()`.
            // It's possible there are other flush requests queued and waiting for it
            // to resolve. We want to reduce all outstanding requests (as well as any
            // new flush requests that occur within a second of the locked flush
            // completing) into a single flush.
            try {
                await this._flushLock;
            } catch (err) {
                $789fbdfdf9798b8b$var$DEBUG_BUILD && (0, $7p8hL.logger).error(err);
            } finally{
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $789fbdfdf9798b8b$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $789fbdfdf9798b8b$var$createBreadcrumb({
                    category: 'replay.mutations',
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.stop({
                    reason: 'mutationLimit',
                    forceFlush: this.recordingMode === 'session'
                });
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $789fbdfdf9798b8b$var$getOption(selectors, defaultSelectors, deprecatedClassOption, deprecatedSelectorOption) {
    const deprecatedSelectors = typeof deprecatedSelectorOption === 'string' ? deprecatedSelectorOption.split(',') : [];
    const allSelectors = [
        ...selectors,
        // @deprecated
        ...deprecatedSelectors,
        // sentry defaults
        ...defaultSelectors
    ];
    // @deprecated
    if (typeof deprecatedClassOption !== 'undefined') {
        // NOTE: No support for RegExp
        if (typeof deprecatedClassOption === 'string') allSelectors.push(`.${deprecatedClassOption}`);
        (0, $7p8hL.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.');
        });
    }
    return allSelectors.join(',');
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $789fbdfdf9798b8b$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore, blockClass: // eslint-disable-next-line deprecation/deprecation
blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
blockSelector, maskTextClass: // eslint-disable-next-line deprecation/deprecation
maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
ignoreClass }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = $789fbdfdf9798b8b$var$getOption(mask, [
        '.sentry-mask',
        '[data-sentry-mask]'
    ], maskTextClass, maskTextSelector);
    const unmaskSelector = $789fbdfdf9798b8b$var$getOption(unmask, [
        '.sentry-unmask',
        '[data-sentry-unmask]'
    ]);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $789fbdfdf9798b8b$var$getOption(block, [
            '.sentry-block',
            '[data-sentry-block]',
            ...defaultBlockedElements
        ], blockClass, blockSelector),
        unblockSelector: $789fbdfdf9798b8b$var$getOption(unblock, [
            '.sentry-unblock',
            '[data-sentry-unblock]'
        ]),
        ignoreSelector: $789fbdfdf9798b8b$var$getOption(ignore, [
            '.sentry-ignore',
            '[data-sentry-ignore]',
            'input[type="file"]'
        ], ignoreClass)
    };
    if (blockClass instanceof RegExp) options.blockClass = blockClass;
    if (maskTextClass instanceof RegExp) options.maskTextClass = maskTextClass;
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $789fbdfdf9798b8b$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precendence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === 'value' && el.tagName === 'INPUT' && [
        'submit',
        'button'
    ].includes(el.getAttribute('type') || '')) return value.replace(/[\S]/g, '*');
    return value;
}
const $789fbdfdf9798b8b$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $789fbdfdf9798b8b$var$DEFAULT_NETWORK_HEADERS = [
    'content-length',
    'content-type',
    'accept'
];
let $789fbdfdf9798b8b$var$_initialized = false;
const $789fbdfdf9798b8b$export$2832a2ae028f5e28 = (options)=>{
    // eslint-disable-next-line deprecation/deprecation
    return new $789fbdfdf9798b8b$export$6b59b88de1ff9cb7(options);
};
/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 * @deprecated Use `replayIntegration()` instead.
 */ class $789fbdfdf9798b8b$export$6b59b88de1ff9cb7 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Replay';
    }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $789fbdfdf9798b8b$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $789fbdfdf9798b8b$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $789fbdfdf9798b8b$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $789fbdfdf9798b8b$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, sessionSampleRate: sessionSampleRate, errorSampleRate: errorSampleRate, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        'title',
        'placeholder'
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, blockClass: // eslint-disable-next-line deprecation/deprecation
    blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
    blockSelector, maskInputOptions: // eslint-disable-next-line deprecation/deprecation
    maskInputOptions, maskTextClass: // eslint-disable-next-line deprecation/deprecation
    maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
    maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
    ignoreClass } = {}){
        // eslint-disable-next-line deprecation/deprecation
        this.name = $789fbdfdf9798b8b$export$6b59b88de1ff9cb7.id;
        const privacyOptions = $789fbdfdf9798b8b$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            ignoreClass: ignoreClass
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                ...maskInputOptions || {},
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$789fbdfdf9798b8b$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: 'all',
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            }
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $789fbdfdf9798b8b$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $789fbdfdf9798b8b$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            sessionSampleRate: sessionSampleRate,
            errorSampleRate: errorSampleRate,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $789fbdfdf9798b8b$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $789fbdfdf9798b8b$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            _experiments: _experiments
        };
        if (typeof sessionSampleRate === 'number') {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`);
            this._initialOptions.sessionSampleRate = sessionSampleRate;
        }
        if (typeof errorSampleRate === 'number') {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`);
            this._initialOptions.errorSampleRate = errorSampleRate;
        }
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $789fbdfdf9798b8b$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$789fbdfdf9798b8b$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, $kVwzp.isBrowser)()) throw new Error('Multiple Sentry Session Replay instances are not supported');
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $789fbdfdf9798b8b$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $789fbdfdf9798b8b$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ setupOnce() {
        if (!(0, $kVwzp.isBrowser)()) return;
        this._setup();
        // Once upon a time, we tried to create a transaction in `setupOnce` and it would
        // potentially create a transaction before some native SDK integrations have run
        // and applied their own global event processor. An example is:
        // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
        //
        // So we call `this._initialize()` in next event loop as a workaround to wait for other
        // global event processors to finish. This is no longer needed, but keeping it
        // here to avoid any future issues.
        setTimeout(()=>this._initialize());
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === 'session'
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay || !this._replay.isEnabled()) return Promise.resolve();
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Initializes replay.
   */ _initialize() {
        if (!this._replay) return;
        // We have to run this in _initialize, because this runs in setTimeout
        // So when this runs all integrations have been added
        // Before this, we cannot access integrations on the client,
        // so we need to mutate the options here
        this._maybeLoadFromReplayCanvasIntegration();
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup() {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $789fbdfdf9798b8b$var$loadReplayOptionsFromClient(this._initialOptions);
        this._replay = new $789fbdfdf9798b8b$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration() {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const client = (0, $hcepo.getClient)();
            const canvasIntegration = client.getIntegrationByName('ReplayCanvas');
            if (!canvasIntegration) return;
            this._replay['_canvas'] = canvasIntegration.getOptions();
        } catch (e) {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
$789fbdfdf9798b8b$export$6b59b88de1ff9cb7.__initStatic();
/** Parse Replay-related options from SDK options */ function $789fbdfdf9798b8b$var$loadReplayOptionsFromClient(initialOptions) {
    const client = (0, $hcepo.getClient)();
    const opt = client && client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $aajbp.dropUndefinedKeys)(initialOptions)
    };
    if (!opt) {
        (0, $7p8hL.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('SDK client is not available.');
        });
        return finalOptions;
    }
    if (initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null && opt.replaysOnErrorSampleRate == null) (0, $7p8hL.consoleSandbox)(()=>{
        // eslint-disable-next-line no-console
        console.warn('Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.');
    });
    if (typeof opt.replaysSessionSampleRate === 'number') finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
    if (typeof opt.replaysOnErrorSampleRate === 'number') finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
    return finalOptions;
}
function $789fbdfdf9798b8b$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$789fbdfdf9798b8b$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ // eslint-disable-next-line deprecation/deprecation
function $789fbdfdf9798b8b$export$81cc0d0f72285d1() {
    const client = (0, $hcepo.getClient)();
    return client && client.getIntegrationByName && client.getIntegrationByName('Replay');
}
// eslint-disable-next-line deprecation/deprecation
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const $789fbdfdf9798b8b$export$b28310b2f161456b = $789fbdfdf9798b8b$export$81cc0d0f72285d1;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const $789fbdfdf9798b8b$export$d7706faf7ab354bf = $789fbdfdf9798b8b$export$2832a2ae028f5e28;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ // eslint-disable-next-line deprecation/deprecation
class $789fbdfdf9798b8b$export$a35c789ed37ee0f7 extends $789fbdfdf9798b8b$export$6b59b88de1ff9cb7 {
}

});
parcelRegister("hvuDy", function(module, exports) {

$parcel$export(module.exports, "_nullishCoalesce", function () { return $cbed18c7b3dde05a$export$8db64e83cc1a933c; });
// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ function $cbed18c7b3dde05a$export$8db64e83cc1a933c(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}

});

parcelRegister("fF2BR", function(module, exports) {

$parcel$export(module.exports, "_optionalChain", function () { return $b66cb594cb3b8f86$export$3cc482e6b02f32f7; });
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $b66cb594cb3b8f86$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}

});

parcelRegister("kVwzp", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $f3c26542921d54b7$export$4e09c449d6c407f7; });

var $asmVu = parcelRequire("asmVu");

var $lNVQ9 = parcelRequire("lNVQ9");
/**
 * Returns true if we are in the browser.
 */ function $f3c26542921d54b7$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== 'undefined' && (!(0, $asmVu.isNodeEnv)() || $f3c26542921d54b7$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $f3c26542921d54b7$var$isElectronNodeRenderer() {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    (0, $lNVQ9.GLOBAL_OBJ).process !== undefined && (0, $lNVQ9.GLOBAL_OBJ).process.type === 'renderer');
}

});
parcelRegister("asmVu", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $f2UY0 = parcelRequire("f2UY0");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $f2UY0.isBrowserBundle)() && Object.prototype.toString.call(0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, 'process');
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});


parcelRegister("aiNal", function(module, exports) {

$parcel$export(module.exports, "addClsInstrumentationHandler", function () { return $7801b91fe69631d0$export$861b82818b37ba5b; });
$parcel$export(module.exports, "addLcpInstrumentationHandler", function () { return $7801b91fe69631d0$export$3fd4b53331200102; });
$parcel$export(module.exports, "addTtfbInstrumentationHandler", function () { return $7801b91fe69631d0$export$699d9529c099a797; });
$parcel$export(module.exports, "addFidInstrumentationHandler", function () { return $7801b91fe69631d0$export$2707d7471c0b918f; });
$parcel$export(module.exports, "addInpInstrumentationHandler", function () { return $7801b91fe69631d0$export$da3b76aa2022cbd7; });
$parcel$export(module.exports, "addPerformanceInstrumentationHandler", function () { return $7801b91fe69631d0$export$69816c1a049f8db6; });

var $kEJYx = parcelRequire("kEJYx");
var $7p8hL = parcelRequire("7p8hL");

var $221nn = parcelRequire("221nn");

var $jnMu7 = parcelRequire("jnMu7");

var $hCnge = parcelRequire("hCnge");

var $fUHEP = parcelRequire("fUHEP");

var $fLb5H = parcelRequire("fLb5H");

var $9zLwN = parcelRequire("9zLwN");

var $kiLF7 = parcelRequire("kiLF7");
const $7801b91fe69631d0$var$handlers = {};
const $7801b91fe69631d0$var$instrumented = {};
let $7801b91fe69631d0$var$_previousCls;
let $7801b91fe69631d0$var$_previousFid;
let $7801b91fe69631d0$var$_previousLcp;
let $7801b91fe69631d0$var$_previousTtfb;
let $7801b91fe69631d0$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $7801b91fe69631d0$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $7801b91fe69631d0$var$addMetricObserver('cls', callback, $7801b91fe69631d0$var$instrumentCls, $7801b91fe69631d0$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $7801b91fe69631d0$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $7801b91fe69631d0$var$addMetricObserver('lcp', callback, $7801b91fe69631d0$var$instrumentLcp, $7801b91fe69631d0$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $7801b91fe69631d0$export$699d9529c099a797(callback) {
    return $7801b91fe69631d0$var$addMetricObserver('ttfb', callback, $7801b91fe69631d0$var$instrumentTtfb, $7801b91fe69631d0$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $7801b91fe69631d0$export$2707d7471c0b918f(callback) {
    return $7801b91fe69631d0$var$addMetricObserver('fid', callback, $7801b91fe69631d0$var$instrumentFid, $7801b91fe69631d0$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $7801b91fe69631d0$export$da3b76aa2022cbd7(callback) {
    return $7801b91fe69631d0$var$addMetricObserver('inp', callback, $7801b91fe69631d0$var$instrumentInp, $7801b91fe69631d0$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $7801b91fe69631d0$export$69816c1a049f8db6(type, callback) {
    $7801b91fe69631d0$var$addHandler(type, callback);
    if (!$7801b91fe69631d0$var$instrumented[type]) {
        $7801b91fe69631d0$var$instrumentPerformanceObserver(type);
        $7801b91fe69631d0$var$instrumented[type] = true;
    }
    return $7801b91fe69631d0$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $7801b91fe69631d0$var$triggerHandlers(type, data) {
    const typeHandlers = $7801b91fe69631d0$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $kEJYx.getFunctionName)(handler)}\nError:`, e);
    }
}
function $7801b91fe69631d0$var$instrumentCls() {
    return (0, $jnMu7.onCLS)((metric)=>{
        $7801b91fe69631d0$var$triggerHandlers('cls', {
            metric: metric
        });
        $7801b91fe69631d0$var$_previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function $7801b91fe69631d0$var$instrumentFid() {
    return (0, $hCnge.onFID)((metric)=>{
        $7801b91fe69631d0$var$triggerHandlers('fid', {
            metric: metric
        });
        $7801b91fe69631d0$var$_previousFid = metric;
    });
}
function $7801b91fe69631d0$var$instrumentLcp() {
    return (0, $fLb5H.onLCP)((metric)=>{
        $7801b91fe69631d0$var$triggerHandlers('lcp', {
            metric: metric
        });
        $7801b91fe69631d0$var$_previousLcp = metric;
    });
}
function $7801b91fe69631d0$var$instrumentTtfb() {
    return (0, $kiLF7.onTTFB)((metric)=>{
        $7801b91fe69631d0$var$triggerHandlers('ttfb', {
            metric: metric
        });
        $7801b91fe69631d0$var$_previousTtfb = metric;
    });
}
function $7801b91fe69631d0$var$instrumentInp() {
    return (0, $fUHEP.onINP)((metric)=>{
        $7801b91fe69631d0$var$triggerHandlers('inp', {
            metric: metric
        });
        $7801b91fe69631d0$var$_previousInp = metric;
    });
}
function $7801b91fe69631d0$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $7801b91fe69631d0$var$addHandler(type, callback);
    let stopListening;
    if (!$7801b91fe69631d0$var$instrumented[type]) {
        stopListening = instrumentFn();
        $7801b91fe69631d0$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $7801b91fe69631d0$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $7801b91fe69631d0$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, $9zLwN.observe)(type, (entries)=>{
        $7801b91fe69631d0$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $7801b91fe69631d0$var$addHandler(type, handler) {
    $7801b91fe69631d0$var$handlers[type] = $7801b91fe69631d0$var$handlers[type] || [];
    $7801b91fe69631d0$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $7801b91fe69631d0$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $7801b91fe69631d0$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}

});
parcelRegister("221nn", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $17acd5eeea63751d$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $17acd5eeea63751d$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("jnMu7", function(module, exports) {

$parcel$export(module.exports, "onCLS", function () { return $e1c5c663fd2a35f4$export$a7873055838e5ad8; });

var $gfJJk = parcelRequire("gfJJk");

var $5aga7 = parcelRequire("5aga7");

var $9zLwN = parcelRequire("9zLwN");

var $12rSf = parcelRequire("12rSf");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $e1c5c663fd2a35f4$export$a7873055838e5ad8 = (onReport, options = {})=>{
    const metric = (0, $5aga7.initMetric)('CLS', 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $9zLwN.observe)('layout-shift', handleEntries);
    if (po) {
        report = (0, $gfJJk.bindReporter)(onReport, metric, options.reportAllChanges);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $12rSf.onHidden)(stopListening);
        return stopListening;
    }
    return;
};

});
parcelRegister("gfJJk", function(module, exports) {

$parcel$export(module.exports, "bindReporter", function () { return $bd5185170f5d4928$export$17679dccdd551979; });
const $bd5185170f5d4928$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};

});

parcelRegister("5aga7", function(module, exports) {

$parcel$export(module.exports, "initMetric", function () { return $3c2a6c631ba7f21c$export$3c29b44508a0612b; });

var $hi3xY = parcelRequire("hi3xY");

var $5KNPZ = parcelRequire("5KNPZ");

var $5TTSp = parcelRequire("5TTSp");

var $gMnkn = parcelRequire("gMnkn");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $3c2a6c631ba7f21c$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $gMnkn.getNavigationEntry)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $hi3xY.WINDOW).document && (0, $hi3xY.WINDOW).document.prerendering || (0, $5TTSp.getActivationStart)() > 0) navigationType = 'prerender';
        else navigationType = navEntry.type.replace(/_/g, '-');
    }
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: [],
        id: (0, $5KNPZ.generateUniqueID)(),
        navigationType: navigationType
    };
};

});
parcelRegister("hi3xY", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $c966de78e07f2fb1$export$56d8a8a25bd48b81; });

var $lNVQ9 = parcelRequire("lNVQ9");
const $c966de78e07f2fb1$export$56d8a8a25bd48b81 = (0, $lNVQ9.GLOBAL_OBJ);

});

parcelRegister("5KNPZ", function(module, exports) {

$parcel$export(module.exports, "generateUniqueID", function () { return $4307e853c9ece84f$export$407ea409d1f3b539; });
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $4307e853c9ece84f$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};

});

parcelRegister("5TTSp", function(module, exports) {

$parcel$export(module.exports, "getActivationStart", function () { return $44bd6eb4b3fd1605$export$d3e828b3c7b5b845; });

var $gMnkn = parcelRequire("gMnkn");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $44bd6eb4b3fd1605$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $gMnkn.getNavigationEntry)();
    return navEntry && navEntry.activationStart || 0;
};

});
parcelRegister("gMnkn", function(module, exports) {

$parcel$export(module.exports, "getNavigationEntry", function () { return $c37339674b8d248c$export$6431553786c94949; });

var $hi3xY = parcelRequire("hi3xY");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c37339674b8d248c$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $hi3xY.WINDOW).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $hi3xY.WINDOW).performance.navigation.type;
    const navigationEntry = {
        entryType: 'navigation',
        startTime: 0,
        type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate'
    };
    for(const key in timing)if (key !== 'navigationStart' && key !== 'toJSON') // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $c37339674b8d248c$export$6431553786c94949 = ()=>{
    if ((0, $hi3xY.WINDOW).__WEB_VITALS_POLYFILL__) return (0, $hi3xY.WINDOW).performance && (performance.getEntriesByType && performance.getEntriesByType('navigation')[0] || $c37339674b8d248c$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $hi3xY.WINDOW).performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
};

});



parcelRegister("9zLwN", function(module, exports) {

$parcel$export(module.exports, "observe", function () { return $6f8c40015604c1b9$export$d1203567a167490e; });
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $6f8c40015604c1b9$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe({
                type: type,
                buffered: true,
                ...opts
            });
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};

});

parcelRegister("12rSf", function(module, exports) {

$parcel$export(module.exports, "onHidden", function () { return $0c1b99844ab69310$export$91ec2be6fdd8f1b4; });

var $hi3xY = parcelRequire("hi3xY");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0c1b99844ab69310$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $hi3xY.WINDOW).document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, $hi3xY.WINDOW).document) {
        addEventListener('visibilitychange', onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener('pagehide', onHiddenOrPageHide, true);
    }
};

});


parcelRegister("hCnge", function(module, exports) {

$parcel$export(module.exports, "onFID", function () { return $cd380764dbfc4a7f$export$39705a25c49af873; });

var $gfJJk = parcelRequire("gfJJk");

var $3zi5n = parcelRequire("3zi5n");

var $5aga7 = parcelRequire("5aga7");

var $9zLwN = parcelRequire("9zLwN");

var $12rSf = parcelRequire("12rSf");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $cd380764dbfc4a7f$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $3zi5n.getVisibilityWatcher)();
    const metric = (0, $5aga7.initMetric)('FID');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $9zLwN.observe)('first-input', handleEntries);
    report = (0, $gfJJk.bindReporter)(onReport, metric);
    if (po) (0, $12rSf.onHidden)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};

});
parcelRegister("3zi5n", function(module, exports) {

$parcel$export(module.exports, "getVisibilityWatcher", function () { return $2992ab71d9a3efdc$export$443f86b2c77012c4; });

var $hi3xY = parcelRequire("hi3xY");

var $12rSf = parcelRequire("12rSf");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $2992ab71d9a3efdc$var$firstHiddenTime = -1;
const $2992ab71d9a3efdc$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, $hi3xY.WINDOW).document && (0, $hi3xY.WINDOW).document.visibilityState) $2992ab71d9a3efdc$var$firstHiddenTime = (0, $hi3xY.WINDOW).document.visibilityState === 'hidden' && !(0, $hi3xY.WINDOW).document.prerendering ? 0 : Infinity;
};
const $2992ab71d9a3efdc$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $12rSf.onHidden)(({ timeStamp: timeStamp })=>{
        $2992ab71d9a3efdc$var$firstHiddenTime = timeStamp;
    }, true);
};
const $2992ab71d9a3efdc$export$443f86b2c77012c4 = ()=>{
    if ($2992ab71d9a3efdc$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $2992ab71d9a3efdc$var$initHiddenTime();
        $2992ab71d9a3efdc$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $2992ab71d9a3efdc$var$firstHiddenTime;
        }
    };
};

});


parcelRegister("fUHEP", function(module, exports) {

$parcel$export(module.exports, "onINP", function () { return $b95df3783e127220$export$7df4b36ecaed99e1; });

var $gfJJk = parcelRequire("gfJJk");

var $5aga7 = parcelRequire("5aga7");

var $9zLwN = parcelRequire("9zLwN");

var $12rSf = parcelRequire("12rSf");

var $gqKd8 = parcelRequire("gqKd8");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $b95df3783e127220$var$getInteractionCountForNavigation = ()=>{
    return (0, $gqKd8.getInteractionCount)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $b95df3783e127220$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $b95df3783e127220$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $b95df3783e127220$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $b95df3783e127220$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $b95df3783e127220$var$longestInteractionList[$b95df3783e127220$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $b95df3783e127220$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $b95df3783e127220$var$longestInteractionList.length < $b95df3783e127220$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $b95df3783e127220$var$longestInteractionMap[interaction.id] = interaction;
            $b95df3783e127220$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $b95df3783e127220$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $b95df3783e127220$var$longestInteractionList.splice($b95df3783e127220$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $b95df3783e127220$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $b95df3783e127220$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($b95df3783e127220$var$longestInteractionList.length - 1, Math.floor($b95df3783e127220$var$getInteractionCountForNavigation() / 50));
    return $b95df3783e127220$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $b95df3783e127220$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $gqKd8.initInteractionCountPolyfill)();
    const metric = (0, $5aga7.initMetric)('INP');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $b95df3783e127220$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === 'first-input') {
                const noMatchingEntry = !$b95df3783e127220$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $b95df3783e127220$var$processEntry(entry);
            }
        });
        const inp = $b95df3783e127220$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $9zLwN.observe)('event', handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $gfJJk.bindReporter)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: 'first-input',
            buffered: true
        });
        (0, $12rSf.onHidden)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $b95df3783e127220$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};

});
parcelRegister("gqKd8", function(module, exports) {

$parcel$export(module.exports, "getInteractionCount", function () { return $bf62eb9683ec9d94$export$8a962f2683a476d1; });
$parcel$export(module.exports, "initInteractionCountPolyfill", function () { return $bf62eb9683ec9d94$export$67d90cda6b78a2eb; });

var $9zLwN = parcelRequire("9zLwN");
let $bf62eb9683ec9d94$var$interactionCountEstimate = 0;
let $bf62eb9683ec9d94$var$minKnownInteractionId = Infinity;
let $bf62eb9683ec9d94$var$maxKnownInteractionId = 0;
const $bf62eb9683ec9d94$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $bf62eb9683ec9d94$var$minKnownInteractionId = Math.min($bf62eb9683ec9d94$var$minKnownInteractionId, e.interactionId);
            $bf62eb9683ec9d94$var$maxKnownInteractionId = Math.max($bf62eb9683ec9d94$var$maxKnownInteractionId, e.interactionId);
            $bf62eb9683ec9d94$var$interactionCountEstimate = $bf62eb9683ec9d94$var$maxKnownInteractionId ? ($bf62eb9683ec9d94$var$maxKnownInteractionId - $bf62eb9683ec9d94$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $bf62eb9683ec9d94$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $bf62eb9683ec9d94$export$8a962f2683a476d1 = ()=>{
    return $bf62eb9683ec9d94$var$po ? $bf62eb9683ec9d94$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $bf62eb9683ec9d94$export$67d90cda6b78a2eb = ()=>{
    if ('interactionCount' in performance || $bf62eb9683ec9d94$var$po) return;
    $bf62eb9683ec9d94$var$po = (0, $9zLwN.observe)('event', $bf62eb9683ec9d94$var$updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};

});


parcelRegister("fLb5H", function(module, exports) {

$parcel$export(module.exports, "onLCP", function () { return $b793d93d4758c2e1$export$947b1626ab8d5632; });

var $hi3xY = parcelRequire("hi3xY");

var $gfJJk = parcelRequire("gfJJk");

var $5TTSp = parcelRequire("5TTSp");

var $3zi5n = parcelRequire("3zi5n");

var $5aga7 = parcelRequire("5aga7");

var $9zLwN = parcelRequire("9zLwN");

var $12rSf = parcelRequire("12rSf");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b793d93d4758c2e1$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $b793d93d4758c2e1$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $3zi5n.getVisibilityWatcher)();
    const metric = (0, $5aga7.initMetric)('LCP');
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $5TTSp.getActivationStart)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $9zLwN.observe)('largest-contentful-paint', handleEntries);
    if (po) {
        report = (0, $gfJJk.bindReporter)(onReport, metric);
        const stopListening = ()=>{
            if (!$b793d93d4758c2e1$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $b793d93d4758c2e1$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            'keydown',
            'click'
        ].forEach((type)=>{
            if ((0, $hi3xY.WINDOW).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $12rSf.onHidden)(stopListening, true);
        return stopListening;
    }
    return;
};

});

parcelRegister("kiLF7", function(module, exports) {

$parcel$export(module.exports, "onTTFB", function () { return $ec7a75cd44a5777e$export$33a01e6c5f2c7e33; });

var $hi3xY = parcelRequire("hi3xY");

var $gfJJk = parcelRequire("gfJJk");

var $5TTSp = parcelRequire("5TTSp");

var $gMnkn = parcelRequire("gMnkn");

var $5aga7 = parcelRequire("5aga7");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $ec7a75cd44a5777e$var$whenReady = (callback)=>{
    if (!(0, $hi3xY.WINDOW).document) return;
    if ((0, $hi3xY.WINDOW).document.prerendering) addEventListener('prerenderingchange', ()=>$ec7a75cd44a5777e$var$whenReady(callback), true);
    else if ((0, $hi3xY.WINDOW).document.readyState !== 'complete') addEventListener('load', ()=>$ec7a75cd44a5777e$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $ec7a75cd44a5777e$export$33a01e6c5f2c7e33 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    const metric = (0, $5aga7.initMetric)('TTFB');
    const report = (0, $gfJJk.bindReporter)(onReport, metric, opts.reportAllChanges);
    $ec7a75cd44a5777e$var$whenReady(()=>{
        const navEntry = (0, $gMnkn.getNavigationEntry)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, $5TTSp.getActivationStart)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};

});



parcelRegister("hz9Jf", function(module, exports) {

$parcel$export(module.exports, "registerBackgroundTabDetection", function () { return $cc9d407a31c7c486$export$6f18f55521af71a1; });

var $7flMU = parcelRequire("7flMU");
var $4RP7L = parcelRequire("4RP7L");

var $7p8hL = parcelRequire("7p8hL");

var $221nn = parcelRequire("221nn");

var $hi3xY = parcelRequire("hi3xY");
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $cc9d407a31c7c486$export$6f18f55521af71a1() {
    if ((0, $hi3xY.WINDOW).document) (0, $hi3xY.WINDOW).document.addEventListener('visibilitychange', ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $7flMU.getActiveTransaction)();
        if ((0, $hi3xY.WINDOW).document.hidden && activeTransaction) {
            const statusType = 'cancelled';
            const { op: op, status: status } = (0, $4RP7L.spanToJSON)(activeTransaction);
            (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag('visibilitychange', 'document.hidden');
            activeTransaction.end();
        }
    });
    else (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}

});

parcelRegister("6RLzi", function(module, exports) {

$parcel$export(module.exports, "startTrackingWebVitals", function () { return $4ffc976292e16022$export$7c69f0412d101b88; });
$parcel$export(module.exports, "startTrackingLongTasks", function () { return $4ffc976292e16022$export$f396d19077034ad2; });
$parcel$export(module.exports, "startTrackingInteractions", function () { return $4ffc976292e16022$export$e27543e0976315e4; });
$parcel$export(module.exports, "startTrackingINP", function () { return $4ffc976292e16022$export$f17d06681a4744a3; });
$parcel$export(module.exports, "addPerformanceEntries", function () { return $4ffc976292e16022$export$5f8fa6b3467a7443; });

var $3U98K = parcelRequire("3U98K");
var $7flMU = parcelRequire("7flMU");
var $hcepo = parcelRequire("hcepo");
var $2aCxe = parcelRequire("2aCxe");
var $g05qq = parcelRequire("g05qq");
var $g6vjT = parcelRequire("g6vjT");
var $5mTXR = parcelRequire("5mTXR");
var $4RP7L = parcelRequire("4RP7L");

var $iGf0k = parcelRequire("iGf0k");
var $04wr6 = parcelRequire("04wr6");
var $7p8hL = parcelRequire("7p8hL");
var $bn8Da = parcelRequire("bn8Da");

var $221nn = parcelRequire("221nn");

var $aiNal = parcelRequire("aiNal");

var $hi3xY = parcelRequire("hi3xY");

var $3zi5n = parcelRequire("3zi5n");

var $3RDMn = parcelRequire("3RDMn");

var $gMnkn = parcelRequire("gMnkn");
const $4ffc976292e16022$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $4ffc976292e16022$var$msToSec(time) {
    return time / 1000;
}
function $4ffc976292e16022$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $hi3xY.WINDOW) && (0, $hi3xY.WINDOW).addEventListener && (0, $hi3xY.WINDOW).performance;
}
let $4ffc976292e16022$var$_performanceCursor = 0;
let $4ffc976292e16022$var$_measurements = {};
let $4ffc976292e16022$var$_lcpEntry;
let $4ffc976292e16022$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $4ffc976292e16022$export$7c69f0412d101b88() {
    const performance = $4ffc976292e16022$var$getBrowserPerformanceAPI();
    if (performance && (0, $iGf0k.browserPerformanceTimeOrigin)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $hi3xY.WINDOW).performance.mark('sentry-tracing-init');
        const fidCallback = $4ffc976292e16022$var$_trackFID();
        const clsCallback = $4ffc976292e16022$var$_trackCLS();
        const lcpCallback = $4ffc976292e16022$var$_trackLCP();
        const ttfbCallback = $4ffc976292e16022$var$_trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $4ffc976292e16022$export$f396d19077034ad2() {
    (0, $aiNal.addPerformanceInstrumentationHandler)('longtask', ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $7flMU.getActiveTransaction)();
            if (!transaction) return;
            const startTime = $4ffc976292e16022$var$msToSec((0, $iGf0k.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = $4ffc976292e16022$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: 'Main UI thread blocked',
                op: 'ui.long-task',
                origin: 'auto.ui.browser.metrics',
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $4ffc976292e16022$export$e27543e0976315e4() {
    (0, $aiNal.addPerformanceInstrumentationHandler)('event', ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $7flMU.getActiveTransaction)();
            if (!transaction) return;
            if (entry.name === 'click') {
                const startTime = $4ffc976292e16022$var$msToSec((0, $iGf0k.browserPerformanceTimeOrigin) + entry.startTime);
                const duration = $4ffc976292e16022$var$msToSec(entry.duration);
                const span = {
                    description: (0, $04wr6.htmlTreeAsString)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: 'auto.ui.browser.metrics',
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $04wr6.getComponentName)(entry.target);
                if (componentName) span.attributes = {
                    'ui.component_name': componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $4ffc976292e16022$export$f17d06681a4744a3(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    const performance = $4ffc976292e16022$var$getBrowserPerformanceAPI();
    if (performance && (0, $iGf0k.browserPerformanceTimeOrigin)) {
        const inpCallback = $4ffc976292e16022$var$_trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $4ffc976292e16022$var$_trackCLS() {
    return (0, $aiNal.addClsInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log('[Measurements] Adding CLS');
        $4ffc976292e16022$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $4ffc976292e16022$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $4ffc976292e16022$var$_trackLCP() {
    return (0, $aiNal.addLcpInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log('[Measurements] Adding LCP');
        $4ffc976292e16022$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $4ffc976292e16022$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $4ffc976292e16022$var$_trackFID() {
    return (0, $aiNal.addFidInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $4ffc976292e16022$var$msToSec((0, $iGf0k.browserPerformanceTimeOrigin));
        const startTime = $4ffc976292e16022$var$msToSec(entry.startTime);
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log('[Measurements] Adding FID');
        $4ffc976292e16022$var$_measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $4ffc976292e16022$var$_measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
function $4ffc976292e16022$var$_trackTtfb() {
    return (0, $aiNal.addTtfbInstrumentationHandler)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log('[Measurements] Adding TTFB');
        $4ffc976292e16022$var$_measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
const $4ffc976292e16022$var$INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $4ffc976292e16022$var$_trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, $aiNal.addInpInstrumentationHandler)(({ metric: metric })=>{
        if (metric.value === undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $4ffc976292e16022$var$INP_ENTRY_MAP[entry.name] !== undefined);
        const client = (0, $hcepo.getClient)();
        if (!entry || !client) return;
        const interactionType = $4ffc976292e16022$var$INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $4ffc976292e16022$var$msToSec((0, $iGf0k.browserPerformanceTimeOrigin) + entry.startTime);
        const duration = $4ffc976292e16022$var$msToSec(metric.value);
        const interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = interaction;
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $5mTXR.Span)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, $04wr6.htmlTreeAsString)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== '' ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: 'millisecond'
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $4ffc976292e16022$var$getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $3U98K.createSpanEnvelope)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).error('Error while sending interaction:', reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $4ffc976292e16022$export$5f8fa6b3467a7443(transaction) {
    const performance = $4ffc976292e16022$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $hi3xY.WINDOW).performance.getEntries || !(0, $iGf0k.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log('[Tracing] Adding & adjusting spans using Performance API');
    const timeOrigin = $4ffc976292e16022$var$msToSec((0, $iGf0k.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $4RP7L.spanToJSON)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($4ffc976292e16022$var$_performanceCursor).forEach((entry)=>{
        const startTime = $4ffc976292e16022$var$msToSec(entry.startTime);
        const duration = $4ffc976292e16022$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                $4ffc976292e16022$var$_addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $4ffc976292e16022$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $3zi5n.getVisibilityWatcher)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log('[Measurements] Adding FP');
                        $4ffc976292e16022$var$_measurements['fp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log('[Measurements] Adding FCP');
                        $4ffc976292e16022$var$_measurements['fcp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    break;
                }
            case 'resource':
                $4ffc976292e16022$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $4ffc976292e16022$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $4ffc976292e16022$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        $4ffc976292e16022$var$_addTtfbRequestTimeToMeasurements($4ffc976292e16022$var$_measurements);
        [
            'fcp',
            'fp',
            'lcp'
        ].forEach((name)=>{
            if (!$4ffc976292e16022$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $4ffc976292e16022$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $4ffc976292e16022$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $4ffc976292e16022$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $4ffc976292e16022$var$_measurements['mark.fid'];
        if (fidMark && $4ffc976292e16022$var$_measurements['fid']) {
            // create span for FID
            (0, $3RDMn._startChild)(transaction, {
                description: 'first input delay',
                endTimestamp: fidMark.value + $4ffc976292e16022$var$msToSec($4ffc976292e16022$var$_measurements['fid'].value),
                op: 'ui.action',
                origin: 'auto.ui.browser.metrics',
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $4ffc976292e16022$var$_measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!('fcp' in $4ffc976292e16022$var$_measurements)) delete $4ffc976292e16022$var$_measurements.cls;
        Object.keys($4ffc976292e16022$var$_measurements).forEach((measurementName)=>{
            (0, $g6vjT.setMeasurement)(measurementName, $4ffc976292e16022$var$_measurements[measurementName].value, $4ffc976292e16022$var$_measurements[measurementName].unit);
        });
        $4ffc976292e16022$var$_tagMetricInfo(transaction);
    }
    $4ffc976292e16022$var$_lcpEntry = undefined;
    $4ffc976292e16022$var$_clsEntry = undefined;
    $4ffc976292e16022$var$_measurements = {};
}
/** Create measure related spans */ function $4ffc976292e16022$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $3RDMn._startChild)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: 'auto.resource.browser.metrics',
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4ffc976292e16022$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $4ffc976292e16022$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $4ffc976292e16022$var$_addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    $4ffc976292e16022$var$_addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    $4ffc976292e16022$var$_addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    $4ffc976292e16022$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $4ffc976292e16022$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $3RDMn._startChild)(transaction, {
        op: 'browser',
        origin: 'auto.browser.browser.metrics',
        description: description || event,
        startTimestamp: timeOrigin + $4ffc976292e16022$var$msToSec(start),
        endTimestamp: timeOrigin + $4ffc976292e16022$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4ffc976292e16022$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $3RDMn._startChild)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'request',
            startTimestamp: timeOrigin + $4ffc976292e16022$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $4ffc976292e16022$var$msToSec(entry.responseEnd)
        });
        (0, $3RDMn._startChild)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'response',
            startTimestamp: timeOrigin + $4ffc976292e16022$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $4ffc976292e16022$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $4ffc976292e16022$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    const parsedUrl = (0, $bn8Da.parseUrl)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $4ffc976292e16022$var$setResourceEntrySizeData(data, entry, 'transferSize', 'http.response_transfer_size');
    $4ffc976292e16022$var$setResourceEntrySizeData(data, entry, 'encodedBodySize', 'http.response_content_length');
    $4ffc976292e16022$var$setResourceEntrySizeData(data, entry, 'decodedBodySize', 'http.decoded_response_content_length');
    if ('renderBlockingStatus' in entry) data['resource.render_blocking_status'] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data['server.address'] = parsedUrl.host;
    data['url.same_origin'] = resourceUrl.includes((0, $hi3xY.WINDOW).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $3RDMn._startChild)(transaction, {
        description: resourceUrl.replace((0, $hi3xY.WINDOW).location.origin, ''),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
        origin: 'auto.resource.browser.metrics',
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $4ffc976292e16022$var$_trackNavigator(transaction) {
    const navigator = (0, $hi3xY.WINDOW).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('effectiveConnectionType', connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('connectionType', connection.type);
        if ((0, $3RDMn.isMeasurementValue)(connection.rtt)) $4ffc976292e16022$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $3RDMn.isMeasurementValue)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $3RDMn.isMeasurementValue)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $4ffc976292e16022$var$_tagMetricInfo(transaction) {
    if ($4ffc976292e16022$var$_lcpEntry) {
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($4ffc976292e16022$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.element', (0, $04wr6.htmlTreeAsString)($4ffc976292e16022$var$_lcpEntry.element));
        if ($4ffc976292e16022$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.id', $4ffc976292e16022$var$_lcpEntry.id);
        if ($4ffc976292e16022$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.url', $4ffc976292e16022$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.size', $4ffc976292e16022$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($4ffc976292e16022$var$_clsEntry && $4ffc976292e16022$var$_clsEntry.sources) {
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log('[Measurements] Adding CLS Data');
        $4ffc976292e16022$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $04wr6.htmlTreeAsString)(source.node)));
    }
}
function $4ffc976292e16022$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $4ffc976292e16022$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $4ffc976292e16022$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $gMnkn.getNavigationEntry)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log('[Measurements] Adding TTFB Request Time');
        _measurements['ttfb.requestTime'] = {
            value: responseStart - requestStart,
            unit: 'millisecond'
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $4ffc976292e16022$var$getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, $2aCxe.hasTracingEnabled)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === 'function') sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $hi3xY.WINDOW).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== 'undefined') sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $g05qq.isValidSampleRate)(sampleRate)) {
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).warn('[Tracing] Discarding interaction span because of invalid sample rate.');
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}

});
parcelRegister("3RDMn", function(module, exports) {

$parcel$export(module.exports, "isMeasurementValue", function () { return $2d052dae999a9a23$export$27169ccae1b439e3; });
$parcel$export(module.exports, "_startChild", function () { return $2d052dae999a9a23$export$8bd469e1f37aa721; });
/**
 * Checks if a given value is a valid measurement value.
 */ function $2d052dae999a9a23$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $2d052dae999a9a23$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}

});


parcelRegister("l7Nlw", function(module, exports) {

$parcel$export(module.exports, "defaultRequestInstrumentationOptions", function () { return $f6108789ffc5fa34$export$cc17fb3c0bc95cd7; });
$parcel$export(module.exports, "instrumentOutgoingRequests", function () { return $f6108789ffc5fa34$export$864489cb3478db3e; });

var $hcepo = parcelRequire("hcepo");
var $2Grcj = parcelRequire("2Grcj");
var $fxUGN = parcelRequire("fxUGN");
var $2aCxe = parcelRequire("2aCxe");
var $kuS4l = parcelRequire("kuS4l");
var $bMwjP = parcelRequire("bMwjP");
var $4RP7L = parcelRequire("4RP7L");
var $mtWu0 = parcelRequire("mtWu0");

var $dQVMO = parcelRequire("dQVMO");
var $jOCzY = parcelRequire("jOCzY");
var $9dJTa = parcelRequire("9dJTa");
var $iGf0k = parcelRequire("iGf0k");
var $6jMr3 = parcelRequire("6jMr3");
var $bn8Da = parcelRequire("bn8Da");
var $bMiqE = parcelRequire("bMiqE");

var $hDXp5 = parcelRequire("hDXp5");

var $aiNal = parcelRequire("aiNal");

var $hi3xY = parcelRequire("hi3xY");
/* eslint-disable max-lines */ const $f6108789ffc5fa34$export$15bd0305d05ad07b = [
    'localhost',
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $f6108789ffc5fa34$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $f6108789ffc5fa34$export$15bd0305d05ad07b,
    tracePropagationTargets: $f6108789ffc5fa34$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $f6108789ffc5fa34$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $f6108789ffc5fa34$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $f6108789ffc5fa34$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$f6108789ffc5fa34$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $dQVMO.addFetchInstrumentationHandler)((handlerData)=>{
        const createdSpan = (0, $hDXp5.instrumentFetchRequest)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = $f6108789ffc5fa34$var$getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, $bn8Da.parseUrl)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                'http.url': fullUrl,
                'server.address': host
            });
        }
        if (enableHTTPTimings && createdSpan) $f6108789ffc5fa34$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $jOCzY.addXhrInstrumentationHandler)((handlerData)=>{
        const createdSpan = $f6108789ffc5fa34$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $f6108789ffc5fa34$var$addHTTPTimings(createdSpan);
    });
}
function $f6108789ffc5fa34$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $f6108789ffc5fa34$var$addHTTPTimings(span) {
    const { url: url } = (0, $4RP7L.spanToJSON)(span).data || {};
    if (!url || typeof url !== 'string') return;
    const cleanup = (0, $aiNal.addPerformanceInstrumentationHandler)('resource', ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($f6108789ffc5fa34$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $f6108789ffc5fa34$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $f6108789ffc5fa34$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = 'unknown';
    let version = 'unknown';
    let _name = '';
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === '/') {
            [name, version] = nextHopProtocol.split('/');
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === 'h' ? 'http' : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $f6108789ffc5fa34$var$getAbsoluteTime(time = 0) {
    return (((0, $iGf0k.browserPerformanceTimeOrigin) || performance.timeOrigin) + time) / 1000;
}
function $f6108789ffc5fa34$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $f6108789ffc5fa34$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        'network.protocol.version',
        version
    ], [
        'network.protocol.name',
        name
    ]);
    if (!(0, $iGf0k.browserPerformanceTimeOrigin)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            'http.request.redirect_start',
            $f6108789ffc5fa34$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            'http.request.fetch_start',
            $f6108789ffc5fa34$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            'http.request.domain_lookup_start',
            $f6108789ffc5fa34$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            'http.request.domain_lookup_end',
            $f6108789ffc5fa34$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            'http.request.connect_start',
            $f6108789ffc5fa34$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            'http.request.secure_connection_start',
            $f6108789ffc5fa34$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            'http.request.connection_end',
            $f6108789ffc5fa34$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            'http.request.request_start',
            $f6108789ffc5fa34$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            'http.request.response_start',
            $f6108789ffc5fa34$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            'http.request.response_end',
            $f6108789ffc5fa34$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $f6108789ffc5fa34$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $bMiqE.stringMatchesSomePattern)(url, tracePropagationTargets || $f6108789ffc5fa34$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $f6108789ffc5fa34$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $jOCzY.SENTRY_XHR_DATA_KEY];
    if (!(0, $2aCxe.hasTracingEnabled)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $bMwjP.setHttpStatus)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $hcepo.getCurrentScope)();
    const isolationScope = (0, $fxUGN.getIsolationScope)();
    const fullUrl = $f6108789ffc5fa34$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $bn8Da.parseUrl)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $mtWu0.startInactiveSpan)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: 'xhr',
            'http.method': sentryXhrData.method,
            'http.url': fullUrl,
            url: sentryXhrData.url,
            'server.address': host,
            [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.http.browser'
        },
        op: 'http.client'
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $hcepo.getClient)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $4RP7L.spanToTraceHeader)(span) : (0, $6jMr3.generateSentryTraceHeader)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $9dJTa.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $2Grcj.getDynamicSamplingContextFromSpan)(span) : (0, $2Grcj.getDynamicSamplingContextFromClient)(traceId, client, scope)));
        $f6108789ffc5fa34$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $f6108789ffc5fa34$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $9dJTa.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $f6108789ffc5fa34$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $hi3xY.WINDOW).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}

});
parcelRegister("hDXp5", function(module, exports) {

$parcel$export(module.exports, "instrumentFetchRequest", function () { return $cd842884c7e01b90$export$6d73c62358c655be; });

var $hcepo = parcelRequire("hcepo");
var $2Grcj = parcelRequire("2Grcj");
var $fxUGN = parcelRequire("fxUGN");
var $2aCxe = parcelRequire("2aCxe");
var $kuS4l = parcelRequire("kuS4l");
var $bMwjP = parcelRequire("bMwjP");
var $4RP7L = parcelRequire("4RP7L");
var $mtWu0 = parcelRequire("mtWu0");

var $9dJTa = parcelRequire("9dJTa");
var $6jMr3 = parcelRequire("6jMr3");
var $jPeZ4 = parcelRequire("jPeZ4");
var $bn8Da = parcelRequire("bn8Da");
/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $cd842884c7e01b90$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = 'auto.http.browser') {
    if (!(0, $2aCxe.hasTracingEnabled)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $cd842884c7e01b90$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $hcepo.getCurrentScope)();
    const client = (0, $hcepo.getClient)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $cd842884c7e01b90$var$getFullURL(url);
    const host = fullUrl ? (0, $bn8Da.parseUrl)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $mtWu0.startInactiveSpan)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: 'fetch',
            'http.method': method,
            'http.url': fullUrl,
            'server.address': host,
            [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin
        },
        op: 'http.client'
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $cd842884c7e01b90$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $cd842884c7e01b90$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $fxUGN.getIsolationScope)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $4RP7L.spanToTraceHeader)(span) : (0, $6jMr3.generateSentryTraceHeader)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $9dJTa.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, $2Grcj.getDynamicSamplingContextFromSpan)(span) : (0, $2Grcj.getDynamicSamplingContextFromClient)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== 'undefined' && (0, $jPeZ4.isInstanceOf)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        'sentry-trace': sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== 'undefined' && (0, $jPeZ4.isInstanceOf)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $9dJTa.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                'sentry-trace',
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $9dJTa.BAGGAGE_HEADER_NAME),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            'sentry-trace': sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
    }
}
function $cd842884c7e01b90$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $cd842884c7e01b90$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $bMwjP.setHttpStatus)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus('internal_error');
    span.end();
}

});


parcelRegister("cd71e", function(module, exports) {

$parcel$export(module.exports, "browserTracingIntegration", function () { return $8e3c24c114a33a8a$export$b4109253475213e9; });
$parcel$export(module.exports, "startBrowserTracingPageLoadSpan", function () { return $8e3c24c114a33a8a$export$aa44a07f82af519f; });
$parcel$export(module.exports, "startBrowserTracingNavigationSpan", function () { return $8e3c24c114a33a8a$export$7d159749bd9969ad; });

var $jEn5j = parcelRequire("jEn5j");
var $mtWu0 = parcelRequire("mtWu0");
var $7flMU = parcelRequire("7flMU");
var $hcepo = parcelRequire("hcepo");
var $fxUGN = parcelRequire("fxUGN");
var $kuS4l = parcelRequire("kuS4l");
var $4RP7L = parcelRequire("4RP7L");
var $k6xPV = parcelRequire("k6xPV");

var $hFlB3 = parcelRequire("hFlB3");
var $iGf0k = parcelRequire("iGf0k");
var $04wr6 = parcelRequire("04wr6");
var $7p8hL = parcelRequire("7p8hL");
var $6jMr3 = parcelRequire("6jMr3");

var $221nn = parcelRequire("221nn");

var $hz9Jf = parcelRequire("hz9Jf");

var $aiNal = parcelRequire("aiNal");

var $6RLzi = parcelRequire("6RLzi");

var $l7Nlw = parcelRequire("l7Nlw");

var $hi3xY = parcelRequire("hi3xY");
const $8e3c24c114a33a8a$export$bbd2089f30bd3708 = 'BrowserTracing';
/** Options for Browser Tracing integration */ const $8e3c24c114a33a8a$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $k6xPV.TRACING_DEFAULTS),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $l7Nlw.defaultRequestInstrumentationOptions)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $8e3c24c114a33a8a$export$b4109253475213e9 = (_options = {})=>{
    const _hasSetTracePropagationTargets = (0, $221nn.DEBUG_BUILD) ? !!// eslint-disable-next-line deprecation/deprecation
    (_options.tracePropagationTargets || _options.tracingOrigins) : false;
    (0, $jEn5j.addTracingExtensions)();
    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (!_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
    _options.tracePropagationTargets = _options.tracingOrigins;
    const options = {
        ...$8e3c24c114a33a8a$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $6RLzi.startTrackingWebVitals)();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ const interactionIdToRouteNameMapping = {};
    if (options.enableInp) (0, $6RLzi.startTrackingINP)(interactionIdToRouteNameMapping, options.interactionsSampleRate);
    if (options.enableLongTask) (0, $6RLzi.startTrackingLongTasks)();
    if (options._experiments.enableInteractions) (0, $6RLzi.startTrackingInteractions)();
    const latestRoute = {
        name: undefined,
        context: undefined
    };
    /** Create routing idle transaction. */ function _createRouteTransaction(context) {
        // eslint-disable-next-line deprecation/deprecation
        const hub = (0, $fxUGN.getCurrentHub)();
        const { beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const isPageloadTransaction = context.op === 'pageload';
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $8e3c24c114a33a8a$export$f147b32b03c9cf11('sentry-trace') : '';
            const baggage = isPageloadTransaction ? $8e3c24c114a33a8a$export$f147b32b03c9cf11('baggage') : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $6jMr3.propagationContextFromHeaders)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const finalContext = beforeStartSpan ? beforeStartSpan(expandedContext) : expandedContext;
        // If `beforeStartSpan` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: 'custom'
        } : finalContext.metadata;
        latestRoute.name = finalContext.name;
        latestRoute.context = finalContext;
        if (finalContext.sampled === false) (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $hi3xY.WINDOW);
        const idleTransaction = (0, $jEn5j.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction && (0, $hi3xY.WINDOW).document) {
            (0, $hi3xY.WINDOW).document.addEventListener('readystatechange', ()=>{
                if ([
                    'interactive',
                    'complete'
                ].includes((0, $hi3xY.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
            });
            if ([
                'interactive',
                'complete'
            ].includes((0, $hi3xY.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            _collectWebVitals();
            (0, $6RLzi.addPerformanceEntries)(transaction);
        });
        return idleTransaction;
    }
    return {
        name: $8e3c24c114a33a8a$export$bbd2089f30bd3708,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: ()=>{},
        afterAllSetup (client) {
            const clientOptions = client.getOptions();
            const { markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = options;
            const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
            // There are three ways to configure tracePropagationTargets:
            // 1. via top level client option `tracePropagationTargets`
            // 2. via BrowserTracing option `tracePropagationTargets`
            // 3. via BrowserTracing option `tracingOrigins` (deprecated)
            //
            // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
            // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
            // This is done as it minimizes bundle size (we don't have to have undefined checks).
            //
            // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
            // eslint-disable-next-line deprecation/deprecation
            const tracePropagationTargets = clientOptionsTracePropagationTargets || options.tracePropagationTargets;
            if ((0, $221nn.DEBUG_BUILD) && _hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $7p8hL.logger).warn('[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.');
            let activeSpan;
            let startingUrl = (0, $hi3xY.WINDOW).location && (0, $hi3xY.WINDOW).location.href;
            if (client.on) {
                client.on('startNavigationSpan', (context)=>{
                    if (activeSpan) {
                        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Finishing current transaction with op: ${(0, $4RP7L.spanToJSON)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: 'navigation',
                        ...context
                    });
                });
                client.on('startPageLoadSpan', (context)=>{
                    if (activeSpan) {
                        (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).log(`[Tracing] Finishing current transaction with op: ${(0, $4RP7L.spanToJSON)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: 'pageload',
                        ...context
                    });
                });
            }
            if (options.instrumentPageLoad && client.emit && (0, $hi3xY.WINDOW).location) {
                const context = {
                    name: (0, $hi3xY.WINDOW).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTimestamp: (0, $iGf0k.browserPerformanceTimeOrigin) ? (0, $iGf0k.browserPerformanceTimeOrigin) / 1000 : undefined,
                    origin: 'auto.pageload.browser',
                    attributes: {
                        [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url'
                    }
                };
                $8e3c24c114a33a8a$export$aa44a07f82af519f(client, context);
            }
            if (options.instrumentNavigation && client.emit && (0, $hi3xY.WINDOW).location) (0, $hFlB3.addHistoryInstrumentationHandler)(({ to: to, from: from })=>{
                /**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                    startingUrl = undefined;
                    return;
                }
                if (from !== to) {
                    startingUrl = undefined;
                    const context = {
                        name: (0, $hi3xY.WINDOW).location.pathname,
                        origin: 'auto.navigation.browser',
                        attributes: {
                            [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url'
                        }
                    };
                    $8e3c24c114a33a8a$export$7d159749bd9969ad(client, context);
                }
            });
            if (markBackgroundSpan) (0, $hz9Jf.registerBackgroundTabDetection)();
            if (_experiments.enableInteractions) $8e3c24c114a33a8a$var$registerInteractionListener(options, latestRoute);
            if (options.enableInp) $8e3c24c114a33a8a$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute);
            (0, $l7Nlw.instrumentOutgoingRequests)({
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        },
        options: // TODO v8: Remove this again
        // This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
        options
    };
};
/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $8e3c24c114a33a8a$export$aa44a07f82af519f(client, spanOptions) {
    if (!client.emit) return;
    client.emit('startPageLoadSpan', spanOptions);
    const span = (0, $mtWu0.getActiveSpan)();
    const op = span && (0, $4RP7L.spanToJSON)(span).op;
    return op === 'pageload' ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $8e3c24c114a33a8a$export$7d159749bd9969ad(client, spanOptions) {
    if (!client.emit) return;
    client.emit('startNavigationSpan', spanOptions);
    const span = (0, $mtWu0.getActiveSpan)();
    const op = span && (0, $4RP7L.spanToJSON)(span).op;
    return op === 'navigation' ? span : undefined;
}
/** Returns the value of a meta tag */ function $8e3c24c114a33a8a$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $04wr6.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : undefined;
}
/** Start listener for interaction transactions */ function $8e3c24c114a33a8a$var$registerInteractionListener(options, latestRoute) {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = ()=>{
        const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const op = 'ui.action.click';
        // eslint-disable-next-line deprecation/deprecation
        const currentTransaction = (0, $7flMU.getActiveTransaction)();
        if (currentTransaction && currentTransaction.op && [
            'navigation',
            'pageload'
        ].includes(currentTransaction.op)) {
            (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
            return undefined;
        }
        if (inflightInteractionTransaction) {
            inflightInteractionTransaction.setFinishReason('interactionInterrupted');
            inflightInteractionTransaction.end();
            inflightInteractionTransaction = undefined;
        }
        if (!latestRoute.name) {
            (0, $221nn.DEBUG_BUILD) && (0, $7p8hL.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        const { location: location } = (0, $hi3xY.WINDOW);
        const context = {
            name: latestRoute.name,
            op: op,
            trimEnd: true,
            data: {
                [(0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: latestRoute.context ? $8e3c24c114a33a8a$var$getSource(latestRoute.context) : 'url'
            }
        };
        inflightInteractionTransaction = (0, $jEn5j.startIdleTransaction)(// eslint-disable-next-line deprecation/deprecation
        (0, $fxUGN.getCurrentHub)(), context, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
    };
    [
        'click'
    ].forEach((type)=>{
        if ((0, $hi3xY.WINDOW).document) addEventListener(type, registerInteractionTransaction, {
            once: false,
            capture: true
        });
    });
}
function $8e3c24c114a33a8a$var$isPerformanceEventTiming(entry) {
    return 'duration' in entry;
}
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $8e3c24c114a33a8a$var$MAX_INTERACTIONS = 10;
/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ function $8e3c24c114a33a8a$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute) {
    const handleEntries = ({ entries: entries })=>{
        const client = (0, $hcepo.getClient)();
        // We need to get the replay, user, and activeTransaction from the current scope
        // so that we can associate replay id, profile id, and a user display to the span
        const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName('Replay') : undefined;
        const replayId = replay !== undefined ? replay.getReplayId() : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $7flMU.getActiveTransaction)();
        const currentScope = (0, $hcepo.getCurrentScope)();
        const user = currentScope !== undefined ? currentScope.getUser() : undefined;
        entries.forEach((entry)=>{
            if ($8e3c24c114a33a8a$var$isPerformanceEventTiming(entry)) {
                const interactionId = entry.interactionId;
                if (interactionId === undefined) return;
                const existingInteraction = interactionIdToRouteNameMapping[interactionId];
                const duration = entry.duration;
                const startTime = entry.startTime;
                const keys = Object.keys(interactionIdToRouteNameMapping);
                const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                    return interactionIdToRouteNameMapping[a].duration < interactionIdToRouteNameMapping[b].duration ? a : b;
                }) : undefined;
                // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                // This is also checked in the web-vitals library.
                if (entry.entryType === 'first-input') {
                    const matchingEntry = keys.map((key)=>interactionIdToRouteNameMapping[key]).some((interaction)=>{
                        return interaction.duration === duration && interaction.startTime === startTime;
                    });
                    if (matchingEntry) return;
                }
                // Interactions with an id of 0 and are not first-input are not valid.
                if (!interactionId) return;
                // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                else if (keys.length < $8e3c24c114a33a8a$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > interactionIdToRouteNameMapping[minInteractionId].duration) {
                    // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                    const routeName = latestRoute.name;
                    const parentContext = latestRoute.context;
                    if (routeName && parentContext) {
                        if (minInteractionId && Object.keys(interactionIdToRouteNameMapping).length >= $8e3c24c114a33a8a$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                        delete interactionIdToRouteNameMapping[minInteractionId];
                        interactionIdToRouteNameMapping[interactionId] = {
                            routeName: routeName,
                            duration: duration,
                            parentContext: parentContext,
                            user: user,
                            activeTransaction: activeTransaction,
                            replayId: replayId,
                            startTime: startTime
                        };
                    }
                }
            }
        });
    };
    (0, $aiNal.addPerformanceInstrumentationHandler)('event', handleEntries);
    (0, $aiNal.addPerformanceInstrumentationHandler)('first-input', handleEntries);
}
function $8e3c24c114a33a8a$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $kuS4l.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}

});

parcelRegister("9BO67", function(module, exports) {
parcelRequire("aSDg5");

});
parcelRegister("aSDg5", function(module, exports) {

var $hVw4Q = parcelRequire("hVw4Q");

var $9adjg = parcelRequire("9adjg");

var $4a6xH = parcelRequire("4a6xH");
const $7ebd66738f4fff52$var$name = "@firebase/analytics-compat";
const $7ebd66738f4fff52$var$version = "0.2.14";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $7ebd66738f4fff52$var$AnalyticsService {
    constructor(app, _delegate){
        this.app = app;
        this._delegate = _delegate;
    }
    logEvent(eventName, eventParams, options) {
        (0, $9adjg.logEvent)(this._delegate, eventName, eventParams, options);
    }
    /**
     * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
     * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
     */ setCurrentScreen(screenName, options) {
        (0, $9adjg.setCurrentScreen)(this._delegate, screenName, options);
    }
    setUserId(id, options) {
        (0, $9adjg.setUserId)(this._delegate, id, options);
    }
    setUserProperties(properties, options) {
        (0, $9adjg.setUserProperties)(this._delegate, properties, options);
    }
    setAnalyticsCollectionEnabled(enabled) {
        (0, $9adjg.setAnalyticsCollectionEnabled)(this._delegate, enabled);
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Officially recommended event names for gtag.js
 * Any other string is also allowed.
 */ var $7ebd66738f4fff52$var$EventName;
(function(EventName) {
    EventName["ADD_SHIPPING_INFO"] = "add_shipping_info";
    EventName["ADD_PAYMENT_INFO"] = "add_payment_info";
    EventName["ADD_TO_CART"] = "add_to_cart";
    EventName["ADD_TO_WISHLIST"] = "add_to_wishlist";
    EventName["BEGIN_CHECKOUT"] = "begin_checkout";
    /**
     * @deprecated
     * This event name is deprecated and is unsupported in updated
     * Enhanced Ecommerce reports.
     */ EventName["CHECKOUT_PROGRESS"] = "checkout_progress";
    EventName["EXCEPTION"] = "exception";
    EventName["GENERATE_LEAD"] = "generate_lead";
    EventName["LOGIN"] = "login";
    EventName["PAGE_VIEW"] = "page_view";
    EventName["PURCHASE"] = "purchase";
    EventName["REFUND"] = "refund";
    EventName["REMOVE_FROM_CART"] = "remove_from_cart";
    EventName["SCREEN_VIEW"] = "screen_view";
    EventName["SEARCH"] = "search";
    EventName["SELECT_CONTENT"] = "select_content";
    EventName["SELECT_ITEM"] = "select_item";
    EventName["SELECT_PROMOTION"] = "select_promotion";
    /** @deprecated */ EventName["SET_CHECKOUT_OPTION"] = "set_checkout_option";
    EventName["SHARE"] = "share";
    EventName["SIGN_UP"] = "sign_up";
    EventName["TIMING_COMPLETE"] = "timing_complete";
    EventName["VIEW_CART"] = "view_cart";
    EventName["VIEW_ITEM"] = "view_item";
    EventName["VIEW_ITEM_LIST"] = "view_item_list";
    EventName["VIEW_PROMOTION"] = "view_promotion";
    EventName["VIEW_SEARCH_RESULTS"] = "view_search_results";
})($7ebd66738f4fff52$var$EventName || ($7ebd66738f4fff52$var$EventName = {}));
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7ebd66738f4fff52$var$factory = (container)=>{
    // Dependencies
    const app = container.getProvider('app-compat').getImmediate();
    const analyticsServiceExp = container.getProvider('analytics').getImmediate();
    return new $7ebd66738f4fff52$var$AnalyticsService(app, analyticsServiceExp);
};
function $7ebd66738f4fff52$export$7c804eebd0c1f2e0() {
    const namespaceExports = {
        Analytics: $7ebd66738f4fff52$var$AnalyticsService,
        settings: (0, $9adjg.settings),
        isSupported: (0, $9adjg.isSupported),
        EventName: // We removed this enum in exp so need to re-create it here for compat.
        $7ebd66738f4fff52$var$EventName
    };
    (0, $hVw4Q.default).INTERNAL.registerComponent(new (0, $4a6xH.Component)('analytics-compat', $7ebd66738f4fff52$var$factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setServiceProps(namespaceExports).setMultipleInstances(true));
}
$7ebd66738f4fff52$export$7c804eebd0c1f2e0();
(0, $hVw4Q.default).registerVersion($7ebd66738f4fff52$var$name, $7ebd66738f4fff52$var$version);

});
parcelRegister("9adjg", function(module, exports) {

$parcel$export(module.exports, "settings", function () { return $6abf5f471d8ed3f5$export$a5a6e0b888b2c992; });
$parcel$export(module.exports, "isSupported", function () { return $6abf5f471d8ed3f5$export$48c17662a6902497; });
$parcel$export(module.exports, "setCurrentScreen", function () { return $6abf5f471d8ed3f5$export$a364c5ef84862575; });
$parcel$export(module.exports, "setUserId", function () { return $6abf5f471d8ed3f5$export$7f5abdb7f5093137; });
$parcel$export(module.exports, "setUserProperties", function () { return $6abf5f471d8ed3f5$export$d0e176862bf869b8; });
$parcel$export(module.exports, "setAnalyticsCollectionEnabled", function () { return $6abf5f471d8ed3f5$export$7d544a250c4ed423; });
$parcel$export(module.exports, "logEvent", function () { return $6abf5f471d8ed3f5$export$5e9eec8001665ac5; });

var $ix4Jr = parcelRequire("ix4Jr");

var $7vF8m = parcelRequire("7vF8m");

var $ffjl9 = parcelRequire("ffjl9");

var $4a6xH = parcelRequire("4a6xH");
parcelRequire("keeEs");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Analytics.
 */ const $6abf5f471d8ed3f5$var$ANALYTICS_TYPE = 'analytics';
// Key to attach FID to in gtag params.
const $6abf5f471d8ed3f5$var$GA_FID_KEY = 'firebase_id';
const $6abf5f471d8ed3f5$var$ORIGIN_KEY = 'origin';
const $6abf5f471d8ed3f5$var$FETCH_TIMEOUT_MILLIS = 60000;
const $6abf5f471d8ed3f5$var$DYNAMIC_CONFIG_URL = 'https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig';
const $6abf5f471d8ed3f5$var$GTAG_URL = 'https://www.googletagmanager.com/gtag/js';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6abf5f471d8ed3f5$var$logger = new (0, $7vF8m.Logger)('@firebase/analytics');
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6abf5f471d8ed3f5$var$ERRORS = {
    ["already-exists" /* AnalyticsError.ALREADY_EXISTS */ ]: "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId.",
    ["already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ ]: "initializeAnalytics() cannot be called again with different options than those it was initially called with. It can be called again with the same options to return the existing instance, or getAnalytics() can be used to get a reference to the already-initialized instance.",
    ["already-initialized-settings" /* AnalyticsError.ALREADY_INITIALIZED_SETTINGS */ ]: "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.",
    ["interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ ]: 'Firebase Analytics Interop Component failed to instantiate: {$reason}',
    ["invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ ]: "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ ]: "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ ]: "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.",
    ["config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ ]: 'Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}',
    ["no-api-key" /* AnalyticsError.NO_API_KEY */ ]: 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.',
    ["no-app-id" /* AnalyticsError.NO_APP_ID */ ]: 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.',
    ["no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ]: 'The "client_id" field is empty.',
    ["invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ ]: 'Trusted Types detected an invalid gtag resource: {$gtagURL}.'
};
const $6abf5f471d8ed3f5$var$ERROR_FACTORY = new (0, $ffjl9.ErrorFactory)('analytics', 'Analytics', $6abf5f471d8ed3f5$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies and creates a TrustedScriptURL.
 */ function $6abf5f471d8ed3f5$var$createGtagTrustedTypesScriptURL(url) {
    if (!url.startsWith($6abf5f471d8ed3f5$var$GTAG_URL)) {
        const err = $6abf5f471d8ed3f5$var$ERROR_FACTORY.create("invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ , {
            gtagURL: url
        });
        $6abf5f471d8ed3f5$var$logger.warn(err.message);
        return '';
    }
    return url;
}
/**
 * Makeshift polyfill for Promise.allSettled(). Resolves when all promises
 * have either resolved or rejected.
 *
 * @param promises Array of promises to wait for.
 */ function $6abf5f471d8ed3f5$var$promiseAllSettled(promises) {
    return Promise.all(promises.map((promise)=>promise.catch((e)=>e)));
}
/**
 * Creates a TrustedTypePolicy object that implements the rules passed as policyOptions.
 *
 * @param policyName A string containing the name of the policy
 * @param policyOptions Object containing implementations of instance methods for TrustedTypesPolicy, see {@link https://developer.mozilla.org/en-US/docs/Web/API/TrustedTypePolicy#instance_methods
 * | the TrustedTypePolicy reference documentation}.
 */ function $6abf5f471d8ed3f5$var$createTrustedTypesPolicy(policyName, policyOptions) {
    // Create a TrustedTypes policy that we can use for updating src
    // properties
    let trustedTypesPolicy;
    if (window.trustedTypes) trustedTypesPolicy = window.trustedTypes.createPolicy(policyName, policyOptions);
    return trustedTypesPolicy;
}
/**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $6abf5f471d8ed3f5$var$insertScriptTag(dataLayerName, measurementId) {
    const trustedTypesPolicy = $6abf5f471d8ed3f5$var$createTrustedTypesPolicy('firebase-js-sdk-policy', {
        createScriptURL: $6abf5f471d8ed3f5$var$createGtagTrustedTypesScriptURL
    });
    const script = document.createElement('script');
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    const gtagScriptURL = `${$6abf5f471d8ed3f5$var$GTAG_URL}?l=${dataLayerName}&id=${measurementId}`;
    script.src = trustedTypesPolicy ? trustedTypesPolicy === null || trustedTypesPolicy === void 0 ? void 0 : trustedTypesPolicy.createScriptURL(gtagScriptURL) : gtagScriptURL;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $6abf5f471d8ed3f5$var$getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    let dataLayer = [];
    if (Array.isArray(window[dataLayerName])) dataLayer = window[dataLayerName];
    else window[dataLayerName] = dataLayer;
    return dataLayer;
}
/**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */ async function $6abf5f471d8ed3f5$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    // If config is already fetched, we know the appId and can use it to look up what FID promise we
    /// are waiting for, and wait only on that one.
    const correspondingAppId = measurementIdToAppId[measurementId];
    try {
        if (correspondingAppId) await initializationPromisesMap[correspondingAppId];
        else {
            // If config is not fetched yet, wait for all configs (we don't know which one we need) and
            // find the appId (if any) corresponding to this measurementId. If there is one, wait on
            // that appId's initialization promise. If there is none, promise resolves and gtag
            // call goes through.
            const dynamicConfigResults = await $6abf5f471d8ed3f5$var$promiseAllSettled(dynamicConfigPromisesList);
            const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === measurementId);
            if (foundConfig) await initializationPromisesMap[foundConfig.appId];
        }
    } catch (e) {
        $6abf5f471d8ed3f5$var$logger.error(e);
    }
    gtagCore("config" /* GtagCommand.CONFIG */ , measurementId, gtagParams);
}
/**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */ async function $6abf5f471d8ed3f5$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    try {
        let initializationPromisesToWaitFor = [];
        // If there's a 'send_to' param, check if any ID specified matches
        // an initializeIds() promise we are waiting for.
        if (gtagParams && gtagParams['send_to']) {
            let gaSendToList = gtagParams['send_to'];
            // Make it an array if is isn't, so it can be dealt with the same way.
            if (!Array.isArray(gaSendToList)) gaSendToList = [
                gaSendToList
            ];
            // Checking 'send_to' fields requires having all measurement ID results back from
            // the dynamic config fetch.
            const dynamicConfigResults = await $6abf5f471d8ed3f5$var$promiseAllSettled(dynamicConfigPromisesList);
            for (const sendToId of gaSendToList){
                // Any fetched dynamic measurement ID that matches this 'send_to' ID
                const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === sendToId);
                const initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                if (initializationPromise) initializationPromisesToWaitFor.push(initializationPromise);
                else {
                    // Found an item in 'send_to' that is not associated
                    // directly with an FID, possibly a group.  Empty this array,
                    // exit the loop early, and let it get populated below.
                    initializationPromisesToWaitFor = [];
                    break;
                }
            }
        }
        // This will be unpopulated if there was no 'send_to' field , or
        // if not all entries in the 'send_to' field could be mapped to
        // a FID. In these cases, wait on all pending initialization promises.
        if (initializationPromisesToWaitFor.length === 0) /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
        // Run core gtag function with args after all relevant initialization
        // promises have been resolved.
        await Promise.all(initializationPromisesToWaitFor);
        // Workaround for http://b/141370449 - third argument cannot be undefined.
        gtagCore("event" /* GtagCommand.EVENT */ , measurementId, gtagParams || {});
    } catch (e) {
        $6abf5f471d8ed3f5$var$logger.error(e);
    }
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */ function $6abf5f471d8ed3f5$var$wrapGtag(gtagCore, /**
 * Allows wrapped gtag calls to wait on whichever initialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */ initializationPromisesMap, /**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */ dynamicConfigPromisesList, /**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */ measurementIdToAppId) {
    /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */ async function gtagWrapper(command, ...args) {
        try {
            // If event, check that relevant initialization promises have completed.
            if (command === "event" /* GtagCommand.EVENT */ ) {
                const [measurementId, gtagParams] = args;
                // If EVENT, second arg must be measurementId.
                await $6abf5f471d8ed3f5$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams);
            } else if (command === "config" /* GtagCommand.CONFIG */ ) {
                const [measurementId, gtagParams] = args;
                // If CONFIG, second arg must be measurementId.
                await $6abf5f471d8ed3f5$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams);
            } else if (command === "consent" /* GtagCommand.CONSENT */ ) {
                const [consentAction, gtagParams] = args;
                // consentAction can be one of 'default' or 'update'.
                gtagCore("consent" /* GtagCommand.CONSENT */ , consentAction, gtagParams);
            } else if (command === "get" /* GtagCommand.GET */ ) {
                const [measurementId, fieldName, callback] = args;
                gtagCore("get" /* GtagCommand.GET */ , measurementId, fieldName, callback);
            } else if (command === "set" /* GtagCommand.SET */ ) {
                const [customParams] = args;
                // If SET, second arg must be params.
                gtagCore("set" /* GtagCommand.SET */ , customParams);
            } else gtagCore(command, ...args);
        } catch (e) {
            $6abf5f471d8ed3f5$var$logger.error(e);
        }
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */ function $6abf5f471d8ed3f5$var$wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    let gtagCore = function(..._args) {
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] && typeof window[gtagFunctionName] === 'function') // @ts-ignore
    gtagCore = window[gtagFunctionName];
    window[gtagFunctionName] = $6abf5f471d8ed3f5$var$wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore: gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns the script tag in the DOM matching both the gtag url pattern
 * and the provided data layer name.
 */ function $6abf5f471d8ed3f5$var$findGtagScriptOnPage(dataLayerName) {
    const scriptTags = window.document.getElementsByTagName('script');
    for (const tag of Object.values(scriptTags)){
        if (tag.src && tag.src.includes($6abf5f471d8ed3f5$var$GTAG_URL) && tag.src.includes(dataLayerName)) return tag;
    }
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */ const $6abf5f471d8ed3f5$var$LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */ const $6abf5f471d8ed3f5$var$BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */ class $6abf5f471d8ed3f5$var$RetryData {
    constructor(throttleMetadata = {}, intervalMillis = $6abf5f471d8ed3f5$var$BASE_INTERVAL_MILLIS){
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
    getThrottleMetadata(appId) {
        return this.throttleMetadata[appId];
    }
    setThrottleMetadata(appId, metadata) {
        this.throttleMetadata[appId] = metadata;
    }
    deleteThrottleMetadata(appId) {
        delete this.throttleMetadata[appId];
    }
}
const $6abf5f471d8ed3f5$var$defaultRetryData = new $6abf5f471d8ed3f5$var$RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */ function $6abf5f471d8ed3f5$var$getHeaders(apiKey) {
    return new Headers({
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
/**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */ async function $6abf5f471d8ed3f5$var$fetchDynamicConfig(appFields) {
    var _a;
    const { appId: appId, apiKey: apiKey } = appFields;
    const request = {
        method: 'GET',
        headers: $6abf5f471d8ed3f5$var$getHeaders(apiKey)
    };
    const appUrl = $6abf5f471d8ed3f5$var$DYNAMIC_CONFIG_URL.replace('{app-id}', appId);
    const response = await fetch(appUrl, request);
    if (response.status !== 200 && response.status !== 304) {
        let errorMessage = '';
        try {
            // Try to get any error message text from server response.
            const jsonResponse = await response.json();
            if ((_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message) errorMessage = jsonResponse.error.message;
        } catch (_ignored) {}
        throw $6abf5f471d8ed3f5$var$ERROR_FACTORY.create("config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ , {
            httpStatus: response.status,
            responseMessage: errorMessage
        });
    }
    return response.json();
}
/**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */ async function $6abf5f471d8ed3f5$var$fetchDynamicConfigWithRetry(app, // retryData and timeoutMillis are parameterized to allow passing a different value for testing.
retryData = $6abf5f471d8ed3f5$var$defaultRetryData, timeoutMillis) {
    const { appId: appId, apiKey: apiKey, measurementId: measurementId } = app.options;
    if (!appId) throw $6abf5f471d8ed3f5$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!apiKey) {
        if (measurementId) return {
            measurementId: measurementId,
            appId: appId
        };
        throw $6abf5f471d8ed3f5$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    const throttleMetadata = retryData.getThrottleMetadata(appId) || {
        backoffCount: 0,
        throttleEndTimeMillis: Date.now()
    };
    const signal = new $6abf5f471d8ed3f5$var$AnalyticsAbortSignal();
    setTimeout(async ()=>{
        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
        signal.abort();
    }, timeoutMillis !== undefined ? timeoutMillis : $6abf5f471d8ed3f5$var$FETCH_TIMEOUT_MILLIS);
    return $6abf5f471d8ed3f5$var$attemptFetchDynamicConfigWithRetry({
        appId: appId,
        apiKey: apiKey,
        measurementId: measurementId
    }, throttleMetadata, signal, retryData);
}
/**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */ async function $6abf5f471d8ed3f5$var$attemptFetchDynamicConfigWithRetry(appFields, { throttleEndTimeMillis: throttleEndTimeMillis, backoffCount: backoffCount }, signal, retryData = $6abf5f471d8ed3f5$var$defaultRetryData // for testing
) {
    var _a;
    const { appId: appId, measurementId: measurementId } = appFields;
    // Starts with a (potentially zero) timeout to support resumption from stored state.
    // Ensures the throttle end time is honored if the last attempt timed out.
    // Note the SDK will never make a request if the fetch timeout expires at this point.
    try {
        await $6abf5f471d8ed3f5$var$setAbortableTimeout(signal, throttleEndTimeMillis);
    } catch (e) {
        if (measurementId) {
            $6abf5f471d8ed3f5$var$logger.warn(`Timed out fetching this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${e === null || e === void 0 ? void 0 : e.message}]`);
            return {
                appId: appId,
                measurementId: measurementId
            };
        }
        throw e;
    }
    try {
        const response = await $6abf5f471d8ed3f5$var$fetchDynamicConfig(appFields);
        // Note the SDK only clears throttle state if response is success or non-retriable.
        retryData.deleteThrottleMetadata(appId);
        return response;
    } catch (e) {
        const error = e;
        if (!$6abf5f471d8ed3f5$var$isRetriableError(error)) {
            retryData.deleteThrottleMetadata(appId);
            if (measurementId) {
                $6abf5f471d8ed3f5$var$logger.warn(`Failed to fetch this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${error === null || error === void 0 ? void 0 : error.message}]`);
                return {
                    appId: appId,
                    measurementId: measurementId
                };
            } else throw e;
        }
        const backoffMillis = Number((_a = error === null || error === void 0 ? void 0 : error.customData) === null || _a === void 0 ? void 0 : _a.httpStatus) === 503 ? (0, $ffjl9.calculateBackoffMillis)(backoffCount, retryData.intervalMillis, $6abf5f471d8ed3f5$var$LONG_RETRY_FACTOR) : (0, $ffjl9.calculateBackoffMillis)(backoffCount, retryData.intervalMillis);
        // Increments backoff state.
        const throttleMetadata = {
            throttleEndTimeMillis: Date.now() + backoffMillis,
            backoffCount: backoffCount + 1
        };
        // Persists state.
        retryData.setThrottleMetadata(appId, throttleMetadata);
        $6abf5f471d8ed3f5$var$logger.debug(`Calling attemptFetch again in ${backoffMillis} millis`);
        return $6abf5f471d8ed3f5$var$attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData);
    }
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */ function $6abf5f471d8ed3f5$var$setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise((resolve, reject)=>{
        // Derives backoff from given end time, normalizing negative numbers to zero.
        const backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        const timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(()=>{
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject($6abf5f471d8ed3f5$var$ERROR_FACTORY.create("fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ , {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */ function $6abf5f471d8ed3f5$var$isRetriableError(e) {
    if (!(e instanceof (0, $ffjl9.FirebaseError)) || !e.customData) return false;
    // Uses string index defined by ErrorData, which FirebaseError implements.
    const httpStatus = Number(e.customData['httpStatus']);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */ class $6abf5f471d8ed3f5$var$AnalyticsAbortSignal {
    constructor(){
        this.listeners = [];
    }
    addEventListener(listener) {
        this.listeners.push(listener);
    }
    abort() {
        this.listeners.forEach((listener)=>listener());
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Event parameters to set on 'gtag' during initialization.
 */ let $6abf5f471d8ed3f5$var$defaultEventParametersForInit;
/**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */ async function $6abf5f471d8ed3f5$var$logEvent$1(gtagFunction, initializationPromise, eventName, eventParams, options) {
    if (options && options.global) {
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, eventParams);
        return;
    } else {
        const measurementId = await initializationPromise;
        const params = Object.assign(Object.assign({}, eventParams), {
            'send_to': measurementId
        });
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, params);
    }
}
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */ async function $6abf5f471d8ed3f5$var$setCurrentScreen$1(gtagFunction, initializationPromise, screenName, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            'screen_name': screenName
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'screen_name': screenName
        });
    }
}
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */ async function $6abf5f471d8ed3f5$var$setUserId$1(gtagFunction, initializationPromise, id, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            'user_id': id
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'user_id': id
        });
    }
}
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */ async function $6abf5f471d8ed3f5$var$setUserProperties$1(gtagFunction, initializationPromise, properties, options) {
    if (options && options.global) {
        const flatProperties = {};
        for (const key of Object.keys(properties))// use dot notation for merge behavior in gtag.js
        flatProperties[`user_properties.${key}`] = properties[key];
        gtagFunction("set" /* GtagCommand.SET */ , flatProperties);
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'user_properties': properties
        });
    }
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 */ async function $6abf5f471d8ed3f5$var$internalGetGoogleAnalyticsClientId(gtagFunction, initializationPromise) {
    const measurementId = await initializationPromise;
    return new Promise((resolve, reject)=>{
        gtagFunction("get" /* GtagCommand.GET */ , measurementId, 'client_id', (clientId)=>{
            if (!clientId) reject($6abf5f471d8ed3f5$var$ERROR_FACTORY.create("no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ));
            resolve(clientId);
        });
    });
}
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */ async function $6abf5f471d8ed3f5$var$setAnalyticsCollectionEnabled$1(initializationPromise, enabled) {
    const measurementId = await initializationPromise;
    window[`ga-disable-${measurementId}`] = !enabled;
}
/**
 * Consent parameters to default to during 'gtag' initialization.
 */ let $6abf5f471d8ed3f5$var$defaultConsentSettingsForInit;
/**
 * Sets the variable {@link defaultConsentSettingsForInit} for use in the initialization of
 * analytics.
 *
 * @param consentSettings Maps the applicable end user consent state for gtag.js.
 */ function $6abf5f471d8ed3f5$var$_setConsentDefaultForInit(consentSettings) {
    $6abf5f471d8ed3f5$var$defaultConsentSettingsForInit = consentSettings;
}
/**
 * Sets the variable `defaultEventParametersForInit` for use in the initialization of
 * analytics.
 *
 * @param customParams Any custom params the user may pass to gtag.js.
 */ function $6abf5f471d8ed3f5$var$_setDefaultEventParametersForInit(customParams) {
    $6abf5f471d8ed3f5$var$defaultEventParametersForInit = customParams;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $6abf5f471d8ed3f5$var$validateIndexedDB() {
    if (!(0, $ffjl9.isIndexedDBAvailable)()) {
        $6abf5f471d8ed3f5$var$logger.warn($6abf5f471d8ed3f5$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: 'IndexedDB is not available in this environment.'
        }).message);
        return false;
    } else try {
        await (0, $ffjl9.validateIndexedDBOpenable)();
    } catch (e) {
        $6abf5f471d8ed3f5$var$logger.warn($6abf5f471d8ed3f5$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: e === null || e === void 0 ? void 0 : e.toString()
        }).message);
        return false;
    }
    return true;
}
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations _FirebaseInstallationsInternal instance.
 *
 * @returns Measurement ID.
 */ async function $6abf5f471d8ed3f5$var$_initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
    var _a;
    const dynamicConfigPromise = $6abf5f471d8ed3f5$var$fetchDynamicConfigWithRetry(app);
    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
    dynamicConfigPromise.then((config)=>{
        measurementIdToAppId[config.measurementId] = config.appId;
        if (app.options.measurementId && config.measurementId !== app.options.measurementId) $6abf5f471d8ed3f5$var$logger.warn(`The measurement ID in the local Firebase config (${app.options.measurementId})` + ` does not match the measurement ID fetched from the server (${config.measurementId}).` + ` To ensure analytics events are always sent to the correct Analytics property,` + ` update the` + ` measurement ID field in the local config or remove it from the local config.`);
    }).catch((e)=>$6abf5f471d8ed3f5$var$logger.error(e));
    // Add to list to track state of all dynamic config promises.
    dynamicConfigPromisesList.push(dynamicConfigPromise);
    const fidPromise = $6abf5f471d8ed3f5$var$validateIndexedDB().then((envIsValid)=>{
        if (envIsValid) return installations.getId();
        else return undefined;
    });
    const [dynamicConfig, fid] = await Promise.all([
        dynamicConfigPromise,
        fidPromise
    ]);
    // Detect if user has already put the gtag <script> tag on this page with the passed in
    // data layer name.
    if (!$6abf5f471d8ed3f5$var$findGtagScriptOnPage(dataLayerName)) $6abf5f471d8ed3f5$var$insertScriptTag(dataLayerName, dynamicConfig.measurementId);
    // Detects if there are consent settings that need to be configured.
    if ($6abf5f471d8ed3f5$var$defaultConsentSettingsForInit) {
        gtagCore("consent" /* GtagCommand.CONSENT */ , 'default', $6abf5f471d8ed3f5$var$defaultConsentSettingsForInit);
        $6abf5f471d8ed3f5$var$_setConsentDefaultForInit(undefined);
    }
    // This command initializes gtag.js and only needs to be called once for the entire web app,
    // but since it is idempotent, we can call it multiple times.
    // We keep it together with other initialization logic for better code structure.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtagCore('js', new Date());
    // User config added first. We don't want users to accidentally overwrite
    // base Firebase config properties.
    const configProperties = (_a = options === null || options === void 0 ? void 0 : options.config) !== null && _a !== void 0 ? _a : {};
    // guard against developers accidentally setting properties with prefix `firebase_`
    configProperties[$6abf5f471d8ed3f5$var$ORIGIN_KEY] = 'firebase';
    configProperties.update = true;
    if (fid != null) configProperties[$6abf5f471d8ed3f5$var$GA_FID_KEY] = fid;
    // It should be the first config command called on this GA-ID
    // Initialize this GA-ID and set FID on it using the gtag config API.
    // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
    // `configProperties`.
    gtagCore("config" /* GtagCommand.CONFIG */ , dynamicConfig.measurementId, configProperties);
    // Detects if there is data that will be set on every event logged from the SDK.
    if ($6abf5f471d8ed3f5$var$defaultEventParametersForInit) {
        gtagCore("set" /* GtagCommand.SET */ , $6abf5f471d8ed3f5$var$defaultEventParametersForInit);
        $6abf5f471d8ed3f5$var$_setDefaultEventParametersForInit(undefined);
    }
    return dynamicConfig.measurementId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Analytics Service class.
 */ class $6abf5f471d8ed3f5$var$AnalyticsService {
    constructor(app){
        this.app = app;
    }
    _delete() {
        delete $6abf5f471d8ed3f5$var$initializationPromisesMap[this.app.options.appId];
        return Promise.resolve();
    }
}
/**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */ let $6abf5f471d8ed3f5$var$initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */ let $6abf5f471d8ed3f5$var$dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */ const $6abf5f471d8ed3f5$var$measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */ let $6abf5f471d8ed3f5$var$dataLayerName = 'dataLayer';
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */ let $6abf5f471d8ed3f5$var$gtagName = 'gtag';
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */ let $6abf5f471d8ed3f5$var$gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */ let $6abf5f471d8ed3f5$var$wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */ let $6abf5f471d8ed3f5$var$globalInitDone = false;
/**
 * Configures Firebase Analytics to use custom `gtag` or `dataLayer` names.
 * Intended to be used if `gtag.js` script has been installed on
 * this page independently of Firebase Analytics, and is using non-default
 * names for either the `gtag` function or for `dataLayer`.
 * Must be called before calling `getAnalytics()` or it won't
 * have any effect.
 *
 * @public
 *
 * @param options - Custom gtag and dataLayer names.
 */ function $6abf5f471d8ed3f5$export$a5a6e0b888b2c992(options) {
    if ($6abf5f471d8ed3f5$var$globalInitDone) throw $6abf5f471d8ed3f5$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    if (options.dataLayerName) $6abf5f471d8ed3f5$var$dataLayerName = options.dataLayerName;
    if (options.gtagName) $6abf5f471d8ed3f5$var$gtagName = options.gtagName;
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */ function $6abf5f471d8ed3f5$var$warnOnBrowserContextMismatch() {
    const mismatchedEnvMessages = [];
    if ((0, $ffjl9.isBrowserExtension)()) mismatchedEnvMessages.push('This is a browser extension environment.');
    if (!(0, $ffjl9.areCookiesEnabled)()) mismatchedEnvMessages.push('Cookies are not available.');
    if (mismatchedEnvMessages.length > 0) {
        const details = mismatchedEnvMessages.map((message, index)=>`(${index + 1}) ${message}`).join(' ');
        const err = $6abf5f471d8ed3f5$var$ERROR_FACTORY.create("invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ , {
            errorInfo: details
        });
        $6abf5f471d8ed3f5$var$logger.warn(err.message);
    }
}
/**
 * Analytics instance factory.
 * @internal
 */ function $6abf5f471d8ed3f5$var$factory(app, installations, options) {
    $6abf5f471d8ed3f5$var$warnOnBrowserContextMismatch();
    const appId = app.options.appId;
    if (!appId) throw $6abf5f471d8ed3f5$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!app.options.apiKey) {
        if (app.options.measurementId) $6abf5f471d8ed3f5$var$logger.warn(`The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest` + ` measurement ID for this Firebase app. Falling back to the measurement ID ${app.options.measurementId}` + ` provided in the "measurementId" field in the local Firebase config.`);
        else throw $6abf5f471d8ed3f5$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    if ($6abf5f471d8ed3f5$var$initializationPromisesMap[appId] != null) throw $6abf5f471d8ed3f5$var$ERROR_FACTORY.create("already-exists" /* AnalyticsError.ALREADY_EXISTS */ , {
        id: appId
    });
    if (!$6abf5f471d8ed3f5$var$globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        $6abf5f471d8ed3f5$var$getOrCreateDataLayer($6abf5f471d8ed3f5$var$dataLayerName);
        const { wrappedGtag: wrappedGtag, gtagCore: gtagCore } = $6abf5f471d8ed3f5$var$wrapOrCreateGtag($6abf5f471d8ed3f5$var$initializationPromisesMap, $6abf5f471d8ed3f5$var$dynamicConfigPromisesList, $6abf5f471d8ed3f5$var$measurementIdToAppId, $6abf5f471d8ed3f5$var$dataLayerName, $6abf5f471d8ed3f5$var$gtagName);
        $6abf5f471d8ed3f5$var$wrappedGtagFunction = wrappedGtag;
        $6abf5f471d8ed3f5$var$gtagCoreFunction = gtagCore;
        $6abf5f471d8ed3f5$var$globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    $6abf5f471d8ed3f5$var$initializationPromisesMap[appId] = $6abf5f471d8ed3f5$var$_initializeAnalytics(app, $6abf5f471d8ed3f5$var$dynamicConfigPromisesList, $6abf5f471d8ed3f5$var$measurementIdToAppId, installations, $6abf5f471d8ed3f5$var$gtagCoreFunction, $6abf5f471d8ed3f5$var$dataLayerName, options);
    const analyticsInstance = new $6abf5f471d8ed3f5$var$AnalyticsService(app);
    return analyticsInstance;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $6abf5f471d8ed3f5$export$b0297573c90085aa(app = (0, $ix4Jr.getApp)()) {
    app = (0, $ffjl9.getModularInstance)(app);
    // Dependencies
    const analyticsProvider = (0, $ix4Jr._getProvider)(app, $6abf5f471d8ed3f5$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) return analyticsProvider.getImmediate();
    return $6abf5f471d8ed3f5$export$e1ffb6ba450b0317(app);
}
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $6abf5f471d8ed3f5$export$e1ffb6ba450b0317(app, options = {}) {
    // Dependencies
    const analyticsProvider = (0, $ix4Jr._getProvider)(app, $6abf5f471d8ed3f5$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        const existingInstance = analyticsProvider.getImmediate();
        if ((0, $ffjl9.deepEqual)(options, analyticsProvider.getOptions())) return existingInstance;
        else throw $6abf5f471d8ed3f5$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    }
    const analyticsInstance = analyticsProvider.initialize({
        options: options
    });
    return analyticsInstance;
}
/**
 * This is a public static method provided to users that wraps four different checks:
 *
 * 1. Check if it's not a browser extension environment.
 * 2. Check if cookies are enabled in current browser.
 * 3. Check if IndexedDB is supported by the browser environment.
 * 4. Check if the current browser context is valid for using `IndexedDB.open()`.
 *
 * @public
 *
 */ async function $6abf5f471d8ed3f5$export$48c17662a6902497() {
    if ((0, $ffjl9.isBrowserExtension)()) return false;
    if (!(0, $ffjl9.areCookiesEnabled)()) return false;
    if (!(0, $ffjl9.isIndexedDBAvailable)()) return false;
    try {
        const isDBOpenable = await (0, $ffjl9.validateIndexedDBOpenable)();
        return isDBOpenable;
    } catch (error) {
        return false;
    }
}
/**
 * Use gtag `config` command to set `screen_name`.
 *
 * @public
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param screenName - Screen name to set.
 */ function $6abf5f471d8ed3f5$export$a364c5ef84862575(analyticsInstance, screenName, options) {
    analyticsInstance = (0, $ffjl9.getModularInstance)(analyticsInstance);
    $6abf5f471d8ed3f5$var$setCurrentScreen$1($6abf5f471d8ed3f5$var$wrappedGtagFunction, $6abf5f471d8ed3f5$var$initializationPromisesMap[analyticsInstance.app.options.appId], screenName, options).catch((e)=>$6abf5f471d8ed3f5$var$logger.error(e));
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ async function $6abf5f471d8ed3f5$export$108b704ce5c937fe(analyticsInstance) {
    analyticsInstance = (0, $ffjl9.getModularInstance)(analyticsInstance);
    return $6abf5f471d8ed3f5$var$internalGetGoogleAnalyticsClientId($6abf5f471d8ed3f5$var$wrappedGtagFunction, $6abf5f471d8ed3f5$var$initializationPromisesMap[analyticsInstance.app.options.appId]);
}
/**
 * Use gtag `config` command to set `user_id`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param id - User ID to set.
 */ function $6abf5f471d8ed3f5$export$7f5abdb7f5093137(analyticsInstance, id, options) {
    analyticsInstance = (0, $ffjl9.getModularInstance)(analyticsInstance);
    $6abf5f471d8ed3f5$var$setUserId$1($6abf5f471d8ed3f5$var$wrappedGtagFunction, $6abf5f471d8ed3f5$var$initializationPromisesMap[analyticsInstance.app.options.appId], id, options).catch((e)=>$6abf5f471d8ed3f5$var$logger.error(e));
}
/**
 * Use gtag `config` command to set all params specified.
 *
 * @public
 */ function $6abf5f471d8ed3f5$export$d0e176862bf869b8(analyticsInstance, properties, options) {
    analyticsInstance = (0, $ffjl9.getModularInstance)(analyticsInstance);
    $6abf5f471d8ed3f5$var$setUserProperties$1($6abf5f471d8ed3f5$var$wrappedGtagFunction, $6abf5f471d8ed3f5$var$initializationPromisesMap[analyticsInstance.app.options.appId], properties, options).catch((e)=>$6abf5f471d8ed3f5$var$logger.error(e));
}
/**
 * Sets whether Google Analytics collection is enabled for this app on this device.
 * Sets global `window['ga-disable-analyticsId'] = true;`
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param enabled - If true, enables collection, if false, disables it.
 */ function $6abf5f471d8ed3f5$export$7d544a250c4ed423(analyticsInstance, enabled) {
    analyticsInstance = (0, $ffjl9.getModularInstance)(analyticsInstance);
    $6abf5f471d8ed3f5$var$setAnalyticsCollectionEnabled$1($6abf5f471d8ed3f5$var$initializationPromisesMap[analyticsInstance.app.options.appId], enabled).catch((e)=>$6abf5f471d8ed3f5$var$logger.error(e));
}
/**
 * Adds data that will be set on every event logged from the SDK, including automatic ones.
 * With gtag's "set" command, the values passed persist on the current page and are passed with
 * all subsequent events.
 * @public
 * @param customParams - Any custom params the user may pass to gtag.js.
 */ function $6abf5f471d8ed3f5$export$9bde4a1551d6c3ba(customParams) {
    // Check if reference to existing gtag function on window object exists
    if ($6abf5f471d8ed3f5$var$wrappedGtagFunction) $6abf5f471d8ed3f5$var$wrappedGtagFunction("set" /* GtagCommand.SET */ , customParams);
    else $6abf5f471d8ed3f5$var$_setDefaultEventParametersForInit(customParams);
}
/**
 * Sends a Google Analytics event with given `eventParams`. This method
 * automatically associates this logged event with this Firebase web
 * app instance on this device.
 * List of official event parameters can be found in the gtag.js
 * reference documentation:
 * {@link https://developers.google.com/gtagjs/reference/ga4-events
 * | the GA4 reference documentation}.
 *
 * @public
 */ function $6abf5f471d8ed3f5$export$5e9eec8001665ac5(analyticsInstance, eventName, eventParams, options) {
    analyticsInstance = (0, $ffjl9.getModularInstance)(analyticsInstance);
    $6abf5f471d8ed3f5$var$logEvent$1($6abf5f471d8ed3f5$var$wrappedGtagFunction, $6abf5f471d8ed3f5$var$initializationPromisesMap[analyticsInstance.app.options.appId], eventName, eventParams, options).catch((e)=>$6abf5f471d8ed3f5$var$logger.error(e));
}
/**
 * Sets the applicable end user consent state for this web app across all gtag references once
 * Firebase Analytics is initialized.
 *
 * Use the {@link ConsentSettings} to specify individual consent type values. By default consent
 * types are set to "granted".
 * @public
 * @param consentSettings - Maps the applicable end user consent state for gtag.js.
 */ function $6abf5f471d8ed3f5$export$ff06c4c0781050d7(consentSettings) {
    // Check if reference to existing gtag function on window object exists
    if ($6abf5f471d8ed3f5$var$wrappedGtagFunction) $6abf5f471d8ed3f5$var$wrappedGtagFunction("consent" /* GtagCommand.CONSENT */ , 'update', consentSettings);
    else $6abf5f471d8ed3f5$var$_setConsentDefaultForInit(consentSettings);
}
const $6abf5f471d8ed3f5$var$name = "@firebase/analytics";
const $6abf5f471d8ed3f5$var$version = "0.10.8";
/**
 * The Firebase Analytics Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ function $6abf5f471d8ed3f5$var$registerAnalytics() {
    (0, $ix4Jr._registerComponent)(new (0, $4a6xH.Component)($6abf5f471d8ed3f5$var$ANALYTICS_TYPE, (container, { options: analyticsOptions })=>{
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider('app').getImmediate();
        const installations = container.getProvider('installations-internal').getImmediate();
        return $6abf5f471d8ed3f5$var$factory(app, installations, analyticsOptions);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $ix4Jr._registerComponent)(new (0, $4a6xH.Component)('analytics-internal', internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $ix4Jr.registerVersion)($6abf5f471d8ed3f5$var$name, $6abf5f471d8ed3f5$var$version);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $ix4Jr.registerVersion)($6abf5f471d8ed3f5$var$name, $6abf5f471d8ed3f5$var$version, 'esm2017');
    function internalFactory(container) {
        try {
            const analytics = container.getProvider($6abf5f471d8ed3f5$var$ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: (eventName, eventParams, options)=>$6abf5f471d8ed3f5$export$5e9eec8001665ac5(analytics, eventName, eventParams, options)
            };
        } catch (e) {
            throw $6abf5f471d8ed3f5$var$ERROR_FACTORY.create("interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ , {
                reason: e
            });
        }
    }
}
$6abf5f471d8ed3f5$var$registerAnalytics();

});
parcelRegister("keeEs", function(module, exports) {

var $ix4Jr = parcelRequire("ix4Jr");

var $4a6xH = parcelRequire("4a6xH");

var $ffjl9 = parcelRequire("ffjl9");

var $cCiiD = parcelRequire("cCiiD");
const $eba07af7d5564af0$var$name = "@firebase/installations";
const $eba07af7d5564af0$var$version = "0.6.9";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $eba07af7d5564af0$var$PENDING_TIMEOUT_MS = 10000;
const $eba07af7d5564af0$var$PACKAGE_VERSION = `w:${$eba07af7d5564af0$var$version}`;
const $eba07af7d5564af0$var$INTERNAL_AUTH_VERSION = 'FIS_v2';
const $eba07af7d5564af0$var$INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
const $eba07af7d5564af0$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
const $eba07af7d5564af0$var$SERVICE = 'installations';
const $eba07af7d5564af0$var$SERVICE_NAME = 'Installations';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $eba07af7d5564af0$var$ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */ ]: 'Firebase Installation is not registered.',
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ ]: 'Firebase Installation not found.',
    ["request-failed" /* ErrorCode.REQUEST_FAILED */ ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */ ]: 'Could not process request. Application offline.',
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ ]: "Can't delete installation while there is a pending registration request."
};
const $eba07af7d5564af0$var$ERROR_FACTORY = new (0, $ffjl9.ErrorFactory)($eba07af7d5564af0$var$SERVICE, $eba07af7d5564af0$var$SERVICE_NAME, $eba07af7d5564af0$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $eba07af7d5564af0$var$isServerError(error) {
    return error instanceof (0, $ffjl9.FirebaseError) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $eba07af7d5564af0$var$getInstallationsEndpoint({ projectId: projectId }) {
    return `${$eba07af7d5564af0$var$INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function $eba07af7d5564af0$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: $eba07af7d5564af0$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function $eba07af7d5564af0$var$getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return $eba07af7d5564af0$var$ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
        requestName: requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function $eba07af7d5564af0$var$getHeaders({ apiKey: apiKey }) {
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function $eba07af7d5564af0$var$getHeadersWithAuth(appConfig, { refreshToken: refreshToken }) {
    const headers = $eba07af7d5564af0$var$getHeaders(appConfig);
    headers.append('Authorization', $eba07af7d5564af0$var$getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ async function $eba07af7d5564af0$var$retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
    return fn();
    return result;
}
function $eba07af7d5564af0$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function $eba07af7d5564af0$var$getAuthorizationHeader(refreshToken) {
    return `${$eba07af7d5564af0$var$INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $eba07af7d5564af0$var$createInstallationRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, { fid: fid }) {
    const endpoint = $eba07af7d5564af0$var$getInstallationsEndpoint(appConfig);
    const headers = $eba07af7d5564af0$var$getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        fid: fid,
        authVersion: $eba07af7d5564af0$var$INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: $eba07af7d5564af0$var$PACKAGE_VERSION
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $eba07af7d5564af0$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
            refreshToken: responseValue.refreshToken,
            authToken: $eba07af7d5564af0$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await $eba07af7d5564af0$var$getErrorFromResponse('Create Installation', response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $eba07af7d5564af0$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $eba07af7d5564af0$var$bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $eba07af7d5564af0$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const $eba07af7d5564af0$var$INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $eba07af7d5564af0$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = $eba07af7d5564af0$var$encode(fidByteArray);
        return $eba07af7d5564af0$var$VALID_FID_PATTERN.test(fid) ? fid : $eba07af7d5564af0$var$INVALID_FID;
    } catch (_a) {
        // FID generation errored
        return $eba07af7d5564af0$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $eba07af7d5564af0$var$encode(fidByteArray) {
    const b64String = $eba07af7d5564af0$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $eba07af7d5564af0$var$getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $eba07af7d5564af0$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $eba07af7d5564af0$var$fidChanged(appConfig, fid) {
    const key = $eba07af7d5564af0$var$getKey(appConfig);
    $eba07af7d5564af0$var$callFidChangeCallbacks(key, fid);
    $eba07af7d5564af0$var$broadcastFidChange(key, fid);
}
function $eba07af7d5564af0$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $eba07af7d5564af0$var$getBroadcastChannel();
    const key = $eba07af7d5564af0$var$getKey(appConfig);
    let callbackSet = $eba07af7d5564af0$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $eba07af7d5564af0$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $eba07af7d5564af0$var$removeCallback(appConfig, callback) {
    const key = $eba07af7d5564af0$var$getKey(appConfig);
    const callbackSet = $eba07af7d5564af0$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $eba07af7d5564af0$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $eba07af7d5564af0$var$closeBroadcastChannel();
}
function $eba07af7d5564af0$var$callFidChangeCallbacks(key, fid) {
    const callbacks = $eba07af7d5564af0$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function $eba07af7d5564af0$var$broadcastFidChange(key, fid) {
    const channel = $eba07af7d5564af0$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $eba07af7d5564af0$var$closeBroadcastChannel();
}
let $eba07af7d5564af0$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $eba07af7d5564af0$var$getBroadcastChannel() {
    if (!$eba07af7d5564af0$var$broadcastChannel && 'BroadcastChannel' in self) {
        $eba07af7d5564af0$var$broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        $eba07af7d5564af0$var$broadcastChannel.onmessage = (e)=>{
            $eba07af7d5564af0$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $eba07af7d5564af0$var$broadcastChannel;
}
function $eba07af7d5564af0$var$closeBroadcastChannel() {
    if ($eba07af7d5564af0$var$fidChangeCallbacks.size === 0 && $eba07af7d5564af0$var$broadcastChannel) {
        $eba07af7d5564af0$var$broadcastChannel.close();
        $eba07af7d5564af0$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $eba07af7d5564af0$var$DATABASE_NAME = 'firebase-installations-database';
const $eba07af7d5564af0$var$DATABASE_VERSION = 1;
const $eba07af7d5564af0$var$OBJECT_STORE_NAME = 'firebase-installations-store';
let $eba07af7d5564af0$var$dbPromise = null;
function $eba07af7d5564af0$var$getDbPromise() {
    if (!$eba07af7d5564af0$var$dbPromise) $eba07af7d5564af0$var$dbPromise = (0, $cCiiD.openDB)($eba07af7d5564af0$var$DATABASE_NAME, $eba07af7d5564af0$var$DATABASE_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($eba07af7d5564af0$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $eba07af7d5564af0$var$dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $eba07af7d5564af0$var$set(appConfig, value) {
    const key = $eba07af7d5564af0$var$getKey(appConfig);
    const db = await $eba07af7d5564af0$var$getDbPromise();
    const tx = db.transaction($eba07af7d5564af0$var$OBJECT_STORE_NAME, 'readwrite');
    const objectStore = tx.objectStore($eba07af7d5564af0$var$OBJECT_STORE_NAME);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) $eba07af7d5564af0$var$fidChanged(appConfig, value.fid);
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $eba07af7d5564af0$var$remove(appConfig) {
    const key = $eba07af7d5564af0$var$getKey(appConfig);
    const db = await $eba07af7d5564af0$var$getDbPromise();
    const tx = db.transaction($eba07af7d5564af0$var$OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore($eba07af7d5564af0$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ async function $eba07af7d5564af0$var$update(appConfig, updateFn) {
    const key = $eba07af7d5564af0$var$getKey(appConfig);
    const db = await $eba07af7d5564af0$var$getDbPromise();
    const tx = db.transaction($eba07af7d5564af0$var$OBJECT_STORE_NAME, 'readwrite');
    const store = tx.objectStore($eba07af7d5564af0$var$OBJECT_STORE_NAME);
    const oldValue = await store.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === undefined) await store.delete(key);
    else await store.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $eba07af7d5564af0$var$fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ async function $eba07af7d5564af0$var$getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await $eba07af7d5564af0$var$update(installations.appConfig, (oldEntry)=>{
        const installationEntry = $eba07af7d5564af0$var$updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = $eba07af7d5564af0$var$triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === $eba07af7d5564af0$var$INVALID_FID) // FID generation failed. Waiting for the FID from the server.
    return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry: installationEntry,
        registrationPromise: registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $eba07af7d5564af0$var$updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: $eba07af7d5564af0$var$generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return $eba07af7d5564af0$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $eba07af7d5564af0$var$triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject($eba07af7d5564af0$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        const registrationPromise = $eba07af7d5564af0$var$registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $eba07af7d5564af0$var$waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry: installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ async function $eba07af7d5564af0$var$registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await $eba07af7d5564af0$var$createInstallationRequest(installations, installationEntry);
        return $eba07af7d5564af0$var$set(installations.appConfig, registeredInstallationEntry);
    } catch (e) {
        if ($eba07af7d5564af0$var$isServerError(e) && e.customData.serverCode === 409) // Server returned a "FID cannot be used" error.
        // Generate a new ID next time.
        await $eba07af7d5564af0$var$remove(installations.appConfig);
        else // Registration failed. Set FID as not registered.
        await $eba07af7d5564af0$var$set(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
        });
        throw e;
    }
}
/** Call if FID registration is pending in another request. */ async function $eba07af7d5564af0$var$waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $eba07af7d5564af0$var$updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // createInstallation request still in progress.
        await $eba07af7d5564af0$var$sleep(100);
        entry = await $eba07af7d5564af0$var$updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $eba07af7d5564af0$var$getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else // if there is no registrationPromise, entry is registered.
        return installationEntry;
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $eba07af7d5564af0$var$updateInstallationRequest(appConfig) {
    return $eba07af7d5564af0$var$update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw $eba07af7d5564af0$var$ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return $eba07af7d5564af0$var$clearTimedOutRequest(oldEntry);
    });
}
function $eba07af7d5564af0$var$clearTimedOutRequest(entry) {
    if ($eba07af7d5564af0$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function $eba07af7d5564af0$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + $eba07af7d5564af0$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $eba07af7d5564af0$var$generateAuthTokenRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, installationEntry) {
    const endpoint = $eba07af7d5564af0$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = $eba07af7d5564af0$var$getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        installation: {
            sdkVersion: $eba07af7d5564af0$var$PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $eba07af7d5564af0$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = $eba07af7d5564af0$var$extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await $eba07af7d5564af0$var$getErrorFromResponse('Generate Auth Token', response);
}
function $eba07af7d5564af0$var$getGenerateAuthTokenEndpoint(appConfig, { fid: fid }) {
    return `${$eba07af7d5564af0$var$getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ async function $eba07af7d5564af0$var$refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await $eba07af7d5564af0$var$update(installations.appConfig, (oldEntry)=>{
        if (!$eba07af7d5564af0$var$isEntryRegistered(oldEntry)) throw $eba07af7d5564af0$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && $eba07af7d5564af0$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
        return oldEntry;
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
            // There already is a token request in progress.
            tokenPromise = $eba07af7d5564af0$var$waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            // No token or token expired.
            if (!navigator.onLine) throw $eba07af7d5564af0$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            const inProgressEntry = $eba07af7d5564af0$var$makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = $eba07af7d5564af0$var$fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ async function $eba07af7d5564af0$var$waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $eba07af7d5564af0$var$updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // generateAuthToken still in progress.
        await $eba07af7d5564af0$var$sleep(100);
        entry = await $eba07af7d5564af0$var$updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
    return $eba07af7d5564af0$var$refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $eba07af7d5564af0$var$updateAuthTokenRequest(appConfig) {
    return $eba07af7d5564af0$var$update(appConfig, (oldEntry)=>{
        if (!$eba07af7d5564af0$var$isEntryRegistered(oldEntry)) throw $eba07af7d5564af0$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if ($eba07af7d5564af0$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return Object.assign(Object.assign({}, oldEntry), {
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        });
        return oldEntry;
    });
}
async function $eba07af7d5564af0$var$fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await $eba07af7d5564af0$var$generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
            authToken: authToken
        });
        await $eba07af7d5564af0$var$set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e) {
        if ($eba07af7d5564af0$var$isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) // Server returned a "FID not found" or a "Invalid authentication" error.
        // Generate a new ID next time.
        await $eba07af7d5564af0$var$remove(installations.appConfig);
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
                authToken: {
                    requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                }
            });
            await $eba07af7d5564af0$var$set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function $eba07af7d5564af0$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function $eba07af7d5564af0$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !$eba07af7d5564af0$var$isAuthTokenExpired(authToken);
}
function $eba07af7d5564af0$var$isAuthTokenExpired(authToken) {
    const now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $eba07af7d5564af0$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $eba07af7d5564af0$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), {
        authToken: inProgressAuthToken
    });
}
function $eba07af7d5564af0$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + $eba07af7d5564af0$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $eba07af7d5564af0$export$218c8c3169c024d2(installations) {
    const installationsImpl = installations;
    const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $eba07af7d5564af0$var$getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else // If the installation is already registered, update the authentication
    // token if needed.
    $eba07af7d5564af0$var$refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $eba07af7d5564af0$export$257b2d10b709d8ef(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await $eba07af7d5564af0$var$completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await $eba07af7d5564af0$var$refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function $eba07af7d5564af0$var$completeInstallationRegistration(installations) {
    const { registrationPromise: registrationPromise } = await $eba07af7d5564af0$var$getInstallationEntry(installations);
    if (registrationPromise) // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $eba07af7d5564af0$var$deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = $eba07af7d5564af0$var$getDeleteEndpoint(appConfig, installationEntry);
    const headers = $eba07af7d5564af0$var$getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: 'DELETE',
        headers: headers
    };
    const response = await $eba07af7d5564af0$var$retryIfServerError(()=>fetch(endpoint, request));
    if (!response.ok) throw await $eba07af7d5564af0$var$getErrorFromResponse('Delete Installation', response);
}
function $eba07af7d5564af0$var$getDeleteEndpoint(appConfig, { fid: fid }) {
    return `${$eba07af7d5564af0$var$getInstallationsEndpoint(appConfig)}/${fid}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $eba07af7d5564af0$export$5f6b87a08674814c(installations) {
    const { appConfig: appConfig } = installations;
    const entry = await $eba07af7d5564af0$var$update(appConfig, (oldEntry)=>{
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
        return undefined;
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) // Can't delete while trying to register.
        throw $eba07af7d5564af0$var$ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ) {
            if (!navigator.onLine) throw $eba07af7d5564af0$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            else {
                await $eba07af7d5564af0$var$deleteInstallationRequest(appConfig, entry);
                await $eba07af7d5564af0$var$remove(appConfig);
            }
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function $eba07af7d5564af0$export$ceb4c11381bc36e8(installations, callback) {
    const { appConfig: appConfig } = installations;
    $eba07af7d5564af0$var$addCallback(appConfig, callback);
    return ()=>{
        $eba07af7d5564af0$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function $eba07af7d5564af0$export$9bfc115e43431ff5(app = (0, $ix4Jr.getApp)()) {
    const installationsImpl = (0, $ix4Jr._getProvider)(app, 'installations').getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $eba07af7d5564af0$var$extractAppConfig(app) {
    if (!app || !app.options) throw $eba07af7d5564af0$var$getMissingValueError('App Configuration');
    if (!app.name) throw $eba07af7d5564af0$var$getMissingValueError('App Name');
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw $eba07af7d5564af0$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $eba07af7d5564af0$var$getMissingValueError(valueName) {
    return $eba07af7d5564af0$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $eba07af7d5564af0$var$INSTALLATIONS_NAME = 'installations';
const $eba07af7d5564af0$var$INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
const $eba07af7d5564af0$var$publicFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = $eba07af7d5564af0$var$extractAppConfig(app);
    const heartbeatServiceProvider = (0, $ix4Jr._getProvider)(app, 'heartbeat');
    const installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const $eba07af7d5564af0$var$internalFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0, $ix4Jr._getProvider)(app, $eba07af7d5564af0$var$INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>$eba07af7d5564af0$export$218c8c3169c024d2(installations),
        getToken: (forceRefresh)=>$eba07af7d5564af0$export$257b2d10b709d8ef(installations, forceRefresh)
    };
    return installationsInternal;
};
function $eba07af7d5564af0$var$registerInstallations() {
    (0, $ix4Jr._registerComponent)(new (0, $4a6xH.Component)($eba07af7d5564af0$var$INSTALLATIONS_NAME, $eba07af7d5564af0$var$publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $ix4Jr._registerComponent)(new (0, $4a6xH.Component)($eba07af7d5564af0$var$INSTALLATIONS_NAME_INTERNAL, $eba07af7d5564af0$var$internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ $eba07af7d5564af0$var$registerInstallations();
(0, $ix4Jr.registerVersion)($eba07af7d5564af0$var$name, $eba07af7d5564af0$var$version);
// BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
(0, $ix4Jr.registerVersion)($eba07af7d5564af0$var$name, $eba07af7d5564af0$var$version, 'esm2017');

});




parcelRegister("8Fos1", function(module, exports) {
parcelRequire("6Yr76");

});
parcelRegister("6Yr76", function(module, exports) {

var $hVw4Q = parcelRequire("hVw4Q");

var $4a6xH = parcelRequire("4a6xH");

var $8NPS8 = parcelRequire("8NPS8");

var $ffjl9 = parcelRequire("ffjl9");

var $7vF8m = parcelRequire("7vF8m");
const $014f710bdf50a6cd$var$name = "@firebase/database-compat";
const $014f710bdf50a6cd$var$version = "1.0.8";
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $014f710bdf50a6cd$var$logClient = new (0, $7vF8m.Logger)('@firebase/database-compat');
const $014f710bdf50a6cd$var$warn = function(msg) {
    const message = 'FIREBASE WARNING: ' + msg;
    $014f710bdf50a6cd$var$logClient.warn(message);
};
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $014f710bdf50a6cd$var$validateBoolean = function(fnName, argumentName, bool, optional) {
    if (optional && bool === undefined) return;
    if (typeof bool !== 'boolean') throw new Error((0, $ffjl9.errorPrefix)(fnName, argumentName) + 'must be a boolean.');
};
const $014f710bdf50a6cd$var$validateEventType = function(fnName, eventType, optional) {
    if (optional && eventType === undefined) return;
    switch(eventType){
        case 'value':
        case 'child_added':
        case 'child_removed':
        case 'child_changed':
        case 'child_moved':
            break;
        default:
            throw new Error((0, $ffjl9.errorPrefix)(fnName, 'eventType') + 'must be a valid event type = "value", "child_added", "child_removed", ' + '"child_changed", or "child_moved".');
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $014f710bdf50a6cd$var$OnDisconnect {
    constructor(_delegate){
        this._delegate = _delegate;
    }
    cancel(onComplete) {
        (0, $ffjl9.validateArgCount)('OnDisconnect.cancel', 0, 1, arguments.length);
        (0, $ffjl9.validateCallback)('OnDisconnect.cancel', 'onComplete', onComplete, true);
        const result = this._delegate.cancel();
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    remove(onComplete) {
        (0, $ffjl9.validateArgCount)('OnDisconnect.remove', 0, 1, arguments.length);
        (0, $ffjl9.validateCallback)('OnDisconnect.remove', 'onComplete', onComplete, true);
        const result = this._delegate.remove();
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    set(value, onComplete) {
        (0, $ffjl9.validateArgCount)('OnDisconnect.set', 1, 2, arguments.length);
        (0, $ffjl9.validateCallback)('OnDisconnect.set', 'onComplete', onComplete, true);
        const result = this._delegate.set(value);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    setWithPriority(value, priority, onComplete) {
        (0, $ffjl9.validateArgCount)('OnDisconnect.setWithPriority', 2, 3, arguments.length);
        (0, $ffjl9.validateCallback)('OnDisconnect.setWithPriority', 'onComplete', onComplete, true);
        const result = this._delegate.setWithPriority(value, priority);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    update(objectToMerge, onComplete) {
        (0, $ffjl9.validateArgCount)('OnDisconnect.update', 1, 2, arguments.length);
        if (Array.isArray(objectToMerge)) {
            const newObjectToMerge = {};
            for(let i = 0; i < objectToMerge.length; ++i)newObjectToMerge['' + i] = objectToMerge[i];
            objectToMerge = newObjectToMerge;
            $014f710bdf50a6cd$var$warn("Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
        }
        (0, $ffjl9.validateCallback)('OnDisconnect.update', 'onComplete', onComplete, true);
        const result = this._delegate.update(objectToMerge);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $014f710bdf50a6cd$var$TransactionResult {
    /**
     * A type for the resolve value of Firebase.transaction.
     */ constructor(committed, snapshot){
        this.committed = committed;
        this.snapshot = snapshot;
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    toJSON() {
        (0, $ffjl9.validateArgCount)('TransactionResult.toJSON', 0, 1, arguments.length);
        return {
            committed: this.committed,
            snapshot: this.snapshot.toJSON()
        };
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
 * surfaces the public methods (val, forEach, etc.) we want to expose.
 */ class $014f710bdf50a6cd$var$DataSnapshot {
    constructor(_database, _delegate){
        this._database = _database;
        this._delegate = _delegate;
    }
    /**
     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
     * empty.
     *
     * @returns JSON representation of the DataSnapshot contents, or null if empty.
     */ val() {
        (0, $ffjl9.validateArgCount)('DataSnapshot.val', 0, 0, arguments.length);
        return this._delegate.val();
    }
    /**
     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
     * the entire node contents.
     * @returns JSON representation of the DataSnapshot contents, or null if empty.
     */ exportVal() {
        (0, $ffjl9.validateArgCount)('DataSnapshot.exportVal', 0, 0, arguments.length);
        return this._delegate.exportVal();
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    toJSON() {
        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
        (0, $ffjl9.validateArgCount)('DataSnapshot.toJSON', 0, 1, arguments.length);
        return this._delegate.toJSON();
    }
    /**
     * Returns whether the snapshot contains a non-null value.
     *
     * @returns Whether the snapshot contains a non-null value, or is empty.
     */ exists() {
        (0, $ffjl9.validateArgCount)('DataSnapshot.exists', 0, 0, arguments.length);
        return this._delegate.exists();
    }
    /**
     * Returns a DataSnapshot of the specified child node's contents.
     *
     * @param path - Path to a child.
     * @returns DataSnapshot for child node.
     */ child(path) {
        (0, $ffjl9.validateArgCount)('DataSnapshot.child', 0, 1, arguments.length);
        // Ensure the childPath is a string (can be a number)
        path = String(path);
        (0, $8NPS8._validatePathString)('DataSnapshot.child', 'path', path, false);
        return new $014f710bdf50a6cd$var$DataSnapshot(this._database, this._delegate.child(path));
    }
    /**
     * Returns whether the snapshot contains a child at the specified path.
     *
     * @param path - Path to a child.
     * @returns Whether the child exists.
     */ hasChild(path) {
        (0, $ffjl9.validateArgCount)('DataSnapshot.hasChild', 1, 1, arguments.length);
        (0, $8NPS8._validatePathString)('DataSnapshot.hasChild', 'path', path, false);
        return this._delegate.hasChild(path);
    }
    /**
     * Returns the priority of the object, or null if no priority was set.
     *
     * @returns The priority.
     */ getPriority() {
        (0, $ffjl9.validateArgCount)('DataSnapshot.getPriority', 0, 0, arguments.length);
        return this._delegate.priority;
    }
    /**
     * Iterates through child nodes and calls the specified action for each one.
     *
     * @param action - Callback function to be called
     * for each child.
     * @returns True if forEach was canceled by action returning true for
     * one of the child nodes.
     */ forEach(action) {
        (0, $ffjl9.validateArgCount)('DataSnapshot.forEach', 1, 1, arguments.length);
        (0, $ffjl9.validateCallback)('DataSnapshot.forEach', 'action', action, false);
        return this._delegate.forEach((expDataSnapshot)=>action(new $014f710bdf50a6cd$var$DataSnapshot(this._database, expDataSnapshot)));
    }
    /**
     * Returns whether this DataSnapshot has children.
     * @returns True if the DataSnapshot contains 1 or more child nodes.
     */ hasChildren() {
        (0, $ffjl9.validateArgCount)('DataSnapshot.hasChildren', 0, 0, arguments.length);
        return this._delegate.hasChildren();
    }
    get key() {
        return this._delegate.key;
    }
    /**
     * Returns the number of children for this DataSnapshot.
     * @returns The number of children that this DataSnapshot contains.
     */ numChildren() {
        (0, $ffjl9.validateArgCount)('DataSnapshot.numChildren', 0, 0, arguments.length);
        return this._delegate.size;
    }
    /**
     * @returns The Firebase reference for the location this snapshot's data came
     * from.
     */ getRef() {
        (0, $ffjl9.validateArgCount)('DataSnapshot.ref', 0, 0, arguments.length);
        return new $014f710bdf50a6cd$var$Reference(this._database, this._delegate.ref);
    }
    get ref() {
        return this.getRef();
    }
}
/**
 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
 *
 * Since every Firebase reference is a query, Firebase inherits from this object.
 */ class $014f710bdf50a6cd$var$Query {
    constructor(database, _delegate){
        this.database = database;
        this._delegate = _delegate;
    }
    on(eventType, callback, cancelCallbackOrContext, context) {
        var _a;
        (0, $ffjl9.validateArgCount)('Query.on', 2, 4, arguments.length);
        (0, $ffjl9.validateCallback)('Query.on', 'callback', callback, false);
        const ret = $014f710bdf50a6cd$var$Query.getCancelAndContextArgs_('Query.on', cancelCallbackOrContext, context);
        const valueCallback = (expSnapshot, previousChildName)=>{
            callback.call(ret.context, new $014f710bdf50a6cd$var$DataSnapshot(this.database, expSnapshot), previousChildName);
        };
        valueCallback.userCallback = callback;
        valueCallback.context = ret.context;
        const cancelCallback = (_a = ret.cancel) === null || _a === void 0 ? void 0 : _a.bind(ret.context);
        switch(eventType){
            case 'value':
                (0, $8NPS8.onValue)(this._delegate, valueCallback, cancelCallback);
                return callback;
            case 'child_added':
                (0, $8NPS8.onChildAdded)(this._delegate, valueCallback, cancelCallback);
                return callback;
            case 'child_removed':
                (0, $8NPS8.onChildRemoved)(this._delegate, valueCallback, cancelCallback);
                return callback;
            case 'child_changed':
                (0, $8NPS8.onChildChanged)(this._delegate, valueCallback, cancelCallback);
                return callback;
            case 'child_moved':
                (0, $8NPS8.onChildMoved)(this._delegate, valueCallback, cancelCallback);
                return callback;
            default:
                throw new Error((0, $ffjl9.errorPrefix)('Query.on', 'eventType') + 'must be a valid event type = "value", "child_added", "child_removed", ' + '"child_changed", or "child_moved".');
        }
    }
    off(eventType, callback, context) {
        (0, $ffjl9.validateArgCount)('Query.off', 0, 3, arguments.length);
        $014f710bdf50a6cd$var$validateEventType('Query.off', eventType, true);
        (0, $ffjl9.validateCallback)('Query.off', 'callback', callback, true);
        (0, $ffjl9.validateContextObject)('Query.off', 'context', context, true);
        if (callback) {
            const valueCallback = ()=>{};
            valueCallback.userCallback = callback;
            valueCallback.context = context;
            (0, $8NPS8.off)(this._delegate, eventType, valueCallback);
        } else (0, $8NPS8.off)(this._delegate, eventType);
    }
    /**
     * Get the server-value for this query, or return a cached value if not connected.
     */ get() {
        return (0, $8NPS8.get)(this._delegate).then((expSnapshot)=>{
            return new $014f710bdf50a6cd$var$DataSnapshot(this.database, expSnapshot);
        });
    }
    /**
     * Attaches a listener, waits for the first event, and then removes the listener
     */ once(eventType, callback, failureCallbackOrContext, context) {
        (0, $ffjl9.validateArgCount)('Query.once', 1, 4, arguments.length);
        (0, $ffjl9.validateCallback)('Query.once', 'callback', callback, true);
        const ret = $014f710bdf50a6cd$var$Query.getCancelAndContextArgs_('Query.once', failureCallbackOrContext, context);
        const deferred = new (0, $ffjl9.Deferred)();
        const valueCallback = (expSnapshot, previousChildName)=>{
            const result = new $014f710bdf50a6cd$var$DataSnapshot(this.database, expSnapshot);
            if (callback) callback.call(ret.context, result, previousChildName);
            deferred.resolve(result);
        };
        valueCallback.userCallback = callback;
        valueCallback.context = ret.context;
        const cancelCallback = (error)=>{
            if (ret.cancel) ret.cancel.call(ret.context, error);
            deferred.reject(error);
        };
        switch(eventType){
            case 'value':
                (0, $8NPS8.onValue)(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            case 'child_added':
                (0, $8NPS8.onChildAdded)(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            case 'child_removed':
                (0, $8NPS8.onChildRemoved)(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            case 'child_changed':
                (0, $8NPS8.onChildChanged)(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            case 'child_moved':
                (0, $8NPS8.onChildMoved)(this._delegate, valueCallback, cancelCallback, {
                    onlyOnce: true
                });
                break;
            default:
                throw new Error((0, $ffjl9.errorPrefix)('Query.once', 'eventType') + 'must be a valid event type = "value", "child_added", "child_removed", ' + '"child_changed", or "child_moved".');
        }
        return deferred.promise;
    }
    /**
     * Set a limit and anchor it to the start of the window.
     */ limitToFirst(limit) {
        (0, $ffjl9.validateArgCount)('Query.limitToFirst', 1, 1, arguments.length);
        return new $014f710bdf50a6cd$var$Query(this.database, (0, $8NPS8.query)(this._delegate, (0, $8NPS8.limitToFirst)(limit)));
    }
    /**
     * Set a limit and anchor it to the end of the window.
     */ limitToLast(limit) {
        (0, $ffjl9.validateArgCount)('Query.limitToLast', 1, 1, arguments.length);
        return new $014f710bdf50a6cd$var$Query(this.database, (0, $8NPS8.query)(this._delegate, (0, $8NPS8.limitToLast)(limit)));
    }
    /**
     * Given a child path, return a new query ordered by the specified grandchild path.
     */ orderByChild(path) {
        (0, $ffjl9.validateArgCount)('Query.orderByChild', 1, 1, arguments.length);
        return new $014f710bdf50a6cd$var$Query(this.database, (0, $8NPS8.query)(this._delegate, (0, $8NPS8.orderByChild)(path)));
    }
    /**
     * Return a new query ordered by the KeyIndex
     */ orderByKey() {
        (0, $ffjl9.validateArgCount)('Query.orderByKey', 0, 0, arguments.length);
        return new $014f710bdf50a6cd$var$Query(this.database, (0, $8NPS8.query)(this._delegate, (0, $8NPS8.orderByKey)()));
    }
    /**
     * Return a new query ordered by the PriorityIndex
     */ orderByPriority() {
        (0, $ffjl9.validateArgCount)('Query.orderByPriority', 0, 0, arguments.length);
        return new $014f710bdf50a6cd$var$Query(this.database, (0, $8NPS8.query)(this._delegate, (0, $8NPS8.orderByPriority)()));
    }
    /**
     * Return a new query ordered by the ValueIndex
     */ orderByValue() {
        (0, $ffjl9.validateArgCount)('Query.orderByValue', 0, 0, arguments.length);
        return new $014f710bdf50a6cd$var$Query(this.database, (0, $8NPS8.query)(this._delegate, (0, $8NPS8.orderByValue)()));
    }
    startAt(value = null, name) {
        (0, $ffjl9.validateArgCount)('Query.startAt', 0, 2, arguments.length);
        return new $014f710bdf50a6cd$var$Query(this.database, (0, $8NPS8.query)(this._delegate, (0, $8NPS8.startAt)(value, name)));
    }
    startAfter(value = null, name) {
        (0, $ffjl9.validateArgCount)('Query.startAfter', 0, 2, arguments.length);
        return new $014f710bdf50a6cd$var$Query(this.database, (0, $8NPS8.query)(this._delegate, (0, $8NPS8.startAfter)(value, name)));
    }
    endAt(value = null, name) {
        (0, $ffjl9.validateArgCount)('Query.endAt', 0, 2, arguments.length);
        return new $014f710bdf50a6cd$var$Query(this.database, (0, $8NPS8.query)(this._delegate, (0, $8NPS8.endAt)(value, name)));
    }
    endBefore(value = null, name) {
        (0, $ffjl9.validateArgCount)('Query.endBefore', 0, 2, arguments.length);
        return new $014f710bdf50a6cd$var$Query(this.database, (0, $8NPS8.query)(this._delegate, (0, $8NPS8.endBefore)(value, name)));
    }
    /**
     * Load the selection of children with exactly the specified value, and, optionally,
     * the specified name.
     */ equalTo(value, name) {
        (0, $ffjl9.validateArgCount)('Query.equalTo', 1, 2, arguments.length);
        return new $014f710bdf50a6cd$var$Query(this.database, (0, $8NPS8.query)(this._delegate, (0, $8NPS8.equalTo)(value, name)));
    }
    /**
     * @returns URL for this location.
     */ toString() {
        (0, $ffjl9.validateArgCount)('Query.toString', 0, 0, arguments.length);
        return this._delegate.toString();
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users.
    toJSON() {
        // An optional spacer argument is unnecessary for a string.
        (0, $ffjl9.validateArgCount)('Query.toJSON', 0, 1, arguments.length);
        return this._delegate.toJSON();
    }
    /**
     * Return true if this query and the provided query are equivalent; otherwise, return false.
     */ isEqual(other) {
        (0, $ffjl9.validateArgCount)('Query.isEqual', 1, 1, arguments.length);
        if (!(other instanceof $014f710bdf50a6cd$var$Query)) {
            const error = 'Query.isEqual failed: First argument must be an instance of firebase.database.Query.';
            throw new Error(error);
        }
        return this._delegate.isEqual(other._delegate);
    }
    /**
     * Helper used by .on and .once to extract the context and or cancel arguments.
     * @param fnName - The function name (on or once)
     *
     */ static getCancelAndContextArgs_(fnName, cancelOrContext, context) {
        const ret = {
            cancel: undefined,
            context: undefined
        };
        if (cancelOrContext && context) {
            ret.cancel = cancelOrContext;
            (0, $ffjl9.validateCallback)(fnName, 'cancel', ret.cancel, true);
            ret.context = context;
            (0, $ffjl9.validateContextObject)(fnName, 'context', ret.context, true);
        } else if (cancelOrContext) {
            // we have either a cancel callback or a context.
            if (typeof cancelOrContext === 'object' && cancelOrContext !== null) // it's a context!
            ret.context = cancelOrContext;
            else if (typeof cancelOrContext === 'function') ret.cancel = cancelOrContext;
            else throw new Error((0, $ffjl9.errorPrefix)(fnName, 'cancelOrContext') + ' must either be a cancel callback or a context object.');
        }
        return ret;
    }
    get ref() {
        return new $014f710bdf50a6cd$var$Reference(this.database, new (0, $8NPS8._ReferenceImpl)(this._delegate._repo, this._delegate._path));
    }
}
class $014f710bdf50a6cd$var$Reference extends $014f710bdf50a6cd$var$Query {
    /**
     * Call options:
     *   new Reference(Repo, Path) or
     *   new Reference(url: string, string|RepoManager)
     *
     * Externally - this is the firebase.database.Reference type.
     */ constructor(database, _delegate){
        super(database, new (0, $8NPS8._QueryImpl)(_delegate._repo, _delegate._path, new (0, $8NPS8._QueryParams)(), false));
        this.database = database;
        this._delegate = _delegate;
    }
    /** @returns {?string} */ getKey() {
        (0, $ffjl9.validateArgCount)('Reference.key', 0, 0, arguments.length);
        return this._delegate.key;
    }
    child(pathString) {
        (0, $ffjl9.validateArgCount)('Reference.child', 1, 1, arguments.length);
        if (typeof pathString === 'number') pathString = String(pathString);
        return new $014f710bdf50a6cd$var$Reference(this.database, (0, $8NPS8.child)(this._delegate, pathString));
    }
    /** @returns {?Reference} */ getParent() {
        (0, $ffjl9.validateArgCount)('Reference.parent', 0, 0, arguments.length);
        const parent = this._delegate.parent;
        return parent ? new $014f710bdf50a6cd$var$Reference(this.database, parent) : null;
    }
    /** @returns {!Reference} */ getRoot() {
        (0, $ffjl9.validateArgCount)('Reference.root', 0, 0, arguments.length);
        return new $014f710bdf50a6cd$var$Reference(this.database, this._delegate.root);
    }
    set(newVal, onComplete) {
        (0, $ffjl9.validateArgCount)('Reference.set', 1, 2, arguments.length);
        (0, $ffjl9.validateCallback)('Reference.set', 'onComplete', onComplete, true);
        const result = (0, $8NPS8.set)(this._delegate, newVal);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    update(values, onComplete) {
        (0, $ffjl9.validateArgCount)('Reference.update', 1, 2, arguments.length);
        if (Array.isArray(values)) {
            const newObjectToMerge = {};
            for(let i = 0; i < values.length; ++i)newObjectToMerge['' + i] = values[i];
            values = newObjectToMerge;
            $014f710bdf50a6cd$var$warn("Passing an Array to Firebase.update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.");
        }
        (0, $8NPS8._validateWritablePath)('Reference.update', this._delegate._path);
        (0, $ffjl9.validateCallback)('Reference.update', 'onComplete', onComplete, true);
        const result = (0, $8NPS8.update)(this._delegate, values);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    setWithPriority(newVal, newPriority, onComplete) {
        (0, $ffjl9.validateArgCount)('Reference.setWithPriority', 2, 3, arguments.length);
        (0, $ffjl9.validateCallback)('Reference.setWithPriority', 'onComplete', onComplete, true);
        const result = (0, $8NPS8.setWithPriority)(this._delegate, newVal, newPriority);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    remove(onComplete) {
        (0, $ffjl9.validateArgCount)('Reference.remove', 0, 1, arguments.length);
        (0, $ffjl9.validateCallback)('Reference.remove', 'onComplete', onComplete, true);
        const result = (0, $8NPS8.remove)(this._delegate);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    transaction(transactionUpdate, onComplete, applyLocally) {
        (0, $ffjl9.validateArgCount)('Reference.transaction', 1, 3, arguments.length);
        (0, $ffjl9.validateCallback)('Reference.transaction', 'transactionUpdate', transactionUpdate, false);
        (0, $ffjl9.validateCallback)('Reference.transaction', 'onComplete', onComplete, true);
        $014f710bdf50a6cd$var$validateBoolean('Reference.transaction', 'applyLocally', applyLocally, true);
        const result = (0, $8NPS8.runTransaction)(this._delegate, transactionUpdate, {
            applyLocally: applyLocally
        }).then((transactionResult)=>new $014f710bdf50a6cd$var$TransactionResult(transactionResult.committed, new $014f710bdf50a6cd$var$DataSnapshot(this.database, transactionResult.snapshot)));
        if (onComplete) result.then((transactionResult)=>onComplete(null, transactionResult.committed, transactionResult.snapshot), (error)=>onComplete(error, false, null));
        return result;
    }
    setPriority(priority, onComplete) {
        (0, $ffjl9.validateArgCount)('Reference.setPriority', 1, 2, arguments.length);
        (0, $ffjl9.validateCallback)('Reference.setPriority', 'onComplete', onComplete, true);
        const result = (0, $8NPS8.setPriority)(this._delegate, priority);
        if (onComplete) result.then(()=>onComplete(null), (error)=>onComplete(error));
        return result;
    }
    push(value, onComplete) {
        (0, $ffjl9.validateArgCount)('Reference.push', 0, 2, arguments.length);
        (0, $ffjl9.validateCallback)('Reference.push', 'onComplete', onComplete, true);
        const expPromise = (0, $8NPS8.push)(this._delegate, value);
        const promise = expPromise.then((expRef)=>new $014f710bdf50a6cd$var$Reference(this.database, expRef));
        if (onComplete) promise.then(()=>onComplete(null), (error)=>onComplete(error));
        const result = new $014f710bdf50a6cd$var$Reference(this.database, expPromise);
        result.then = promise.then.bind(promise);
        result.catch = promise.catch.bind(promise, undefined);
        return result;
    }
    onDisconnect() {
        (0, $8NPS8._validateWritablePath)('Reference.onDisconnect', this._delegate._path);
        return new $014f710bdf50a6cd$var$OnDisconnect(new (0, $8NPS8.OnDisconnect)(this._delegate._repo, this._delegate._path));
    }
    get key() {
        return this.getKey();
    }
    get parent() {
        return this.getParent();
    }
    get root() {
        return this.getRoot();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Class representing a firebase database.
 */ class $014f710bdf50a6cd$var$Database {
    /**
     * The constructor should not be called by users of our public API.
     */ constructor(_delegate, app){
        this._delegate = _delegate;
        this.app = app;
        this.INTERNAL = {
            delete: ()=>this._delegate._delete(),
            forceWebSockets: $8NPS8.forceWebSockets,
            forceLongPolling: $8NPS8.forceLongPolling
        };
    }
    /**
     * Modify this instance to communicate with the Realtime Database emulator.
     *
     * <p>Note: This method must be called before performing any other operation.
     *
     * @param host - the emulator host (ex: localhost)
     * @param port - the emulator port (ex: 8080)
     * @param options.mockUserToken - the mock auth token to use for unit testing Security Rules
     */ useEmulator(host, port, options = {}) {
        (0, $8NPS8.connectDatabaseEmulator)(this._delegate, host, port, options);
    }
    ref(path) {
        (0, $ffjl9.validateArgCount)('database.ref', 0, 1, arguments.length);
        if (path instanceof $014f710bdf50a6cd$var$Reference) {
            const childRef = (0, $8NPS8.refFromURL)(this._delegate, path.toString());
            return new $014f710bdf50a6cd$var$Reference(this, childRef);
        } else {
            const childRef = (0, $8NPS8.ref)(this._delegate, path);
            return new $014f710bdf50a6cd$var$Reference(this, childRef);
        }
    }
    /**
     * Returns a reference to the root or the path specified in url.
     * We throw a exception if the url is not in the same domain as the
     * current repo.
     * @returns Firebase reference.
     */ refFromURL(url) {
        const apiName = 'database.refFromURL';
        (0, $ffjl9.validateArgCount)(apiName, 1, 1, arguments.length);
        const childRef = (0, $8NPS8.refFromURL)(this._delegate, url);
        return new $014f710bdf50a6cd$var$Reference(this, childRef);
    }
    // Make individual repo go offline.
    goOffline() {
        (0, $ffjl9.validateArgCount)('database.goOffline', 0, 0, arguments.length);
        return (0, $8NPS8.goOffline)(this._delegate);
    }
    goOnline() {
        (0, $ffjl9.validateArgCount)('database.goOnline', 0, 0, arguments.length);
        return (0, $8NPS8.goOnline)(this._delegate);
    }
}
$014f710bdf50a6cd$var$Database.ServerValue = {
    TIMESTAMP: (0, $8NPS8.serverTimestamp)(),
    increment: (delta)=>(0, $8NPS8.increment)(delta)
};
/**
 * Used by console to create a database based on the app,
 * passed database URL and a custom auth implementation.
 *
 * @param app - A valid FirebaseApp-like object
 * @param url - A valid Firebase databaseURL
 * @param version - custom version e.g. firebase-admin version
 * @param customAuthImpl - custom auth implementation
 */ function $014f710bdf50a6cd$var$initStandalone({ app: app, url: url, version: version, customAuthImpl: customAuthImpl, customAppCheckImpl: customAppCheckImpl, namespace: namespace, nodeAdmin: nodeAdmin = false }) {
    (0, $8NPS8._setSDKVersion)(version);
    const container = new (0, $4a6xH.ComponentContainer)('database-standalone');
    /**
     * ComponentContainer('database-standalone') is just a placeholder that doesn't perform
     * any actual function.
     */ const authProvider = new (0, $4a6xH.Provider)('auth-internal', container);
    authProvider.setComponent(new (0, $4a6xH.Component)('auth-internal', ()=>customAuthImpl, "PRIVATE" /* ComponentType.PRIVATE */ ));
    let appCheckProvider = undefined;
    if (customAppCheckImpl) {
        appCheckProvider = new (0, $4a6xH.Provider)('app-check-internal', container);
        appCheckProvider.setComponent(new (0, $4a6xH.Component)('app-check-internal', ()=>customAppCheckImpl, "PRIVATE" /* ComponentType.PRIVATE */ ));
    }
    return {
        instance: new $014f710bdf50a6cd$var$Database((0, $8NPS8._repoManagerDatabaseFromApp)(app, authProvider, appCheckProvider, url, nodeAdmin), app),
        namespace: namespace
    };
}
var $014f710bdf50a6cd$var$INTERNAL = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    initStandalone: $014f710bdf50a6cd$var$initStandalone
});
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $014f710bdf50a6cd$var$ServerValue = $014f710bdf50a6cd$var$Database.ServerValue;
function $014f710bdf50a6cd$export$44894f2caba7dc4c(instance) {
    // Register the Database Service with the 'firebase' namespace.
    instance.INTERNAL.registerComponent(new (0, $4a6xH.Component)('database-compat', (container, { instanceIdentifier: url })=>{
        /* Dependencies */ // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider('app-compat').getImmediate();
        const databaseExp = container.getProvider('database').getImmediate({
            identifier: url
        });
        return new $014f710bdf50a6cd$var$Database(databaseExp, app);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ).setServiceProps(// firebase.database namespace properties
    {
        Reference: $014f710bdf50a6cd$var$Reference,
        Query: $014f710bdf50a6cd$var$Query,
        Database: $014f710bdf50a6cd$var$Database,
        DataSnapshot: $014f710bdf50a6cd$var$DataSnapshot,
        enableLogging: $8NPS8.enableLogging,
        INTERNAL: $014f710bdf50a6cd$var$INTERNAL,
        ServerValue: $014f710bdf50a6cd$var$ServerValue
    }).setMultipleInstances(true));
    instance.registerVersion($014f710bdf50a6cd$var$name, $014f710bdf50a6cd$var$version);
}
$014f710bdf50a6cd$export$44894f2caba7dc4c((0, $hVw4Q.default));

});
parcelRegister("8NPS8", function(module, exports) {

$parcel$export(module.exports, "_setSDKVersion", function () { return $668b2310913a4fe8$export$c9fb972242fcb3c4; });
$parcel$export(module.exports, "_QueryParams", function () { return $668b2310913a4fe8$export$7ba287e361c94330; });
$parcel$export(module.exports, "_validatePathString", function () { return $668b2310913a4fe8$export$8637b026ace8abb1; });
$parcel$export(module.exports, "_validateWritablePath", function () { return $668b2310913a4fe8$export$8d83036122ae444e; });
$parcel$export(module.exports, "OnDisconnect", function () { return $668b2310913a4fe8$export$95b7818b4ee6c2af; });
$parcel$export(module.exports, "_QueryImpl", function () { return $668b2310913a4fe8$export$e79c8d837d2220a8; });
$parcel$export(module.exports, "_ReferenceImpl", function () { return $668b2310913a4fe8$export$35c3a5e7c9d1033c; });
$parcel$export(module.exports, "child", function () { return $668b2310913a4fe8$export$f9574b70e1d95d9d; });
$parcel$export(module.exports, "ref", function () { return $668b2310913a4fe8$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "refFromURL", function () { return $668b2310913a4fe8$export$291fc3c05735451; });
$parcel$export(module.exports, "push", function () { return $668b2310913a4fe8$export$4cbf152802aa238; });
$parcel$export(module.exports, "set", function () { return $668b2310913a4fe8$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "remove", function () { return $668b2310913a4fe8$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "setPriority", function () { return $668b2310913a4fe8$export$313bf5dbe7a1196e; });
$parcel$export(module.exports, "setWithPriority", function () { return $668b2310913a4fe8$export$1fa5d5bf488088f3; });
$parcel$export(module.exports, "update", function () { return $668b2310913a4fe8$export$722fbec263ad908a; });
$parcel$export(module.exports, "get", function () { return $668b2310913a4fe8$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "onValue", function () { return $668b2310913a4fe8$export$ad30f661f41f4d90; });
$parcel$export(module.exports, "onChildAdded", function () { return $668b2310913a4fe8$export$fdc3e67b2775c753; });
$parcel$export(module.exports, "onChildChanged", function () { return $668b2310913a4fe8$export$a3fdf31223dcb03; });
$parcel$export(module.exports, "onChildMoved", function () { return $668b2310913a4fe8$export$1b001b15904d2a7f; });
$parcel$export(module.exports, "onChildRemoved", function () { return $668b2310913a4fe8$export$8362b530316d1aba; });
$parcel$export(module.exports, "off", function () { return $668b2310913a4fe8$export$8c8705df4a2dcec9; });
$parcel$export(module.exports, "endAt", function () { return $668b2310913a4fe8$export$28ec54a8428bdb3f; });
$parcel$export(module.exports, "endBefore", function () { return $668b2310913a4fe8$export$57203950645b8b11; });
$parcel$export(module.exports, "startAt", function () { return $668b2310913a4fe8$export$859941c5fc8eba6b; });
$parcel$export(module.exports, "startAfter", function () { return $668b2310913a4fe8$export$dd8dee5f7b804673; });
$parcel$export(module.exports, "limitToFirst", function () { return $668b2310913a4fe8$export$9d02e839f813b99d; });
$parcel$export(module.exports, "limitToLast", function () { return $668b2310913a4fe8$export$f823b3589f69d3b8; });
$parcel$export(module.exports, "orderByChild", function () { return $668b2310913a4fe8$export$5162bd9025f8e144; });
$parcel$export(module.exports, "orderByKey", function () { return $668b2310913a4fe8$export$d5ab8b3bbd8afbf8; });
$parcel$export(module.exports, "orderByPriority", function () { return $668b2310913a4fe8$export$19e8ae5500cf2e55; });
$parcel$export(module.exports, "orderByValue", function () { return $668b2310913a4fe8$export$7f2f62793c39d0c0; });
$parcel$export(module.exports, "equalTo", function () { return $668b2310913a4fe8$export$bdcdec1f91f16dff; });
$parcel$export(module.exports, "query", function () { return $668b2310913a4fe8$export$2fa187e846a241c4; });
$parcel$export(module.exports, "_repoManagerDatabaseFromApp", function () { return $668b2310913a4fe8$export$a248c1d2ea757674; });
$parcel$export(module.exports, "forceWebSockets", function () { return $668b2310913a4fe8$export$752b38c15a5377b6; });
$parcel$export(module.exports, "forceLongPolling", function () { return $668b2310913a4fe8$export$387cff57f2608869; });
$parcel$export(module.exports, "connectDatabaseEmulator", function () { return $668b2310913a4fe8$export$87f3cfc4a2e3958d; });
$parcel$export(module.exports, "goOffline", function () { return $668b2310913a4fe8$export$bee838355d017f0a; });
$parcel$export(module.exports, "goOnline", function () { return $668b2310913a4fe8$export$e0eecaabee32dd; });
$parcel$export(module.exports, "enableLogging", function () { return $668b2310913a4fe8$export$4e1d237eb9e560af; });
$parcel$export(module.exports, "serverTimestamp", function () { return $668b2310913a4fe8$export$3ff8e7e00c3264b7; });
$parcel$export(module.exports, "increment", function () { return $668b2310913a4fe8$export$a2647aa13413c947; });
$parcel$export(module.exports, "runTransaction", function () { return $668b2310913a4fe8$export$3c54e006bf9c93b7; });

var $ix4Jr = parcelRequire("ix4Jr");

var $4a6xH = parcelRequire("4a6xH");

var $ffjl9 = parcelRequire("ffjl9");

var $7vF8m = parcelRequire("7vF8m");

var $4TNnu = parcelRequire("4TNnu");
const $668b2310913a4fe8$var$name = "@firebase/database";
const $668b2310913a4fe8$var$version = "1.0.8";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The semver (www.semver.org) version of the SDK. */ let $668b2310913a4fe8$var$SDK_VERSION = '';
/**
 * SDK_VERSION should be set before any database instance is created
 * @internal
 */ function $668b2310913a4fe8$export$c9fb972242fcb3c4(version) {
    $668b2310913a4fe8$var$SDK_VERSION = version;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 */ class $668b2310913a4fe8$var$DOMStorageWrapper {
    /**
     * @param domStorage_ - The underlying storage object (e.g. localStorage or sessionStorage)
     */ constructor(domStorage_){
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = 'firebase:';
    }
    /**
     * @param key - The key to save the value under
     * @param value - The value being stored, or null to remove the key.
     */ set(key, value) {
        if (value == null) this.domStorage_.removeItem(this.prefixedName_(key));
        else this.domStorage_.setItem(this.prefixedName_(key), (0, $ffjl9.stringify)(value));
    }
    /**
     * @returns The value that was stored under this key, or null
     */ get(key) {
        const storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) return null;
        else return (0, $ffjl9.jsonEval)(storedVal);
    }
    remove(key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    }
    prefixedName_(name) {
        return this.prefix_ + name;
    }
    toString() {
        return this.domStorage_.toString();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 */ class $668b2310913a4fe8$var$MemoryStorage {
    constructor(){
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    set(key, value) {
        if (value == null) delete this.cache_[key];
        else this.cache_[key] = value;
    }
    get(key) {
        if ((0, $ffjl9.contains)(this.cache_, key)) return this.cache_[key];
        return null;
    }
    remove(key) {
        delete this.cache_[key];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param domStorageName - Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @returns Turning off type information until a common interface is defined.
 */ const $668b2310913a4fe8$var$createStoragefor = function(domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== 'undefined' && typeof window[domStorageName] !== 'undefined') {
            // Need to test cache. Just because it's here doesn't mean it works
            const domStorage = window[domStorageName];
            domStorage.setItem('firebase:sentinel', 'cache');
            domStorage.removeItem('firebase:sentinel');
            return new $668b2310913a4fe8$var$DOMStorageWrapper(domStorage);
        }
    } catch (e) {}
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new $668b2310913a4fe8$var$MemoryStorage();
};
/** A storage object that lasts across sessions */ const $668b2310913a4fe8$var$PersistentStorage = $668b2310913a4fe8$var$createStoragefor('localStorage');
/** A storage object that only lasts one session */ const $668b2310913a4fe8$var$SessionStorage = $668b2310913a4fe8$var$createStoragefor('sessionStorage');
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $668b2310913a4fe8$var$logClient = new (0, $7vF8m.Logger)('@firebase/database');
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 */ const $668b2310913a4fe8$var$LUIDGenerator = function() {
    let id = 1;
    return function() {
        return id++;
    };
}();
/**
 * Sha1 hash of the input string
 * @param str - The string to hash
 * @returns {!string} The resulting hash
 */ const $668b2310913a4fe8$var$sha1 = function(str) {
    const utf8Bytes = (0, $ffjl9.stringToByteArray)(str);
    const sha1 = new (0, $ffjl9.Sha1)();
    sha1.update(utf8Bytes);
    const sha1Bytes = sha1.digest();
    return (0, $ffjl9.base64).encodeByteArray(sha1Bytes);
};
const $668b2310913a4fe8$var$buildLogMessage_ = function(...varArgs) {
    let message = '';
    for(let i = 0; i < varArgs.length; i++){
        const arg = varArgs[i];
        if (Array.isArray(arg) || arg && typeof arg === 'object' && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        typeof arg.length === 'number') message += $668b2310913a4fe8$var$buildLogMessage_.apply(null, arg);
        else if (typeof arg === 'object') message += (0, $ffjl9.stringify)(arg);
        else message += arg;
        message += ' ';
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 */ let $668b2310913a4fe8$var$logger = null;
/**
 * Flag to check for log availability on first log message
 */ let $668b2310913a4fe8$var$firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param logger_ - A flag to turn on logging, or a custom logger
 * @param persistent - Whether or not to persist logging settings across refreshes
 */ const $668b2310913a4fe8$var$enableLogging$1 = function(logger_, persistent) {
    (0, $ffjl9.assert)(!persistent || logger_ === true || logger_ === false, "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        $668b2310913a4fe8$var$logClient.logLevel = (0, $7vF8m.LogLevel).VERBOSE;
        $668b2310913a4fe8$var$logger = $668b2310913a4fe8$var$logClient.log.bind($668b2310913a4fe8$var$logClient);
        if (persistent) $668b2310913a4fe8$var$SessionStorage.set('logging_enabled', true);
    } else if (typeof logger_ === 'function') $668b2310913a4fe8$var$logger = logger_;
    else {
        $668b2310913a4fe8$var$logger = null;
        $668b2310913a4fe8$var$SessionStorage.remove('logging_enabled');
    }
};
const $668b2310913a4fe8$var$log = function(...varArgs) {
    if ($668b2310913a4fe8$var$firstLog_ === true) {
        $668b2310913a4fe8$var$firstLog_ = false;
        if ($668b2310913a4fe8$var$logger === null && $668b2310913a4fe8$var$SessionStorage.get('logging_enabled') === true) $668b2310913a4fe8$var$enableLogging$1(true);
    }
    if ($668b2310913a4fe8$var$logger) {
        const message = $668b2310913a4fe8$var$buildLogMessage_.apply(null, varArgs);
        $668b2310913a4fe8$var$logger(message);
    }
};
const $668b2310913a4fe8$var$logWrapper = function(prefix) {
    return function(...varArgs) {
        $668b2310913a4fe8$var$log(prefix, ...varArgs);
    };
};
const $668b2310913a4fe8$var$error = function(...varArgs) {
    const message = 'FIREBASE INTERNAL ERROR: ' + $668b2310913a4fe8$var$buildLogMessage_(...varArgs);
    $668b2310913a4fe8$var$logClient.error(message);
};
const $668b2310913a4fe8$var$fatal = function(...varArgs) {
    const message = `FIREBASE FATAL ERROR: ${$668b2310913a4fe8$var$buildLogMessage_(...varArgs)}`;
    $668b2310913a4fe8$var$logClient.error(message);
    throw new Error(message);
};
const $668b2310913a4fe8$var$warn = function(...varArgs) {
    const message = 'FIREBASE WARNING: ' + $668b2310913a4fe8$var$buildLogMessage_(...varArgs);
    $668b2310913a4fe8$var$logClient.warn(message);
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */ const $668b2310913a4fe8$var$warnIfPageIsSecure = function() {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== 'undefined' && window.location && window.location.protocol && window.location.protocol.indexOf('https:') !== -1) $668b2310913a4fe8$var$warn("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 */ const $668b2310913a4fe8$var$isInvalidJSONNumber = function(data) {
    return typeof data === 'number' && (data !== data || // NaN
    data === Number.POSITIVE_INFINITY || data === Number.NEGATIVE_INFINITY);
};
const $668b2310913a4fe8$var$executeWhenDOMReady = function(fn) {
    if ((0, $ffjl9.isNodeSdk)() || document.readyState === 'complete') fn();
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        let called = false;
        const wrappedFn = function() {
            if (!document.body) {
                setTimeout(wrappedFn, Math.floor(10));
                return;
            }
            if (!called) {
                called = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', wrappedFn, false);
            // fallback to onload.
            window.addEventListener('load', wrappedFn, false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } else if (document.attachEvent) {
            // IE.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            document.attachEvent('onreadystatechange', ()=>{
                if (document.readyState === 'complete') wrappedFn();
            });
            // fallback to onload.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.attachEvent('onload', wrappedFn);
        // jQuery has an extra hack for IE that we could employ (based on
        // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
        // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 */ const $668b2310913a4fe8$var$MIN_NAME = '[MIN_NAME]';
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 */ const $668b2310913a4fe8$var$MAX_NAME = '[MAX_NAME]';
/**
 * Compares valid Firebase key names, plus min and max name
 */ const $668b2310913a4fe8$var$nameCompare = function(a, b) {
    if (a === b) return 0;
    else if (a === $668b2310913a4fe8$var$MIN_NAME || b === $668b2310913a4fe8$var$MAX_NAME) return -1;
    else if (b === $668b2310913a4fe8$var$MIN_NAME || a === $668b2310913a4fe8$var$MAX_NAME) return 1;
    else {
        const aAsInt = $668b2310913a4fe8$var$tryParseInt(a), bAsInt = $668b2310913a4fe8$var$tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) return aAsInt - bAsInt === 0 ? a.length - b.length : aAsInt - bAsInt;
            else return -1;
        } else if (bAsInt !== null) return 1;
        else return a < b ? -1 : 1;
    }
};
/**
 * @returns {!number} comparison result.
 */ const $668b2310913a4fe8$var$stringCompare = function(a, b) {
    if (a === b) return 0;
    else if (a < b) return -1;
    else return 1;
};
const $668b2310913a4fe8$var$requireKey = function(key, obj) {
    if (obj && key in obj) return obj[key];
    else throw new Error('Missing required key (' + key + ') in object: ' + (0, $ffjl9.stringify)(obj));
};
const $668b2310913a4fe8$var$ObjectToUniqueKey = function(obj) {
    if (typeof obj !== 'object' || obj === null) return (0, $ffjl9.stringify)(obj);
    const keys = [];
    // eslint-disable-next-line guard-for-in
    for(const k in obj)keys.push(k);
    // Export as json, but with the keys sorted.
    keys.sort();
    let key = '{';
    for(let i = 0; i < keys.length; i++){
        if (i !== 0) key += ',';
        key += (0, $ffjl9.stringify)(keys[i]);
        key += ':';
        key += $668b2310913a4fe8$var$ObjectToUniqueKey(obj[keys[i]]);
    }
    key += '}';
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param str - The string
 * @param segsize - The maximum number of chars in the string.
 * @returns The string, split into appropriately-sized chunks
 */ const $668b2310913a4fe8$var$splitStringBySize = function(str, segsize) {
    const len = str.length;
    if (len <= segsize) return [
        str
    ];
    const dataSegs = [];
    for(let c = 0; c < len; c += segsize)if (c + segsize > len) dataSegs.push(str.substring(c, len));
    else dataSegs.push(str.substring(c, c + segsize));
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param obj - The object or array to iterate over
 * @param fn - The function to apply
 */ function $668b2310913a4fe8$var$each(obj, fn) {
    for(const key in obj)if (obj.hasOwnProperty(key)) fn(key, obj[key]);
}
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param v - A double
 *
 */ const $668b2310913a4fe8$var$doubleToIEEE754String = function(v) {
    (0, $ffjl9.assert)(!$668b2310913a4fe8$var$isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
    const ebits = 11, fbits = 52;
    const bias = (1 << ebits - 1) - 1;
    let s, e, f, ln, i;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    } else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        } else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    const bits = [];
    for(i = fbits; i; i -= 1){
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for(i = ebits; i; i -= 1){
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    const str = bits.join('');
    // Return the data as a hex string. --MJL
    let hexByteString = '';
    for(i = 0; i < 64; i += 8){
        let hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1) hexByte = '0' + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 */ const $668b2310913a4fe8$var$isChromeExtensionContentScript = function() {
    return !!(typeof window === 'object' && window['chrome'] && window['chrome']['extension'] && !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 */ const $668b2310913a4fe8$var$isWindowsStoreApp = function() {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === 'object' && typeof Windows.UI === 'object';
};
/**
 * Converts a server error code to a JavaScript Error
 */ function $668b2310913a4fe8$var$errorForServerCode(code, query) {
    let reason = 'Unknown Error';
    if (code === 'too_big') reason = "The data requested exceeds the maximum size that can be accessed with a single request.";
    else if (code === 'permission_denied') reason = "Client doesn't have permission to access the desired data.";
    else if (code === 'unavailable') reason = 'The service is unavailable';
    const error = new Error(code + ' at ' + query._path.toString() + ': ' + reason);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error.code = code.toUpperCase();
    return error;
}
/**
 * Used to test for integer-looking strings
 */ const $668b2310913a4fe8$var$INTEGER_REGEXP_ = new RegExp('^-?(0*)\\d{1,10}$');
/**
 * For use in keys, the minimum possible 32-bit integer.
 */ const $668b2310913a4fe8$var$INTEGER_32_MIN = -2147483648;
/**
 * For use in keys, the maximum possible 32-bit integer.
 */ const $668b2310913a4fe8$var$INTEGER_32_MAX = 2147483647;
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 */ const $668b2310913a4fe8$var$tryParseInt = function(str) {
    if ($668b2310913a4fe8$var$INTEGER_REGEXP_.test(str)) {
        const intVal = Number(str);
        if (intVal >= $668b2310913a4fe8$var$INTEGER_32_MIN && intVal <= $668b2310913a4fe8$var$INTEGER_32_MAX) return intVal;
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param fn - The code to guard.
 */ const $668b2310913a4fe8$var$exceptionGuard = function(fn) {
    try {
        fn();
    } catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(()=>{
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            const stack = e.stack || '';
            $668b2310913a4fe8$var$warn('Exception was thrown by user callback.', stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * @returns {boolean} true if we think we're currently being crawled.
 */ const $668b2310913a4fe8$var$beingCrawled = function() {
    const userAgent = typeof window === 'object' && window['navigator'] && window['navigator']['userAgent'] || '';
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0;
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param fn - Function to run.
 * @param time - Milliseconds to wait before running.
 * @returns The setTimeout() return value.
 */ const $668b2310913a4fe8$var$setTimeoutNonBlocking = function(fn, time) {
    const timeout = setTimeout(fn, time);
    // Note: at the time of this comment, unrefTimer is under the unstable set of APIs. Run with --unstable to enable the API.
    if (typeof timeout === 'number' && // @ts-ignore Is only defined in Deno environments.
    typeof Deno !== 'undefined' && // @ts-ignore Deno and unrefTimer are only defined in Deno environments.
    Deno['unrefTimer']) // @ts-ignore Deno and unrefTimer are only defined in Deno environments.
    Deno.unrefTimer(timeout);
    else if (typeof timeout === 'object' && timeout['unref']) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    timeout['unref']();
    return timeout;
};
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around AppCheck's token fetching capabilities.
 */ class $668b2310913a4fe8$var$AppCheckTokenProvider {
    constructor(appName_, appCheckProvider){
        this.appName_ = appName_;
        this.appCheckProvider = appCheckProvider;
        this.appCheck = appCheckProvider === null || appCheckProvider === void 0 ? void 0 : appCheckProvider.getImmediate({
            optional: true
        });
        if (!this.appCheck) appCheckProvider === null || appCheckProvider === void 0 || appCheckProvider.get().then((appCheck)=>this.appCheck = appCheck);
    }
    getToken(forceRefresh) {
        if (!this.appCheck) return new Promise((resolve, reject)=>{
            // Support delayed initialization of FirebaseAppCheck. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // AppCheck and ensures that all requests are authenticated if a token
            // becomes available before the timeout below expires.
            setTimeout(()=>{
                if (this.appCheck) this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.appCheck.getToken(forceRefresh);
    }
    addTokenChangeListener(listener) {
        var _a;
        (_a = this.appCheckProvider) === null || _a === void 0 || _a.get().then((appCheck)=>appCheck.addTokenListener(listener));
    }
    notifyForInvalidToken() {
        $668b2310913a4fe8$var$warn(`Provided AppCheck credentials for the app named "${this.appName_}" ` + 'are invalid. This usually indicates your app was not initialized correctly.');
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */ class $668b2310913a4fe8$var$FirebaseAuthTokenProvider {
    constructor(appName_, firebaseOptions_, authProvider_){
        this.appName_ = appName_;
        this.firebaseOptions_ = firebaseOptions_;
        this.authProvider_ = authProvider_;
        this.auth_ = null;
        this.auth_ = authProvider_.getImmediate({
            optional: true
        });
        if (!this.auth_) authProvider_.onInit((auth)=>this.auth_ = auth);
    }
    getToken(forceRefresh) {
        if (!this.auth_) return new Promise((resolve, reject)=>{
            // Support delayed initialization of FirebaseAuth. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // Auth and ensures that all requests are authenticated if a token
            // becomes available before the timeout below expires.
            setTimeout(()=>{
                if (this.auth_) this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.auth_.getToken(forceRefresh).catch((error)=>{
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error && error.code === 'auth/token-not-initialized') {
                $668b2310913a4fe8$var$log('Got auth/token-not-initialized error.  Treating as null token.');
                return null;
            } else return Promise.reject(error);
        });
    }
    addTokenChangeListener(listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        if (this.auth_) this.auth_.addAuthTokenListener(listener);
        else this.authProvider_.get().then((auth)=>auth.addAuthTokenListener(listener));
    }
    removeTokenChangeListener(listener) {
        this.authProvider_.get().then((auth)=>auth.removeAuthTokenListener(listener));
    }
    notifyForInvalidToken() {
        let errorMessage = 'Provided authentication credentials for the app named "' + this.appName_ + '" are invalid. This usually indicates your app was not ' + 'initialized correctly. ';
        if ('credential' in this.firebaseOptions_) errorMessage += 'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else if ('serviceAccount' in this.firebaseOptions_) errorMessage += 'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else errorMessage += 'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.';
        $668b2310913a4fe8$var$warn(errorMessage);
    }
}
/* AuthTokenProvider that supplies a constant token. Used by Admin SDK or mockUserToken with emulators. */ class $668b2310913a4fe8$var$EmulatorTokenProvider {
    constructor(accessToken){
        this.accessToken = accessToken;
    }
    getToken(forceRefresh) {
        return Promise.resolve({
            accessToken: this.accessToken
        });
    }
    addTokenChangeListener(listener) {
        // Invoke the listener immediately to match the behavior in Firebase Auth
        // (see packages/auth/src/auth.js#L1807)
        listener(this.accessToken);
    }
    removeTokenChangeListener(listener) {}
    notifyForInvalidToken() {}
}
/** A string that is treated as an admin access token by the RTDB emulator. Used by Admin SDK. */ $668b2310913a4fe8$var$EmulatorTokenProvider.OWNER = 'owner';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $668b2310913a4fe8$var$PROTOCOL_VERSION = '5';
const $668b2310913a4fe8$var$VERSION_PARAM = 'v';
const $668b2310913a4fe8$var$TRANSPORT_SESSION_PARAM = 's';
const $668b2310913a4fe8$var$REFERER_PARAM = 'r';
const $668b2310913a4fe8$var$FORGE_REF = 'f';
// Matches console.firebase.google.com, firebase-console-*.corp.google.com and
// firebase.corp.google.com
const $668b2310913a4fe8$var$FORGE_DOMAIN_RE = /(console\.firebase|firebase-console-\w+\.corp|firebase\.corp)\.google\.com/;
const $668b2310913a4fe8$var$LAST_SESSION_PARAM = 'ls';
const $668b2310913a4fe8$var$APPLICATION_ID_PARAM = 'p';
const $668b2310913a4fe8$var$APP_CHECK_TOKEN_PARAM = 'ac';
const $668b2310913a4fe8$var$WEBSOCKET = 'websocket';
const $668b2310913a4fe8$var$LONG_POLLING = 'long_polling';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that holds metadata about a Repo object
 */ class $668b2310913a4fe8$var$RepoInfo {
    /**
     * @param host - Hostname portion of the url for the repo
     * @param secure - Whether or not this repo is accessed over ssl
     * @param namespace - The namespace represented by the repo
     * @param webSocketOnly - Whether to prefer websockets over all other transports (used by Nest).
     * @param nodeAdmin - Whether this instance uses Admin SDK credentials
     * @param persistenceKey - Override the default session persistence storage key
     */ constructor(host, secure, namespace, webSocketOnly, nodeAdmin = false, persistenceKey = '', includeNamespaceInQueryParams = false, isUsingEmulator = false){
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.nodeAdmin = nodeAdmin;
        this.persistenceKey = persistenceKey;
        this.includeNamespaceInQueryParams = includeNamespaceInQueryParams;
        this.isUsingEmulator = isUsingEmulator;
        this._host = host.toLowerCase();
        this._domain = this._host.substr(this._host.indexOf('.') + 1);
        this.internalHost = $668b2310913a4fe8$var$PersistentStorage.get('host:' + host) || this._host;
    }
    isCacheableHost() {
        return this.internalHost.substr(0, 2) === 's-';
    }
    isCustomHost() {
        return this._domain !== 'firebaseio.com' && this._domain !== 'firebaseio-demo.com';
    }
    get host() {
        return this._host;
    }
    set host(newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) $668b2310913a4fe8$var$PersistentStorage.set('host:' + this._host, this.internalHost);
        }
    }
    toString() {
        let str = this.toURLString();
        if (this.persistenceKey) str += '<' + this.persistenceKey + '>';
        return str;
    }
    toURLString() {
        const protocol = this.secure ? 'https://' : 'http://';
        const query = this.includeNamespaceInQueryParams ? `?ns=${this.namespace}` : '';
        return `${protocol}${this.host}/${query}`;
    }
}
function $668b2310913a4fe8$var$repoInfoNeedsQueryParam(repoInfo) {
    return repoInfo.host !== repoInfo.internalHost || repoInfo.isCustomHost() || repoInfo.includeNamespaceInQueryParams;
}
/**
 * Returns the websocket URL for this repo
 * @param repoInfo - RepoInfo object
 * @param type - of connection
 * @param params - list
 * @returns The URL for this repo
 */ function $668b2310913a4fe8$var$repoInfoConnectionURL(repoInfo, type, params) {
    (0, $ffjl9.assert)(typeof type === 'string', 'typeof type must == string');
    (0, $ffjl9.assert)(typeof params === 'object', 'typeof params must == object');
    let connURL;
    if (type === $668b2310913a4fe8$var$WEBSOCKET) connURL = (repoInfo.secure ? 'wss://' : 'ws://') + repoInfo.internalHost + '/.ws?';
    else if (type === $668b2310913a4fe8$var$LONG_POLLING) connURL = (repoInfo.secure ? 'https://' : 'http://') + repoInfo.internalHost + '/.lp?';
    else throw new Error('Unknown connection type: ' + type);
    if ($668b2310913a4fe8$var$repoInfoNeedsQueryParam(repoInfo)) params['ns'] = repoInfo.namespace;
    const pairs = [];
    $668b2310913a4fe8$var$each(params, (key, value)=>{
        pairs.push(key + '=' + value);
    });
    return connURL + pairs.join('&');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Tracks a collection of stats.
 */ class $668b2310913a4fe8$var$StatsCollection {
    constructor(){
        this.counters_ = {};
    }
    incrementCounter(name, amount = 1) {
        if (!(0, $ffjl9.contains)(this.counters_, name)) this.counters_[name] = 0;
        this.counters_[name] += amount;
    }
    get() {
        return (0, $ffjl9.deepCopy)(this.counters_);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $668b2310913a4fe8$var$collections = {};
const $668b2310913a4fe8$var$reporters = {};
function $668b2310913a4fe8$var$statsManagerGetCollection(repoInfo) {
    const hashString = repoInfo.toString();
    if (!$668b2310913a4fe8$var$collections[hashString]) $668b2310913a4fe8$var$collections[hashString] = new $668b2310913a4fe8$var$StatsCollection();
    return $668b2310913a4fe8$var$collections[hashString];
}
function $668b2310913a4fe8$var$statsManagerGetOrCreateReporter(repoInfo, creatorFunction) {
    const hashString = repoInfo.toString();
    if (!$668b2310913a4fe8$var$reporters[hashString]) $668b2310913a4fe8$var$reporters[hashString] = creatorFunction();
    return $668b2310913a4fe8$var$reporters[hashString];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 */ class $668b2310913a4fe8$var$PacketReceiver {
    /**
     * @param onMessage_
     */ constructor(onMessage_){
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    closeAfter(responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    }
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     */ handleResponse(requestNum, data) {
        this.pendingResponses[requestNum] = data;
        while(this.pendingResponses[this.currentResponseNum]){
            const toProcess = this.pendingResponses[this.currentResponseNum];
            delete this.pendingResponses[this.currentResponseNum];
            for(let i = 0; i < toProcess.length; ++i)if (toProcess[i]) $668b2310913a4fe8$var$exceptionGuard(()=>{
                this.onMessage_(toProcess[i]);
            });
            if (this.currentResponseNum === this.closeAfterResponse) {
                if (this.onClose) {
                    this.onClose();
                    this.onClose = null;
                }
                break;
            }
            this.currentResponseNum++;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // URL query parameters associated with longpolling
const $668b2310913a4fe8$var$FIREBASE_LONGPOLL_START_PARAM = 'start';
const $668b2310913a4fe8$var$FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
const $668b2310913a4fe8$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
const $668b2310913a4fe8$var$FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
const $668b2310913a4fe8$var$FIREBASE_LONGPOLL_ID_PARAM = 'id';
const $668b2310913a4fe8$var$FIREBASE_LONGPOLL_PW_PARAM = 'pw';
const $668b2310913a4fe8$var$FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
const $668b2310913a4fe8$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
const $668b2310913a4fe8$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
const $668b2310913a4fe8$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
const $668b2310913a4fe8$var$FIREBASE_LONGPOLL_DATA_PARAM = 'd';
const $668b2310913a4fe8$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
const $668b2310913a4fe8$var$MAX_URL_DATA_SIZE = 1870;
const $668b2310913a4fe8$var$SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
const $668b2310913a4fe8$var$MAX_PAYLOAD_SIZE = $668b2310913a4fe8$var$MAX_URL_DATA_SIZE - $668b2310913a4fe8$var$SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 */ const $668b2310913a4fe8$var$KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 */ const $668b2310913a4fe8$var$LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 */ class $668b2310913a4fe8$var$BrowserPollConnection {
    /**
     * @param connId An identifier for this connection, used for logging
     * @param repoInfo The info for the endpoint to send data to.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The AppCheck token for this client.
     * @param authToken The AuthToken to use for this connection.
     * @param transportSessionId Optional transportSessionid if we are
     * reconnecting for an existing transport session
     * @param lastSessionId Optional lastSessionId if the PersistentConnection has
     * already created a connection previously
     */ constructor(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId){
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = $668b2310913a4fe8$var$logWrapper(connId);
        this.stats_ = $668b2310913a4fe8$var$statsManagerGetCollection(repoInfo);
        this.urlFn = (params)=>{
            // Always add the token if we have one.
            if (this.appCheckToken) params[$668b2310913a4fe8$var$APP_CHECK_TOKEN_PARAM] = this.appCheckToken;
            return $668b2310913a4fe8$var$repoInfoConnectionURL(repoInfo, $668b2310913a4fe8$var$LONG_POLLING, params);
        };
    }
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ open(onMessage, onDisconnect) {
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new $668b2310913a4fe8$var$PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(()=>{
            this.log_('Timed out trying to connect.');
            // Make sure we clear the host cache
            this.onClosed_();
            this.connectTimeoutTimer_ = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($668b2310913a4fe8$var$LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        $668b2310913a4fe8$var$executeWhenDOMReady(()=>{
            if (this.isClosed_) return;
            //Set up a callback that gets triggered once a connection is set up.
            this.scriptTagHolder = new $668b2310913a4fe8$var$FirebaseIFrameScriptHolder((...args)=>{
                const [command, arg1, arg2, arg3, arg4] = args;
                this.incrementIncomingBytes_(args);
                if (!this.scriptTagHolder) return; // we closed the connection.
                if (this.connectTimeoutTimer_) {
                    clearTimeout(this.connectTimeoutTimer_);
                    this.connectTimeoutTimer_ = null;
                }
                this.everConnected_ = true;
                if (command === $668b2310913a4fe8$var$FIREBASE_LONGPOLL_START_PARAM) {
                    this.id = arg1;
                    this.password = arg2;
                } else if (command === $668b2310913a4fe8$var$FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        this.myPacketOrderer.closeAfter(arg1, ()=>{
                            this.onClosed_();
                        });
                    } else this.onClosed_();
                } else throw new Error('Unrecognized command received: ' + command);
            }, (...args)=>{
                const [pN, data] = args;
                this.incrementIncomingBytes_(args);
                this.myPacketOrderer.handleResponse(pN, data);
            }, ()=>{
                this.onClosed_();
            }, this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            const urlParams = {};
            urlParams[$668b2310913a4fe8$var$FIREBASE_LONGPOLL_START_PARAM] = 't';
            urlParams[$668b2310913a4fe8$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (this.scriptTagHolder.uniqueCallbackIdentifier) urlParams[$668b2310913a4fe8$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[$668b2310913a4fe8$var$VERSION_PARAM] = $668b2310913a4fe8$var$PROTOCOL_VERSION;
            if (this.transportSessionId) urlParams[$668b2310913a4fe8$var$TRANSPORT_SESSION_PARAM] = this.transportSessionId;
            if (this.lastSessionId) urlParams[$668b2310913a4fe8$var$LAST_SESSION_PARAM] = this.lastSessionId;
            if (this.applicationId) urlParams[$668b2310913a4fe8$var$APPLICATION_ID_PARAM] = this.applicationId;
            if (this.appCheckToken) urlParams[$668b2310913a4fe8$var$APP_CHECK_TOKEN_PARAM] = this.appCheckToken;
            if (typeof location !== 'undefined' && location.hostname && $668b2310913a4fe8$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$668b2310913a4fe8$var$REFERER_PARAM] = $668b2310913a4fe8$var$FORGE_REF;
            const connectURL = this.urlFn(urlParams);
            this.log_('Connecting via long-poll to ' + connectURL);
            this.scriptTagHolder.addTag(connectURL, ()=>{
            /* do nothing */ });
        });
    }
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */ start() {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    }
    /**
     * Forces long polling to be considered as a potential transport
     */ static forceAllow() {
        $668b2310913a4fe8$var$BrowserPollConnection.forceAllow_ = true;
    }
    /**
     * Forces longpolling to not be considered as a potential transport
     */ static forceDisallow() {
        $668b2310913a4fe8$var$BrowserPollConnection.forceDisallow_ = true;
    }
    // Static method, use string literal so it can be accessed in a generic way
    static isAvailable() {
        if ((0, $ffjl9.isNodeSdk)()) return false;
        else if ($668b2310913a4fe8$var$BrowserPollConnection.forceAllow_) return true;
        else // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
        return !$668b2310913a4fe8$var$BrowserPollConnection.forceDisallow_ && typeof document !== 'undefined' && document.createElement != null && !$668b2310913a4fe8$var$isChromeExtensionContentScript() && !$668b2310913a4fe8$var$isWindowsStoreApp();
    }
    /**
     * No-op for polling
     */ markConnectionHealthy() {}
    /**
     * Stops polling and cleans up the iframe
     */ shutdown_() {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    }
    /**
     * Triggered when this transport is closed
     */ onClosed_() {
        if (!this.isClosed_) {
            this.log_('Longpoll is closing itself');
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    }
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */ close() {
        if (!this.isClosed_) {
            this.log_('Longpoll is being closed.');
            this.shutdown_();
        }
    }
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param data - The JSON data to transmit.
     */ send(data) {
        const dataStr = (0, $ffjl9.stringify)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //first, lets get the base64-encoded data
        const base64data = (0, $ffjl9.base64Encode)(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        const dataSegs = $668b2310913a4fe8$var$splitStringBySize(base64data, $668b2310913a4fe8$var$MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for(let i = 0; i < dataSegs.length; i++){
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    }
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     */ addDisconnectPingFrame(id, pw) {
        if ((0, $ffjl9.isNodeSdk)()) return;
        this.myDisconnFrame = document.createElement('iframe');
        const urlParams = {};
        urlParams[$668b2310913a4fe8$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
        urlParams[$668b2310913a4fe8$var$FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[$668b2310913a4fe8$var$FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = 'none';
        document.body.appendChild(this.myDisconnFrame);
    }
    /**
     * Used to track the bytes received by this client
     */ incrementIncomingBytes_(args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        const bytesReceived = (0, $ffjl9.stringify)(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter('bytes_received', bytesReceived);
    }
}
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 *********************************************************************************************/ class $668b2310913a4fe8$var$FirebaseIFrameScriptHolder {
    /**
     * @param commandCB - The callback to be called when control commands are received from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */ constructor(commandCB, onMessageCB, onDisconnect, urlFn){
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        this.outstandingRequests = new Set();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!(0, $ffjl9.isNodeSdk)()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = $668b2310913a4fe8$var$LUIDGenerator();
            window[$668b2310913a4fe8$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[$668b2310913a4fe8$var$FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = $668b2310913a4fe8$var$FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            let script = '';
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src && this.myIFrame.src.substr(0, 11) === 'javascript:') {
                const currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            const iframeContents = '<html><body>' + script + '</body></html>';
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            } catch (e) {
                $668b2310913a4fe8$var$log('frame writing exception');
                if (e.stack) $668b2310913a4fe8$var$log(e.stack);
                $668b2310913a4fe8$var$log(e);
            }
        } else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     */ static createIFrame_() {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                const a = iframe.contentWindow.document;
                if (!a) // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                $668b2310913a4fe8$var$log('No IE domain setting required');
            } catch (e) {
                const domain = document.domain;
                iframe.src = "javascript:void((function(){document.open();document.domain='" + domain + "';document.close();})())";
            }
        } else // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
        // never gets hit.
        throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        else if (iframe.contentWindow) iframe.doc = iframe.contentWindow.document; // Internet Explorer
        else if (iframe.document) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        iframe.doc = iframe.document; //others?
        return iframe;
    }
    /**
     * Cancel all outstanding queries and remove the frame.
     */ close() {
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting textContent seems to be the safest way to do this.
            this.myIFrame.doc.body.textContent = '';
            setTimeout(()=>{
                if (this.myIFrame !== null) {
                    document.body.removeChild(this.myIFrame);
                    this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        // Protect from being called recursively.
        const onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    }
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param id - The ID of this connection
     * @param pw - The password for this connection
     */ startLongPoll(id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while(this.newRequest_());
    }
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */ newRequest_() {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive && this.sendNewPolls && this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            const urlParams = {};
            urlParams[$668b2310913a4fe8$var$FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[$668b2310913a4fe8$var$FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[$668b2310913a4fe8$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            let theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            let curDataString = '';
            let i = 0;
            while(this.pendingSegs.length > 0){
                //first, lets see if the next segment will fit.
                const nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + $668b2310913a4fe8$var$SEG_HEADER_SIZE + curDataString.length <= $668b2310913a4fe8$var$MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    const theSeg = this.pendingSegs.shift();
                    curDataString = curDataString + '&' + $668b2310913a4fe8$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM + i + '=' + theSeg.seg + '&' + $668b2310913a4fe8$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET + i + '=' + theSeg.ts + '&' + $668b2310913a4fe8$var$FIREBASE_LONGPOLL_DATA_PARAM + i + '=' + theSeg.d;
                    i++;
                } else break;
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        } else return false;
    }
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */ enqueueSegment(segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({
            seg: segnum,
            ts: totalsegs,
            d: data
        });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) this.newRequest_();
    }
    /**
     * Add a script tag for a regular long-poll request.
     * @param url - The URL of the script tag.
     * @param serial - The serial number of the request.
     */ addLongPollTag_(url, serial) {
        //remember that we sent this request.
        this.outstandingRequests.add(serial);
        const doNewRequest = ()=>{
            this.outstandingRequests.delete(serial);
            this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        const keepaliveTimeout = setTimeout(doNewRequest, Math.floor($668b2310913a4fe8$var$KEEPALIVE_REQUEST_INTERVAL));
        const readyStateCB = ()=>{
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    }
    /**
     * Add an arbitrary script tag to the iframe.
     * @param url - The URL for the script tag source.
     * @param loadCB - A callback to be triggered once the script has loaded.
     */ addTag(url, loadCB) {
        if ((0, $ffjl9.isNodeSdk)()) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.doNodeLongPoll(url, loadCB);
        else setTimeout(()=>{
            try {
                // if we're already closed, don't add this poll
                if (!this.sendNewPolls) return;
                const newScript = this.myIFrame.doc.createElement('script');
                newScript.type = 'text/javascript';
                newScript.async = true;
                newScript.src = url;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                newScript.onload = newScript.onreadystatechange = function() {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const rstate = newScript.readyState;
                    if (!rstate || rstate === 'loaded' || rstate === 'complete') {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        newScript.onload = newScript.onreadystatechange = null;
                        if (newScript.parentNode) newScript.parentNode.removeChild(newScript);
                        loadCB();
                    }
                };
                newScript.onerror = ()=>{
                    $668b2310913a4fe8$var$log('Long-poll script failed to load: ' + url);
                    this.sendNewPolls = false;
                    this.close();
                };
                this.myIFrame.doc.body.appendChild(newScript);
            } catch (e) {
            // TODO: we should make this error visible somehow
            }
        }, Math.floor(1));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $668b2310913a4fe8$var$WEBSOCKET_MAX_FRAME_SIZE = 16384;
const $668b2310913a4fe8$var$WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
let $668b2310913a4fe8$var$WebSocketImpl = null;
if (typeof MozWebSocket !== 'undefined') $668b2310913a4fe8$var$WebSocketImpl = MozWebSocket;
else if (typeof WebSocket !== 'undefined') $668b2310913a4fe8$var$WebSocketImpl = WebSocket;
/**
 * Create a new websocket connection with the given callbacks.
 */ class $668b2310913a4fe8$var$WebSocketConnection {
    /**
     * @param connId identifier for this transport
     * @param repoInfo The info for the websocket endpoint.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The App Check Token for this client.
     * @param authToken The Auth Token for this client.
     * @param transportSessionId Optional transportSessionId if this is connecting
     * to an existing transport session
     * @param lastSessionId Optional lastSessionId if there was a previous
     * connection
     */ constructor(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId){
        this.connId = connId;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = $668b2310913a4fe8$var$logWrapper(this.connId);
        this.stats_ = $668b2310913a4fe8$var$statsManagerGetCollection(repoInfo);
        this.connURL = $668b2310913a4fe8$var$WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken, applicationId);
        this.nodeAdmin = repoInfo.nodeAdmin;
    }
    /**
     * @param repoInfo - The info for the websocket endpoint.
     * @param transportSessionId - Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param lastSessionId - Optional lastSessionId if there was a previous connection
     * @returns connection url
     */ static connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken, applicationId) {
        const urlParams = {};
        urlParams[$668b2310913a4fe8$var$VERSION_PARAM] = $668b2310913a4fe8$var$PROTOCOL_VERSION;
        if (!(0, $ffjl9.isNodeSdk)() && typeof location !== 'undefined' && location.hostname && $668b2310913a4fe8$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$668b2310913a4fe8$var$REFERER_PARAM] = $668b2310913a4fe8$var$FORGE_REF;
        if (transportSessionId) urlParams[$668b2310913a4fe8$var$TRANSPORT_SESSION_PARAM] = transportSessionId;
        if (lastSessionId) urlParams[$668b2310913a4fe8$var$LAST_SESSION_PARAM] = lastSessionId;
        if (appCheckToken) urlParams[$668b2310913a4fe8$var$APP_CHECK_TOKEN_PARAM] = appCheckToken;
        if (applicationId) urlParams[$668b2310913a4fe8$var$APPLICATION_ID_PARAM] = applicationId;
        return $668b2310913a4fe8$var$repoInfoConnectionURL(repoInfo, $668b2310913a4fe8$var$WEBSOCKET, urlParams);
    }
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ open(onMessage, onDisconnect) {
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_('Websocket connecting to ' + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        $668b2310913a4fe8$var$PersistentStorage.set('previous_websocket_failure', true);
        try {
            let options;
            if ((0, $ffjl9.isNodeSdk)()) {
                const device = this.nodeAdmin ? 'AdminNode' : 'Node';
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                options = {
                    headers: {
                        'User-Agent': `Firebase/${$668b2310913a4fe8$var$PROTOCOL_VERSION}/${$668b2310913a4fe8$var$SDK_VERSION}/${$4TNnu.platform}/${device}`,
                        'X-Firebase-GMPID': this.applicationId || ''
                    }
                };
                // If using Node with admin creds, AppCheck-related checks are unnecessary.
                // Note that we send the credentials here even if they aren't admin credentials, which is
                // not a problem.
                // Note that this header is just used to bypass appcheck, and the token should still be sent
                // through the websocket connection once it is established.
                if (this.authToken) options.headers['Authorization'] = `Bearer ${this.authToken}`;
                if (this.appCheckToken) options.headers['X-Firebase-AppCheck'] = this.appCheckToken;
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                const env = {};
                const proxy = this.connURL.indexOf('wss://') === 0 ? env['HTTPS_PROXY'] || env['https_proxy'] : env['HTTP_PROXY'] || env['http_proxy'];
                if (proxy) options['proxy'] = {
                    origin: proxy
                };
            }
            this.mySock = new $668b2310913a4fe8$var$WebSocketImpl(this.connURL, [], options);
        } catch (e) {
            this.log_('Error instantiating WebSocket.');
            const error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
            return;
        }
        this.mySock.onopen = ()=>{
            this.log_('Websocket connected.');
            this.everConnected_ = true;
        };
        this.mySock.onclose = ()=>{
            this.log_('Websocket connection was disconnected.');
            this.mySock = null;
            this.onClosed_();
        };
        this.mySock.onmessage = (m)=>{
            this.handleIncomingFrame(m);
        };
        this.mySock.onerror = (e)=>{
            this.log_('WebSocket error.  Closing connection.');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
        };
    }
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */ start() {}
    static forceDisallow() {
        $668b2310913a4fe8$var$WebSocketConnection.forceDisallow_ = true;
    }
    static isAvailable() {
        let isOldAndroid = false;
        if (typeof navigator !== 'undefined' && navigator.userAgent) {
            const oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            const oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) isOldAndroid = true;
            }
        }
        return !isOldAndroid && $668b2310913a4fe8$var$WebSocketImpl !== null && !$668b2310913a4fe8$var$WebSocketConnection.forceDisallow_;
    }
    /**
     * Returns true if we previously failed to connect with this transport.
     */ static previouslyFailed() {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return $668b2310913a4fe8$var$PersistentStorage.isInMemoryStorage || $668b2310913a4fe8$var$PersistentStorage.get('previous_websocket_failure') === true;
    }
    markConnectionHealthy() {
        $668b2310913a4fe8$var$PersistentStorage.remove('previous_websocket_failure');
    }
    appendFrame_(data) {
        this.frames.push(data);
        if (this.frames.length === this.totalFrames) {
            const fullMess = this.frames.join('');
            this.frames = null;
            const jsonMess = (0, $ffjl9.jsonEval)(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    }
    /**
     * @param frameCount - The number of frames we are expecting from the server
     */ handleNewFrameCount_(frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    }
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @returns Any remaining data to be process, or null if there is none
     */ extractFrameCount_(data) {
        (0, $ffjl9.assert)(this.frames === null, 'We already have a frame buffer');
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            const frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    }
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess - The frame data
     */ handleIncomingFrame(mess) {
        if (this.mySock === null) return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        const data = mess['data'];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter('bytes_received', data.length);
        this.resetKeepAlive();
        if (this.frames !== null) // we're buffering
        this.appendFrame_(data);
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            const remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) this.appendFrame_(remainingData);
        }
    }
    /**
     * Send a message to the server
     * @param data - The JSON object to transmit
     */ send(data) {
        this.resetKeepAlive();
        const dataStr = (0, $ffjl9.stringify)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        const dataSegs = $668b2310913a4fe8$var$splitStringBySize(dataStr, $668b2310913a4fe8$var$WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) this.sendString_(String(dataSegs.length));
        //Send the actual data in segments.
        for(let i = 0; i < dataSegs.length; i++)this.sendString_(dataSegs[i]);
    }
    shutdown_() {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    }
    onClosed_() {
        if (!this.isClosed_) {
            this.log_('WebSocket is closing itself');
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    }
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */ close() {
        if (!this.isClosed_) {
            this.log_('WebSocket is being closed');
            this.shutdown_();
        }
    }
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */ resetKeepAlive() {
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(()=>{
            //If there has been no websocket activity for a while, send a no-op
            if (this.mySock) this.sendString_('0');
            this.resetKeepAlive();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($668b2310913a4fe8$var$WEBSOCKET_KEEPALIVE_INTERVAL));
    }
    /**
     * Send a string over the websocket.
     *
     * @param str - String to send.
     */ sendString_(str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        } catch (e) {
            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
            setTimeout(this.onClosed_.bind(this), 0);
        }
    }
}
/**
 * Number of response before we consider the connection "healthy."
 */ $668b2310913a4fe8$var$WebSocketConnection.responsesRequiredToBeHealthy = 2;
/**
 * Time to wait for the connection te become healthy before giving up.
 */ $668b2310913a4fe8$var$WebSocketConnection.healthyTimeout = 30000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 */ class $668b2310913a4fe8$var$TransportManager {
    /**
     * @param repoInfo - Metadata around the namespace we're connecting to
     */ constructor(repoInfo){
        this.initTransports_(repoInfo);
    }
    static get ALL_TRANSPORTS() {
        return [
            $668b2310913a4fe8$var$BrowserPollConnection,
            $668b2310913a4fe8$var$WebSocketConnection
        ];
    }
    /**
     * Returns whether transport has been selected to ensure WebSocketConnection or BrowserPollConnection are not called after
     * TransportManager has already set up transports_
     */ static get IS_TRANSPORT_INITIALIZED() {
        return this.globalTransportInitialized_;
    }
    initTransports_(repoInfo) {
        const isWebSocketsAvailable = $668b2310913a4fe8$var$WebSocketConnection && $668b2310913a4fe8$var$WebSocketConnection['isAvailable']();
        let isSkipPollConnection = isWebSocketsAvailable && !$668b2310913a4fe8$var$WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable) $668b2310913a4fe8$var$warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) this.transports_ = [
            $668b2310913a4fe8$var$WebSocketConnection
        ];
        else {
            const transports = this.transports_ = [];
            for (const transport of $668b2310913a4fe8$var$TransportManager.ALL_TRANSPORTS)if (transport && transport['isAvailable']()) transports.push(transport);
            $668b2310913a4fe8$var$TransportManager.globalTransportInitialized_ = true;
        }
    }
    /**
     * @returns The constructor for the initial transport to use
     */ initialTransport() {
        if (this.transports_.length > 0) return this.transports_[0];
        else throw new Error('No transports available');
    }
    /**
     * @returns The constructor for the next transport, or null
     */ upgradeTransport() {
        if (this.transports_.length > 1) return this.transports_[1];
        else return null;
    }
}
// Keeps track of whether the TransportManager has already chosen a transport to use
$668b2310913a4fe8$var$TransportManager.globalTransportInitialized_ = false;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Abort upgrade attempt if it takes longer than 60s.
const $668b2310913a4fe8$var$UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
const $668b2310913a4fe8$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
const $668b2310913a4fe8$var$BYTES_SENT_HEALTHY_OVERRIDE = 10240;
const $668b2310913a4fe8$var$BYTES_RECEIVED_HEALTHY_OVERRIDE = 102400;
const $668b2310913a4fe8$var$MESSAGE_TYPE = 't';
const $668b2310913a4fe8$var$MESSAGE_DATA = 'd';
const $668b2310913a4fe8$var$CONTROL_SHUTDOWN = 's';
const $668b2310913a4fe8$var$CONTROL_RESET = 'r';
const $668b2310913a4fe8$var$CONTROL_ERROR = 'e';
const $668b2310913a4fe8$var$CONTROL_PONG = 'o';
const $668b2310913a4fe8$var$SWITCH_ACK = 'a';
const $668b2310913a4fe8$var$END_TRANSMISSION = 'n';
const $668b2310913a4fe8$var$PING = 'p';
const $668b2310913a4fe8$var$SERVER_HELLO = 'h';
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 */ class $668b2310913a4fe8$var$Connection {
    /**
     * @param id - an id for this connection
     * @param repoInfo_ - the info for the endpoint to connect to
     * @param applicationId_ - the Firebase App ID for this project
     * @param appCheckToken_ - The App Check Token for this device.
     * @param authToken_ - The auth token for this session.
     * @param onMessage_ - the callback to be triggered when a server-push message arrives
     * @param onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param onDisconnect_ - the callback to be triggered when a connection was lost
     * @param onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */ constructor(id, repoInfo_, applicationId_, appCheckToken_, authToken_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId){
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.appCheckToken_ = appCheckToken_;
        this.authToken_ = authToken_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* RealtimeState.CONNECTING */ ;
        this.log_ = $668b2310913a4fe8$var$logWrapper('c:' + this.id + ':');
        this.transportManager_ = new $668b2310913a4fe8$var$TransportManager(repoInfo_);
        this.log_('Connection created');
        this.start_();
    }
    /**
     * Starts a connection attempt
     */ start_() {
        const conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, null, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        const onMessageReceived = this.connReceiver_(this.conn_);
        const onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */ setTimeout(()=>{
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            this.conn_ && this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        const healthyTimeoutMS = conn['healthyTimeout'] || 0;
        if (healthyTimeoutMS > 0) this.healthyTimeout_ = $668b2310913a4fe8$var$setTimeoutNonBlocking(()=>{
            this.healthyTimeout_ = null;
            if (!this.isHealthy_) {
                if (this.conn_ && this.conn_.bytesReceived > $668b2310913a4fe8$var$BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                    this.log_('Connection exceeded healthy timeout but has received ' + this.conn_.bytesReceived + ' bytes.  Marking connection healthy.');
                    this.isHealthy_ = true;
                    this.conn_.markConnectionHealthy();
                } else if (this.conn_ && this.conn_.bytesSent > $668b2310913a4fe8$var$BYTES_SENT_HEALTHY_OVERRIDE) this.log_('Connection exceeded healthy timeout but has sent ' + this.conn_.bytesSent + ' bytes.  Leaving connection alive.');
                else {
                    this.log_('Closing unhealthy connection after timeout.');
                    this.close();
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(healthyTimeoutMS));
    }
    nextTransportId_() {
        return 'c:' + this.id + ':' + this.connectionCount++;
    }
    disconnReceiver_(conn) {
        return (everConnected)=>{
            if (conn === this.conn_) this.onConnectionLost_(everConnected);
            else if (conn === this.secondaryConn_) {
                this.log_('Secondary connection lost.');
                this.onSecondaryConnectionLost_();
            } else this.log_('closing an old connection');
        };
    }
    connReceiver_(conn) {
        return (message)=>{
            if (this.state_ !== 2 /* RealtimeState.DISCONNECTED */ ) {
                if (conn === this.rx_) this.onPrimaryMessageReceived_(message);
                else if (conn === this.secondaryConn_) this.onSecondaryMessageReceived_(message);
                else this.log_('message on old connection');
            }
        };
    }
    /**
     * @param dataMsg - An arbitrary data message to be sent to the server
     */ sendRequest(dataMsg) {
        // wrap in a data message envelope and send it on
        const msg = {
            t: 'd',
            d: dataMsg
        };
        this.sendData_(msg);
    }
    tryCleanupConnection() {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
        // the server will shutdown the old connection
        }
    }
    onSecondaryControl_(controlData) {
        if ($668b2310913a4fe8$var$MESSAGE_TYPE in controlData) {
            const cmd = controlData[$668b2310913a4fe8$var$MESSAGE_TYPE];
            if (cmd === $668b2310913a4fe8$var$SWITCH_ACK) this.upgradeIfSecondaryHealthy_();
            else if (cmd === $668b2310913a4fe8$var$CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_('Got a reset on secondary, closing it');
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ || this.rx_ === this.secondaryConn_) this.close();
            } else if (cmd === $668b2310913a4fe8$var$CONTROL_PONG) {
                this.log_('got pong on secondary.');
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    }
    onSecondaryMessageReceived_(parsedData) {
        const layer = $668b2310913a4fe8$var$requireKey('t', parsedData);
        const data = $668b2310913a4fe8$var$requireKey('d', parsedData);
        if (layer === 'c') this.onSecondaryControl_(data);
        else if (layer === 'd') // got a data message, but we're still second connection. Need to buffer it up
        this.pendingDataMessages.push(data);
        else throw new Error('Unknown protocol layer: ' + layer);
    }
    upgradeIfSecondaryHealthy_() {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_('Secondary connection is healthy.');
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        } else {
            // Send a ping to make sure the connection is healthy.
            this.log_('sending ping on secondary.');
            this.secondaryConn_.send({
                t: 'c',
                d: {
                    t: $668b2310913a4fe8$var$PING,
                    d: {}
                }
            });
        }
    }
    proceedWithUpgrade_() {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_('sending client ack on secondary');
        this.secondaryConn_.send({
            t: 'c',
            d: {
                t: $668b2310913a4fe8$var$SWITCH_ACK,
                d: {}
            }
        });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_('Ending transmission on primary');
        this.conn_.send({
            t: 'c',
            d: {
                t: $668b2310913a4fe8$var$END_TRANSMISSION,
                d: {}
            }
        });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    }
    onPrimaryMessageReceived_(parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        const layer = $668b2310913a4fe8$var$requireKey('t', parsedData);
        const data = $668b2310913a4fe8$var$requireKey('d', parsedData);
        if (layer === 'c') this.onControl_(data);
        else if (layer === 'd') this.onDataMessage_(data);
    }
    onDataMessage_(message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    }
    onPrimaryResponse_() {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_('Primary connection is healthy.');
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    }
    onControl_(controlData) {
        const cmd = $668b2310913a4fe8$var$requireKey($668b2310913a4fe8$var$MESSAGE_TYPE, controlData);
        if ($668b2310913a4fe8$var$MESSAGE_DATA in controlData) {
            const payload = controlData[$668b2310913a4fe8$var$MESSAGE_DATA];
            if (cmd === $668b2310913a4fe8$var$SERVER_HELLO) {
                const handshakePayload = Object.assign({}, payload);
                if (this.repoInfo_.isUsingEmulator) // Upon connecting, the emulator will pass the hostname that it's aware of, but we prefer the user's set hostname via `connectDatabaseEmulator` over what the emulator passes.
                handshakePayload.h = this.repoInfo_.host;
                this.onHandshake_(handshakePayload);
            } else if (cmd === $668b2310913a4fe8$var$END_TRANSMISSION) {
                this.log_('recvd end transmission on primary');
                this.rx_ = this.secondaryConn_;
                for(let i = 0; i < this.pendingDataMessages.length; ++i)this.onDataMessage_(this.pendingDataMessages[i]);
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            } else if (cmd === $668b2310913a4fe8$var$CONTROL_SHUTDOWN) // This was previously the 'onKill' callback passed to the lower-level connection
            // payload in this case is the reason for the shutdown. Generally a human-readable error
            this.onConnectionShutdown_(payload);
            else if (cmd === $668b2310913a4fe8$var$CONTROL_RESET) // payload in this case is the host we should contact
            this.onReset_(payload);
            else if (cmd === $668b2310913a4fe8$var$CONTROL_ERROR) $668b2310913a4fe8$var$error('Server Error: ' + payload);
            else if (cmd === $668b2310913a4fe8$var$CONTROL_PONG) {
                this.log_('got pong on primary.');
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            } else $668b2310913a4fe8$var$error('Unknown control packet command: ' + cmd);
        }
    }
    /**
     * @param handshake - The handshake data returned from the server
     */ onHandshake_(handshake) {
        const timestamp = handshake.ts;
        const version = handshake.v;
        const host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.host = host;
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ === 0 /* RealtimeState.CONNECTING */ ) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if ($668b2310913a4fe8$var$PROTOCOL_VERSION !== version) $668b2310913a4fe8$var$warn('Protocol version mismatch detected');
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    }
    tryStartUpgrade_() {
        const conn = this.transportManager_.upgradeTransport();
        if (conn) this.startUpgrade_(conn);
    }
    startUpgrade_(conn) {
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        const onMessage = this.connReceiver_(this.secondaryConn_);
        const onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        $668b2310913a4fe8$var$setTimeoutNonBlocking(()=>{
            if (this.secondaryConn_) {
                this.log_('Timed out trying to upgrade.');
                this.secondaryConn_.close();
            }
        }, Math.floor($668b2310913a4fe8$var$UPGRADE_TIMEOUT));
    }
    onReset_(host) {
        this.log_('Reset packet received.  New host: ' + host);
        this.repoInfo_.host = host;
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* RealtimeState.CONNECTED */ ) this.close();
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    }
    onConnectionEstablished_(conn, timestamp) {
        this.log_('Realtime connection established.');
        this.conn_ = conn;
        this.state_ = 1 /* RealtimeState.CONNECTED */ ;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_('Primary connection is healthy.');
            this.isHealthy_ = true;
        } else $668b2310913a4fe8$var$setTimeoutNonBlocking(()=>{
            this.sendPingOnPrimaryIfNecessary_();
        }, Math.floor($668b2310913a4fe8$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
    }
    sendPingOnPrimaryIfNecessary_() {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* RealtimeState.CONNECTED */ ) {
            this.log_('sending ping on primary.');
            this.sendData_({
                t: 'c',
                d: {
                    t: $668b2310913a4fe8$var$PING,
                    d: {}
                }
            });
        }
    }
    onSecondaryConnectionLost_() {
        const conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) // we are relying on this connection already in some capacity. Therefore, a failure is real
        this.close();
    }
    /**
     * @param everConnected - Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     */ onConnectionLost_(everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* RealtimeState.CONNECTING */ ) {
            this.log_('Realtime connection failed.');
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                $668b2310913a4fe8$var$PersistentStorage.remove('host:' + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        } else if (this.state_ === 1 /* RealtimeState.CONNECTED */ ) this.log_('Realtime connection lost.');
        this.close();
    }
    onConnectionShutdown_(reason) {
        this.log_('Connection shutdown command received. Shutting down...');
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    }
    sendData_(data) {
        if (this.state_ !== 1 /* RealtimeState.CONNECTED */ ) throw 'Connection is not connected';
        else this.tx_.send(data);
    }
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */ close() {
        if (this.state_ !== 2 /* RealtimeState.DISCONNECTED */ ) {
            this.log_('Closing realtime connection.');
            this.state_ = 2 /* RealtimeState.DISCONNECTED */ ;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    }
    closeConnections_() {
        this.log_('Shutting down all connections');
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */ class $668b2310913a4fe8$var$ServerActions {
    put(pathString, data, onComplete, hash) {}
    merge(pathString, data, onComplete, hash) {}
    /**
     * Refreshes the auth token for the current connection.
     * @param token - The authentication token
     */ refreshAuthToken(token) {}
    /**
     * Refreshes the app check token for the current connection.
     * @param token The app check token
     */ refreshAppCheckToken(token) {}
    onDisconnectPut(pathString, data, onComplete) {}
    onDisconnectMerge(pathString, data, onComplete) {}
    onDisconnectCancel(pathString, onComplete) {}
    reportStats(stats) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */ class $668b2310913a4fe8$var$EventEmitter {
    constructor(allowedEvents_){
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        (0, $ffjl9.assert)(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
    }
    /**
     * To be called by derived classes to trigger events.
     */ trigger(eventType, ...varArgs) {
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            const listeners = [
                ...this.listeners_[eventType]
            ];
            for(let i = 0; i < listeners.length; i++)listeners[i].callback.apply(listeners[i].context, varArgs);
        }
    }
    on(eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({
            callback: callback,
            context: context
        });
        const eventData = this.getInitialEvent(eventType);
        if (eventData) callback.apply(context, eventData);
    }
    off(eventType, callback, context) {
        this.validateEventType_(eventType);
        const listeners = this.listeners_[eventType] || [];
        for(let i = 0; i < listeners.length; i++)if (listeners[i].callback === callback && (!context || context === listeners[i].context)) {
            listeners.splice(i, 1);
            return;
        }
    }
    validateEventType_(eventType) {
        (0, $ffjl9.assert)(this.allowedEvents_.find((et)=>{
            return et === eventType;
        }), 'Unknown event: ' + eventType);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 */ class $668b2310913a4fe8$var$OnlineMonitor extends $668b2310913a4fe8$var$EventEmitter {
    constructor(){
        super([
            'online'
        ]);
        this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined' && !(0, $ffjl9.isMobileCordova)()) {
            window.addEventListener('online', ()=>{
                if (!this.online_) {
                    this.online_ = true;
                    this.trigger('online', true);
                }
            }, false);
            window.addEventListener('offline', ()=>{
                if (this.online_) {
                    this.online_ = false;
                    this.trigger('online', false);
                }
            }, false);
        }
    }
    static getInstance() {
        return new $668b2310913a4fe8$var$OnlineMonitor();
    }
    getInitialEvent(eventType) {
        (0, $ffjl9.assert)(eventType === 'online', 'Unknown event type: ' + eventType);
        return [
            this.online_
        ];
    }
    currentlyOnline() {
        return this.online_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Maximum key depth. */ const $668b2310913a4fe8$var$MAX_PATH_DEPTH = 32;
/** Maximum number of (UTF8) bytes in a Firebase path. */ const $668b2310913a4fe8$var$MAX_PATH_LENGTH_BYTES = 768;
/**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */ class $668b2310913a4fe8$var$Path {
    /**
     * @param pathOrString - Path string to parse, or another path, or the raw
     * tokens array
     */ constructor(pathOrString, pieceNum){
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split('/');
            // Remove empty pieces.
            let copyTo = 0;
            for(let i = 0; i < this.pieces_.length; i++)if (this.pieces_[i].length > 0) {
                this.pieces_[copyTo] = this.pieces_[i];
                copyTo++;
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        } else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    toString() {
        let pathString = '';
        for(let i = this.pieceNum_; i < this.pieces_.length; i++)if (this.pieces_[i] !== '') pathString += '/' + this.pieces_[i];
        return pathString || '/';
    }
}
function $668b2310913a4fe8$var$newEmptyPath() {
    return new $668b2310913a4fe8$var$Path('');
}
function $668b2310913a4fe8$var$pathGetFront(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    return path.pieces_[path.pieceNum_];
}
/**
 * @returns The number of segments in this path
 */ function $668b2310913a4fe8$var$pathGetLength(path) {
    return path.pieces_.length - path.pieceNum_;
}
function $668b2310913a4fe8$var$pathPopFront(path) {
    let pieceNum = path.pieceNum_;
    if (pieceNum < path.pieces_.length) pieceNum++;
    return new $668b2310913a4fe8$var$Path(path.pieces_, pieceNum);
}
function $668b2310913a4fe8$var$pathGetBack(path) {
    if (path.pieceNum_ < path.pieces_.length) return path.pieces_[path.pieces_.length - 1];
    return null;
}
function $668b2310913a4fe8$var$pathToUrlEncodedString(path) {
    let pathString = '';
    for(let i = path.pieceNum_; i < path.pieces_.length; i++)if (path.pieces_[i] !== '') pathString += '/' + encodeURIComponent(String(path.pieces_[i]));
    return pathString || '/';
}
/**
 * Shallow copy of the parts of the path.
 *
 */ function $668b2310913a4fe8$var$pathSlice(path, begin = 0) {
    return path.pieces_.slice(path.pieceNum_ + begin);
}
function $668b2310913a4fe8$var$pathParent(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    const pieces = [];
    for(let i = path.pieceNum_; i < path.pieces_.length - 1; i++)pieces.push(path.pieces_[i]);
    return new $668b2310913a4fe8$var$Path(pieces, 0);
}
function $668b2310913a4fe8$var$pathChild(path, childPathObj) {
    const pieces = [];
    for(let i = path.pieceNum_; i < path.pieces_.length; i++)pieces.push(path.pieces_[i]);
    if (childPathObj instanceof $668b2310913a4fe8$var$Path) for(let i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++)pieces.push(childPathObj.pieces_[i]);
    else {
        const childPieces = childPathObj.split('/');
        for(let i = 0; i < childPieces.length; i++)if (childPieces[i].length > 0) pieces.push(childPieces[i]);
    }
    return new $668b2310913a4fe8$var$Path(pieces, 0);
}
/**
 * @returns True if there are no segments in this path
 */ function $668b2310913a4fe8$var$pathIsEmpty(path) {
    return path.pieceNum_ >= path.pieces_.length;
}
/**
 * @returns The path from outerPath to innerPath
 */ function $668b2310913a4fe8$var$newRelativePath(outerPath, innerPath) {
    const outer = $668b2310913a4fe8$var$pathGetFront(outerPath), inner = $668b2310913a4fe8$var$pathGetFront(innerPath);
    if (outer === null) return innerPath;
    else if (outer === inner) return $668b2310913a4fe8$var$newRelativePath($668b2310913a4fe8$var$pathPopFront(outerPath), $668b2310913a4fe8$var$pathPopFront(innerPath));
    else throw new Error('INTERNAL ERROR: innerPath (' + innerPath + ') is not within ' + 'outerPath (' + outerPath + ')');
}
/**
 * @returns -1, 0, 1 if left is less, equal, or greater than the right.
 */ function $668b2310913a4fe8$var$pathCompare(left, right) {
    const leftKeys = $668b2310913a4fe8$var$pathSlice(left, 0);
    const rightKeys = $668b2310913a4fe8$var$pathSlice(right, 0);
    for(let i = 0; i < leftKeys.length && i < rightKeys.length; i++){
        const cmp = $668b2310913a4fe8$var$nameCompare(leftKeys[i], rightKeys[i]);
        if (cmp !== 0) return cmp;
    }
    if (leftKeys.length === rightKeys.length) return 0;
    return leftKeys.length < rightKeys.length ? -1 : 1;
}
/**
 * @returns true if paths are the same.
 */ function $668b2310913a4fe8$var$pathEquals(path, other) {
    if ($668b2310913a4fe8$var$pathGetLength(path) !== $668b2310913a4fe8$var$pathGetLength(other)) return false;
    for(let i = path.pieceNum_, j = other.pieceNum_; i <= path.pieces_.length; i++, j++){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
    }
    return true;
}
/**
 * @returns True if this path is a parent of (or the same as) other
 */ function $668b2310913a4fe8$var$pathContains(path, other) {
    let i = path.pieceNum_;
    let j = other.pieceNum_;
    if ($668b2310913a4fe8$var$pathGetLength(path) > $668b2310913a4fe8$var$pathGetLength(other)) return false;
    while(i < path.pieces_.length){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
        ++i;
        ++j;
    }
    return true;
}
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */ class $668b2310913a4fe8$var$ValidationPath {
    /**
     * @param path - Initial Path.
     * @param errorPrefix_ - Prefix for any error messages.
     */ constructor(path, errorPrefix_){
        this.errorPrefix_ = errorPrefix_;
        this.parts_ = $668b2310913a4fe8$var$pathSlice(path, 0);
        /** Initialize to number of '/' chars needed in path. */ this.byteLength_ = Math.max(1, this.parts_.length);
        for(let i = 0; i < this.parts_.length; i++)this.byteLength_ += (0, $ffjl9.stringLength)(this.parts_[i]);
        $668b2310913a4fe8$var$validationPathCheckValid(this);
    }
}
function $668b2310913a4fe8$var$validationPathPush(validationPath, child) {
    // Count the needed '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ += 1;
    validationPath.parts_.push(child);
    validationPath.byteLength_ += (0, $ffjl9.stringLength)(child);
    $668b2310913a4fe8$var$validationPathCheckValid(validationPath);
}
function $668b2310913a4fe8$var$validationPathPop(validationPath) {
    const last = validationPath.parts_.pop();
    validationPath.byteLength_ -= (0, $ffjl9.stringLength)(last);
    // Un-count the previous '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ -= 1;
}
function $668b2310913a4fe8$var$validationPathCheckValid(validationPath) {
    if (validationPath.byteLength_ > $668b2310913a4fe8$var$MAX_PATH_LENGTH_BYTES) throw new Error(validationPath.errorPrefix_ + 'has a key path longer than ' + $668b2310913a4fe8$var$MAX_PATH_LENGTH_BYTES + ' bytes (' + validationPath.byteLength_ + ').');
    if (validationPath.parts_.length > $668b2310913a4fe8$var$MAX_PATH_DEPTH) throw new Error(validationPath.errorPrefix_ + 'path specified exceeds the maximum depth that can be written (' + $668b2310913a4fe8$var$MAX_PATH_DEPTH + ') or object contains a cycle ' + $668b2310913a4fe8$var$validationPathToErrorString(validationPath));
}
/**
 * String for use in error messages - uses '.' notation for path.
 */ function $668b2310913a4fe8$var$validationPathToErrorString(validationPath) {
    if (validationPath.parts_.length === 0) return '';
    return "in property '" + validationPath.parts_.join('.') + "'";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $668b2310913a4fe8$var$VisibilityMonitor extends $668b2310913a4fe8$var$EventEmitter {
    constructor(){
        super([
            'visible'
        ]);
        let hidden;
        let visibilityChange;
        if (typeof document !== 'undefined' && typeof document.addEventListener !== 'undefined') {
            if (typeof document['hidden'] !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = 'visibilitychange';
                hidden = 'hidden';
            } else if (typeof document['mozHidden'] !== 'undefined') {
                visibilityChange = 'mozvisibilitychange';
                hidden = 'mozHidden';
            } else if (typeof document['msHidden'] !== 'undefined') {
                visibilityChange = 'msvisibilitychange';
                hidden = 'msHidden';
            } else if (typeof document['webkitHidden'] !== 'undefined') {
                visibilityChange = 'webkitvisibilitychange';
                hidden = 'webkitHidden';
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        this.visible_ = true;
        if (visibilityChange) document.addEventListener(visibilityChange, ()=>{
            const visible = !document[hidden];
            if (visible !== this.visible_) {
                this.visible_ = visible;
                this.trigger('visible', visible);
            }
        }, false);
    }
    static getInstance() {
        return new $668b2310913a4fe8$var$VisibilityMonitor();
    }
    getInitialEvent(eventType) {
        (0, $ffjl9.assert)(eventType === 'visible', 'Unknown event type: ' + eventType);
        return [
            this.visible_
        ];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $668b2310913a4fe8$var$RECONNECT_MIN_DELAY = 1000;
const $668b2310913a4fe8$var$RECONNECT_MAX_DELAY_DEFAULT = 300000; // 5 minutes in milliseconds (Case: 1858)
const $668b2310913a4fe8$var$RECONNECT_MAX_DELAY_FOR_ADMINS = 30000; // 30 seconds for admin clients (likely to be a backend server)
const $668b2310913a4fe8$var$RECONNECT_DELAY_MULTIPLIER = 1.3;
const $668b2310913a4fe8$var$RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
const $668b2310913a4fe8$var$SERVER_KILL_INTERRUPT_REASON = 'server_kill';
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
const $668b2310913a4fe8$var$INVALID_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */ class $668b2310913a4fe8$var$PersistentConnection extends $668b2310913a4fe8$var$ServerActions {
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param applicationId_ - The Firebase App ID for this project
     * @param onDataUpdate_ - A callback for new data from the server
     */ constructor(repoInfo_, applicationId_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, appCheckTokenProvider_, authOverride_){
        super();
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.onDataUpdate_ = onDataUpdate_;
        this.onConnectStatus_ = onConnectStatus_;
        this.onServerInfoUpdate_ = onServerInfoUpdate_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckTokenProvider_ = appCheckTokenProvider_;
        this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        this.id = $668b2310913a4fe8$var$PersistentConnection.nextPersistentConnectionId_++;
        this.log_ = $668b2310913a4fe8$var$logWrapper('p:' + this.id + ':');
        this.interruptReasons_ = {};
        this.listens = new Map();
        this.outstandingPuts_ = [];
        this.outstandingGets_ = [];
        this.outstandingPutCount_ = 0;
        this.outstandingGetCount_ = 0;
        this.onDisconnectRequestQueue_ = [];
        this.connected_ = false;
        this.reconnectDelay_ = $668b2310913a4fe8$var$RECONNECT_MIN_DELAY;
        this.maxReconnectDelay_ = $668b2310913a4fe8$var$RECONNECT_MAX_DELAY_DEFAULT;
        this.securityDebugCallback_ = null;
        this.lastSessionId = null;
        this.establishConnectionTimer_ = null;
        this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        this.requestCBHash_ = {};
        this.requestNumber_ = 0;
        this.realtime_ = null;
        this.authToken_ = null;
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = false;
        this.invalidAuthTokenCount_ = 0;
        this.invalidAppCheckTokenCount_ = 0;
        this.firstConnection_ = true;
        this.lastConnectionAttemptTime_ = null;
        this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !(0, $ffjl9.isNodeSdk)()) throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
        $668b2310913a4fe8$var$VisibilityMonitor.getInstance().on('visible', this.onVisible_, this);
        if (repoInfo_.host.indexOf('fblocal') === -1) $668b2310913a4fe8$var$OnlineMonitor.getInstance().on('online', this.onOnline_, this);
    }
    sendRequest(action, body, onResponse) {
        const curReqNum = ++this.requestNumber_;
        const msg = {
            r: curReqNum,
            a: action,
            b: body
        };
        this.log_((0, $ffjl9.stringify)(msg));
        (0, $ffjl9.assert)(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) this.requestCBHash_[curReqNum] = onResponse;
    }
    get(query) {
        this.initConnection_();
        const deferred = new (0, $ffjl9.Deferred)();
        const request = {
            p: query._path.toString(),
            q: query._queryObject
        };
        const outstandingGet = {
            action: 'g',
            request: request,
            onComplete: (message)=>{
                const payload = message['d'];
                if (message['s'] === 'ok') deferred.resolve(payload);
                else deferred.reject(payload);
            }
        };
        this.outstandingGets_.push(outstandingGet);
        this.outstandingGetCount_++;
        const index = this.outstandingGets_.length - 1;
        if (this.connected_) this.sendGet_(index);
        return deferred.promise;
    }
    listen(query, currentHashFn, tag, onComplete) {
        this.initConnection_();
        const queryId = query._queryIdentifier;
        const pathString = query._path.toString();
        this.log_('Listen called for ' + pathString + ' ' + queryId);
        if (!this.listens.has(pathString)) this.listens.set(pathString, new Map());
        (0, $ffjl9.assert)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), 'listen() called for non-default but complete query');
        (0, $ffjl9.assert)(!this.listens.get(pathString).has(queryId), `listen() called twice for same path/queryId.`);
        const listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens.get(pathString).set(queryId, listenSpec);
        if (this.connected_) this.sendListen_(listenSpec);
    }
    sendGet_(index) {
        const get = this.outstandingGets_[index];
        this.sendRequest('g', get.request, (message)=>{
            delete this.outstandingGets_[index];
            this.outstandingGetCount_--;
            if (this.outstandingGetCount_ === 0) this.outstandingGets_ = [];
            if (get.onComplete) get.onComplete(message);
        });
    }
    sendListen_(listenSpec) {
        const query = listenSpec.query;
        const pathString = query._path.toString();
        const queryId = query._queryIdentifier;
        this.log_('Listen on ' + pathString + ' for ' + queryId);
        const req = {
            p: pathString
        };
        const action = 'q';
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req['q'] = query._queryObject;
            req['t'] = listenSpec.tag;
        }
        req[/*hash*/ 'h'] = listenSpec.hashFn();
        this.sendRequest(action, req, (message)=>{
            const payload = message[/*data*/ 'd'];
            const status = message[/*status*/ 's'];
            // print warnings in any case...
            $668b2310913a4fe8$var$PersistentConnection.warnOnListenWarnings_(payload, query);
            const currentListenSpec = this.listens.get(pathString) && this.listens.get(pathString).get(queryId);
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                this.log_('listen response', message);
                if (status !== 'ok') this.removeListen_(pathString, queryId);
                if (listenSpec.onComplete) listenSpec.onComplete(status, payload);
            }
        });
    }
    static warnOnListenWarnings_(payload, query) {
        if (payload && typeof payload === 'object' && (0, $ffjl9.contains)(payload, 'w')) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const warnings = (0, $ffjl9.safeGet)(payload, 'w');
            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
                const indexSpec = '".indexOn": "' + query._queryParams.getIndex().toString() + '"';
                const indexPath = query._path.toString();
                $668b2310913a4fe8$var$warn(`Using an unspecified index. Your data will be downloaded and ` + `filtered on the client. Consider adding ${indexSpec} at ` + `${indexPath} to your security rules for better performance.`);
            }
        }
    }
    refreshAuthToken(token) {
        this.authToken_ = token;
        this.log_('Auth token refreshed');
        if (this.authToken_) this.tryAuth();
        else //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
        //the credential so we dont become authenticated next time we connect.
        if (this.connected_) this.sendRequest('unauth', {}, ()=>{});
        this.reduceReconnectDelayIfAdminCredential_(token);
    }
    reduceReconnectDelayIfAdminCredential_(credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        const isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || (0, $ffjl9.isAdmin)(credential)) {
            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
            this.maxReconnectDelay_ = $668b2310913a4fe8$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    }
    refreshAppCheckToken(token) {
        this.appCheckToken_ = token;
        this.log_('App check token refreshed');
        if (this.appCheckToken_) this.tryAppCheck();
        else //If we're connected we want to let the server know to unauthenticate us.
        //If we're not connected, simply delete the credential so we dont become
        // authenticated next time we connect.
        if (this.connected_) this.sendRequest('unappeck', {}, ()=>{});
    }
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */ tryAuth() {
        if (this.connected_ && this.authToken_) {
            const token = this.authToken_;
            const authMethod = (0, $ffjl9.isValidFormat)(token) ? 'auth' : 'gauth';
            const requestData = {
                cred: token
            };
            if (this.authOverride_ === null) requestData['noauth'] = true;
            else if (typeof this.authOverride_ === 'object') requestData['authvar'] = this.authOverride_;
            this.sendRequest(authMethod, requestData, (res)=>{
                const status = res[/*status*/ 's'];
                const data = res[/*data*/ 'd'] || 'error';
                if (this.authToken_ === token) {
                    if (status === 'ok') this.invalidAuthTokenCount_ = 0;
                    else // Triggers reconnect and force refresh for auth token
                    this.onAuthRevoked_(status, data);
                }
            });
        }
    }
    /**
     * Attempts to authenticate with the given token. If the authentication
     * attempt fails, it's triggered like the token was revoked (the connection is
     * closed).
     */ tryAppCheck() {
        if (this.connected_ && this.appCheckToken_) this.sendRequest('appcheck', {
            'token': this.appCheckToken_
        }, (res)=>{
            const status = res[/*status*/ 's'];
            const data = res[/*data*/ 'd'] || 'error';
            if (status === 'ok') this.invalidAppCheckTokenCount_ = 0;
            else this.onAppCheckRevoked_(status, data);
        });
    }
    /**
     * @inheritDoc
     */ unlisten(query, tag) {
        const pathString = query._path.toString();
        const queryId = query._queryIdentifier;
        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
        (0, $ffjl9.assert)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), 'unlisten() called for non-default but complete query');
        const listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) this.sendUnlisten_(pathString, queryId, query._queryObject, tag);
    }
    sendUnlisten_(pathString, queryId, queryObj, tag) {
        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
        const req = {
            p: pathString
        };
        const action = 'n';
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req['q'] = queryObj;
            req['t'] = tag;
        }
        this.sendRequest(action, req);
    }
    onDisconnectPut(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('o', pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'o',
            data: data,
            onComplete: onComplete
        });
    }
    onDisconnectMerge(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('om', pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'om',
            data: data,
            onComplete: onComplete
        });
    }
    onDisconnectCancel(pathString, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('oc', pathString, null, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'oc',
            data: null,
            onComplete: onComplete
        });
    }
    sendOnDisconnect_(action, pathString, data, onComplete) {
        const request = {
            p: pathString,
            /*data*/ d: data
        };
        this.log_('onDisconnect ' + action, request);
        this.sendRequest(action, request, (response)=>{
            if (onComplete) setTimeout(()=>{
                onComplete(response[/*status*/ 's'], response[/* data */ 'd']);
            }, Math.floor(0));
        });
    }
    put(pathString, data, onComplete, hash) {
        this.putInternal('p', pathString, data, onComplete, hash);
    }
    merge(pathString, data, onComplete, hash) {
        this.putInternal('m', pathString, data, onComplete, hash);
    }
    putInternal(action, pathString, data, onComplete, hash) {
        this.initConnection_();
        const request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined) request[/*hash*/ 'h'] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        const index = this.outstandingPuts_.length - 1;
        if (this.connected_) this.sendPut_(index);
        else this.log_('Buffering put: ' + pathString);
    }
    sendPut_(index) {
        const action = this.outstandingPuts_[index].action;
        const request = this.outstandingPuts_[index].request;
        const onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, (message)=>{
            this.log_(action + ' response', message);
            delete this.outstandingPuts_[index];
            this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
            if (onComplete) onComplete(message[/*status*/ 's'], message[/* data */ 'd']);
        });
    }
    reportStats(stats) {
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            const request = {
                c: stats
            };
            this.log_('reportStats', request);
            this.sendRequest(/*stats*/ 's', request, (result)=>{
                const status = result[/*status*/ 's'];
                if (status !== 'ok') {
                    const errorReason = result[/* data */ 'd'];
                    this.log_('reportStats', 'Error sending stats: ' + errorReason);
                }
            });
        }
    }
    onDataMessage_(message) {
        if ('r' in message) {
            // this is a response
            this.log_('from server: ' + (0, $ffjl9.stringify)(message));
            const reqNum = message['r'];
            const onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message[/*body*/ 'b']);
            }
        } else if ('error' in message) throw 'A server-side error has occurred: ' + message['error'];
        else if ('a' in message) // a and b are action and body, respectively
        this.onDataPush_(message['a'], message['b']);
    }
    onDataPush_(action, body) {
        this.log_('handleServerMessage', action, body);
        if (action === 'd') this.onDataUpdate_(body[/*path*/ 'p'], body[/*data*/ 'd'], /*isMerge*/ false, body['t']);
        else if (action === 'm') this.onDataUpdate_(body[/*path*/ 'p'], body[/*data*/ 'd'], /*isMerge=*/ true, body['t']);
        else if (action === 'c') this.onListenRevoked_(body[/*path*/ 'p'], body[/*query*/ 'q']);
        else if (action === 'ac') this.onAuthRevoked_(body[/*status code*/ 's'], body[/* explanation */ 'd']);
        else if (action === 'apc') this.onAppCheckRevoked_(body[/*status code*/ 's'], body[/* explanation */ 'd']);
        else if (action === 'sd') this.onSecurityDebugPacket_(body);
        else $668b2310913a4fe8$var$error('Unrecognized action received from server: ' + (0, $ffjl9.stringify)(action) + '\nAre you using the latest client?');
    }
    onReady_(timestamp, sessionId) {
        this.log_('connection ready');
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) this.sendConnectStats_();
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    }
    scheduleConnect_(timeout) {
        (0, $ffjl9.assert)(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) clearTimeout(this.establishConnectionTimer_);
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(()=>{
            this.establishConnectionTimer_ = null;
            this.establishConnection_();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(timeout));
    }
    initConnection_() {
        if (!this.realtime_ && this.firstConnection_) this.scheduleConnect_(0);
    }
    onVisible_(visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible && !this.visible_ && this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_('Window became visible.  Reducing delay.');
            this.reconnectDelay_ = $668b2310913a4fe8$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
        this.visible_ = visible;
    }
    onOnline_(online) {
        if (online) {
            this.log_('Browser went online.');
            this.reconnectDelay_ = $668b2310913a4fe8$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        } else {
            this.log_('Browser went offline.  Killing connection.');
            if (this.realtime_) this.realtime_.close();
        }
    }
    onRealtimeDisconnect_() {
        this.log_('data client disconnected');
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            } else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                const timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > $668b2310913a4fe8$var$RECONNECT_DELAY_RESET_TIMEOUT) this.reconnectDelay_ = $668b2310913a4fe8$var$RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            const timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
            let reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * $668b2310913a4fe8$var$RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    }
    async establishConnection_() {
        if (this.shouldReconnect_()) {
            this.log_('Making a connection attempt');
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            const onDataMessage = this.onDataMessage_.bind(this);
            const onReady = this.onReady_.bind(this);
            const onDisconnect = this.onRealtimeDisconnect_.bind(this);
            const connId = this.id + ':' + $668b2310913a4fe8$var$PersistentConnection.nextConnectionId_++;
            const lastSessionId = this.lastSessionId;
            let canceled = false;
            let connection = null;
            const closeFn = function() {
                if (connection) connection.close();
                else {
                    canceled = true;
                    onDisconnect();
                }
            };
            const sendRequestFn = function(msg) {
                (0, $ffjl9.assert)(connection, "sendRequest call when we're not connected not allowed.");
                connection.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn,
                sendRequest: sendRequestFn
            };
            const forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            try {
                // First fetch auth and app check token, and establish connection after
                // fetching the token was successful
                const [authToken, appCheckToken] = await Promise.all([
                    this.authTokenProvider_.getToken(forceRefresh),
                    this.appCheckTokenProvider_.getToken(forceRefresh)
                ]);
                if (!canceled) {
                    $668b2310913a4fe8$var$log('getToken() completed. Creating connection.');
                    this.authToken_ = authToken && authToken.accessToken;
                    this.appCheckToken_ = appCheckToken && appCheckToken.token;
                    connection = new $668b2310913a4fe8$var$Connection(connId, this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, onDataMessage, onReady, onDisconnect, /* onKill= */ (reason)=>{
                        $668b2310913a4fe8$var$warn(reason + ' (' + this.repoInfo_.toString() + ')');
                        this.interrupt($668b2310913a4fe8$var$SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId);
                } else $668b2310913a4fe8$var$log('getToken() completed but was canceled');
            } catch (error) {
                this.log_('Failed to get token: ' + error);
                if (!canceled) {
                    if (this.repoInfo_.nodeAdmin) // This may be a critical error for the Admin Node.js SDK, so log a warning.
                    // But getToken() may also just have temporarily failed, so we still want to
                    // continue retrying.
                    $668b2310913a4fe8$var$warn(error);
                    closeFn();
                }
            }
        }
    }
    interrupt(reason) {
        $668b2310913a4fe8$var$log('Interrupting connection for reason: ' + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) this.realtime_.close();
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) this.onRealtimeDisconnect_();
        }
    }
    resume(reason) {
        $668b2310913a4fe8$var$log('Resuming connection for reason: ' + reason);
        delete this.interruptReasons_[reason];
        if ((0, $ffjl9.isEmpty)(this.interruptReasons_)) {
            this.reconnectDelay_ = $668b2310913a4fe8$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
    }
    handleTimestamp_(timestamp) {
        const delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({
            serverTimeOffset: delta
        });
    }
    cancelSentTransactions_() {
        for(let i = 0; i < this.outstandingPuts_.length; i++){
            const put = this.outstandingPuts_[i];
            if (put && /*hash*/ 'h' in put.request && put.queued) {
                if (put.onComplete) put.onComplete('disconnect');
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
    }
    onListenRevoked_(pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        let queryId;
        if (!query) queryId = 'default';
        else queryId = query.map((q)=>$668b2310913a4fe8$var$ObjectToUniqueKey(q)).join('$');
        const listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete) listen.onComplete('permission_denied');
    }
    removeListen_(pathString, queryId) {
        const normalizedPathString = new $668b2310913a4fe8$var$Path(pathString).toString(); // normalize path.
        let listen;
        if (this.listens.has(normalizedPathString)) {
            const map = this.listens.get(normalizedPathString);
            listen = map.get(queryId);
            map.delete(queryId);
            if (map.size === 0) this.listens.delete(normalizedPathString);
        } else // all listens for this path has already been removed
        listen = undefined;
        return listen;
    }
    onAuthRevoked_(statusCode, explanation) {
        $668b2310913a4fe8$var$log('Auth token revoked: ' + statusCode + '/' + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= $668b2310913a4fe8$var$INVALID_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = $668b2310913a4fe8$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    }
    onAppCheckRevoked_(statusCode, explanation) {
        $668b2310913a4fe8$var$log('App check token revoked: ' + statusCode + '/' + explanation);
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = true;
        // Note: We don't close the connection as the developer may not have
        // enforcement enabled. The backend closes connections with enforcements.
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAppCheckTokenCount_++;
            if (this.invalidAppCheckTokenCount_ >= $668b2310913a4fe8$var$INVALID_TOKEN_THRESHOLD) this.appCheckTokenProvider_.notifyForInvalidToken();
        }
    }
    onSecurityDebugPacket_(body) {
        if (this.securityDebugCallback_) this.securityDebugCallback_(body);
        else if ('msg' in body) console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
    }
    restoreState_() {
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        this.tryAppCheck();
        // Puts depend on having received the corresponding data update from the server before they complete, so we must
        // make sure to send listens before puts.
        for (const queries of this.listens.values())for (const listenSpec of queries.values())this.sendListen_(listenSpec);
        for(let i = 0; i < this.outstandingPuts_.length; i++)if (this.outstandingPuts_[i]) this.sendPut_(i);
        while(this.onDisconnectRequestQueue_.length){
            const request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
        for(let i = 0; i < this.outstandingGets_.length; i++)if (this.outstandingGets_[i]) this.sendGet_(i);
    }
    /**
     * Sends client stats for first connection
     */ sendConnectStats_() {
        const stats = {};
        let clientName = 'js';
        if ((0, $ffjl9.isNodeSdk)()) {
            if (this.repoInfo_.nodeAdmin) clientName = 'admin_node';
            else clientName = 'node';
        }
        stats['sdk.' + clientName + '.' + $668b2310913a4fe8$var$SDK_VERSION.replace(/\./g, '-')] = 1;
        if ((0, $ffjl9.isMobileCordova)()) stats['framework.cordova'] = 1;
        else if ((0, $ffjl9.isReactNative)()) stats['framework.reactnative'] = 1;
        this.reportStats(stats);
    }
    shouldReconnect_() {
        const online = $668b2310913a4fe8$var$OnlineMonitor.getInstance().currentlyOnline();
        return (0, $ffjl9.isEmpty)(this.interruptReasons_) && online;
    }
}
$668b2310913a4fe8$var$PersistentConnection.nextPersistentConnectionId_ = 0;
/**
 * Counter for number of connections created. Mainly used for tagging in the logs
 */ $668b2310913a4fe8$var$PersistentConnection.nextConnectionId_ = 0;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $668b2310913a4fe8$var$NamedNode {
    constructor(name, node){
        this.name = name;
        this.node = node;
    }
    static Wrap(name, node) {
        return new $668b2310913a4fe8$var$NamedNode(name, node);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $668b2310913a4fe8$var$Index {
    /**
     * @returns A standalone comparison function for
     * this index
     */ getCompare() {
        return this.compare.bind(this);
    }
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     *
     * @returns True if the portion of the snapshot being indexed changed between oldNode and newNode
     */ indexedValueChanged(oldNode, newNode) {
        const oldWrapped = new $668b2310913a4fe8$var$NamedNode($668b2310913a4fe8$var$MIN_NAME, oldNode);
        const newWrapped = new $668b2310913a4fe8$var$NamedNode($668b2310913a4fe8$var$MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    }
    /**
     * @returns a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */ minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $668b2310913a4fe8$var$NamedNode.MIN;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $668b2310913a4fe8$var$__EMPTY_NODE;
class $668b2310913a4fe8$var$KeyIndex extends $668b2310913a4fe8$var$Index {
    static get __EMPTY_NODE() {
        return $668b2310913a4fe8$var$__EMPTY_NODE;
    }
    static set __EMPTY_NODE(val) {
        $668b2310913a4fe8$var$__EMPTY_NODE = val;
    }
    compare(a, b) {
        return $668b2310913a4fe8$var$nameCompare(a.name, b.name);
    }
    isDefinedOn(node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw (0, $ffjl9.assertionError)('KeyIndex.isDefinedOn not expected to be called.');
    }
    indexedValueChanged(oldNode, newNode) {
        return false; // The key for a node never changes.
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $668b2310913a4fe8$var$NamedNode.MIN;
    }
    maxPost() {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new $668b2310913a4fe8$var$NamedNode($668b2310913a4fe8$var$MAX_NAME, $668b2310913a4fe8$var$__EMPTY_NODE);
    }
    makePost(indexValue, name) {
        (0, $ffjl9.assert)(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new $668b2310913a4fe8$var$NamedNode(indexValue, $668b2310913a4fe8$var$__EMPTY_NODE);
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.key';
    }
}
const $668b2310913a4fe8$var$KEY_INDEX = new $668b2310913a4fe8$var$KeyIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An iterator over an LLRBNode.
 */ class $668b2310913a4fe8$var$SortedMapIterator {
    /**
     * @param node - Node to iterate.
     * @param isReverse_ - Whether or not to iterate in reverse
     */ constructor(node, startKey, comparator, isReverse_, resultGenerator_ = null){
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        this.nodeStack_ = [];
        let cmp = 1;
        while(!node.isEmpty()){
            node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_) cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) node = node.left;
                else node = node.right;
            } else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            } else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) node = node.right;
                else node = node.left;
            }
        }
    }
    getNext() {
        if (this.nodeStack_.length === 0) return null;
        let node = this.nodeStack_.pop();
        let result;
        if (this.resultGenerator_) result = this.resultGenerator_(node.key, node.value);
        else result = {
            key: node.key,
            value: node.value
        };
        if (this.isReverse_) {
            node = node.left;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.right;
            }
        } else {
            node = node.right;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    }
    hasNext() {
        return this.nodeStack_.length > 0;
    }
    peek() {
        if (this.nodeStack_.length === 0) return null;
        const node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) return this.resultGenerator_(node.key, node.value);
        else return {
            key: node.key,
            value: node.value
        };
    }
}
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */ class $668b2310913a4fe8$var$LLRBNode {
    /**
     * @param key - Key associated with this node.
     * @param value - Value associated with this node.
     * @param color - Whether this node is red.
     * @param left - Left child.
     * @param right - Right child.
     */ constructor(key, value, color, left, right){
        this.key = key;
        this.value = value;
        this.color = color != null ? color : $668b2310913a4fe8$var$LLRBNode.RED;
        this.left = left != null ? left : $668b2310913a4fe8$var$SortedMap.EMPTY_NODE;
        this.right = right != null ? right : $668b2310913a4fe8$var$SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param key - New key for the node, or null.
     * @param value - New value for the node, or null.
     * @param color - New color for the node, or null.
     * @param left - New left child for the node, or null.
     * @param right - New right child for the node, or null.
     * @returns The node copy.
     */ copy(key, value, color, left, right) {
        return new $668b2310913a4fe8$var$LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    }
    /**
     * @returns The total number of nodes in the tree.
     */ count() {
        return this.left.count() + 1 + this.right.count();
    }
    /**
     * @returns True if the tree is empty.
     */ isEmpty() {
        return false;
    }
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ inorderTraversal(action) {
        return this.left.inorderTraversal(action) || !!action(this.key, this.value) || this.right.inorderTraversal(action);
    }
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ reverseTraversal(action) {
        return this.right.reverseTraversal(action) || action(this.key, this.value) || this.left.reverseTraversal(action);
    }
    /**
     * @returns The minimum node in the tree.
     */ min_() {
        if (this.left.isEmpty()) return this;
        else return this.left.min_();
    }
    /**
     * @returns The maximum key in the tree.
     */ minKey() {
        return this.min_().key;
    }
    /**
     * @returns The maximum key in the tree.
     */ maxKey() {
        if (this.right.isEmpty()) return this.key;
        else return this.right.maxKey();
    }
    /**
     * @param key - Key to insert.
     * @param value - Value to insert.
     * @param comparator - Comparator.
     * @returns New tree, with the key/value added.
     */ insert(key, value, comparator) {
        let n = this;
        const cmp = comparator(key, n.key);
        if (cmp < 0) n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        else if (cmp === 0) n = n.copy(null, value, null, null, null);
        else n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        return n.fixUp_();
    }
    /**
     * @returns New tree, with the minimum key removed.
     */ removeMin_() {
        if (this.left.isEmpty()) return $668b2310913a4fe8$var$SortedMap.EMPTY_NODE;
        let n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    }
    /**
     * @param key - The key of the item to remove.
     * @param comparator - Comparator.
     * @returns New tree, with the specified item removed.
     */ remove(key, comparator) {
        let n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        } else {
            if (n.left.isRed_()) n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) n = n.moveRedRight_();
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) return $668b2310913a4fe8$var$SortedMap.EMPTY_NODE;
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    }
    /**
     * @returns Whether this is a RED node.
     */ isRed_() {
        return this.color;
    }
    /**
     * @returns New tree after performing any needed rotations.
     */ fixUp_() {
        let n = this;
        if (n.right.isRed_() && !n.left.isRed_()) n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_()) n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_()) n = n.colorFlip_();
        return n;
    }
    /**
     * @returns New tree, after moveRedLeft.
     */ moveRedLeft_() {
        let n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    }
    /**
     * @returns New tree, after moveRedRight.
     */ moveRedRight_() {
        let n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    }
    /**
     * @returns New tree, after rotateLeft.
     */ rotateLeft_() {
        const nl = this.copy(null, null, $668b2310913a4fe8$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    }
    /**
     * @returns New tree, after rotateRight.
     */ rotateRight_() {
        const nr = this.copy(null, null, $668b2310913a4fe8$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    }
    /**
     * @returns Newt ree, after colorFlip.
     */ colorFlip_() {
        const left = this.left.copy(null, null, !this.left.color, null, null);
        const right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    }
    /**
     * For testing.
     *
     * @returns True if all is well.
     */ checkMaxDepth_() {
        const blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    }
    check_() {
        if (this.isRed_() && this.left.isRed_()) throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
        if (this.right.isRed_()) throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
        const blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) throw new Error('Black depths differ');
        else return blackDepth + (this.isRed_() ? 0 : 1);
    }
}
$668b2310913a4fe8$var$LLRBNode.RED = true;
$668b2310913a4fe8$var$LLRBNode.BLACK = false;
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */ class $668b2310913a4fe8$var$LLRBEmptyNode {
    /**
     * Returns a copy of the current node.
     *
     * @returns The node copy.
     */ copy(key, value, color, left, right) {
        return this;
    }
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @param comparator - Comparator.
     * @returns New tree, with item added.
     */ insert(key, value, comparator) {
        return new $668b2310913a4fe8$var$LLRBNode(key, value, null);
    }
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param key - The key to remove.
     * @param comparator - Comparator.
     * @returns New tree, with item removed.
     */ remove(key, comparator) {
        return this;
    }
    /**
     * @returns The total number of nodes in the tree.
     */ count() {
        return 0;
    }
    /**
     * @returns True if the tree is empty.
     */ isEmpty() {
        return true;
    }
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ inorderTraversal(action) {
        return false;
    }
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ reverseTraversal(action) {
        return false;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    check_() {
        return 0;
    }
    /**
     * @returns Whether this node is red.
     */ isRed_() {
        return false;
    }
}
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */ class $668b2310913a4fe8$var$SortedMap {
    /**
     * @param comparator_ - Key comparator.
     * @param root_ - Optional root node for the map.
     */ constructor(comparator_, root_ = $668b2310913a4fe8$var$SortedMap.EMPTY_NODE){
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @returns New map, with item added.
     */ insert(key, value) {
        return new $668b2310913a4fe8$var$SortedMap(this.comparator_, this.root_.insert(key, value, this.comparator_).copy(null, null, $668b2310913a4fe8$var$LLRBNode.BLACK, null, null));
    }
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param key - The key to remove.
     * @returns New map, with item removed.
     */ remove(key) {
        return new $668b2310913a4fe8$var$SortedMap(this.comparator_, this.root_.remove(key, this.comparator_).copy(null, null, $668b2310913a4fe8$var$LLRBNode.BLACK, null, null));
    }
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param key - The key to look up.
     * @returns The value of the node with the given key, or null if the
     * key doesn't exist.
     */ get(key) {
        let cmp;
        let node = this.root_;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) return node.value;
            else if (cmp < 0) node = node.left;
            else if (cmp > 0) node = node.right;
        }
        return null;
    }
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param key - The key to find the predecessor of
     * @returns The predecessor key.
     */ getPredecessorKey(key) {
        let cmp, node = this.root_, rightParent = null;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while(!node.right.isEmpty())node = node.right;
                    return node.key;
                } else if (rightParent) return rightParent.key;
                else return null; // first item.
            } else if (cmp < 0) node = node.left;
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
    }
    /**
     * @returns True if the map is empty.
     */ isEmpty() {
        return this.root_.isEmpty();
    }
    /**
     * @returns The total number of nodes in the map.
     */ count() {
        return this.root_.count();
    }
    /**
     * @returns The minimum key in the map.
     */ minKey() {
        return this.root_.minKey();
    }
    /**
     * @returns The maximum key in the map.
     */ maxKey() {
        return this.root_.maxKey();
    }
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ inorderTraversal(action) {
        return this.root_.inorderTraversal(action);
    }
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns True if the traversal was aborted.
     */ reverseTraversal(action) {
        return this.root_.reverseTraversal(action);
    }
    /**
     * Returns an iterator over the SortedMap.
     * @returns The iterator.
     */ getIterator(resultGenerator) {
        return new $668b2310913a4fe8$var$SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    }
    getIteratorFrom(key, resultGenerator) {
        return new $668b2310913a4fe8$var$SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    }
    getReverseIteratorFrom(key, resultGenerator) {
        return new $668b2310913a4fe8$var$SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    }
    getReverseIterator(resultGenerator) {
        return new $668b2310913a4fe8$var$SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    }
}
/**
 * Always use the same empty node, to reduce memory.
 */ $668b2310913a4fe8$var$SortedMap.EMPTY_NODE = new $668b2310913a4fe8$var$LLRBEmptyNode();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $668b2310913a4fe8$var$NAME_ONLY_COMPARATOR(left, right) {
    return $668b2310913a4fe8$var$nameCompare(left.name, right.name);
}
function $668b2310913a4fe8$var$NAME_COMPARATOR(left, right) {
    return $668b2310913a4fe8$var$nameCompare(left, right);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $668b2310913a4fe8$var$MAX_NODE$2;
function $668b2310913a4fe8$var$setMaxNode$1(val) {
    $668b2310913a4fe8$var$MAX_NODE$2 = val;
}
const $668b2310913a4fe8$var$priorityHashText = function(priority) {
    if (typeof priority === 'number') return 'number:' + $668b2310913a4fe8$var$doubleToIEEE754String(priority);
    else return 'string:' + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 */ const $668b2310913a4fe8$var$validatePriorityNode = function(priorityNode) {
    if (priorityNode.isLeafNode()) {
        const val = priorityNode.val();
        (0, $ffjl9.assert)(typeof val === 'string' || typeof val === 'number' || typeof val === 'object' && (0, $ffjl9.contains)(val, '.sv'), 'Priority must be a string or number.');
    } else (0, $ffjl9.assert)(priorityNode === $668b2310913a4fe8$var$MAX_NODE$2 || priorityNode.isEmpty(), 'priority of unexpected type.');
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    (0, $ffjl9.assert)(priorityNode === $668b2310913a4fe8$var$MAX_NODE$2 || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $668b2310913a4fe8$var$__childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */ class $668b2310913a4fe8$var$LeafNode {
    /**
     * @param value_ - The value to store in this leaf node. The object type is
     * possible in the event of a deferred value
     * @param priorityNode_ - The priority of this node.
     */ constructor(value_, priorityNode_ = $668b2310913a4fe8$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE){
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        (0, $ffjl9.assert)(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        $668b2310913a4fe8$var$validatePriorityNode(this.priorityNode_);
    }
    static set __childrenNodeConstructor(val) {
        $668b2310913a4fe8$var$__childrenNodeConstructor = val;
    }
    static get __childrenNodeConstructor() {
        return $668b2310913a4fe8$var$__childrenNodeConstructor;
    }
    /** @inheritDoc */ isLeafNode() {
        return true;
    }
    /** @inheritDoc */ getPriority() {
        return this.priorityNode_;
    }
    /** @inheritDoc */ updatePriority(newPriorityNode) {
        return new $668b2310913a4fe8$var$LeafNode(this.value_, newPriorityNode);
    }
    /** @inheritDoc */ getImmediateChild(childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') return this.priorityNode_;
        else return $668b2310913a4fe8$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    }
    /** @inheritDoc */ getChild(path) {
        if ($668b2310913a4fe8$var$pathIsEmpty(path)) return this;
        else if ($668b2310913a4fe8$var$pathGetFront(path) === '.priority') return this.priorityNode_;
        else return $668b2310913a4fe8$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    }
    hasChild() {
        return false;
    }
    /** @inheritDoc */ getPredecessorChildName(childName, childNode) {
        return null;
    }
    /** @inheritDoc */ updateImmediateChild(childName, newChildNode) {
        if (childName === '.priority') return this.updatePriority(newChildNode);
        else if (newChildNode.isEmpty() && childName !== '.priority') return this;
        else return $668b2310913a4fe8$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
    }
    /** @inheritDoc */ updateChild(path, newChildNode) {
        const front = $668b2310913a4fe8$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else if (newChildNode.isEmpty() && front !== '.priority') return this;
        else {
            (0, $ffjl9.assert)(front !== '.priority' || $668b2310913a4fe8$var$pathGetLength(path) === 1, '.priority must be the last token in a path');
            return this.updateImmediateChild(front, $668b2310913a4fe8$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild($668b2310913a4fe8$var$pathPopFront(path), newChildNode));
        }
    }
    /** @inheritDoc */ isEmpty() {
        return false;
    }
    /** @inheritDoc */ numChildren() {
        return 0;
    }
    /** @inheritDoc */ forEachChild(index, action) {
        return false;
    }
    val(exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty()) return {
            '.value': this.getValue(),
            '.priority': this.getPriority().val()
        };
        else return this.getValue();
    }
    /** @inheritDoc */ hash() {
        if (this.lazyHash_ === null) {
            let toHash = '';
            if (!this.priorityNode_.isEmpty()) toHash += 'priority:' + $668b2310913a4fe8$var$priorityHashText(this.priorityNode_.val()) + ':';
            const type = typeof this.value_;
            toHash += type + ':';
            if (type === 'number') toHash += $668b2310913a4fe8$var$doubleToIEEE754String(this.value_);
            else toHash += this.value_;
            this.lazyHash_ = $668b2310913a4fe8$var$sha1(toHash);
        }
        return this.lazyHash_;
    }
    /**
     * Returns the value of the leaf node.
     * @returns The value of the node.
     */ getValue() {
        return this.value_;
    }
    compareTo(other) {
        if (other === $668b2310913a4fe8$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE) return 1;
        else if (other instanceof $668b2310913a4fe8$var$LeafNode.__childrenNodeConstructor) return -1;
        else {
            (0, $ffjl9.assert)(other.isLeafNode(), 'Unknown node type');
            return this.compareToLeafNode_(other);
        }
    }
    /**
     * Comparison specifically for two leaf nodes
     */ compareToLeafNode_(otherLeaf) {
        const otherLeafType = typeof otherLeaf.value_;
        const thisLeafType = typeof this.value_;
        const otherIndex = $668b2310913a4fe8$var$LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        const thisIndex = $668b2310913a4fe8$var$LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        (0, $ffjl9.assert)(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
        (0, $ffjl9.assert)(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === 'object') // Deferred value nodes are all equal, but we should also never get to this point...
            return 0;
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) return -1;
                else if (this.value_ === otherLeaf.value_) return 0;
                else return 1;
            }
        } else return thisIndex - otherIndex;
    }
    withIndex() {
        return this;
    }
    isIndexed() {
        return true;
    }
    equals(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) {
            const otherLeaf = other;
            return this.value_ === otherLeaf.value_ && this.priorityNode_.equals(otherLeaf.priorityNode_);
        } else return false;
    }
}
/**
 * The sort order for comparing leaf nodes of different types. If two leaf nodes have
 * the same type, the comparison falls back to their value
 */ $668b2310913a4fe8$var$LeafNode.VALUE_TYPE_ORDER = [
    'object',
    'boolean',
    'number',
    'string'
];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $668b2310913a4fe8$var$nodeFromJSON$1;
let $668b2310913a4fe8$var$MAX_NODE$1;
function $668b2310913a4fe8$var$setNodeFromJSON(val) {
    $668b2310913a4fe8$var$nodeFromJSON$1 = val;
}
function $668b2310913a4fe8$var$setMaxNode(val) {
    $668b2310913a4fe8$var$MAX_NODE$1 = val;
}
class $668b2310913a4fe8$var$PriorityIndex extends $668b2310913a4fe8$var$Index {
    compare(a, b) {
        const aPriority = a.node.getPriority();
        const bPriority = b.node.getPriority();
        const indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) return $668b2310913a4fe8$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    isDefinedOn(node) {
        return !node.getPriority().isEmpty();
    }
    indexedValueChanged(oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $668b2310913a4fe8$var$NamedNode.MIN;
    }
    maxPost() {
        return new $668b2310913a4fe8$var$NamedNode($668b2310913a4fe8$var$MAX_NAME, new $668b2310913a4fe8$var$LeafNode('[PRIORITY-POST]', $668b2310913a4fe8$var$MAX_NODE$1));
    }
    makePost(indexValue, name) {
        const priorityNode = $668b2310913a4fe8$var$nodeFromJSON$1(indexValue);
        return new $668b2310913a4fe8$var$NamedNode(name, new $668b2310913a4fe8$var$LeafNode('[PRIORITY-POST]', priorityNode));
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.priority';
    }
}
const $668b2310913a4fe8$var$PRIORITY_INDEX = new $668b2310913a4fe8$var$PriorityIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $668b2310913a4fe8$var$LOG_2 = Math.log(2);
class $668b2310913a4fe8$var$Base12Num {
    constructor(length){
        const logBase2 = (num)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            parseInt(Math.log(num) / $668b2310913a4fe8$var$LOG_2, 10);
        const bitMask = (bits)=>parseInt(Array(bits + 1).join('1'), 2);
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        const mask = bitMask(this.count);
        this.bits_ = length + 1 & mask;
    }
    nextBitIsOne() {
        //noinspection JSBitwiseOperatorUsage
        const result = !(this.bits_ & 0x1 << this.current_);
        this.current_--;
        return result;
    }
}
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @param childList - Unsorted list of children
 * @param cmp - The comparison method to be used
 * @param keyFn - An optional function to extract K from a node wrapper, if K's
 * type is not NamedNode
 * @param mapSortFn - An optional override for comparator used by the generated sorted map
 */ const $668b2310913a4fe8$var$buildChildSet = function(childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    const buildBalancedTree = function(low, high) {
        const length = high - low;
        let namedNode;
        let key;
        if (length === 0) return null;
        else if (length === 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $668b2310913a4fe8$var$LLRBNode(key, namedNode.node, $668b2310913a4fe8$var$LLRBNode.BLACK, null, null);
        } else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const middle = parseInt(length / 2, 10) + low;
            const left = buildBalancedTree(low, middle);
            const right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $668b2310913a4fe8$var$LLRBNode(key, namedNode.node, $668b2310913a4fe8$var$LLRBNode.BLACK, left, right);
        }
    };
    const buildFrom12Array = function(base12) {
        let node = null;
        let root = null;
        let index = childList.length;
        const buildPennant = function(chunkSize, color) {
            const low = index - chunkSize;
            const high = index;
            index -= chunkSize;
            const childTree = buildBalancedTree(low + 1, high);
            const namedNode = childList[low];
            const key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new $668b2310913a4fe8$var$LLRBNode(key, namedNode.node, color, null, childTree));
        };
        const attachPennant = function(pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            } else {
                root = pennant;
                node = pennant;
            }
        };
        for(let i = 0; i < base12.count; ++i){
            const isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            const chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) buildPennant(chunkSize, $668b2310913a4fe8$var$LLRBNode.BLACK);
            else {
                // current == 2
                buildPennant(chunkSize, $668b2310913a4fe8$var$LLRBNode.BLACK);
                buildPennant(chunkSize, $668b2310913a4fe8$var$LLRBNode.RED);
            }
        }
        return root;
    };
    const base12 = new $668b2310913a4fe8$var$Base12Num(childList.length);
    const root = buildFrom12Array(base12);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new $668b2310913a4fe8$var$SortedMap(mapSortFn || cmp, root);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $668b2310913a4fe8$var$_defaultIndexMap;
const $668b2310913a4fe8$var$fallbackObject = {};
class $668b2310913a4fe8$var$IndexMap {
    constructor(indexes_, indexSet_){
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    /**
     * The default IndexMap for nodes without a priority
     */ static get Default() {
        (0, $ffjl9.assert)($668b2310913a4fe8$var$fallbackObject && $668b2310913a4fe8$var$PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
        $668b2310913a4fe8$var$_defaultIndexMap = $668b2310913a4fe8$var$_defaultIndexMap || new $668b2310913a4fe8$var$IndexMap({
            '.priority': $668b2310913a4fe8$var$fallbackObject
        }, {
            '.priority': $668b2310913a4fe8$var$PRIORITY_INDEX
        });
        return $668b2310913a4fe8$var$_defaultIndexMap;
    }
    get(indexKey) {
        const sortedMap = (0, $ffjl9.safeGet)(this.indexes_, indexKey);
        if (!sortedMap) throw new Error('No index defined for ' + indexKey);
        if (sortedMap instanceof $668b2310913a4fe8$var$SortedMap) return sortedMap;
        else // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
        // regular child map
        return null;
    }
    hasIndex(indexDefinition) {
        return (0, $ffjl9.contains)(this.indexSet_, indexDefinition.toString());
    }
    addIndex(indexDefinition, existingChildren) {
        (0, $ffjl9.assert)(indexDefinition !== $668b2310913a4fe8$var$KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        const childList = [];
        let sawIndexedValue = false;
        const iter = existingChildren.getIterator($668b2310913a4fe8$var$NamedNode.Wrap);
        let next = iter.getNext();
        while(next){
            sawIndexedValue = sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        let newIndex;
        if (sawIndexedValue) newIndex = $668b2310913a4fe8$var$buildChildSet(childList, indexDefinition.getCompare());
        else newIndex = $668b2310913a4fe8$var$fallbackObject;
        const indexName = indexDefinition.toString();
        const newIndexSet = Object.assign({}, this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        const newIndexes = Object.assign({}, this.indexes_);
        newIndexes[indexName] = newIndex;
        return new $668b2310913a4fe8$var$IndexMap(newIndexes, newIndexSet);
    }
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     */ addToIndexes(namedNode, existingChildren) {
        const newIndexes = (0, $ffjl9.map)(this.indexes_, (indexedChildren, indexName)=>{
            const index = (0, $ffjl9.safeGet)(this.indexSet_, indexName);
            (0, $ffjl9.assert)(index, 'Missing index implementation for ' + indexName);
            if (indexedChildren === $668b2310913a4fe8$var$fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    const childList = [];
                    const iter = existingChildren.getIterator($668b2310913a4fe8$var$NamedNode.Wrap);
                    let next = iter.getNext();
                    while(next){
                        if (next.name !== namedNode.name) childList.push(next);
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return $668b2310913a4fe8$var$buildChildSet(childList, index.getCompare());
                } else // No change, this remains a fallback
                return $668b2310913a4fe8$var$fallbackObject;
            } else {
                const existingSnap = existingChildren.get(namedNode.name);
                let newChildren = indexedChildren;
                if (existingSnap) newChildren = newChildren.remove(new $668b2310913a4fe8$var$NamedNode(namedNode.name, existingSnap));
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new $668b2310913a4fe8$var$IndexMap(newIndexes, this.indexSet_);
    }
    /**
     * Create a new IndexMap instance with the given value removed
     */ removeFromIndexes(namedNode, existingChildren) {
        const newIndexes = (0, $ffjl9.map)(this.indexes_, (indexedChildren)=>{
            if (indexedChildren === $668b2310913a4fe8$var$fallbackObject) // This is the fallback. Just return it, nothing to do in this case
            return indexedChildren;
            else {
                const existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) return indexedChildren.remove(new $668b2310913a4fe8$var$NamedNode(namedNode.name, existingSnap));
                else // No record of this child
                return indexedChildren;
            }
        });
        return new $668b2310913a4fe8$var$IndexMap(newIndexes, this.indexSet_);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO: For memory savings, don't store priorityNode_ if it's empty.
let $668b2310913a4fe8$var$EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 */ class $668b2310913a4fe8$var$ChildrenNode {
    /**
     * @param children_ - List of children of this node..
     * @param priorityNode_ - The priority of this node (as a snapshot node).
     */ constructor(children_, priorityNode_, indexMap_){
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */ if (this.priorityNode_) $668b2310913a4fe8$var$validatePriorityNode(this.priorityNode_);
        if (this.children_.isEmpty()) (0, $ffjl9.assert)(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
    }
    static get EMPTY_NODE() {
        return $668b2310913a4fe8$var$EMPTY_NODE || ($668b2310913a4fe8$var$EMPTY_NODE = new $668b2310913a4fe8$var$ChildrenNode(new $668b2310913a4fe8$var$SortedMap($668b2310913a4fe8$var$NAME_COMPARATOR), null, $668b2310913a4fe8$var$IndexMap.Default));
    }
    /** @inheritDoc */ isLeafNode() {
        return false;
    }
    /** @inheritDoc */ getPriority() {
        return this.priorityNode_ || $668b2310913a4fe8$var$EMPTY_NODE;
    }
    /** @inheritDoc */ updatePriority(newPriorityNode) {
        if (this.children_.isEmpty()) // Don't allow priorities on empty nodes
        return this;
        else return new $668b2310913a4fe8$var$ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
    }
    /** @inheritDoc */ getImmediateChild(childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') return this.getPriority();
        else {
            const child = this.children_.get(childName);
            return child === null ? $668b2310913a4fe8$var$EMPTY_NODE : child;
        }
    }
    /** @inheritDoc */ getChild(path) {
        const front = $668b2310913a4fe8$var$pathGetFront(path);
        if (front === null) return this;
        return this.getImmediateChild(front).getChild($668b2310913a4fe8$var$pathPopFront(path));
    }
    /** @inheritDoc */ hasChild(childName) {
        return this.children_.get(childName) !== null;
    }
    /** @inheritDoc */ updateImmediateChild(childName, newChildNode) {
        (0, $ffjl9.assert)(newChildNode, 'We should always be passing snapshot nodes');
        if (childName === '.priority') return this.updatePriority(newChildNode);
        else {
            const namedNode = new $668b2310913a4fe8$var$NamedNode(childName, newChildNode);
            let newChildren, newIndexMap;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            } else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            const newPriority = newChildren.isEmpty() ? $668b2310913a4fe8$var$EMPTY_NODE : this.priorityNode_;
            return new $668b2310913a4fe8$var$ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    }
    /** @inheritDoc */ updateChild(path, newChildNode) {
        const front = $668b2310913a4fe8$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else {
            (0, $ffjl9.assert)($668b2310913a4fe8$var$pathGetFront(path) !== '.priority' || $668b2310913a4fe8$var$pathGetLength(path) === 1, '.priority must be the last token in a path');
            const newImmediateChild = this.getImmediateChild(front).updateChild($668b2310913a4fe8$var$pathPopFront(path), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    }
    /** @inheritDoc */ isEmpty() {
        return this.children_.isEmpty();
    }
    /** @inheritDoc */ numChildren() {
        return this.children_.count();
    }
    /** @inheritDoc */ val(exportFormat) {
        if (this.isEmpty()) return null;
        const obj = {};
        let numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild($668b2310913a4fe8$var$PRIORITY_INDEX, (key, childNode)=>{
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && $668b2310913a4fe8$var$ChildrenNode.INTEGER_REGEXP_.test(key)) maxKey = Math.max(maxKey, Number(key));
            else allIntegerKeys = false;
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            const array = [];
            // eslint-disable-next-line guard-for-in
            for(const key in obj)array[key] = obj[key];
            return array;
        } else {
            if (exportFormat && !this.getPriority().isEmpty()) obj['.priority'] = this.getPriority().val();
            return obj;
        }
    }
    /** @inheritDoc */ hash() {
        if (this.lazyHash_ === null) {
            let toHash = '';
            if (!this.getPriority().isEmpty()) toHash += 'priority:' + $668b2310913a4fe8$var$priorityHashText(this.getPriority().val()) + ':';
            this.forEachChild($668b2310913a4fe8$var$PRIORITY_INDEX, (key, childNode)=>{
                const childHash = childNode.hash();
                if (childHash !== '') toHash += ':' + key + ':' + childHash;
            });
            this.lazyHash_ = toHash === '' ? '' : $668b2310913a4fe8$var$sha1(toHash);
        }
        return this.lazyHash_;
    }
    /** @inheritDoc */ getPredecessorChildName(childName, childNode, index) {
        const idx = this.resolveIndex_(index);
        if (idx) {
            const predecessor = idx.getPredecessorKey(new $668b2310913a4fe8$var$NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        } else return this.children_.getPredecessorKey(childName);
    }
    getFirstChildName(indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            const minKey = idx.minKey();
            return minKey && minKey.name;
        } else return this.children_.minKey();
    }
    getFirstChild(indexDefinition) {
        const minKey = this.getFirstChildName(indexDefinition);
        if (minKey) return new $668b2310913a4fe8$var$NamedNode(minKey, this.children_.get(minKey));
        else return null;
    }
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     */ getLastChildName(indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            const maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        } else return this.children_.maxKey();
    }
    getLastChild(indexDefinition) {
        const maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) return new $668b2310913a4fe8$var$NamedNode(maxKey, this.children_.get(maxKey));
        else return null;
    }
    forEachChild(index, action) {
        const idx = this.resolveIndex_(index);
        if (idx) return idx.inorderTraversal((wrappedNode)=>{
            return action(wrappedNode.name, wrappedNode.node);
        });
        else return this.children_.inorderTraversal(action);
    }
    getIterator(indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    }
    getIteratorFrom(startPost, indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getIteratorFrom(startPost, (key)=>key);
        else {
            const iterator = this.children_.getIteratorFrom(startPost.name, $668b2310913a4fe8$var$NamedNode.Wrap);
            let next = iterator.peek();
            while(next != null && indexDefinition.compare(next, startPost) < 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    }
    getReverseIterator(indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    }
    getReverseIteratorFrom(endPost, indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getReverseIteratorFrom(endPost, (key)=>{
            return key;
        });
        else {
            const iterator = this.children_.getReverseIteratorFrom(endPost.name, $668b2310913a4fe8$var$NamedNode.Wrap);
            let next = iterator.peek();
            while(next != null && indexDefinition.compare(next, endPost) > 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    }
    compareTo(other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) return 0;
            else return -1;
        } else if (other.isLeafNode() || other.isEmpty()) return 1;
        else if (other === $668b2310913a4fe8$var$MAX_NODE) return -1;
        else // Must be another node with children.
        return 0;
    }
    withIndex(indexDefinition) {
        if (indexDefinition === $668b2310913a4fe8$var$KEY_INDEX || this.indexMap_.hasIndex(indexDefinition)) return this;
        else {
            const newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new $668b2310913a4fe8$var$ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    }
    isIndexed(index) {
        return index === $668b2310913a4fe8$var$KEY_INDEX || this.indexMap_.hasIndex(index);
    }
    equals(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) return false;
        else {
            const otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) return false;
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                const thisIter = this.getIterator($668b2310913a4fe8$var$PRIORITY_INDEX);
                const otherIter = otherChildrenNode.getIterator($668b2310913a4fe8$var$PRIORITY_INDEX);
                let thisCurrent = thisIter.getNext();
                let otherCurrent = otherIter.getNext();
                while(thisCurrent && otherCurrent){
                    if (thisCurrent.name !== otherCurrent.name || !thisCurrent.node.equals(otherCurrent.node)) return false;
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            } else return false;
        }
    }
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     */ resolveIndex_(indexDefinition) {
        if (indexDefinition === $668b2310913a4fe8$var$KEY_INDEX) return null;
        else return this.indexMap_.get(indexDefinition.toString());
    }
}
$668b2310913a4fe8$var$ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
class $668b2310913a4fe8$var$MaxNode extends $668b2310913a4fe8$var$ChildrenNode {
    constructor(){
        super(new $668b2310913a4fe8$var$SortedMap($668b2310913a4fe8$var$NAME_COMPARATOR), $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE, $668b2310913a4fe8$var$IndexMap.Default);
    }
    compareTo(other) {
        if (other === this) return 0;
        else return 1;
    }
    equals(other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    }
    getPriority() {
        return this;
    }
    getImmediateChild(childName) {
        return $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE;
    }
    isEmpty() {
        return false;
    }
}
/**
 * Marker that will sort higher than any other snapshot.
 */ const $668b2310913a4fe8$var$MAX_NODE = new $668b2310913a4fe8$var$MaxNode();
Object.defineProperties($668b2310913a4fe8$var$NamedNode, {
    MIN: {
        value: new $668b2310913a4fe8$var$NamedNode($668b2310913a4fe8$var$MIN_NAME, $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new $668b2310913a4fe8$var$NamedNode($668b2310913a4fe8$var$MAX_NAME, $668b2310913a4fe8$var$MAX_NODE)
    }
});
/**
 * Reference Extensions
 */ $668b2310913a4fe8$var$KeyIndex.__EMPTY_NODE = $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE;
$668b2310913a4fe8$var$LeafNode.__childrenNodeConstructor = $668b2310913a4fe8$var$ChildrenNode;
$668b2310913a4fe8$var$setMaxNode$1($668b2310913a4fe8$var$MAX_NODE);
$668b2310913a4fe8$var$setMaxNode($668b2310913a4fe8$var$MAX_NODE);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $668b2310913a4fe8$var$USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param json - JSON to create a node for.
 * @param priority - Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 */ function $668b2310913a4fe8$var$nodeFromJSON(json, priority = null) {
    if (json === null) return $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE;
    if (typeof json === 'object' && '.priority' in json) priority = json['.priority'];
    (0, $ffjl9.assert)(priority === null || typeof priority === 'string' || typeof priority === 'number' || typeof priority === 'object' && '.sv' in priority, 'Invalid priority type found: ' + typeof priority);
    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) json = json['.value'];
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== 'object' || '.sv' in json) {
        const jsonLeaf = json;
        return new $668b2310913a4fe8$var$LeafNode(jsonLeaf, $668b2310913a4fe8$var$nodeFromJSON(priority));
    }
    if (!(json instanceof Array) && $668b2310913a4fe8$var$USE_HINZE) {
        const children = [];
        let childrenHavePriority = false;
        const hinzeJsonObj = json;
        $668b2310913a4fe8$var$each(hinzeJsonObj, (key, child)=>{
            if (key.substring(0, 1) !== '.') {
                // Ignore metadata nodes
                const childNode = $668b2310913a4fe8$var$nodeFromJSON(child);
                if (!childNode.isEmpty()) {
                    childrenHavePriority = childrenHavePriority || !childNode.getPriority().isEmpty();
                    children.push(new $668b2310913a4fe8$var$NamedNode(key, childNode));
                }
            }
        });
        if (children.length === 0) return $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE;
        const childSet = $668b2310913a4fe8$var$buildChildSet(children, $668b2310913a4fe8$var$NAME_ONLY_COMPARATOR, (namedNode)=>namedNode.name, $668b2310913a4fe8$var$NAME_COMPARATOR);
        if (childrenHavePriority) {
            const sortedChildSet = $668b2310913a4fe8$var$buildChildSet(children, $668b2310913a4fe8$var$PRIORITY_INDEX.getCompare());
            return new $668b2310913a4fe8$var$ChildrenNode(childSet, $668b2310913a4fe8$var$nodeFromJSON(priority), new $668b2310913a4fe8$var$IndexMap({
                '.priority': sortedChildSet
            }, {
                '.priority': $668b2310913a4fe8$var$PRIORITY_INDEX
            }));
        } else return new $668b2310913a4fe8$var$ChildrenNode(childSet, $668b2310913a4fe8$var$nodeFromJSON(priority), $668b2310913a4fe8$var$IndexMap.Default);
    } else {
        let node = $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE;
        $668b2310913a4fe8$var$each(json, (key, childData)=>{
            if ((0, $ffjl9.contains)(json, key)) {
                if (key.substring(0, 1) !== '.') {
                    // ignore metadata nodes.
                    const childNode = $668b2310913a4fe8$var$nodeFromJSON(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty()) node = node.updateImmediateChild(key, childNode);
                }
            }
        });
        return node.updatePriority($668b2310913a4fe8$var$nodeFromJSON(priority));
    }
}
$668b2310913a4fe8$var$setNodeFromJSON($668b2310913a4fe8$var$nodeFromJSON);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $668b2310913a4fe8$var$PathIndex extends $668b2310913a4fe8$var$Index {
    constructor(indexPath_){
        super();
        this.indexPath_ = indexPath_;
        (0, $ffjl9.assert)(!$668b2310913a4fe8$var$pathIsEmpty(indexPath_) && $668b2310913a4fe8$var$pathGetFront(indexPath_) !== '.priority', "Can't create PathIndex with empty path or .priority key");
    }
    extractChild(snap) {
        return snap.getChild(this.indexPath_);
    }
    isDefinedOn(node) {
        return !node.getChild(this.indexPath_).isEmpty();
    }
    compare(a, b) {
        const aChild = this.extractChild(a.node);
        const bChild = this.extractChild(b.node);
        const indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) return $668b2310913a4fe8$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    makePost(indexValue, name) {
        const valueNode = $668b2310913a4fe8$var$nodeFromJSON(indexValue);
        const node = $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new $668b2310913a4fe8$var$NamedNode(name, node);
    }
    maxPost() {
        const node = $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, $668b2310913a4fe8$var$MAX_NODE);
        return new $668b2310913a4fe8$var$NamedNode($668b2310913a4fe8$var$MAX_NAME, node);
    }
    toString() {
        return $668b2310913a4fe8$var$pathSlice(this.indexPath_, 0).join('/');
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $668b2310913a4fe8$var$ValueIndex extends $668b2310913a4fe8$var$Index {
    compare(a, b) {
        const indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) return $668b2310913a4fe8$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    isDefinedOn(node) {
        return true;
    }
    indexedValueChanged(oldNode, newNode) {
        return !oldNode.equals(newNode);
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $668b2310913a4fe8$var$NamedNode.MIN;
    }
    maxPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $668b2310913a4fe8$var$NamedNode.MAX;
    }
    makePost(indexValue, name) {
        const valueNode = $668b2310913a4fe8$var$nodeFromJSON(indexValue);
        return new $668b2310913a4fe8$var$NamedNode(name, valueNode);
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.value';
    }
}
const $668b2310913a4fe8$var$VALUE_INDEX = new $668b2310913a4fe8$var$ValueIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $668b2310913a4fe8$var$changeValue(snapshotNode) {
    return {
        type: "value" /* ChangeType.VALUE */ ,
        snapshotNode: snapshotNode
    };
}
function $668b2310913a4fe8$var$changeChildAdded(childName, snapshotNode) {
    return {
        type: "child_added" /* ChangeType.CHILD_ADDED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $668b2310913a4fe8$var$changeChildRemoved(childName, snapshotNode) {
    return {
        type: "child_removed" /* ChangeType.CHILD_REMOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $668b2310913a4fe8$var$changeChildChanged(childName, snapshotNode, oldSnap) {
    return {
        type: "child_changed" /* ChangeType.CHILD_CHANGED */ ,
        snapshotNode: snapshotNode,
        childName: childName,
        oldSnap: oldSnap
    };
}
function $668b2310913a4fe8$var$changeChildMoved(childName, snapshotNode) {
    return {
        type: "child_moved" /* ChangeType.CHILD_MOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 */ class $668b2310913a4fe8$var$IndexedFilter {
    constructor(index_){
        this.index_ = index_;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        (0, $ffjl9.assert)(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
        const oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() === newChild.isEmpty()) // Nothing changed.
            // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
            //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
            return snap;
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) optChangeAccumulator.trackChildChange($668b2310913a4fe8$var$changeChildRemoved(key, oldChild));
                else (0, $ffjl9.assert)(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
            } else if (oldChild.isEmpty()) optChangeAccumulator.trackChildChange($668b2310913a4fe8$var$changeChildAdded(key, newChild));
            else optChangeAccumulator.trackChildChange($668b2310913a4fe8$var$changeChildChanged(key, newChild, oldChild));
        }
        if (snap.isLeafNode() && newChild.isEmpty()) return snap;
        else // Make sure the node is indexed
        return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) oldSnap.forEachChild($668b2310913a4fe8$var$PRIORITY_INDEX, (key, childNode)=>{
                if (!newSnap.hasChild(key)) optChangeAccumulator.trackChildChange($668b2310913a4fe8$var$changeChildRemoved(key, childNode));
            });
            if (!newSnap.isLeafNode()) newSnap.forEachChild($668b2310913a4fe8$var$PRIORITY_INDEX, (key, childNode)=>{
                if (oldSnap.hasChild(key)) {
                    const oldChild = oldSnap.getImmediateChild(key);
                    if (!oldChild.equals(childNode)) optChangeAccumulator.trackChildChange($668b2310913a4fe8$var$changeChildChanged(key, childNode, oldChild));
                } else optChangeAccumulator.trackChildChange($668b2310913a4fe8$var$changeChildAdded(key, childNode));
            });
        }
        return newSnap.withIndex(this.index_);
    }
    updatePriority(oldSnap, newPriority) {
        if (oldSnap.isEmpty()) return $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE;
        else return oldSnap.updatePriority(newPriority);
    }
    filtersNodes() {
        return false;
    }
    getIndexedFilter() {
        return this;
    }
    getIndex() {
        return this.index_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 */ class $668b2310913a4fe8$var$RangedFilter {
    constructor(params){
        this.indexedFilter_ = new $668b2310913a4fe8$var$IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = $668b2310913a4fe8$var$RangedFilter.getStartPost_(params);
        this.endPost_ = $668b2310913a4fe8$var$RangedFilter.getEndPost_(params);
        this.startIsInclusive_ = !params.startAfterSet_;
        this.endIsInclusive_ = !params.endBeforeSet_;
    }
    getStartPost() {
        return this.startPost_;
    }
    getEndPost() {
        return this.endPost_;
    }
    matches(node) {
        const isWithinStart = this.startIsInclusive_ ? this.index_.compare(this.getStartPost(), node) <= 0 : this.index_.compare(this.getStartPost(), node) < 0;
        const isWithinEnd = this.endIsInclusive_ ? this.index_.compare(node, this.getEndPost()) <= 0 : this.index_.compare(node, this.getEndPost()) < 0;
        return isWithinStart && isWithinEnd;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new $668b2310913a4fe8$var$NamedNode(key, newChild))) newChild = $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE;
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) // Make sure we have a children node with the correct index, not a leaf node;
        newSnap = $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE;
        let filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority($668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE);
        const self = this;
        newSnap.forEachChild($668b2310913a4fe8$var$PRIORITY_INDEX, (key, childNode)=>{
            if (!self.matches(new $668b2310913a4fe8$var$NamedNode(key, childNode))) filtered = filtered.updateImmediateChild(key, $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE);
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    }
    updatePriority(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    }
    filtersNodes() {
        return true;
    }
    getIndexedFilter() {
        return this.indexedFilter_;
    }
    getIndex() {
        return this.index_;
    }
    static getStartPost_(params) {
        if (params.hasStart()) {
            const startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        } else return params.getIndex().minPost();
    }
    static getEndPost_(params) {
        if (params.hasEnd()) {
            const endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        } else return params.getIndex().maxPost();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 */ class $668b2310913a4fe8$var$LimitedFilter {
    constructor(params){
        this.withinDirectionalStart = (node)=>this.reverse_ ? this.withinEndPost(node) : this.withinStartPost(node);
        this.withinDirectionalEnd = (node)=>this.reverse_ ? this.withinStartPost(node) : this.withinEndPost(node);
        this.withinStartPost = (node)=>{
            const compareRes = this.index_.compare(this.rangedFilter_.getStartPost(), node);
            return this.startIsInclusive_ ? compareRes <= 0 : compareRes < 0;
        };
        this.withinEndPost = (node)=>{
            const compareRes = this.index_.compare(node, this.rangedFilter_.getEndPost());
            return this.endIsInclusive_ ? compareRes <= 0 : compareRes < 0;
        };
        this.rangedFilter_ = new $668b2310913a4fe8$var$RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
        this.startIsInclusive_ = !params.startAfterSet_;
        this.endIsInclusive_ = !params.endBeforeSet_;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new $668b2310913a4fe8$var$NamedNode(key, newChild))) newChild = $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE;
        if (snap.getImmediateChild(key).equals(newChild)) // No change
        return snap;
        else if (snap.numChildren() < this.limit_) return this.rangedFilter_.getIndexedFilter().updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        else return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        let filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) // Make sure we have a children node with the correct index, not a leaf node;
        filtered = $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        else if (this.limit_ * 2 < newSnap.numChildren() && newSnap.isIndexed(this.index_)) {
            // Easier to build up a snapshot, since what we're given has more than twice the elements we want
            filtered = $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
            // anchor to the startPost, endPost, or last element as appropriate
            let iterator;
            if (this.reverse_) iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
            else iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
            let count = 0;
            while(iterator.hasNext() && count < this.limit_){
                const next = iterator.getNext();
                if (!this.withinDirectionalStart(next)) continue;
                else if (!this.withinDirectionalEnd(next)) break;
                else {
                    filtered = filtered.updateImmediateChild(next.name, next.node);
                    count++;
                }
            }
        } else {
            // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
            filtered = newSnap.withIndex(this.index_);
            // Don't support priorities on queries
            filtered = filtered.updatePriority($668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE);
            let iterator;
            if (this.reverse_) iterator = filtered.getReverseIterator(this.index_);
            else iterator = filtered.getIterator(this.index_);
            let count = 0;
            while(iterator.hasNext()){
                const next = iterator.getNext();
                const inRange = count < this.limit_ && this.withinDirectionalStart(next) && this.withinDirectionalEnd(next);
                if (inRange) count++;
                else filtered = filtered.updateImmediateChild(next.name, $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE);
            }
        }
        return this.rangedFilter_.getIndexedFilter().updateFullNode(oldSnap, filtered, optChangeAccumulator);
    }
    updatePriority(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    }
    filtersNodes() {
        return true;
    }
    getIndexedFilter() {
        return this.rangedFilter_.getIndexedFilter();
    }
    getIndex() {
        return this.index_;
    }
    fullLimitUpdateChild_(snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        let cmp;
        if (this.reverse_) {
            const indexCmp = this.index_.getCompare();
            cmp = (a, b)=>indexCmp(b, a);
        } else cmp = this.index_.getCompare();
        const oldEventCache = snap;
        (0, $ffjl9.assert)(oldEventCache.numChildren() === this.limit_, '');
        const newChildNamedNode = new $668b2310913a4fe8$var$NamedNode(childKey, childSnap);
        const windowBoundary = this.reverse_ ? oldEventCache.getFirstChild(this.index_) : oldEventCache.getLastChild(this.index_);
        const inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            const oldChildSnap = oldEventCache.getImmediateChild(childKey);
            let nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while(nextChild != null && (nextChild.name === childKey || oldEventCache.hasChild(nextChild.name)))// There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
            // been applied to the limited filter yet. Ignore this next child which will be updated later in
            // the limited filter...
            nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            const compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            const remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($668b2310913a4fe8$var$changeChildChanged(childKey, childSnap, oldChildSnap));
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            } else {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($668b2310913a4fe8$var$changeChildRemoved(childKey, oldChildSnap));
                const newEventCache = oldEventCache.updateImmediateChild(childKey, $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE);
                const nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) changeAccumulator.trackChildChange($668b2310913a4fe8$var$changeChildAdded(nextChild.name, nextChild.node));
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                } else return newEventCache;
            }
        } else if (childSnap.isEmpty()) // we're deleting a node, but it was not in the window, so ignore it
        return snap;
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange($668b2310913a4fe8$var$changeChildRemoved(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange($668b2310913a4fe8$var$changeChildAdded(childKey, childSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap).updateImmediateChild(windowBoundary.name, $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE);
            } else return snap;
        } else return snap;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 *
 * @internal
 */ class $668b2310913a4fe8$export$7ba287e361c94330 {
    constructor(){
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.startAfterSet_ = false; // can only be true if startSet_ is true
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.endBeforeSet_ = false; // can only be true if endSet_ is true
        this.limit_ = 0;
        this.viewFrom_ = '';
        this.indexStartValue_ = null;
        this.indexStartName_ = '';
        this.indexEndValue_ = null;
        this.indexEndName_ = '';
        this.index_ = $668b2310913a4fe8$var$PRIORITY_INDEX;
    }
    hasStart() {
        return this.startSet_;
    }
    /**
     * @returns True if it would return from left.
     */ isViewFromLeft() {
        if (this.viewFrom_ === '') // limit(), rather than limitToFirst or limitToLast was called.
        // This means that only one of startSet_ and endSet_ is true. Use them
        // to calculate which side of the view to anchor to. If neither is set,
        // anchor to the end.
        return this.startSet_;
        else return this.viewFrom_ === "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
    }
    /**
     * Only valid to call if hasStart() returns true
     */ getIndexStartValue() {
        (0, $ffjl9.assert)(this.startSet_, 'Only valid if start has been set');
        return this.indexStartValue_;
    }
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     */ getIndexStartName() {
        (0, $ffjl9.assert)(this.startSet_, 'Only valid if start has been set');
        if (this.startNameSet_) return this.indexStartName_;
        else return $668b2310913a4fe8$var$MIN_NAME;
    }
    hasEnd() {
        return this.endSet_;
    }
    /**
     * Only valid to call if hasEnd() returns true.
     */ getIndexEndValue() {
        (0, $ffjl9.assert)(this.endSet_, 'Only valid if end has been set');
        return this.indexEndValue_;
    }
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     */ getIndexEndName() {
        (0, $ffjl9.assert)(this.endSet_, 'Only valid if end has been set');
        if (this.endNameSet_) return this.indexEndName_;
        else return $668b2310913a4fe8$var$MAX_NAME;
    }
    hasLimit() {
        return this.limitSet_;
    }
    /**
     * @returns True if a limit has been set and it has been explicitly anchored
     */ hasAnchoredLimit() {
        return this.limitSet_ && this.viewFrom_ !== '';
    }
    /**
     * Only valid to call if hasLimit() returns true
     */ getLimit() {
        (0, $ffjl9.assert)(this.limitSet_, 'Only valid if limit has been set');
        return this.limit_;
    }
    getIndex() {
        return this.index_;
    }
    loadsAllData() {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    }
    isDefault() {
        return this.loadsAllData() && this.index_ === $668b2310913a4fe8$var$PRIORITY_INDEX;
    }
    copy() {
        const copy = new $668b2310913a4fe8$export$7ba287e361c94330();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.startAfterSet_ = this.startAfterSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.endBeforeSet_ = this.endBeforeSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    }
}
function $668b2310913a4fe8$var$queryParamsGetNodeFilter(queryParams) {
    if (queryParams.loadsAllData()) return new $668b2310913a4fe8$var$IndexedFilter(queryParams.getIndex());
    else if (queryParams.hasLimit()) return new $668b2310913a4fe8$var$LimitedFilter(queryParams);
    else return new $668b2310913a4fe8$var$RangedFilter(queryParams);
}
function $668b2310913a4fe8$var$queryParamsLimitToFirst(queryParams, newLimit) {
    const newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
    return newParams;
}
function $668b2310913a4fe8$var$queryParamsLimitToLast(queryParams, newLimit) {
    const newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "r" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT */ ;
    return newParams;
}
function $668b2310913a4fe8$var$queryParamsStartAt(queryParams, indexValue, key) {
    const newParams = queryParams.copy();
    newParams.startSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexStartValue_ = indexValue;
    if (key != null) {
        newParams.startNameSet_ = true;
        newParams.indexStartName_ = key;
    } else {
        newParams.startNameSet_ = false;
        newParams.indexStartName_ = '';
    }
    return newParams;
}
function $668b2310913a4fe8$var$queryParamsStartAfter(queryParams, indexValue, key) {
    let params;
    if (queryParams.index_ === $668b2310913a4fe8$var$KEY_INDEX || !!key) params = $668b2310913a4fe8$var$queryParamsStartAt(queryParams, indexValue, key);
    else params = $668b2310913a4fe8$var$queryParamsStartAt(queryParams, indexValue, $668b2310913a4fe8$var$MAX_NAME);
    params.startAfterSet_ = true;
    return params;
}
function $668b2310913a4fe8$var$queryParamsEndAt(queryParams, indexValue, key) {
    const newParams = queryParams.copy();
    newParams.endSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexEndValue_ = indexValue;
    if (key !== undefined) {
        newParams.endNameSet_ = true;
        newParams.indexEndName_ = key;
    } else {
        newParams.endNameSet_ = false;
        newParams.indexEndName_ = '';
    }
    return newParams;
}
function $668b2310913a4fe8$var$queryParamsEndBefore(queryParams, indexValue, key) {
    let params;
    if (queryParams.index_ === $668b2310913a4fe8$var$KEY_INDEX || !!key) params = $668b2310913a4fe8$var$queryParamsEndAt(queryParams, indexValue, key);
    else params = $668b2310913a4fe8$var$queryParamsEndAt(queryParams, indexValue, $668b2310913a4fe8$var$MIN_NAME);
    params.endBeforeSet_ = true;
    return params;
}
function $668b2310913a4fe8$var$queryParamsOrderBy(queryParams, index) {
    const newParams = queryParams.copy();
    newParams.index_ = index;
    return newParams;
}
/**
 * Returns a set of REST query string parameters representing this query.
 *
 * @returns query string parameters
 */ function $668b2310913a4fe8$var$queryParamsToRestQueryStringParameters(queryParams) {
    const qs = {};
    if (queryParams.isDefault()) return qs;
    let orderBy;
    if (queryParams.index_ === $668b2310913a4fe8$var$PRIORITY_INDEX) orderBy = "$priority" /* REST_QUERY_CONSTANTS.PRIORITY_INDEX */ ;
    else if (queryParams.index_ === $668b2310913a4fe8$var$VALUE_INDEX) orderBy = "$value" /* REST_QUERY_CONSTANTS.VALUE_INDEX */ ;
    else if (queryParams.index_ === $668b2310913a4fe8$var$KEY_INDEX) orderBy = "$key" /* REST_QUERY_CONSTANTS.KEY_INDEX */ ;
    else {
        (0, $ffjl9.assert)(queryParams.index_ instanceof $668b2310913a4fe8$var$PathIndex, 'Unrecognized index type!');
        orderBy = queryParams.index_.toString();
    }
    qs["orderBy" /* REST_QUERY_CONSTANTS.ORDER_BY */ ] = (0, $ffjl9.stringify)(orderBy);
    if (queryParams.startSet_) {
        const startParam = queryParams.startAfterSet_ ? "startAfter" /* REST_QUERY_CONSTANTS.START_AFTER */  : "startAt" /* REST_QUERY_CONSTANTS.START_AT */ ;
        qs[startParam] = (0, $ffjl9.stringify)(queryParams.indexStartValue_);
        if (queryParams.startNameSet_) qs[startParam] += ',' + (0, $ffjl9.stringify)(queryParams.indexStartName_);
    }
    if (queryParams.endSet_) {
        const endParam = queryParams.endBeforeSet_ ? "endBefore" /* REST_QUERY_CONSTANTS.END_BEFORE */  : "endAt" /* REST_QUERY_CONSTANTS.END_AT */ ;
        qs[endParam] = (0, $ffjl9.stringify)(queryParams.indexEndValue_);
        if (queryParams.endNameSet_) qs[endParam] += ',' + (0, $ffjl9.stringify)(queryParams.indexEndName_);
    }
    if (queryParams.limitSet_) {
        if (queryParams.isViewFromLeft()) qs["limitToFirst" /* REST_QUERY_CONSTANTS.LIMIT_TO_FIRST */ ] = queryParams.limit_;
        else qs["limitToLast" /* REST_QUERY_CONSTANTS.LIMIT_TO_LAST */ ] = queryParams.limit_;
    }
    return qs;
}
function $668b2310913a4fe8$var$queryParamsGetQueryObject(queryParams) {
    const obj = {};
    if (queryParams.startSet_) {
        obj["sp" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE */ ] = queryParams.indexStartValue_;
        if (queryParams.startNameSet_) obj["sn" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME */ ] = queryParams.indexStartName_;
        obj["sin" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_IS_INCLUSIVE */ ] = !queryParams.startAfterSet_;
    }
    if (queryParams.endSet_) {
        obj["ep" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE */ ] = queryParams.indexEndValue_;
        if (queryParams.endNameSet_) obj["en" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME */ ] = queryParams.indexEndName_;
        obj["ein" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_IS_INCLUSIVE */ ] = !queryParams.endBeforeSet_;
    }
    if (queryParams.limitSet_) {
        obj["l" /* WIRE_PROTOCOL_CONSTANTS.LIMIT */ ] = queryParams.limit_;
        let viewFrom = queryParams.viewFrom_;
        if (viewFrom === '') {
            if (queryParams.isViewFromLeft()) viewFrom = "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
            else viewFrom = "r" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT */ ;
        }
        obj["vf" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM */ ] = viewFrom;
    }
    // For now, priority index is the default, so we only specify if it's some other index
    if (queryParams.index_ !== $668b2310913a4fe8$var$PRIORITY_INDEX) obj["i" /* WIRE_PROTOCOL_CONSTANTS.INDEX */ ] = queryParams.index_.toString();
    return obj;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */ class $668b2310913a4fe8$var$ReadonlyRestClient extends $668b2310913a4fe8$var$ServerActions {
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param onDataUpdate_ - A callback for new data from the server
     */ constructor(repoInfo_, onDataUpdate_, authTokenProvider_, appCheckTokenProvider_){
        super();
        this.repoInfo_ = repoInfo_;
        this.onDataUpdate_ = onDataUpdate_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckTokenProvider_ = appCheckTokenProvider_;
        /** @private {function(...[*])} */ this.log_ = $668b2310913a4fe8$var$logWrapper('p:rest:');
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         */ this.listens_ = {};
    }
    reportStats(stats) {
        throw new Error('Method not implemented.');
    }
    static getListenId_(query, tag) {
        if (tag !== undefined) return 'tag$' + tag;
        else {
            (0, $ffjl9.assert)(query._queryParams.isDefault(), "should have a tag if it's not a default query.");
            return query._path.toString();
        }
    }
    /** @inheritDoc */ listen(query, currentHashFn, tag, onComplete) {
        const pathString = query._path.toString();
        this.log_('Listen called for ' + pathString + ' ' + query._queryIdentifier);
        // Mark this listener so we can tell if it's removed.
        const listenId = $668b2310913a4fe8$var$ReadonlyRestClient.getListenId_(query, tag);
        const thisListen = {};
        this.listens_[listenId] = thisListen;
        const queryStringParameters = $668b2310913a4fe8$var$queryParamsToRestQueryStringParameters(query._queryParams);
        this.restRequest_(pathString + '.json', queryStringParameters, (error, result)=>{
            let data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            if ((0, $ffjl9.safeGet)(this.listens_, listenId) === thisListen) {
                let status;
                if (!error) status = 'ok';
                else if (error === 401) status = 'permission_denied';
                else status = 'rest_error:' + error;
                onComplete(status, null);
            }
        });
    }
    /** @inheritDoc */ unlisten(query, tag) {
        const listenId = $668b2310913a4fe8$var$ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    }
    get(query) {
        const queryStringParameters = $668b2310913a4fe8$var$queryParamsToRestQueryStringParameters(query._queryParams);
        const pathString = query._path.toString();
        const deferred = new (0, $ffjl9.Deferred)();
        this.restRequest_(pathString + '.json', queryStringParameters, (error, result)=>{
            let data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) {
                this.onDataUpdate_(pathString, data, /*isMerge=*/ false, /*tag=*/ null);
                deferred.resolve(data);
            } else deferred.reject(new Error(data));
        });
        return deferred.promise;
    }
    /** @inheritDoc */ refreshAuthToken(token) {
    // no-op since we just always call getToken.
    }
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     */ restRequest_(pathString, queryStringParameters = {}, callback) {
        queryStringParameters['format'] = 'export';
        return Promise.all([
            this.authTokenProvider_.getToken(/*forceRefresh=*/ false),
            this.appCheckTokenProvider_.getToken(/*forceRefresh=*/ false)
        ]).then(([authToken, appCheckToken])=>{
            if (authToken && authToken.accessToken) queryStringParameters['auth'] = authToken.accessToken;
            if (appCheckToken && appCheckToken.token) queryStringParameters['ac'] = appCheckToken.token;
            const url = (this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host + pathString + '?' + 'ns=' + this.repoInfo_.namespace + (0, $ffjl9.querystring)(queryStringParameters);
            this.log_('Sending REST request for ' + url);
            const xhr = new XMLHttpRequest();
            xhr.onreadystatechange = ()=>{
                if (callback && xhr.readyState === 4) {
                    this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
                    let res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = (0, $ffjl9.jsonEval)(xhr.responseText);
                        } catch (e) {
                            $668b2310913a4fe8$var$warn('Failed to parse JSON response for ' + url + ': ' + xhr.responseText);
                        }
                        callback(null, res);
                    } else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) $668b2310913a4fe8$var$warn('Got unsuccessful REST response for ' + url + ' Status: ' + xhr.status);
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open('GET', url, /*asynchronous=*/ true);
            xhr.send();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 */ class $668b2310913a4fe8$var$SnapshotHolder {
    constructor(){
        this.rootNode_ = $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE;
    }
    getNode(path) {
        return this.rootNode_.getChild(path);
    }
    updateSnapshot(path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $668b2310913a4fe8$var$newSparseSnapshotTree() {
    return {
        value: null,
        children: new Map()
    };
}
/**
 * Stores the given node at the specified path. If there is already a node
 * at a shallower path, it merges the new data into that snapshot node.
 *
 * @param path - Path to look up snapshot for.
 * @param data - The new data, or null.
 */ function $668b2310913a4fe8$var$sparseSnapshotTreeRemember(sparseSnapshotTree, path, data) {
    if ($668b2310913a4fe8$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = data;
        sparseSnapshotTree.children.clear();
    } else if (sparseSnapshotTree.value !== null) sparseSnapshotTree.value = sparseSnapshotTree.value.updateChild(path, data);
    else {
        const childKey = $668b2310913a4fe8$var$pathGetFront(path);
        if (!sparseSnapshotTree.children.has(childKey)) sparseSnapshotTree.children.set(childKey, $668b2310913a4fe8$var$newSparseSnapshotTree());
        const child = sparseSnapshotTree.children.get(childKey);
        path = $668b2310913a4fe8$var$pathPopFront(path);
        $668b2310913a4fe8$var$sparseSnapshotTreeRemember(child, path, data);
    }
}
/**
 * Purge the data at path from the cache.
 *
 * @param path - Path to look up snapshot for.
 * @returns True if this node should now be removed.
 */ function $668b2310913a4fe8$var$sparseSnapshotTreeForget(sparseSnapshotTree, path) {
    if ($668b2310913a4fe8$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = null;
        sparseSnapshotTree.children.clear();
        return true;
    } else {
        if (sparseSnapshotTree.value !== null) {
            if (sparseSnapshotTree.value.isLeafNode()) // We're trying to forget a node that doesn't exist
            return false;
            else {
                const value = sparseSnapshotTree.value;
                sparseSnapshotTree.value = null;
                value.forEachChild($668b2310913a4fe8$var$PRIORITY_INDEX, (key, tree)=>{
                    $668b2310913a4fe8$var$sparseSnapshotTreeRemember(sparseSnapshotTree, new $668b2310913a4fe8$var$Path(key), tree);
                });
                return $668b2310913a4fe8$var$sparseSnapshotTreeForget(sparseSnapshotTree, path);
            }
        } else if (sparseSnapshotTree.children.size > 0) {
            const childKey = $668b2310913a4fe8$var$pathGetFront(path);
            path = $668b2310913a4fe8$var$pathPopFront(path);
            if (sparseSnapshotTree.children.has(childKey)) {
                const safeToRemove = $668b2310913a4fe8$var$sparseSnapshotTreeForget(sparseSnapshotTree.children.get(childKey), path);
                if (safeToRemove) sparseSnapshotTree.children.delete(childKey);
            }
            return sparseSnapshotTree.children.size === 0;
        } else return true;
    }
}
/**
 * Recursively iterates through all of the stored tree and calls the
 * callback on each one.
 *
 * @param prefixPath - Path to look up node for.
 * @param func - The function to invoke for each tree.
 */ function $668b2310913a4fe8$var$sparseSnapshotTreeForEachTree(sparseSnapshotTree, prefixPath, func) {
    if (sparseSnapshotTree.value !== null) func(prefixPath, sparseSnapshotTree.value);
    else $668b2310913a4fe8$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, (key, tree)=>{
        const path = new $668b2310913a4fe8$var$Path(prefixPath.toString() + '/' + key);
        $668b2310913a4fe8$var$sparseSnapshotTreeForEachTree(tree, path, func);
    });
}
/**
 * Iterates through each immediate child and triggers the callback.
 * Only seems to be used in tests.
 *
 * @param func - The function to invoke for each child.
 */ function $668b2310913a4fe8$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, func) {
    sparseSnapshotTree.children.forEach((tree, key)=>{
        func(key, tree);
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ - The collection to "listen" to.
 */ class $668b2310913a4fe8$var$StatsListener {
    constructor(collection_){
        this.collection_ = collection_;
        this.last_ = null;
    }
    get() {
        const newStats = this.collection_.get();
        const delta = Object.assign({}, newStats);
        if (this.last_) $668b2310913a4fe8$var$each(this.last_, (stat, value)=>{
            delta[stat] = delta[stat] - value;
        });
        this.last_ = newStats;
        return delta;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
const $668b2310913a4fe8$var$FIRST_STATS_MIN_TIME = 10000;
const $668b2310913a4fe8$var$FIRST_STATS_MAX_TIME = 30000;
// We'll continue to report stats on average every 5 minutes.
const $668b2310913a4fe8$var$REPORT_STATS_INTERVAL = 300000;
class $668b2310913a4fe8$var$StatsReporter {
    constructor(collection, server_){
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new $668b2310913a4fe8$var$StatsListener(collection);
        const timeout = $668b2310913a4fe8$var$FIRST_STATS_MIN_TIME + ($668b2310913a4fe8$var$FIRST_STATS_MAX_TIME - $668b2310913a4fe8$var$FIRST_STATS_MIN_TIME) * Math.random();
        $668b2310913a4fe8$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
    reportStats_() {
        const stats = this.statsListener_.get();
        const reportedStats = {};
        let haveStatsToReport = false;
        $668b2310913a4fe8$var$each(stats, (stat, value)=>{
            if (value > 0 && (0, $ffjl9.contains)(this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) this.server_.reportStats(reportedStats);
        // queue our next run.
        $668b2310913a4fe8$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * $668b2310913a4fe8$var$REPORT_STATS_INTERVAL));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 *
 * @enum
 */ var $668b2310913a4fe8$var$OperationType;
(function(OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})($668b2310913a4fe8$var$OperationType || ($668b2310913a4fe8$var$OperationType = {}));
function $668b2310913a4fe8$var$newOperationSourceUser() {
    return {
        fromUser: true,
        fromServer: false,
        queryId: null,
        tagged: false
    };
}
function $668b2310913a4fe8$var$newOperationSourceServer() {
    return {
        fromUser: false,
        fromServer: true,
        queryId: null,
        tagged: false
    };
}
function $668b2310913a4fe8$var$newOperationSourceServerTaggedQuery(queryId) {
    return {
        fromUser: false,
        fromServer: true,
        queryId: queryId,
        tagged: true
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $668b2310913a4fe8$var$AckUserWrite {
    /**
     * @param affectedTree - A tree containing true for each affected path. Affected paths can't overlap.
     */ constructor(/** @inheritDoc */ path, /** @inheritDoc */ affectedTree, /** @inheritDoc */ revert){
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */ this.type = $668b2310913a4fe8$var$OperationType.ACK_USER_WRITE;
        /** @inheritDoc */ this.source = $668b2310913a4fe8$var$newOperationSourceUser();
    }
    operationForChild(childName) {
        if (!$668b2310913a4fe8$var$pathIsEmpty(this.path)) {
            (0, $ffjl9.assert)($668b2310913a4fe8$var$pathGetFront(this.path) === childName, 'operationForChild called for unrelated child.');
            return new $668b2310913a4fe8$var$AckUserWrite($668b2310913a4fe8$var$pathPopFront(this.path), this.affectedTree, this.revert);
        } else if (this.affectedTree.value != null) {
            (0, $ffjl9.assert)(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
            // All child locations are affected as well; just return same operation.
            return this;
        } else {
            const childTree = this.affectedTree.subtree(new $668b2310913a4fe8$var$Path(childName));
            return new $668b2310913a4fe8$var$AckUserWrite($668b2310913a4fe8$var$newEmptyPath(), childTree, this.revert);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $668b2310913a4fe8$var$ListenComplete {
    constructor(source, path){
        this.source = source;
        this.path = path;
        /** @inheritDoc */ this.type = $668b2310913a4fe8$var$OperationType.LISTEN_COMPLETE;
    }
    operationForChild(childName) {
        if ($668b2310913a4fe8$var$pathIsEmpty(this.path)) return new $668b2310913a4fe8$var$ListenComplete(this.source, $668b2310913a4fe8$var$newEmptyPath());
        else return new $668b2310913a4fe8$var$ListenComplete(this.source, $668b2310913a4fe8$var$pathPopFront(this.path));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $668b2310913a4fe8$var$Overwrite {
    constructor(source, path, snap){
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */ this.type = $668b2310913a4fe8$var$OperationType.OVERWRITE;
    }
    operationForChild(childName) {
        if ($668b2310913a4fe8$var$pathIsEmpty(this.path)) return new $668b2310913a4fe8$var$Overwrite(this.source, $668b2310913a4fe8$var$newEmptyPath(), this.snap.getImmediateChild(childName));
        else return new $668b2310913a4fe8$var$Overwrite(this.source, $668b2310913a4fe8$var$pathPopFront(this.path), this.snap);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $668b2310913a4fe8$var$Merge {
    constructor(/** @inheritDoc */ source, /** @inheritDoc */ path, /** @inheritDoc */ children){
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */ this.type = $668b2310913a4fe8$var$OperationType.MERGE;
    }
    operationForChild(childName) {
        if ($668b2310913a4fe8$var$pathIsEmpty(this.path)) {
            const childTree = this.children.subtree(new $668b2310913a4fe8$var$Path(childName));
            if (childTree.isEmpty()) // This child is unaffected
            return null;
            else if (childTree.value) // We have a snapshot for the child in question.  This becomes an overwrite of the child.
            return new $668b2310913a4fe8$var$Overwrite(this.source, $668b2310913a4fe8$var$newEmptyPath(), childTree.value);
            else // This is a merge at a deeper level
            return new $668b2310913a4fe8$var$Merge(this.source, $668b2310913a4fe8$var$newEmptyPath(), childTree);
        } else {
            (0, $ffjl9.assert)($668b2310913a4fe8$var$pathGetFront(this.path) === childName, "Can't get a merge for a child not on the path of the operation");
            return new $668b2310913a4fe8$var$Merge(this.source, $668b2310913a4fe8$var$pathPopFront(this.path), this.children);
        }
    }
    toString() {
        return 'Operation(' + this.path + ': ' + this.source.toString() + ' merge: ' + this.children.toString() + ')';
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */ class $668b2310913a4fe8$var$CacheNode {
    constructor(node_, fullyInitialized_, filtered_){
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     */ isFullyInitialized() {
        return this.fullyInitialized_;
    }
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     */ isFiltered() {
        return this.filtered_;
    }
    isCompleteForPath(path) {
        if ($668b2310913a4fe8$var$pathIsEmpty(path)) return this.isFullyInitialized() && !this.filtered_;
        const childKey = $668b2310913a4fe8$var$pathGetFront(path);
        return this.isCompleteForChild(childKey);
    }
    isCompleteForChild(key) {
        return this.isFullyInitialized() && !this.filtered_ || this.node_.hasChild(key);
    }
    getNode() {
        return this.node_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 */ class $668b2310913a4fe8$var$EventGenerator {
    constructor(query_){
        this.query_ = query_;
        this.index_ = this.query_._queryParams.getIndex();
    }
}
/**
 * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
 * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
 *
 * Notes:
 *  - child_moved events will be synthesized at this time for any child_changed events that affect
 *    our index.
 *  - prevName will be calculated based on the index ordering.
 */ function $668b2310913a4fe8$var$eventGeneratorGenerateEventsForChanges(eventGenerator, changes, eventCache, eventRegistrations) {
    const events = [];
    const moves = [];
    changes.forEach((change)=>{
        if (change.type === "child_changed" /* ChangeType.CHILD_CHANGED */  && eventGenerator.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) moves.push($668b2310913a4fe8$var$changeChildMoved(change.childName, change.snapshotNode));
    });
    $668b2310913a4fe8$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_removed" /* ChangeType.CHILD_REMOVED */ , changes, eventRegistrations, eventCache);
    $668b2310913a4fe8$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_added" /* ChangeType.CHILD_ADDED */ , changes, eventRegistrations, eventCache);
    $668b2310913a4fe8$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_moved" /* ChangeType.CHILD_MOVED */ , moves, eventRegistrations, eventCache);
    $668b2310913a4fe8$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_changed" /* ChangeType.CHILD_CHANGED */ , changes, eventRegistrations, eventCache);
    $668b2310913a4fe8$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "value" /* ChangeType.VALUE */ , changes, eventRegistrations, eventCache);
    return events;
}
/**
 * Given changes of a single change type, generate the corresponding events.
 */ function $668b2310913a4fe8$var$eventGeneratorGenerateEventsForType(eventGenerator, events, eventType, changes, registrations, eventCache) {
    const filteredChanges = changes.filter((change)=>change.type === eventType);
    filteredChanges.sort((a, b)=>$668b2310913a4fe8$var$eventGeneratorCompareChanges(eventGenerator, a, b));
    filteredChanges.forEach((change)=>{
        const materializedChange = $668b2310913a4fe8$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache);
        registrations.forEach((registration)=>{
            if (registration.respondsTo(change.type)) events.push(registration.createEvent(materializedChange, eventGenerator.query_));
        });
    });
}
function $668b2310913a4fe8$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache) {
    if (change.type === 'value' || change.type === 'child_removed') return change;
    else {
        change.prevName = eventCache.getPredecessorChildName(change.childName, change.snapshotNode, eventGenerator.index_);
        return change;
    }
}
function $668b2310913a4fe8$var$eventGeneratorCompareChanges(eventGenerator, a, b) {
    if (a.childName == null || b.childName == null) throw (0, $ffjl9.assertionError)('Should only compare child_ events.');
    const aWrapped = new $668b2310913a4fe8$var$NamedNode(a.childName, a.snapshotNode);
    const bWrapped = new $668b2310913a4fe8$var$NamedNode(b.childName, b.snapshotNode);
    return eventGenerator.index_.compare(aWrapped, bWrapped);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $668b2310913a4fe8$var$newViewCache(eventCache, serverCache) {
    return {
        eventCache: eventCache,
        serverCache: serverCache
    };
}
function $668b2310913a4fe8$var$viewCacheUpdateEventSnap(viewCache, eventSnap, complete, filtered) {
    return $668b2310913a4fe8$var$newViewCache(new $668b2310913a4fe8$var$CacheNode(eventSnap, complete, filtered), viewCache.serverCache);
}
function $668b2310913a4fe8$var$viewCacheUpdateServerSnap(viewCache, serverSnap, complete, filtered) {
    return $668b2310913a4fe8$var$newViewCache(viewCache.eventCache, new $668b2310913a4fe8$var$CacheNode(serverSnap, complete, filtered));
}
function $668b2310913a4fe8$var$viewCacheGetCompleteEventSnap(viewCache) {
    return viewCache.eventCache.isFullyInitialized() ? viewCache.eventCache.getNode() : null;
}
function $668b2310913a4fe8$var$viewCacheGetCompleteServerSnap(viewCache) {
    return viewCache.serverCache.isFullyInitialized() ? viewCache.serverCache.getNode() : null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $668b2310913a4fe8$var$emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 */ const $668b2310913a4fe8$var$EmptyChildren = ()=>{
    if (!$668b2310913a4fe8$var$emptyChildrenSingleton) $668b2310913a4fe8$var$emptyChildrenSingleton = new $668b2310913a4fe8$var$SortedMap($668b2310913a4fe8$var$stringCompare);
    return $668b2310913a4fe8$var$emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */ class $668b2310913a4fe8$var$ImmutableTree {
    constructor(value, children = $668b2310913a4fe8$var$EmptyChildren()){
        this.value = value;
        this.children = children;
    }
    static fromObject(obj) {
        let tree = new $668b2310913a4fe8$var$ImmutableTree(null);
        $668b2310913a4fe8$var$each(obj, (childPath, childSnap)=>{
            tree = tree.set(new $668b2310913a4fe8$var$Path(childPath), childSnap);
        });
        return tree;
    }
    /**
     * True if the value is empty and there are no children
     */ isEmpty() {
        return this.value === null && this.children.isEmpty();
    }
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of `{path: value:}`
     * objects on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param relativePath - The remainder of the path
     * @param predicate - The predicate to satisfy to return a node
     */ findRootMostMatchingPathAndValue(relativePath, predicate) {
        if (this.value != null && predicate(this.value)) return {
            path: $668b2310913a4fe8$var$newEmptyPath(),
            value: this.value
        };
        else {
            if ($668b2310913a4fe8$var$pathIsEmpty(relativePath)) return null;
            else {
                const front = $668b2310913a4fe8$var$pathGetFront(relativePath);
                const child = this.children.get(front);
                if (child !== null) {
                    const childExistingPathAndValue = child.findRootMostMatchingPathAndValue($668b2310913a4fe8$var$pathPopFront(relativePath), predicate);
                    if (childExistingPathAndValue != null) {
                        const fullPath = $668b2310913a4fe8$var$pathChild(new $668b2310913a4fe8$var$Path(front), childExistingPathAndValue.path);
                        return {
                            path: fullPath,
                            value: childExistingPathAndValue.value
                        };
                    } else return null;
                } else return null;
            }
        }
    }
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     */ findRootMostValueAndPath(relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, ()=>true);
    }
    /**
     * @returns The subtree at the given path
     */ subtree(relativePath) {
        if ($668b2310913a4fe8$var$pathIsEmpty(relativePath)) return this;
        else {
            const front = $668b2310913a4fe8$var$pathGetFront(relativePath);
            const childTree = this.children.get(front);
            if (childTree !== null) return childTree.subtree($668b2310913a4fe8$var$pathPopFront(relativePath));
            else return new $668b2310913a4fe8$var$ImmutableTree(null);
        }
    }
    /**
     * Sets a value at the specified path.
     *
     * @param relativePath - Path to set value at.
     * @param toSet - Value to set.
     * @returns Resulting tree.
     */ set(relativePath, toSet) {
        if ($668b2310913a4fe8$var$pathIsEmpty(relativePath)) return new $668b2310913a4fe8$var$ImmutableTree(toSet, this.children);
        else {
            const front = $668b2310913a4fe8$var$pathGetFront(relativePath);
            const child = this.children.get(front) || new $668b2310913a4fe8$var$ImmutableTree(null);
            const newChild = child.set($668b2310913a4fe8$var$pathPopFront(relativePath), toSet);
            const newChildren = this.children.insert(front, newChild);
            return new $668b2310913a4fe8$var$ImmutableTree(this.value, newChildren);
        }
    }
    /**
     * Removes the value at the specified path.
     *
     * @param relativePath - Path to value to remove.
     * @returns Resulting tree.
     */ remove(relativePath) {
        if ($668b2310913a4fe8$var$pathIsEmpty(relativePath)) {
            if (this.children.isEmpty()) return new $668b2310913a4fe8$var$ImmutableTree(null);
            else return new $668b2310913a4fe8$var$ImmutableTree(null, this.children);
        } else {
            const front = $668b2310913a4fe8$var$pathGetFront(relativePath);
            const child = this.children.get(front);
            if (child) {
                const newChild = child.remove($668b2310913a4fe8$var$pathPopFront(relativePath));
                let newChildren;
                if (newChild.isEmpty()) newChildren = this.children.remove(front);
                else newChildren = this.children.insert(front, newChild);
                if (this.value === null && newChildren.isEmpty()) return new $668b2310913a4fe8$var$ImmutableTree(null);
                else return new $668b2310913a4fe8$var$ImmutableTree(this.value, newChildren);
            } else return this;
        }
    }
    /**
     * Gets a value from the tree.
     *
     * @param relativePath - Path to get value for.
     * @returns Value at path, or null.
     */ get(relativePath) {
        if ($668b2310913a4fe8$var$pathIsEmpty(relativePath)) return this.value;
        else {
            const front = $668b2310913a4fe8$var$pathGetFront(relativePath);
            const child = this.children.get(front);
            if (child) return child.get($668b2310913a4fe8$var$pathPopFront(relativePath));
            else return null;
        }
    }
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param relativePath - Path to replace subtree for.
     * @param newTree - New tree.
     * @returns Resulting tree.
     */ setTree(relativePath, newTree) {
        if ($668b2310913a4fe8$var$pathIsEmpty(relativePath)) return newTree;
        else {
            const front = $668b2310913a4fe8$var$pathGetFront(relativePath);
            const child = this.children.get(front) || new $668b2310913a4fe8$var$ImmutableTree(null);
            const newChild = child.setTree($668b2310913a4fe8$var$pathPopFront(relativePath), newTree);
            let newChildren;
            if (newChild.isEmpty()) newChildren = this.children.remove(front);
            else newChildren = this.children.insert(front, newChild);
            return new $668b2310913a4fe8$var$ImmutableTree(this.value, newChildren);
        }
    }
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     */ fold(fn) {
        return this.fold_($668b2310913a4fe8$var$newEmptyPath(), fn);
    }
    /**
     * Recursive helper for public-facing fold() method
     */ fold_(pathSoFar, fn) {
        const accum = {};
        this.children.inorderTraversal((childKey, childTree)=>{
            accum[childKey] = childTree.fold_($668b2310913a4fe8$var$pathChild(pathSoFar, childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    }
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     */ findOnPath(path, f) {
        return this.findOnPath_(path, $668b2310913a4fe8$var$newEmptyPath(), f);
    }
    findOnPath_(pathToFollow, pathSoFar, f) {
        const result = this.value ? f(pathSoFar, this.value) : false;
        if (result) return result;
        else {
            if ($668b2310913a4fe8$var$pathIsEmpty(pathToFollow)) return null;
            else {
                const front = $668b2310913a4fe8$var$pathGetFront(pathToFollow);
                const nextChild = this.children.get(front);
                if (nextChild) return nextChild.findOnPath_($668b2310913a4fe8$var$pathPopFront(pathToFollow), $668b2310913a4fe8$var$pathChild(pathSoFar, front), f);
                else return null;
            }
        }
    }
    foreachOnPath(path, f) {
        return this.foreachOnPath_(path, $668b2310913a4fe8$var$newEmptyPath(), f);
    }
    foreachOnPath_(pathToFollow, currentRelativePath, f) {
        if ($668b2310913a4fe8$var$pathIsEmpty(pathToFollow)) return this;
        else {
            if (this.value) f(currentRelativePath, this.value);
            const front = $668b2310913a4fe8$var$pathGetFront(pathToFollow);
            const nextChild = this.children.get(front);
            if (nextChild) return nextChild.foreachOnPath_($668b2310913a4fe8$var$pathPopFront(pathToFollow), $668b2310913a4fe8$var$pathChild(currentRelativePath, front), f);
            else return new $668b2310913a4fe8$var$ImmutableTree(null);
        }
    }
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param f - A function to be called with the path from the root of the tree to
     * a node, and the value at that node. Called in depth-first order.
     */ foreach(f) {
        this.foreach_($668b2310913a4fe8$var$newEmptyPath(), f);
    }
    foreach_(currentRelativePath, f) {
        this.children.inorderTraversal((childName, childTree)=>{
            childTree.foreach_($668b2310913a4fe8$var$pathChild(currentRelativePath, childName), f);
        });
        if (this.value) f(currentRelativePath, this.value);
    }
    foreachChild(f) {
        this.children.inorderTraversal((childName, childTree)=>{
            if (childTree.value) f(childName, childTree.value);
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 */ class $668b2310913a4fe8$var$CompoundWrite {
    constructor(writeTree_){
        this.writeTree_ = writeTree_;
    }
    static empty() {
        return new $668b2310913a4fe8$var$CompoundWrite(new $668b2310913a4fe8$var$ImmutableTree(null));
    }
}
function $668b2310913a4fe8$var$compoundWriteAddWrite(compoundWrite, path, node) {
    if ($668b2310913a4fe8$var$pathIsEmpty(path)) return new $668b2310913a4fe8$var$CompoundWrite(new $668b2310913a4fe8$var$ImmutableTree(node));
    else {
        const rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) {
            const rootMostPath = rootmost.path;
            let value = rootmost.value;
            const relativePath = $668b2310913a4fe8$var$newRelativePath(rootMostPath, path);
            value = value.updateChild(relativePath, node);
            return new $668b2310913a4fe8$var$CompoundWrite(compoundWrite.writeTree_.set(rootMostPath, value));
        } else {
            const subtree = new $668b2310913a4fe8$var$ImmutableTree(node);
            const newWriteTree = compoundWrite.writeTree_.setTree(path, subtree);
            return new $668b2310913a4fe8$var$CompoundWrite(newWriteTree);
        }
    }
}
function $668b2310913a4fe8$var$compoundWriteAddWrites(compoundWrite, path, updates) {
    let newWrite = compoundWrite;
    $668b2310913a4fe8$var$each(updates, (childKey, node)=>{
        newWrite = $668b2310913a4fe8$var$compoundWriteAddWrite(newWrite, $668b2310913a4fe8$var$pathChild(path, childKey), node);
    });
    return newWrite;
}
/**
 * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
 * location, which must be removed by calling this method with that path.
 *
 * @param compoundWrite - The CompoundWrite to remove.
 * @param path - The path at which a write and all deeper writes should be removed
 * @returns The new CompoundWrite with the removed path
 */ function $668b2310913a4fe8$var$compoundWriteRemoveWrite(compoundWrite, path) {
    if ($668b2310913a4fe8$var$pathIsEmpty(path)) return $668b2310913a4fe8$var$CompoundWrite.empty();
    else {
        const newWriteTree = compoundWrite.writeTree_.setTree(path, new $668b2310913a4fe8$var$ImmutableTree(null));
        return new $668b2310913a4fe8$var$CompoundWrite(newWriteTree);
    }
}
/**
 * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
 * considered "complete".
 *
 * @param compoundWrite - The CompoundWrite to check.
 * @param path - The path to check for
 * @returns Whether there is a complete write at that path
 */ function $668b2310913a4fe8$var$compoundWriteHasCompleteWrite(compoundWrite, path) {
    return $668b2310913a4fe8$var$compoundWriteGetCompleteNode(compoundWrite, path) != null;
}
/**
 * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
 * writes from deeper paths, but will return child nodes from a more shallow path.
 *
 * @param compoundWrite - The CompoundWrite to get the node from.
 * @param path - The path to get a complete write
 * @returns The node if complete at that path, or null otherwise.
 */ function $668b2310913a4fe8$var$compoundWriteGetCompleteNode(compoundWrite, path) {
    const rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
    if (rootmost != null) return compoundWrite.writeTree_.get(rootmost.path).getChild($668b2310913a4fe8$var$newRelativePath(rootmost.path, path));
    else return null;
}
/**
 * Returns all children that are guaranteed to be a complete overwrite.
 *
 * @param compoundWrite - The CompoundWrite to get children from.
 * @returns A list of all complete children.
 */ function $668b2310913a4fe8$var$compoundWriteGetCompleteChildren(compoundWrite) {
    const children = [];
    const node = compoundWrite.writeTree_.value;
    if (node != null) // If it's a leaf node, it has no children; so nothing to do.
    {
        if (!node.isLeafNode()) node.forEachChild($668b2310913a4fe8$var$PRIORITY_INDEX, (childName, childNode)=>{
            children.push(new $668b2310913a4fe8$var$NamedNode(childName, childNode));
        });
    } else compoundWrite.writeTree_.children.inorderTraversal((childName, childTree)=>{
        if (childTree.value != null) children.push(new $668b2310913a4fe8$var$NamedNode(childName, childTree.value));
    });
    return children;
}
function $668b2310913a4fe8$var$compoundWriteChildCompoundWrite(compoundWrite, path) {
    if ($668b2310913a4fe8$var$pathIsEmpty(path)) return compoundWrite;
    else {
        const shadowingNode = $668b2310913a4fe8$var$compoundWriteGetCompleteNode(compoundWrite, path);
        if (shadowingNode != null) return new $668b2310913a4fe8$var$CompoundWrite(new $668b2310913a4fe8$var$ImmutableTree(shadowingNode));
        else return new $668b2310913a4fe8$var$CompoundWrite(compoundWrite.writeTree_.subtree(path));
    }
}
/**
 * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
 * @returns Whether this CompoundWrite is empty
 */ function $668b2310913a4fe8$var$compoundWriteIsEmpty(compoundWrite) {
    return compoundWrite.writeTree_.isEmpty();
}
/**
 * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
 * node
 * @param node - The node to apply this CompoundWrite to
 * @returns The node with all writes applied
 */ function $668b2310913a4fe8$var$compoundWriteApply(compoundWrite, node) {
    return $668b2310913a4fe8$var$applySubtreeWrite($668b2310913a4fe8$var$newEmptyPath(), compoundWrite.writeTree_, node);
}
function $668b2310913a4fe8$var$applySubtreeWrite(relativePath, writeTree, node) {
    if (writeTree.value != null) // Since there a write is always a leaf, we're done here
    return node.updateChild(relativePath, writeTree.value);
    else {
        let priorityWrite = null;
        writeTree.children.inorderTraversal((childKey, childTree)=>{
            if (childKey === '.priority') {
                // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                // to apply priorities to empty nodes that are later filled
                (0, $ffjl9.assert)(childTree.value !== null, 'Priority writes must always be leaf nodes');
                priorityWrite = childTree.value;
            } else node = $668b2310913a4fe8$var$applySubtreeWrite($668b2310913a4fe8$var$pathChild(relativePath, childKey), childTree, node);
        });
        // If there was a priority write, we only apply it if the node is not empty
        if (!node.getChild(relativePath).isEmpty() && priorityWrite !== null) node = node.updateChild($668b2310913a4fe8$var$pathChild(relativePath, '.priority'), priorityWrite);
        return node;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
 *
 */ function $668b2310913a4fe8$var$writeTreeChildWrites(writeTree, path) {
    return $668b2310913a4fe8$var$newWriteTreeRef(path, writeTree);
}
/**
 * Record a new overwrite from user code.
 *
 * @param visible - This is set to false by some transactions. It should be excluded from event caches
 */ function $668b2310913a4fe8$var$writeTreeAddOverwrite(writeTree, path, snap, writeId, visible) {
    (0, $ffjl9.assert)(writeId > writeTree.lastWriteId, 'Stacking an older write on top of newer ones');
    if (visible === undefined) visible = true;
    writeTree.allWrites.push({
        path: path,
        snap: snap,
        writeId: writeId,
        visible: visible
    });
    if (visible) writeTree.visibleWrites = $668b2310913a4fe8$var$compoundWriteAddWrite(writeTree.visibleWrites, path, snap);
    writeTree.lastWriteId = writeId;
}
/**
 * Record a new merge from user code.
 */ function $668b2310913a4fe8$var$writeTreeAddMerge(writeTree, path, changedChildren, writeId) {
    (0, $ffjl9.assert)(writeId > writeTree.lastWriteId, 'Stacking an older merge on top of newer ones');
    writeTree.allWrites.push({
        path: path,
        children: changedChildren,
        writeId: writeId,
        visible: true
    });
    writeTree.visibleWrites = $668b2310913a4fe8$var$compoundWriteAddWrites(writeTree.visibleWrites, path, changedChildren);
    writeTree.lastWriteId = writeId;
}
function $668b2310913a4fe8$var$writeTreeGetWrite(writeTree, writeId) {
    for(let i = 0; i < writeTree.allWrites.length; i++){
        const record = writeTree.allWrites[i];
        if (record.writeId === writeId) return record;
    }
    return null;
}
/**
 * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
 * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
 *
 * @returns true if the write may have been visible (meaning we'll need to reevaluate / raise
 * events as a result).
 */ function $668b2310913a4fe8$var$writeTreeRemoveWrite(writeTree, writeId) {
    // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
    // out of order.
    //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
    //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
    const idx = writeTree.allWrites.findIndex((s)=>{
        return s.writeId === writeId;
    });
    (0, $ffjl9.assert)(idx >= 0, 'removeWrite called with nonexistent writeId.');
    const writeToRemove = writeTree.allWrites[idx];
    writeTree.allWrites.splice(idx, 1);
    let removedWriteWasVisible = writeToRemove.visible;
    let removedWriteOverlapsWithOtherWrites = false;
    let i = writeTree.allWrites.length - 1;
    while(removedWriteWasVisible && i >= 0){
        const currentWrite = writeTree.allWrites[i];
        if (currentWrite.visible) {
            if (i >= idx && $668b2310913a4fe8$var$writeTreeRecordContainsPath_(currentWrite, writeToRemove.path)) // The removed write was completely shadowed by a subsequent write.
            removedWriteWasVisible = false;
            else if ($668b2310913a4fe8$var$pathContains(writeToRemove.path, currentWrite.path)) // Either we're covering some writes or they're covering part of us (depending on which came first).
            removedWriteOverlapsWithOtherWrites = true;
        }
        i--;
    }
    if (!removedWriteWasVisible) return false;
    else if (removedWriteOverlapsWithOtherWrites) {
        // There's some shadowing going on. Just rebuild the visible writes from scratch.
        $668b2310913a4fe8$var$writeTreeResetTree_(writeTree);
        return true;
    } else {
        // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
        if (writeToRemove.snap) writeTree.visibleWrites = $668b2310913a4fe8$var$compoundWriteRemoveWrite(writeTree.visibleWrites, writeToRemove.path);
        else {
            const children = writeToRemove.children;
            $668b2310913a4fe8$var$each(children, (childName)=>{
                writeTree.visibleWrites = $668b2310913a4fe8$var$compoundWriteRemoveWrite(writeTree.visibleWrites, $668b2310913a4fe8$var$pathChild(writeToRemove.path, childName));
            });
        }
        return true;
    }
}
function $668b2310913a4fe8$var$writeTreeRecordContainsPath_(writeRecord, path) {
    if (writeRecord.snap) return $668b2310913a4fe8$var$pathContains(writeRecord.path, path);
    else {
        for(const childName in writeRecord.children){
            if (writeRecord.children.hasOwnProperty(childName) && $668b2310913a4fe8$var$pathContains($668b2310913a4fe8$var$pathChild(writeRecord.path, childName), path)) return true;
        }
        return false;
    }
}
/**
 * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
 */ function $668b2310913a4fe8$var$writeTreeResetTree_(writeTree) {
    writeTree.visibleWrites = $668b2310913a4fe8$var$writeTreeLayerTree_(writeTree.allWrites, $668b2310913a4fe8$var$writeTreeDefaultFilter_, $668b2310913a4fe8$var$newEmptyPath());
    if (writeTree.allWrites.length > 0) writeTree.lastWriteId = writeTree.allWrites[writeTree.allWrites.length - 1].writeId;
    else writeTree.lastWriteId = -1;
}
/**
 * The default filter used when constructing the tree. Keep everything that's visible.
 */ function $668b2310913a4fe8$var$writeTreeDefaultFilter_(write) {
    return write.visible;
}
/**
 * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
 * event data at that path.
 */ function $668b2310913a4fe8$var$writeTreeLayerTree_(writes, filter, treeRoot) {
    let compoundWrite = $668b2310913a4fe8$var$CompoundWrite.empty();
    for(let i = 0; i < writes.length; ++i){
        const write = writes[i];
        // Theory, a later set will either:
        // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
        // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
        if (filter(write)) {
            const writePath = write.path;
            let relativePath;
            if (write.snap) {
                if ($668b2310913a4fe8$var$pathContains(treeRoot, writePath)) {
                    relativePath = $668b2310913a4fe8$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $668b2310913a4fe8$var$compoundWriteAddWrite(compoundWrite, relativePath, write.snap);
                } else if ($668b2310913a4fe8$var$pathContains(writePath, treeRoot)) {
                    relativePath = $668b2310913a4fe8$var$newRelativePath(writePath, treeRoot);
                    compoundWrite = $668b2310913a4fe8$var$compoundWriteAddWrite(compoundWrite, $668b2310913a4fe8$var$newEmptyPath(), write.snap.getChild(relativePath));
                }
            } else if (write.children) {
                if ($668b2310913a4fe8$var$pathContains(treeRoot, writePath)) {
                    relativePath = $668b2310913a4fe8$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $668b2310913a4fe8$var$compoundWriteAddWrites(compoundWrite, relativePath, write.children);
                } else if ($668b2310913a4fe8$var$pathContains(writePath, treeRoot)) {
                    relativePath = $668b2310913a4fe8$var$newRelativePath(writePath, treeRoot);
                    if ($668b2310913a4fe8$var$pathIsEmpty(relativePath)) compoundWrite = $668b2310913a4fe8$var$compoundWriteAddWrites(compoundWrite, $668b2310913a4fe8$var$newEmptyPath(), write.children);
                    else {
                        const child = (0, $ffjl9.safeGet)(write.children, $668b2310913a4fe8$var$pathGetFront(relativePath));
                        if (child) {
                            // There exists a child in this node that matches the root path
                            const deepNode = child.getChild($668b2310913a4fe8$var$pathPopFront(relativePath));
                            compoundWrite = $668b2310913a4fe8$var$compoundWriteAddWrite(compoundWrite, $668b2310913a4fe8$var$newEmptyPath(), deepNode);
                        }
                    }
                }
            } else throw (0, $ffjl9.assertionError)('WriteRecord should have .snap or .children');
        }
    }
    return compoundWrite;
}
/**
 * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
 * writes), attempt to calculate a complete snapshot for the given path
 *
 * @param writeIdsToExclude - An optional set to be excluded
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $668b2310913a4fe8$var$writeTreeCalcCompleteEventCache(writeTree, treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    if (!writeIdsToExclude && !includeHiddenWrites) {
        const shadowingNode = $668b2310913a4fe8$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
        if (shadowingNode != null) return shadowingNode;
        else {
            const subMerge = $668b2310913a4fe8$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
            if ($668b2310913a4fe8$var$compoundWriteIsEmpty(subMerge)) return completeServerCache;
            else if (completeServerCache == null && !$668b2310913a4fe8$var$compoundWriteHasCompleteWrite(subMerge, $668b2310913a4fe8$var$newEmptyPath())) // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
            return null;
            else {
                const layeredCache = completeServerCache || $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE;
                return $668b2310913a4fe8$var$compoundWriteApply(subMerge, layeredCache);
            }
        }
    } else {
        const merge = $668b2310913a4fe8$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        if (!includeHiddenWrites && $668b2310913a4fe8$var$compoundWriteIsEmpty(merge)) return completeServerCache;
        else {
            // If the server cache is null, and we don't have a complete cache, we need to return null
            if (!includeHiddenWrites && completeServerCache == null && !$668b2310913a4fe8$var$compoundWriteHasCompleteWrite(merge, $668b2310913a4fe8$var$newEmptyPath())) return null;
            else {
                const filter = function(write) {
                    return (write.visible || includeHiddenWrites) && (!writeIdsToExclude || !~writeIdsToExclude.indexOf(write.writeId)) && ($668b2310913a4fe8$var$pathContains(write.path, treePath) || $668b2310913a4fe8$var$pathContains(treePath, write.path));
                };
                const mergeAtPath = $668b2310913a4fe8$var$writeTreeLayerTree_(writeTree.allWrites, filter, treePath);
                const layeredCache = completeServerCache || $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE;
                return $668b2310913a4fe8$var$compoundWriteApply(mergeAtPath, layeredCache);
            }
        }
    }
}
/**
 * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
 * Used when creating new views, to pre-fill their complete event children snapshot.
 */ function $668b2310913a4fe8$var$writeTreeCalcCompleteEventChildren(writeTree, treePath, completeServerChildren) {
    let completeChildren = $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE;
    const topLevelSet = $668b2310913a4fe8$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
    if (topLevelSet) {
        if (!topLevelSet.isLeafNode()) // we're shadowing everything. Return the children.
        topLevelSet.forEachChild($668b2310913a4fe8$var$PRIORITY_INDEX, (childName, childSnap)=>{
            completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
        });
        return completeChildren;
    } else if (completeServerChildren) {
        // Layer any children we have on top of this
        // We know we don't have a top-level set, so just enumerate existing children
        const merge = $668b2310913a4fe8$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        completeServerChildren.forEachChild($668b2310913a4fe8$var$PRIORITY_INDEX, (childName, childNode)=>{
            const node = $668b2310913a4fe8$var$compoundWriteApply($668b2310913a4fe8$var$compoundWriteChildCompoundWrite(merge, new $668b2310913a4fe8$var$Path(childName)), childNode);
            completeChildren = completeChildren.updateImmediateChild(childName, node);
        });
        // Add any complete children we have from the set
        $668b2310913a4fe8$var$compoundWriteGetCompleteChildren(merge).forEach((namedNode)=>{
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    } else {
        // We don't have anything to layer on top of. Layer on any children we have
        // Note that we can return an empty snap if we have a defined delete
        const merge = $668b2310913a4fe8$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        $668b2310913a4fe8$var$compoundWriteGetCompleteChildren(merge).forEach((namedNode)=>{
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    }
}
/**
 * Given that the underlying server data has updated, determine what, if anything, needs to be
 * applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events
 *
 * Either existingEventSnap or existingServerSnap must exist
 */ function $668b2310913a4fe8$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTree, treePath, childPath, existingEventSnap, existingServerSnap) {
    (0, $ffjl9.assert)(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
    const path = $668b2310913a4fe8$var$pathChild(treePath, childPath);
    if ($668b2310913a4fe8$var$compoundWriteHasCompleteWrite(writeTree.visibleWrites, path)) // At this point we can probably guarantee that we're in case 2, meaning no events
    // May need to check visibility while doing the findRootMostValueAndPath call
    return null;
    else {
        // No complete shadowing. We're either partially shadowing or not shadowing at all.
        const childMerge = $668b2310913a4fe8$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
        if ($668b2310913a4fe8$var$compoundWriteIsEmpty(childMerge)) // We're not shadowing at all. Case 1
        return existingServerSnap.getChild(childPath);
        else // This could be more efficient if the serverNode + updates doesn't change the eventSnap
        // However this is tricky to find out, since user updates don't necessary change the server
        // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
        // adds nodes, but doesn't change any existing writes. It is therefore not enough to
        // only check if the updates change the serverNode.
        // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
        return $668b2310913a4fe8$var$compoundWriteApply(childMerge, existingServerSnap.getChild(childPath));
    }
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $668b2310913a4fe8$var$writeTreeCalcCompleteChild(writeTree, treePath, childKey, existingServerSnap) {
    const path = $668b2310913a4fe8$var$pathChild(treePath, childKey);
    const shadowingNode = $668b2310913a4fe8$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
    if (shadowingNode != null) return shadowingNode;
    else {
        if (existingServerSnap.isCompleteForChild(childKey)) {
            const childMerge = $668b2310913a4fe8$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
            return $668b2310913a4fe8$var$compoundWriteApply(childMerge, existingServerSnap.getNode().getImmediateChild(childKey));
        } else return null;
    }
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 */ function $668b2310913a4fe8$var$writeTreeShadowingWrite(writeTree, path) {
    return $668b2310913a4fe8$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window.
 */ function $668b2310913a4fe8$var$writeTreeCalcIndexedSlice(writeTree, treePath, completeServerData, startPost, count, reverse, index) {
    let toIterate;
    const merge = $668b2310913a4fe8$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
    const shadowingNode = $668b2310913a4fe8$var$compoundWriteGetCompleteNode(merge, $668b2310913a4fe8$var$newEmptyPath());
    if (shadowingNode != null) toIterate = shadowingNode;
    else if (completeServerData != null) toIterate = $668b2310913a4fe8$var$compoundWriteApply(merge, completeServerData);
    else // no children to iterate on
    return [];
    toIterate = toIterate.withIndex(index);
    if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
        const nodes = [];
        const cmp = index.getCompare();
        const iter = reverse ? toIterate.getReverseIteratorFrom(startPost, index) : toIterate.getIteratorFrom(startPost, index);
        let next = iter.getNext();
        while(next && nodes.length < count){
            if (cmp(next, startPost) !== 0) nodes.push(next);
            next = iter.getNext();
        }
        return nodes;
    } else return [];
}
function $668b2310913a4fe8$var$newWriteTree() {
    return {
        visibleWrites: $668b2310913a4fe8$var$CompoundWrite.empty(),
        allWrites: [],
        lastWriteId: -1
    };
}
/**
 * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
 * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
 * can lead to a more expensive calculation.
 *
 * @param writeIdsToExclude - Optional writes to exclude.
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $668b2310913a4fe8$var$writeTreeRefCalcCompleteEventCache(writeTreeRef, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    return $668b2310913a4fe8$var$writeTreeCalcCompleteEventCache(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites);
}
/**
 * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
 * mix of the given server data and write data.
 *
 */ function $668b2310913a4fe8$var$writeTreeRefCalcCompleteEventChildren(writeTreeRef, completeServerChildren) {
    return $668b2310913a4fe8$var$writeTreeCalcCompleteEventChildren(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerChildren);
}
/**
 * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
 * if anything, needs to be applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events should be raised
 *
 * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
 *
 *
 */ function $668b2310913a4fe8$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writeTreeRef, path, existingEventSnap, existingServerSnap) {
    return $668b2310913a4fe8$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTreeRef.writeTree, writeTreeRef.treePath, path, existingEventSnap, existingServerSnap);
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 *
 */ function $668b2310913a4fe8$var$writeTreeRefShadowingWrite(writeTreeRef, path) {
    return $668b2310913a4fe8$var$writeTreeShadowingWrite(writeTreeRef.writeTree, $668b2310913a4fe8$var$pathChild(writeTreeRef.treePath, path));
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window
 */ function $668b2310913a4fe8$var$writeTreeRefCalcIndexedSlice(writeTreeRef, completeServerData, startPost, count, reverse, index) {
    return $668b2310913a4fe8$var$writeTreeCalcIndexedSlice(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerData, startPost, count, reverse, index);
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $668b2310913a4fe8$var$writeTreeRefCalcCompleteChild(writeTreeRef, childKey, existingServerCache) {
    return $668b2310913a4fe8$var$writeTreeCalcCompleteChild(writeTreeRef.writeTree, writeTreeRef.treePath, childKey, existingServerCache);
}
/**
 * Return a WriteTreeRef for a child.
 */ function $668b2310913a4fe8$var$writeTreeRefChild(writeTreeRef, childName) {
    return $668b2310913a4fe8$var$newWriteTreeRef($668b2310913a4fe8$var$pathChild(writeTreeRef.treePath, childName), writeTreeRef.writeTree);
}
function $668b2310913a4fe8$var$newWriteTreeRef(path, writeTree) {
    return {
        treePath: path,
        writeTree: writeTree
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $668b2310913a4fe8$var$ChildChangeAccumulator {
    constructor(){
        this.changeMap = new Map();
    }
    trackChildChange(change) {
        const type = change.type;
        const childKey = change.childName;
        (0, $ffjl9.assert)(type === "child_added" /* ChangeType.CHILD_ADDED */  || type === "child_changed" /* ChangeType.CHILD_CHANGED */  || type === "child_removed" /* ChangeType.CHILD_REMOVED */ , 'Only child changes supported for tracking');
        (0, $ffjl9.assert)(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
        const oldChange = this.changeMap.get(childKey);
        if (oldChange) {
            const oldType = oldChange.type;
            if (type === "child_added" /* ChangeType.CHILD_ADDED */  && oldType === "child_removed" /* ChangeType.CHILD_REMOVED */ ) this.changeMap.set(childKey, $668b2310913a4fe8$var$changeChildChanged(childKey, change.snapshotNode, oldChange.snapshotNode));
            else if (type === "child_removed" /* ChangeType.CHILD_REMOVED */  && oldType === "child_added" /* ChangeType.CHILD_ADDED */ ) this.changeMap.delete(childKey);
            else if (type === "child_removed" /* ChangeType.CHILD_REMOVED */  && oldType === "child_changed" /* ChangeType.CHILD_CHANGED */ ) this.changeMap.set(childKey, $668b2310913a4fe8$var$changeChildRemoved(childKey, oldChange.oldSnap));
            else if (type === "child_changed" /* ChangeType.CHILD_CHANGED */  && oldType === "child_added" /* ChangeType.CHILD_ADDED */ ) this.changeMap.set(childKey, $668b2310913a4fe8$var$changeChildAdded(childKey, change.snapshotNode));
            else if (type === "child_changed" /* ChangeType.CHILD_CHANGED */  && oldType === "child_changed" /* ChangeType.CHILD_CHANGED */ ) this.changeMap.set(childKey, $668b2310913a4fe8$var$changeChildChanged(childKey, change.snapshotNode, oldChange.oldSnap));
            else throw (0, $ffjl9.assertionError)('Illegal combination of changes: ' + change + ' occurred after ' + oldChange);
        } else this.changeMap.set(childKey, change);
    }
    getChanges() {
        return Array.from(this.changeMap.values());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of CompleteChildSource that never returns any additional children
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
class $668b2310913a4fe8$var$NoCompleteChildSource_ {
    getCompleteChild(childKey) {
        return null;
    }
    getChildAfterChild(index, child, reverse) {
        return null;
    }
}
/**
 * Singleton instance.
 */ const $668b2310913a4fe8$var$NO_COMPLETE_CHILD_SOURCE = new $668b2310913a4fe8$var$NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 */ class $668b2310913a4fe8$var$WriteTreeCompleteChildSource {
    constructor(writes_, viewCache_, optCompleteServerCache_ = null){
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    getCompleteChild(childKey) {
        const node = this.viewCache_.eventCache;
        if (node.isCompleteForChild(childKey)) return node.getNode().getImmediateChild(childKey);
        else {
            const serverNode = this.optCompleteServerCache_ != null ? new $668b2310913a4fe8$var$CacheNode(this.optCompleteServerCache_, true, false) : this.viewCache_.serverCache;
            return $668b2310913a4fe8$var$writeTreeRefCalcCompleteChild(this.writes_, childKey, serverNode);
        }
    }
    getChildAfterChild(index, child, reverse) {
        const completeServerData = this.optCompleteServerCache_ != null ? this.optCompleteServerCache_ : $668b2310913a4fe8$var$viewCacheGetCompleteServerSnap(this.viewCache_);
        const nodes = $668b2310913a4fe8$var$writeTreeRefCalcIndexedSlice(this.writes_, completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) return null;
        else return nodes[0];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $668b2310913a4fe8$var$newViewProcessor(filter) {
    return {
        filter: filter
    };
}
function $668b2310913a4fe8$var$viewProcessorAssertIndexed(viewProcessor, viewCache) {
    (0, $ffjl9.assert)(viewCache.eventCache.getNode().isIndexed(viewProcessor.filter.getIndex()), 'Event snap not indexed');
    (0, $ffjl9.assert)(viewCache.serverCache.getNode().isIndexed(viewProcessor.filter.getIndex()), 'Server snap not indexed');
}
function $668b2310913a4fe8$var$viewProcessorApplyOperation(viewProcessor, oldViewCache, operation, writesCache, completeCache) {
    const accumulator = new $668b2310913a4fe8$var$ChildChangeAccumulator();
    let newViewCache, filterServerNode;
    if (operation.type === $668b2310913a4fe8$var$OperationType.OVERWRITE) {
        const overwrite = operation;
        if (overwrite.source.fromUser) newViewCache = $668b2310913a4fe8$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
        else {
            (0, $ffjl9.assert)(overwrite.source.fromServer, 'Unknown source.');
            // We filter the node if it's a tagged update or the node has been previously filtered  and the
            // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
            // again
            filterServerNode = overwrite.source.tagged || oldViewCache.serverCache.isFiltered() && !$668b2310913a4fe8$var$pathIsEmpty(overwrite.path);
            newViewCache = $668b2310913a4fe8$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $668b2310913a4fe8$var$OperationType.MERGE) {
        const merge = operation;
        if (merge.source.fromUser) newViewCache = $668b2310913a4fe8$var$viewProcessorApplyUserMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
        else {
            (0, $ffjl9.assert)(merge.source.fromServer, 'Unknown source.');
            // We filter the node if it's a tagged update or the node has been previously filtered
            filterServerNode = merge.source.tagged || oldViewCache.serverCache.isFiltered();
            newViewCache = $668b2310913a4fe8$var$viewProcessorApplyServerMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $668b2310913a4fe8$var$OperationType.ACK_USER_WRITE) {
        const ackUserWrite = operation;
        if (!ackUserWrite.revert) newViewCache = $668b2310913a4fe8$var$viewProcessorAckUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
        else newViewCache = $668b2310913a4fe8$var$viewProcessorRevertUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
    } else if (operation.type === $668b2310913a4fe8$var$OperationType.LISTEN_COMPLETE) newViewCache = $668b2310913a4fe8$var$viewProcessorListenComplete(viewProcessor, oldViewCache, operation.path, writesCache, accumulator);
    else throw (0, $ffjl9.assertionError)('Unknown operation type: ' + operation.type);
    const changes = accumulator.getChanges();
    $668b2310913a4fe8$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, changes);
    return {
        viewCache: newViewCache,
        changes: changes
    };
}
function $668b2310913a4fe8$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, accumulator) {
    const eventSnap = newViewCache.eventCache;
    if (eventSnap.isFullyInitialized()) {
        const isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
        const oldCompleteSnap = $668b2310913a4fe8$var$viewCacheGetCompleteEventSnap(oldViewCache);
        if (accumulator.length > 0 || !oldViewCache.eventCache.isFullyInitialized() || isLeafOrEmpty && !eventSnap.getNode().equals(oldCompleteSnap) || !eventSnap.getNode().getPriority().equals(oldCompleteSnap.getPriority())) accumulator.push($668b2310913a4fe8$var$changeValue($668b2310913a4fe8$var$viewCacheGetCompleteEventSnap(newViewCache)));
    }
}
function $668b2310913a4fe8$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, viewCache, changePath, writesCache, source, accumulator) {
    const oldEventSnap = viewCache.eventCache;
    if ($668b2310913a4fe8$var$writeTreeRefShadowingWrite(writesCache, changePath) != null) // we have a shadowing write, ignore changes
    return viewCache;
    else {
        let newEventCache, serverNode;
        if ($668b2310913a4fe8$var$pathIsEmpty(changePath)) {
            // TODO: figure out how this plays with "sliding ack windows"
            (0, $ffjl9.assert)(viewCache.serverCache.isFullyInitialized(), 'If change path is empty, we must have complete server data');
            if (viewCache.serverCache.isFiltered()) {
                // We need to special case this, because we need to only apply writes to complete children, or
                // we might end up raising events for incomplete children. If the server data is filtered deep
                // writes cannot be guaranteed to be complete
                const serverCache = $668b2310913a4fe8$var$viewCacheGetCompleteServerSnap(viewCache);
                const completeChildren = serverCache instanceof $668b2310913a4fe8$var$ChildrenNode ? serverCache : $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE;
                const completeEventChildren = $668b2310913a4fe8$var$writeTreeRefCalcCompleteEventChildren(writesCache, completeChildren);
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeEventChildren, accumulator);
            } else {
                const completeNode = $668b2310913a4fe8$var$writeTreeRefCalcCompleteEventCache(writesCache, $668b2310913a4fe8$var$viewCacheGetCompleteServerSnap(viewCache));
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeNode, accumulator);
            }
        } else {
            const childKey = $668b2310913a4fe8$var$pathGetFront(changePath);
            if (childKey === '.priority') {
                (0, $ffjl9.assert)($668b2310913a4fe8$var$pathGetLength(changePath) === 1, "Can't have a priority with additional path components");
                const oldEventNode = oldEventSnap.getNode();
                serverNode = viewCache.serverCache.getNode();
                // we might have overwrites for this priority
                const updatedPriority = $668b2310913a4fe8$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventNode, serverNode);
                if (updatedPriority != null) newEventCache = viewProcessor.filter.updatePriority(oldEventNode, updatedPriority);
                else // priority didn't change, keep old node
                newEventCache = oldEventSnap.getNode();
            } else {
                const childChangePath = $668b2310913a4fe8$var$pathPopFront(changePath);
                // update child
                let newEventChild;
                if (oldEventSnap.isCompleteForChild(childKey)) {
                    serverNode = viewCache.serverCache.getNode();
                    const eventChildUpdate = $668b2310913a4fe8$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventSnap.getNode(), serverNode);
                    if (eventChildUpdate != null) newEventChild = oldEventSnap.getNode().getImmediateChild(childKey).updateChild(childChangePath, eventChildUpdate);
                    else // Nothing changed, just keep the old child
                    newEventChild = oldEventSnap.getNode().getImmediateChild(childKey);
                } else newEventChild = $668b2310913a4fe8$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
                if (newEventChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                else // no complete child available or no change
                newEventCache = oldEventSnap.getNode();
            }
        }
        return $668b2310913a4fe8$var$viewCacheUpdateEventSnap(viewCache, newEventCache, oldEventSnap.isFullyInitialized() || $668b2310913a4fe8$var$pathIsEmpty(changePath), viewProcessor.filter.filtersNodes());
    }
}
function $668b2310913a4fe8$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
    const oldServerSnap = oldViewCache.serverCache;
    let newServerCache;
    const serverFilter = filterServerNode ? viewProcessor.filter : viewProcessor.filter.getIndexedFilter();
    if ($668b2310913a4fe8$var$pathIsEmpty(changePath)) newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
    else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
        // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
        const newServerNode = oldServerSnap.getNode().updateChild(changePath, changedSnap);
        newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
    } else {
        const childKey = $668b2310913a4fe8$var$pathGetFront(changePath);
        if (!oldServerSnap.isCompleteForPath(changePath) && $668b2310913a4fe8$var$pathGetLength(changePath) > 1) // We don't update incomplete nodes with updates intended for other listeners
        return oldViewCache;
        const childChangePath = $668b2310913a4fe8$var$pathPopFront(changePath);
        const childNode = oldServerSnap.getNode().getImmediateChild(childKey);
        const newChildNode = childNode.updateChild(childChangePath, changedSnap);
        if (childKey === '.priority') newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
        else newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, $668b2310913a4fe8$var$NO_COMPLETE_CHILD_SOURCE, null);
    }
    const newViewCache = $668b2310913a4fe8$var$viewCacheUpdateServerSnap(oldViewCache, newServerCache, oldServerSnap.isFullyInitialized() || $668b2310913a4fe8$var$pathIsEmpty(changePath), serverFilter.filtersNodes());
    const source = new $668b2310913a4fe8$var$WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
    return $668b2310913a4fe8$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, changePath, writesCache, source, accumulator);
}
function $668b2310913a4fe8$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
    const oldEventSnap = oldViewCache.eventCache;
    let newViewCache, newEventCache;
    const source = new $668b2310913a4fe8$var$WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
    if ($668b2310913a4fe8$var$pathIsEmpty(changePath)) {
        newEventCache = viewProcessor.filter.updateFullNode(oldViewCache.eventCache.getNode(), changedSnap, accumulator);
        newViewCache = $668b2310913a4fe8$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, true, viewProcessor.filter.filtersNodes());
    } else {
        const childKey = $668b2310913a4fe8$var$pathGetFront(changePath);
        if (childKey === '.priority') {
            newEventCache = viewProcessor.filter.updatePriority(oldViewCache.eventCache.getNode(), changedSnap);
            newViewCache = $668b2310913a4fe8$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
        } else {
            const childChangePath = $668b2310913a4fe8$var$pathPopFront(changePath);
            const oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
            let newChild;
            if ($668b2310913a4fe8$var$pathIsEmpty(childChangePath)) // Child overwrite, we can replace the child
            newChild = changedSnap;
            else {
                const childNode = source.getCompleteChild(childKey);
                if (childNode != null) {
                    if ($668b2310913a4fe8$var$pathGetBack(childChangePath) === '.priority' && childNode.getChild($668b2310913a4fe8$var$pathParent(childChangePath)).isEmpty()) // This is a priority update on an empty node. If this node exists on the server, the
                    // server will send down the priority in the update, so ignore for now
                    newChild = childNode;
                    else newChild = childNode.updateChild(childChangePath, changedSnap);
                } else // There is no complete child node available
                newChild = $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE;
            }
            if (!oldChild.equals(newChild)) {
                const newEventSnap = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                newViewCache = $668b2310913a4fe8$var$viewCacheUpdateEventSnap(oldViewCache, newEventSnap, oldEventSnap.isFullyInitialized(), viewProcessor.filter.filtersNodes());
            } else newViewCache = oldViewCache;
        }
    }
    return newViewCache;
}
function $668b2310913a4fe8$var$viewProcessorCacheHasChild(viewCache, childKey) {
    return viewCache.eventCache.isCompleteForChild(childKey);
}
function $668b2310913a4fe8$var$viewProcessorApplyUserMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    let curViewCache = viewCache;
    changedChildren.foreach((relativePath, childNode)=>{
        const writePath = $668b2310913a4fe8$var$pathChild(path, relativePath);
        if ($668b2310913a4fe8$var$viewProcessorCacheHasChild(viewCache, $668b2310913a4fe8$var$pathGetFront(writePath))) curViewCache = $668b2310913a4fe8$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    changedChildren.foreach((relativePath, childNode)=>{
        const writePath = $668b2310913a4fe8$var$pathChild(path, relativePath);
        if (!$668b2310913a4fe8$var$viewProcessorCacheHasChild(viewCache, $668b2310913a4fe8$var$pathGetFront(writePath))) curViewCache = $668b2310913a4fe8$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    return curViewCache;
}
function $668b2310913a4fe8$var$viewProcessorApplyMerge(viewProcessor, node, merge) {
    merge.foreach((relativePath, childNode)=>{
        node = node.updateChild(relativePath, childNode);
    });
    return node;
}
function $668b2310913a4fe8$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
    // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
    // wait for the complete data update coming soon.
    if (viewCache.serverCache.getNode().isEmpty() && !viewCache.serverCache.isFullyInitialized()) return viewCache;
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    let curViewCache = viewCache;
    let viewMergeTree;
    if ($668b2310913a4fe8$var$pathIsEmpty(path)) viewMergeTree = changedChildren;
    else viewMergeTree = new $668b2310913a4fe8$var$ImmutableTree(null).setTree(path, changedChildren);
    const serverNode = viewCache.serverCache.getNode();
    viewMergeTree.children.inorderTraversal((childKey, childTree)=>{
        if (serverNode.hasChild(childKey)) {
            const serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            const newChild = $668b2310913a4fe8$var$viewProcessorApplyMerge(viewProcessor, serverChild, childTree);
            curViewCache = $668b2310913a4fe8$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $668b2310913a4fe8$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    viewMergeTree.children.inorderTraversal((childKey, childMergeTree)=>{
        const isUnknownDeepMerge = !viewCache.serverCache.isCompleteForChild(childKey) && childMergeTree.value === null;
        if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
            const serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            const newChild = $668b2310913a4fe8$var$viewProcessorApplyMerge(viewProcessor, serverChild, childMergeTree);
            curViewCache = $668b2310913a4fe8$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $668b2310913a4fe8$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    return curViewCache;
}
function $668b2310913a4fe8$var$viewProcessorAckUserWrite(viewProcessor, viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
    if ($668b2310913a4fe8$var$writeTreeRefShadowingWrite(writesCache, ackPath) != null) return viewCache;
    // Only filter server node if it is currently filtered
    const filterServerNode = viewCache.serverCache.isFiltered();
    // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
    // now that it won't be shadowed.
    const serverCache = viewCache.serverCache;
    if (affectedTree.value != null) {
        // This is an overwrite.
        if ($668b2310913a4fe8$var$pathIsEmpty(ackPath) && serverCache.isFullyInitialized() || serverCache.isCompleteForPath(ackPath)) return $668b2310913a4fe8$var$viewProcessorApplyServerOverwrite(viewProcessor, viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
        else if ($668b2310913a4fe8$var$pathIsEmpty(ackPath)) {
            // This is a goofy edge case where we are acking data at this location but don't have full data.  We
            // should just re-apply whatever we have in our cache as a merge.
            let changedChildren = new $668b2310913a4fe8$var$ImmutableTree(null);
            serverCache.getNode().forEachChild($668b2310913a4fe8$var$KEY_INDEX, (name, node)=>{
                changedChildren = changedChildren.set(new $668b2310913a4fe8$var$Path(name), node);
            });
            return $668b2310913a4fe8$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren, writesCache, completeCache, filterServerNode, accumulator);
        } else return viewCache;
    } else {
        // This is a merge.
        let changedChildren = new $668b2310913a4fe8$var$ImmutableTree(null);
        affectedTree.foreach((mergePath, value)=>{
            const serverCachePath = $668b2310913a4fe8$var$pathChild(ackPath, mergePath);
            if (serverCache.isCompleteForPath(serverCachePath)) changedChildren = changedChildren.set(mergePath, serverCache.getNode().getChild(serverCachePath));
        });
        return $668b2310913a4fe8$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren, writesCache, completeCache, filterServerNode, accumulator);
    }
}
function $668b2310913a4fe8$var$viewProcessorListenComplete(viewProcessor, viewCache, path, writesCache, accumulator) {
    const oldServerNode = viewCache.serverCache;
    const newViewCache = $668b2310913a4fe8$var$viewCacheUpdateServerSnap(viewCache, oldServerNode.getNode(), oldServerNode.isFullyInitialized() || $668b2310913a4fe8$var$pathIsEmpty(path), oldServerNode.isFiltered());
    return $668b2310913a4fe8$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, path, writesCache, $668b2310913a4fe8$var$NO_COMPLETE_CHILD_SOURCE, accumulator);
}
function $668b2310913a4fe8$var$viewProcessorRevertUserWrite(viewProcessor, viewCache, path, writesCache, completeServerCache, accumulator) {
    let complete;
    if ($668b2310913a4fe8$var$writeTreeRefShadowingWrite(writesCache, path) != null) return viewCache;
    else {
        const source = new $668b2310913a4fe8$var$WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
        const oldEventCache = viewCache.eventCache.getNode();
        let newEventCache;
        if ($668b2310913a4fe8$var$pathIsEmpty(path) || $668b2310913a4fe8$var$pathGetFront(path) === '.priority') {
            let newNode;
            if (viewCache.serverCache.isFullyInitialized()) newNode = $668b2310913a4fe8$var$writeTreeRefCalcCompleteEventCache(writesCache, $668b2310913a4fe8$var$viewCacheGetCompleteServerSnap(viewCache));
            else {
                const serverChildren = viewCache.serverCache.getNode();
                (0, $ffjl9.assert)(serverChildren instanceof $668b2310913a4fe8$var$ChildrenNode, 'serverChildren would be complete if leaf node');
                newNode = $668b2310913a4fe8$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverChildren);
            }
            newNode;
            newEventCache = viewProcessor.filter.updateFullNode(oldEventCache, newNode, accumulator);
        } else {
            const childKey = $668b2310913a4fe8$var$pathGetFront(path);
            let newChild = $668b2310913a4fe8$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
            if (newChild == null && viewCache.serverCache.isCompleteForChild(childKey)) newChild = oldEventCache.getImmediateChild(childKey);
            if (newChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, newChild, $668b2310913a4fe8$var$pathPopFront(path), source, accumulator);
            else if (viewCache.eventCache.getNode().hasChild(childKey)) // No complete child available, delete the existing one, if any
            newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE, $668b2310913a4fe8$var$pathPopFront(path), source, accumulator);
            else newEventCache = oldEventCache;
            if (newEventCache.isEmpty() && viewCache.serverCache.isFullyInitialized()) {
                // We might have reverted all child writes. Maybe the old event was a leaf node
                complete = $668b2310913a4fe8$var$writeTreeRefCalcCompleteEventCache(writesCache, $668b2310913a4fe8$var$viewCacheGetCompleteServerSnap(viewCache));
                if (complete.isLeafNode()) newEventCache = viewProcessor.filter.updateFullNode(newEventCache, complete, accumulator);
            }
        }
        complete = viewCache.serverCache.isFullyInitialized() || $668b2310913a4fe8$var$writeTreeRefShadowingWrite(writesCache, $668b2310913a4fe8$var$newEmptyPath()) != null;
        return $668b2310913a4fe8$var$viewCacheUpdateEventSnap(viewCache, newEventCache, complete, viewProcessor.filter.filtersNodes());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 */ class $668b2310913a4fe8$var$View {
    constructor(query_, initialViewCache){
        this.query_ = query_;
        this.eventRegistrations_ = [];
        const params = this.query_._queryParams;
        const indexFilter = new $668b2310913a4fe8$var$IndexedFilter(params.getIndex());
        const filter = $668b2310913a4fe8$var$queryParamsGetNodeFilter(params);
        this.processor_ = $668b2310913a4fe8$var$newViewProcessor(filter);
        const initialServerCache = initialViewCache.serverCache;
        const initialEventCache = initialViewCache.eventCache;
        // Don't filter server node with other filter than index, wait for tagged listen
        const serverSnap = indexFilter.updateFullNode($668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        const eventSnap = filter.updateFullNode($668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        const newServerCache = new $668b2310913a4fe8$var$CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        const newEventCache = new $668b2310913a4fe8$var$CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        this.viewCache_ = $668b2310913a4fe8$var$newViewCache(newEventCache, newServerCache);
        this.eventGenerator_ = new $668b2310913a4fe8$var$EventGenerator(this.query_);
    }
    get query() {
        return this.query_;
    }
}
function $668b2310913a4fe8$var$viewGetServerCache(view) {
    return view.viewCache_.serverCache.getNode();
}
function $668b2310913a4fe8$var$viewGetCompleteNode(view) {
    return $668b2310913a4fe8$var$viewCacheGetCompleteEventSnap(view.viewCache_);
}
function $668b2310913a4fe8$var$viewGetCompleteServerCache(view, path) {
    const cache = $668b2310913a4fe8$var$viewCacheGetCompleteServerSnap(view.viewCache_);
    if (cache) {
        // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
        // we need to see if it contains the child we're interested in.
        if (view.query._queryParams.loadsAllData() || !$668b2310913a4fe8$var$pathIsEmpty(path) && !cache.getImmediateChild($668b2310913a4fe8$var$pathGetFront(path)).isEmpty()) return cache.getChild(path);
    }
    return null;
}
function $668b2310913a4fe8$var$viewIsEmpty(view) {
    return view.eventRegistrations_.length === 0;
}
function $668b2310913a4fe8$var$viewAddEventRegistration(view, eventRegistration) {
    view.eventRegistrations_.push(eventRegistration);
}
/**
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns Cancel events, if cancelError was provided.
 */ function $668b2310913a4fe8$var$viewRemoveEventRegistration(view, eventRegistration, cancelError) {
    const cancelEvents = [];
    if (cancelError) {
        (0, $ffjl9.assert)(eventRegistration == null, 'A cancel should cancel all event registrations.');
        const path = view.query._path;
        view.eventRegistrations_.forEach((registration)=>{
            const maybeEvent = registration.createCancelEvent(cancelError, path);
            if (maybeEvent) cancelEvents.push(maybeEvent);
        });
    }
    if (eventRegistration) {
        let remaining = [];
        for(let i = 0; i < view.eventRegistrations_.length; ++i){
            const existing = view.eventRegistrations_[i];
            if (!existing.matches(eventRegistration)) remaining.push(existing);
            else if (eventRegistration.hasAnyCallback()) {
                // We're removing just this one
                remaining = remaining.concat(view.eventRegistrations_.slice(i + 1));
                break;
            }
        }
        view.eventRegistrations_ = remaining;
    } else view.eventRegistrations_ = [];
    return cancelEvents;
}
/**
 * Applies the given Operation, updates our cache, and returns the appropriate events.
 */ function $668b2310913a4fe8$var$viewApplyOperation(view, operation, writesCache, completeServerCache) {
    if (operation.type === $668b2310913a4fe8$var$OperationType.MERGE && operation.source.queryId !== null) {
        (0, $ffjl9.assert)($668b2310913a4fe8$var$viewCacheGetCompleteServerSnap(view.viewCache_), 'We should always have a full cache before handling merges');
        (0, $ffjl9.assert)($668b2310913a4fe8$var$viewCacheGetCompleteEventSnap(view.viewCache_), 'Missing event cache, even though we have a server cache');
    }
    const oldViewCache = view.viewCache_;
    const result = $668b2310913a4fe8$var$viewProcessorApplyOperation(view.processor_, oldViewCache, operation, writesCache, completeServerCache);
    $668b2310913a4fe8$var$viewProcessorAssertIndexed(view.processor_, result.viewCache);
    (0, $ffjl9.assert)(result.viewCache.serverCache.isFullyInitialized() || !oldViewCache.serverCache.isFullyInitialized(), 'Once a server snap is complete, it should never go back');
    view.viewCache_ = result.viewCache;
    return $668b2310913a4fe8$var$viewGenerateEventsForChanges_(view, result.changes, result.viewCache.eventCache.getNode(), null);
}
function $668b2310913a4fe8$var$viewGetInitialEvents(view, registration) {
    const eventSnap = view.viewCache_.eventCache;
    const initialChanges = [];
    if (!eventSnap.getNode().isLeafNode()) {
        const eventNode = eventSnap.getNode();
        eventNode.forEachChild($668b2310913a4fe8$var$PRIORITY_INDEX, (key, childNode)=>{
            initialChanges.push($668b2310913a4fe8$var$changeChildAdded(key, childNode));
        });
    }
    if (eventSnap.isFullyInitialized()) initialChanges.push($668b2310913a4fe8$var$changeValue(eventSnap.getNode()));
    return $668b2310913a4fe8$var$viewGenerateEventsForChanges_(view, initialChanges, eventSnap.getNode(), registration);
}
function $668b2310913a4fe8$var$viewGenerateEventsForChanges_(view, changes, eventCache, eventRegistration) {
    const registrations = eventRegistration ? [
        eventRegistration
    ] : view.eventRegistrations_;
    return $668b2310913a4fe8$var$eventGeneratorGenerateEventsForChanges(view.eventGenerator_, changes, eventCache, registrations);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $668b2310913a4fe8$var$referenceConstructor$1;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */ class $668b2310913a4fe8$var$SyncPoint {
    constructor(){
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         */ this.views = new Map();
    }
}
function $668b2310913a4fe8$var$syncPointSetReferenceConstructor(val) {
    (0, $ffjl9.assert)(!$668b2310913a4fe8$var$referenceConstructor$1, '__referenceConstructor has already been defined');
    $668b2310913a4fe8$var$referenceConstructor$1 = val;
}
function $668b2310913a4fe8$var$syncPointGetReferenceConstructor() {
    (0, $ffjl9.assert)($668b2310913a4fe8$var$referenceConstructor$1, 'Reference.ts has not been loaded');
    return $668b2310913a4fe8$var$referenceConstructor$1;
}
function $668b2310913a4fe8$var$syncPointIsEmpty(syncPoint) {
    return syncPoint.views.size === 0;
}
function $668b2310913a4fe8$var$syncPointApplyOperation(syncPoint, operation, writesCache, optCompleteServerCache) {
    const queryId = operation.source.queryId;
    if (queryId !== null) {
        const view = syncPoint.views.get(queryId);
        (0, $ffjl9.assert)(view != null, 'SyncTree gave us an op for an invalid query.');
        return $668b2310913a4fe8$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache);
    } else {
        let events = [];
        for (const view of syncPoint.views.values())events = events.concat($668b2310913a4fe8$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache));
        return events;
    }
}
/**
 * Get a view for the specified query.
 *
 * @param query - The query to return a view for
 * @param writesCache
 * @param serverCache
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $668b2310913a4fe8$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete) {
    const queryId = query._queryIdentifier;
    const view = syncPoint.views.get(queryId);
    if (!view) {
        // TODO: make writesCache take flag for complete server node
        let eventCache = $668b2310913a4fe8$var$writeTreeRefCalcCompleteEventCache(writesCache, serverCacheComplete ? serverCache : null);
        let eventCacheComplete = false;
        if (eventCache) eventCacheComplete = true;
        else if (serverCache instanceof $668b2310913a4fe8$var$ChildrenNode) {
            eventCache = $668b2310913a4fe8$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverCache);
            eventCacheComplete = false;
        } else {
            eventCache = $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE;
            eventCacheComplete = false;
        }
        const viewCache = $668b2310913a4fe8$var$newViewCache(new $668b2310913a4fe8$var$CacheNode(eventCache, eventCacheComplete, false), new $668b2310913a4fe8$var$CacheNode(serverCache, serverCacheComplete, false));
        return new $668b2310913a4fe8$var$View(query, viewCache);
    }
    return view;
}
/**
 * Add an event callback for the specified query.
 *
 * @param query
 * @param eventRegistration
 * @param writesCache
 * @param serverCache - Complete server cache, if we have it.
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $668b2310913a4fe8$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
    const view = $668b2310913a4fe8$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete);
    if (!syncPoint.views.has(query._queryIdentifier)) syncPoint.views.set(query._queryIdentifier, view);
    // This is guaranteed to exist now, we just created anything that was missing
    $668b2310913a4fe8$var$viewAddEventRegistration(view, eventRegistration);
    return $668b2310913a4fe8$var$viewGetInitialEvents(view, eventRegistration);
}
/**
 * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
 *
 * If query is the default query, we'll check all views for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
 *
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns removed queries and any cancel events
 */ function $668b2310913a4fe8$var$syncPointRemoveEventRegistration(syncPoint, query, eventRegistration, cancelError) {
    const queryId = query._queryIdentifier;
    const removed = [];
    let cancelEvents = [];
    const hadCompleteView = $668b2310913a4fe8$var$syncPointHasCompleteView(syncPoint);
    if (queryId === 'default') // When you do ref.off(...), we search all views for the registration to remove.
    for (const [viewQueryId, view] of syncPoint.views.entries()){
        cancelEvents = cancelEvents.concat($668b2310913a4fe8$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
        if ($668b2310913a4fe8$var$viewIsEmpty(view)) {
            syncPoint.views.delete(viewQueryId);
            // We'll deal with complete views later.
            if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
        }
    }
    else {
        // remove the callback from the specific view.
        const view = syncPoint.views.get(queryId);
        if (view) {
            cancelEvents = cancelEvents.concat($668b2310913a4fe8$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
            if ($668b2310913a4fe8$var$viewIsEmpty(view)) {
                syncPoint.views.delete(queryId);
                // We'll deal with complete views later.
                if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
            }
        }
    }
    if (hadCompleteView && !$668b2310913a4fe8$var$syncPointHasCompleteView(syncPoint)) // We removed our last complete view.
    removed.push(new ($668b2310913a4fe8$var$syncPointGetReferenceConstructor())(query._repo, query._path));
    return {
        removed: removed,
        events: cancelEvents
    };
}
function $668b2310913a4fe8$var$syncPointGetQueryViews(syncPoint) {
    const result = [];
    for (const view of syncPoint.views.values())if (!view.query._queryParams.loadsAllData()) result.push(view);
    return result;
}
/**
 * @param path - The path to the desired complete snapshot
 * @returns A complete cache, if it exists
 */ function $668b2310913a4fe8$var$syncPointGetCompleteServerCache(syncPoint, path) {
    let serverCache = null;
    for (const view of syncPoint.views.values())serverCache = serverCache || $668b2310913a4fe8$var$viewGetCompleteServerCache(view, path);
    return serverCache;
}
function $668b2310913a4fe8$var$syncPointViewForQuery(syncPoint, query) {
    const params = query._queryParams;
    if (params.loadsAllData()) return $668b2310913a4fe8$var$syncPointGetCompleteView(syncPoint);
    else {
        const queryId = query._queryIdentifier;
        return syncPoint.views.get(queryId);
    }
}
function $668b2310913a4fe8$var$syncPointViewExistsForQuery(syncPoint, query) {
    return $668b2310913a4fe8$var$syncPointViewForQuery(syncPoint, query) != null;
}
function $668b2310913a4fe8$var$syncPointHasCompleteView(syncPoint) {
    return $668b2310913a4fe8$var$syncPointGetCompleteView(syncPoint) != null;
}
function $668b2310913a4fe8$var$syncPointGetCompleteView(syncPoint) {
    for (const view of syncPoint.views.values()){
        if (view.query._queryParams.loadsAllData()) return view;
    }
    return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $668b2310913a4fe8$var$referenceConstructor;
function $668b2310913a4fe8$var$syncTreeSetReferenceConstructor(val) {
    (0, $ffjl9.assert)(!$668b2310913a4fe8$var$referenceConstructor, '__referenceConstructor has already been defined');
    $668b2310913a4fe8$var$referenceConstructor = val;
}
function $668b2310913a4fe8$var$syncTreeGetReferenceConstructor() {
    (0, $ffjl9.assert)($668b2310913a4fe8$var$referenceConstructor, 'Reference.ts has not been loaded');
    return $668b2310913a4fe8$var$referenceConstructor;
}
/**
 * Static tracker for next query tag.
 */ let $668b2310913a4fe8$var$syncTreeNextQueryTag_ = 1;
/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 */ class $668b2310913a4fe8$var$SyncTree {
    /**
     * @param listenProvider_ - Used by SyncTree to start / stop listening
     *   to server data.
     */ constructor(listenProvider_){
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         */ this.syncPointTree_ = new $668b2310913a4fe8$var$ImmutableTree(null);
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         */ this.pendingWriteTree_ = $668b2310913a4fe8$var$newWriteTree();
        this.tagToQueryMap = new Map();
        this.queryToTagMap = new Map();
    }
}
/**
 * Apply the data changes for a user-generated set() or transaction() call.
 *
 * @returns Events to raise.
 */ function $668b2310913a4fe8$var$syncTreeApplyUserOverwrite(syncTree, path, newData, writeId, visible) {
    // Record pending write.
    $668b2310913a4fe8$var$writeTreeAddOverwrite(syncTree.pendingWriteTree_, path, newData, writeId, visible);
    if (!visible) return [];
    else return $668b2310913a4fe8$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $668b2310913a4fe8$var$Overwrite($668b2310913a4fe8$var$newOperationSourceUser(), path, newData));
}
/**
 * Apply the data from a user-generated update() call
 *
 * @returns Events to raise.
 */ function $668b2310913a4fe8$var$syncTreeApplyUserMerge(syncTree, path, changedChildren, writeId) {
    // Record pending merge.
    $668b2310913a4fe8$var$writeTreeAddMerge(syncTree.pendingWriteTree_, path, changedChildren, writeId);
    const changeTree = $668b2310913a4fe8$var$ImmutableTree.fromObject(changedChildren);
    return $668b2310913a4fe8$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $668b2310913a4fe8$var$Merge($668b2310913a4fe8$var$newOperationSourceUser(), path, changeTree));
}
/**
 * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
 *
 * @param revert - True if the given write failed and needs to be reverted
 * @returns Events to raise.
 */ function $668b2310913a4fe8$var$syncTreeAckUserWrite(syncTree, writeId, revert = false) {
    const write = $668b2310913a4fe8$var$writeTreeGetWrite(syncTree.pendingWriteTree_, writeId);
    const needToReevaluate = $668b2310913a4fe8$var$writeTreeRemoveWrite(syncTree.pendingWriteTree_, writeId);
    if (!needToReevaluate) return [];
    else {
        let affectedTree = new $668b2310913a4fe8$var$ImmutableTree(null);
        if (write.snap != null) // overwrite
        affectedTree = affectedTree.set($668b2310913a4fe8$var$newEmptyPath(), true);
        else $668b2310913a4fe8$var$each(write.children, (pathString)=>{
            affectedTree = affectedTree.set(new $668b2310913a4fe8$var$Path(pathString), true);
        });
        return $668b2310913a4fe8$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $668b2310913a4fe8$var$AckUserWrite(write.path, affectedTree, revert));
    }
}
/**
 * Apply new server data for the specified path..
 *
 * @returns Events to raise.
 */ function $668b2310913a4fe8$var$syncTreeApplyServerOverwrite(syncTree, path, newData) {
    return $668b2310913a4fe8$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $668b2310913a4fe8$var$Overwrite($668b2310913a4fe8$var$newOperationSourceServer(), path, newData));
}
/**
 * Apply new server data to be merged in at the specified path.
 *
 * @returns Events to raise.
 */ function $668b2310913a4fe8$var$syncTreeApplyServerMerge(syncTree, path, changedChildren) {
    const changeTree = $668b2310913a4fe8$var$ImmutableTree.fromObject(changedChildren);
    return $668b2310913a4fe8$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $668b2310913a4fe8$var$Merge($668b2310913a4fe8$var$newOperationSourceServer(), path, changeTree));
}
/**
 * Apply a listen complete for a query
 *
 * @returns Events to raise.
 */ function $668b2310913a4fe8$var$syncTreeApplyListenComplete(syncTree, path) {
    return $668b2310913a4fe8$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $668b2310913a4fe8$var$ListenComplete($668b2310913a4fe8$var$newOperationSourceServer(), path));
}
/**
 * Apply a listen complete for a tagged query
 *
 * @returns Events to raise.
 */ function $668b2310913a4fe8$var$syncTreeApplyTaggedListenComplete(syncTree, path, tag) {
    const queryKey = $668b2310913a4fe8$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        const r = $668b2310913a4fe8$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $668b2310913a4fe8$var$newRelativePath(queryPath, path);
        const op = new $668b2310913a4fe8$var$ListenComplete($668b2310913a4fe8$var$newOperationSourceServerTaggedQuery(queryId), relativePath);
        return $668b2310913a4fe8$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Remove event callback(s).
 *
 * If query is the default query, we'll check all queries for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
 *
 * @param eventRegistration - If null, all callbacks are removed.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @param skipListenerDedup - When performing a `get()`, we don't add any new listeners, so no
 *  deduping needs to take place. This flag allows toggling of that behavior
 * @returns Cancel events, if cancelError was provided.
 */ function $668b2310913a4fe8$var$syncTreeRemoveEventRegistration(syncTree, query, eventRegistration, cancelError, skipListenerDedup = false) {
    // Find the syncPoint first. Then deal with whether or not it has matching listeners
    const path = query._path;
    const maybeSyncPoint = syncTree.syncPointTree_.get(path);
    let cancelEvents = [];
    // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
    // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
    // not loadsAllData().
    if (maybeSyncPoint && (query._queryIdentifier === 'default' || $668b2310913a4fe8$var$syncPointViewExistsForQuery(maybeSyncPoint, query))) {
        const removedAndEvents = $668b2310913a4fe8$var$syncPointRemoveEventRegistration(maybeSyncPoint, query, eventRegistration, cancelError);
        if ($668b2310913a4fe8$var$syncPointIsEmpty(maybeSyncPoint)) syncTree.syncPointTree_ = syncTree.syncPointTree_.remove(path);
        const removed = removedAndEvents.removed;
        cancelEvents = removedAndEvents.events;
        if (!skipListenerDedup) {
            /**
             * We may have just removed one of many listeners and can short-circuit this whole process
             * We may also not have removed a default listener, in which case all of the descendant listeners should already be
             * properly set up.
             */ // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
            // queryId === 'default'
            const removingDefault = -1 !== removed.findIndex((query)=>{
                return query._queryParams.loadsAllData();
            });
            const covered = syncTree.syncPointTree_.findOnPath(path, (relativePath, parentSyncPoint)=>$668b2310913a4fe8$var$syncPointHasCompleteView(parentSyncPoint));
            if (removingDefault && !covered) {
                const subtree = syncTree.syncPointTree_.subtree(path);
                // There are potentially child listeners. Determine what if any listens we need to send before executing the
                // removal
                if (!subtree.isEmpty()) {
                    // We need to fold over our subtree and collect the listeners to send
                    const newViews = $668b2310913a4fe8$var$syncTreeCollectDistinctViewsForSubTree_(subtree);
                    // Ok, we've collected all the listens we need. Set them up.
                    for(let i = 0; i < newViews.length; ++i){
                        const view = newViews[i], newQuery = view.query;
                        const listener = $668b2310913a4fe8$var$syncTreeCreateListenerForView_(syncTree, view);
                        syncTree.listenProvider_.startListening($668b2310913a4fe8$var$syncTreeQueryForListening_(newQuery), $668b2310913a4fe8$var$syncTreeTagForQuery(syncTree, newQuery), listener.hashFn, listener.onComplete);
                    }
                }
            // Otherwise there's nothing below us, so nothing we need to start listening on
            }
            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
            // Also, note that if we have a cancelError, it's already been removed at the provider level.
            if (!covered && removed.length > 0 && !cancelError) {
                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
                // default. Otherwise, we need to iterate through and cancel each individual query
                if (removingDefault) {
                    // We don't tag default listeners
                    const defaultTag = null;
                    syncTree.listenProvider_.stopListening($668b2310913a4fe8$var$syncTreeQueryForListening_(query), defaultTag);
                } else removed.forEach((queryToRemove)=>{
                    const tagToRemove = syncTree.queryToTagMap.get($668b2310913a4fe8$var$syncTreeMakeQueryKey_(queryToRemove));
                    syncTree.listenProvider_.stopListening($668b2310913a4fe8$var$syncTreeQueryForListening_(queryToRemove), tagToRemove);
                });
            }
        }
        // Now, clear all of the tags we're tracking for the removed listens
        $668b2310913a4fe8$var$syncTreeRemoveTags_(syncTree, removed);
    }
    return cancelEvents;
}
/**
 * Apply new server data for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $668b2310913a4fe8$var$syncTreeApplyTaggedQueryOverwrite(syncTree, path, snap, tag) {
    const queryKey = $668b2310913a4fe8$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey != null) {
        const r = $668b2310913a4fe8$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $668b2310913a4fe8$var$newRelativePath(queryPath, path);
        const op = new $668b2310913a4fe8$var$Overwrite($668b2310913a4fe8$var$newOperationSourceServerTaggedQuery(queryId), relativePath, snap);
        return $668b2310913a4fe8$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // Query must have been removed already
    return [];
}
/**
 * Apply server data to be merged in for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $668b2310913a4fe8$var$syncTreeApplyTaggedQueryMerge(syncTree, path, changedChildren, tag) {
    const queryKey = $668b2310913a4fe8$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        const r = $668b2310913a4fe8$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $668b2310913a4fe8$var$newRelativePath(queryPath, path);
        const changeTree = $668b2310913a4fe8$var$ImmutableTree.fromObject(changedChildren);
        const op = new $668b2310913a4fe8$var$Merge($668b2310913a4fe8$var$newOperationSourceServerTaggedQuery(queryId), relativePath, changeTree);
        return $668b2310913a4fe8$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Add an event callback for the specified query.
 *
 * @returns Events to raise.
 */ function $668b2310913a4fe8$var$syncTreeAddEventRegistration(syncTree, query, eventRegistration, skipSetupListener = false) {
    const path = query._path;
    let serverCache = null;
    let foundAncestorDefaultView = false;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, (pathToSyncPoint, sp)=>{
        const relativePath = $668b2310913a4fe8$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $668b2310913a4fe8$var$syncPointGetCompleteServerCache(sp, relativePath);
        foundAncestorDefaultView = foundAncestorDefaultView || $668b2310913a4fe8$var$syncPointHasCompleteView(sp);
    });
    let syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $668b2310913a4fe8$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else {
        foundAncestorDefaultView = foundAncestorDefaultView || $668b2310913a4fe8$var$syncPointHasCompleteView(syncPoint);
        serverCache = serverCache || $668b2310913a4fe8$var$syncPointGetCompleteServerCache(syncPoint, $668b2310913a4fe8$var$newEmptyPath());
    }
    let serverCacheComplete;
    if (serverCache != null) serverCacheComplete = true;
    else {
        serverCacheComplete = false;
        serverCache = $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE;
        const subtree = syncTree.syncPointTree_.subtree(path);
        subtree.foreachChild((childName, childSyncPoint)=>{
            const completeCache = $668b2310913a4fe8$var$syncPointGetCompleteServerCache(childSyncPoint, $668b2310913a4fe8$var$newEmptyPath());
            if (completeCache) serverCache = serverCache.updateImmediateChild(childName, completeCache);
        });
    }
    const viewAlreadyExists = $668b2310913a4fe8$var$syncPointViewExistsForQuery(syncPoint, query);
    if (!viewAlreadyExists && !query._queryParams.loadsAllData()) {
        // We need to track a tag for this query
        const queryKey = $668b2310913a4fe8$var$syncTreeMakeQueryKey_(query);
        (0, $ffjl9.assert)(!syncTree.queryToTagMap.has(queryKey), 'View does not exist, but we have a tag');
        const tag = $668b2310913a4fe8$var$syncTreeGetNextQueryTag_();
        syncTree.queryToTagMap.set(queryKey, tag);
        syncTree.tagToQueryMap.set(tag, queryKey);
    }
    const writesCache = $668b2310913a4fe8$var$writeTreeChildWrites(syncTree.pendingWriteTree_, path);
    let events = $668b2310913a4fe8$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete);
    if (!viewAlreadyExists && !foundAncestorDefaultView && !skipSetupListener) {
        const view = $668b2310913a4fe8$var$syncPointViewForQuery(syncPoint, query);
        events = events.concat($668b2310913a4fe8$var$syncTreeSetupListener_(syncTree, query, view));
    }
    return events;
}
/**
 * Returns a complete cache, if we have one, of the data at a particular path. If the location does not have a
 * listener above it, we will get a false "null". This shouldn't be a problem because transactions will always
 * have a listener above, and atomic operations would correctly show a jitter of <increment value> ->
 *     <incremented total> as the write is applied locally and then acknowledged at the server.
 *
 * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
 *
 * @param path - The path to the data we want
 * @param writeIdsToExclude - A specific set to be excluded
 */ function $668b2310913a4fe8$var$syncTreeCalcCompleteEventCache(syncTree, path, writeIdsToExclude) {
    const includeHiddenSets = true;
    const writeTree = syncTree.pendingWriteTree_;
    const serverCache = syncTree.syncPointTree_.findOnPath(path, (pathSoFar, syncPoint)=>{
        const relativePath = $668b2310913a4fe8$var$newRelativePath(pathSoFar, path);
        const serverCache = $668b2310913a4fe8$var$syncPointGetCompleteServerCache(syncPoint, relativePath);
        if (serverCache) return serverCache;
    });
    return $668b2310913a4fe8$var$writeTreeCalcCompleteEventCache(writeTree, path, serverCache, writeIdsToExclude, includeHiddenSets);
}
function $668b2310913a4fe8$var$syncTreeGetServerValue(syncTree, query) {
    const path = query._path;
    let serverCache = null;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, (pathToSyncPoint, sp)=>{
        const relativePath = $668b2310913a4fe8$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $668b2310913a4fe8$var$syncPointGetCompleteServerCache(sp, relativePath);
    });
    let syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $668b2310913a4fe8$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else serverCache = serverCache || $668b2310913a4fe8$var$syncPointGetCompleteServerCache(syncPoint, $668b2310913a4fe8$var$newEmptyPath());
    const serverCacheComplete = serverCache != null;
    const serverCacheNode = serverCacheComplete ? new $668b2310913a4fe8$var$CacheNode(serverCache, true, false) : null;
    const writesCache = $668b2310913a4fe8$var$writeTreeChildWrites(syncTree.pendingWriteTree_, query._path);
    const view = $668b2310913a4fe8$var$syncPointGetView(syncPoint, query, writesCache, serverCacheComplete ? serverCacheNode.getNode() : $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE, serverCacheComplete);
    return $668b2310913a4fe8$var$viewGetCompleteNode(view);
}
/**
 * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
 *
 * NOTES:
 * - Descendant SyncPoints will be visited first (since we raise events depth-first).
 *
 * - We call applyOperation() on each SyncPoint passing three things:
 *   1. A version of the Operation that has been made relative to the SyncPoint location.
 *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
 *   3. A snapshot Node with cached server data, if we have it.
 *
 * - We concatenate all of the events returned by each SyncPoint and return the result.
 */ function $668b2310913a4fe8$var$syncTreeApplyOperationToSyncPoints_(syncTree, operation) {
    return $668b2310913a4fe8$var$syncTreeApplyOperationHelper_(operation, syncTree.syncPointTree_, /*serverCache=*/ null, $668b2310913a4fe8$var$writeTreeChildWrites(syncTree.pendingWriteTree_, $668b2310913a4fe8$var$newEmptyPath()));
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $668b2310913a4fe8$var$syncTreeApplyOperationHelper_(operation, syncPointTree, serverCache, writesCache) {
    if ($668b2310913a4fe8$var$pathIsEmpty(operation.path)) return $668b2310913a4fe8$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
    else {
        const syncPoint = syncPointTree.get($668b2310913a4fe8$var$newEmptyPath());
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) serverCache = $668b2310913a4fe8$var$syncPointGetCompleteServerCache(syncPoint, $668b2310913a4fe8$var$newEmptyPath());
        let events = [];
        const childName = $668b2310913a4fe8$var$pathGetFront(operation.path);
        const childOperation = operation.operationForChild(childName);
        const childTree = syncPointTree.children.get(childName);
        if (childTree && childOperation) {
            const childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
            const childWritesCache = $668b2310913a4fe8$var$writeTreeRefChild(writesCache, childName);
            events = events.concat($668b2310913a4fe8$var$syncTreeApplyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
        }
        if (syncPoint) events = events.concat($668b2310913a4fe8$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
        return events;
    }
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $668b2310913a4fe8$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache) {
    const syncPoint = syncPointTree.get($668b2310913a4fe8$var$newEmptyPath());
    // If we don't have cached server data, see if we can get it from this SyncPoint.
    if (serverCache == null && syncPoint != null) serverCache = $668b2310913a4fe8$var$syncPointGetCompleteServerCache(syncPoint, $668b2310913a4fe8$var$newEmptyPath());
    let events = [];
    syncPointTree.children.inorderTraversal((childName, childTree)=>{
        const childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
        const childWritesCache = $668b2310913a4fe8$var$writeTreeRefChild(writesCache, childName);
        const childOperation = operation.operationForChild(childName);
        if (childOperation) events = events.concat($668b2310913a4fe8$var$syncTreeApplyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
    });
    if (syncPoint) events = events.concat($668b2310913a4fe8$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
    return events;
}
function $668b2310913a4fe8$var$syncTreeCreateListenerForView_(syncTree, view) {
    const query = view.query;
    const tag = $668b2310913a4fe8$var$syncTreeTagForQuery(syncTree, query);
    return {
        hashFn: ()=>{
            const cache = $668b2310913a4fe8$var$viewGetServerCache(view) || $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE;
            return cache.hash();
        },
        onComplete: (status)=>{
            if (status === 'ok') {
                if (tag) return $668b2310913a4fe8$var$syncTreeApplyTaggedListenComplete(syncTree, query._path, tag);
                else return $668b2310913a4fe8$var$syncTreeApplyListenComplete(syncTree, query._path);
            } else {
                // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                const error = $668b2310913a4fe8$var$errorForServerCode(status, query);
                return $668b2310913a4fe8$var$syncTreeRemoveEventRegistration(syncTree, query, /*eventRegistration*/ null, error);
            }
        }
    };
}
/**
 * Return the tag associated with the given query.
 */ function $668b2310913a4fe8$var$syncTreeTagForQuery(syncTree, query) {
    const queryKey = $668b2310913a4fe8$var$syncTreeMakeQueryKey_(query);
    return syncTree.queryToTagMap.get(queryKey);
}
/**
 * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
 */ function $668b2310913a4fe8$var$syncTreeMakeQueryKey_(query) {
    return query._path.toString() + '$' + query._queryIdentifier;
}
/**
 * Return the query associated with the given tag, if we have one
 */ function $668b2310913a4fe8$var$syncTreeQueryKeyForTag_(syncTree, tag) {
    return syncTree.tagToQueryMap.get(tag);
}
/**
 * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
 */ function $668b2310913a4fe8$var$syncTreeParseQueryKey_(queryKey) {
    const splitIndex = queryKey.indexOf('$');
    (0, $ffjl9.assert)(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
    return {
        queryId: queryKey.substr(splitIndex + 1),
        path: new $668b2310913a4fe8$var$Path(queryKey.substr(0, splitIndex))
    };
}
/**
 * A helper method to apply tagged operations
 */ function $668b2310913a4fe8$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, operation) {
    const syncPoint = syncTree.syncPointTree_.get(queryPath);
    (0, $ffjl9.assert)(syncPoint, "Missing sync point for query tag that we're tracking");
    const writesCache = $668b2310913a4fe8$var$writeTreeChildWrites(syncTree.pendingWriteTree_, queryPath);
    return $668b2310913a4fe8$var$syncPointApplyOperation(syncPoint, operation, writesCache, null);
}
/**
 * This collapses multiple unfiltered views into a single view, since we only need a single
 * listener for them.
 */ function $668b2310913a4fe8$var$syncTreeCollectDistinctViewsForSubTree_(subtree) {
    return subtree.fold((relativePath, maybeChildSyncPoint, childMap)=>{
        if (maybeChildSyncPoint && $668b2310913a4fe8$var$syncPointHasCompleteView(maybeChildSyncPoint)) {
            const completeView = $668b2310913a4fe8$var$syncPointGetCompleteView(maybeChildSyncPoint);
            return [
                completeView
            ];
        } else {
            // No complete view here, flatten any deeper listens into an array
            let views = [];
            if (maybeChildSyncPoint) views = $668b2310913a4fe8$var$syncPointGetQueryViews(maybeChildSyncPoint);
            $668b2310913a4fe8$var$each(childMap, (_key, childViews)=>{
                views = views.concat(childViews);
            });
            return views;
        }
    });
}
/**
 * Normalizes a query to a query we send the server for listening
 *
 * @returns The normalized query
 */ function $668b2310913a4fe8$var$syncTreeQueryForListening_(query) {
    if (query._queryParams.loadsAllData() && !query._queryParams.isDefault()) // We treat queries that load all data as default queries
    // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
    // from Query
    return new ($668b2310913a4fe8$var$syncTreeGetReferenceConstructor())(query._repo, query._path);
    else return query;
}
function $668b2310913a4fe8$var$syncTreeRemoveTags_(syncTree, queries) {
    for(let j = 0; j < queries.length; ++j){
        const removedQuery = queries[j];
        if (!removedQuery._queryParams.loadsAllData()) {
            // We should have a tag for this
            const removedQueryKey = $668b2310913a4fe8$var$syncTreeMakeQueryKey_(removedQuery);
            const removedQueryTag = syncTree.queryToTagMap.get(removedQueryKey);
            syncTree.queryToTagMap.delete(removedQueryKey);
            syncTree.tagToQueryMap.delete(removedQueryTag);
        }
    }
}
/**
 * Static accessor for query tags.
 */ function $668b2310913a4fe8$var$syncTreeGetNextQueryTag_() {
    return $668b2310913a4fe8$var$syncTreeNextQueryTag_++;
}
/**
 * For a given new listen, manage the de-duplication of outstanding subscriptions.
 *
 * @returns This method can return events to support synchronous data sources
 */ function $668b2310913a4fe8$var$syncTreeSetupListener_(syncTree, query, view) {
    const path = query._path;
    const tag = $668b2310913a4fe8$var$syncTreeTagForQuery(syncTree, query);
    const listener = $668b2310913a4fe8$var$syncTreeCreateListenerForView_(syncTree, view);
    const events = syncTree.listenProvider_.startListening($668b2310913a4fe8$var$syncTreeQueryForListening_(query), tag, listener.hashFn, listener.onComplete);
    const subtree = syncTree.syncPointTree_.subtree(path);
    // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
    // may need to shadow other listens as well.
    if (tag) (0, $ffjl9.assert)(!$668b2310913a4fe8$var$syncPointHasCompleteView(subtree.value), "If we're adding a query, it shouldn't be shadowed");
    else {
        // Shadow everything at or below this location, this is a default listener.
        const queriesToStop = subtree.fold((relativePath, maybeChildSyncPoint, childMap)=>{
            if (!$668b2310913a4fe8$var$pathIsEmpty(relativePath) && maybeChildSyncPoint && $668b2310913a4fe8$var$syncPointHasCompleteView(maybeChildSyncPoint)) return [
                $668b2310913a4fe8$var$syncPointGetCompleteView(maybeChildSyncPoint).query
            ];
            else {
                // No default listener here, flatten any deeper queries into an array
                let queries = [];
                if (maybeChildSyncPoint) queries = queries.concat($668b2310913a4fe8$var$syncPointGetQueryViews(maybeChildSyncPoint).map((view)=>view.query));
                $668b2310913a4fe8$var$each(childMap, (_key, childQueries)=>{
                    queries = queries.concat(childQueries);
                });
                return queries;
            }
        });
        for(let i = 0; i < queriesToStop.length; ++i){
            const queryToStop = queriesToStop[i];
            syncTree.listenProvider_.stopListening($668b2310913a4fe8$var$syncTreeQueryForListening_(queryToStop), $668b2310913a4fe8$var$syncTreeTagForQuery(syncTree, queryToStop));
        }
    }
    return events;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $668b2310913a4fe8$var$ExistingValueProvider {
    constructor(node_){
        this.node_ = node_;
    }
    getImmediateChild(childName) {
        const child = this.node_.getImmediateChild(childName);
        return new $668b2310913a4fe8$var$ExistingValueProvider(child);
    }
    node() {
        return this.node_;
    }
}
class $668b2310913a4fe8$var$DeferredValueProvider {
    constructor(syncTree, path){
        this.syncTree_ = syncTree;
        this.path_ = path;
    }
    getImmediateChild(childName) {
        const childPath = $668b2310913a4fe8$var$pathChild(this.path_, childName);
        return new $668b2310913a4fe8$var$DeferredValueProvider(this.syncTree_, childPath);
    }
    node() {
        return $668b2310913a4fe8$var$syncTreeCalcCompleteEventCache(this.syncTree_, this.path_);
    }
}
/**
 * Generate placeholders for deferred values.
 */ const $668b2310913a4fe8$var$generateWithValues = function(values) {
    values = values || {};
    values['timestamp'] = values['timestamp'] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 */ const $668b2310913a4fe8$var$resolveDeferredLeafValue = function(value, existingVal, serverValues) {
    if (!value || typeof value !== 'object') return value;
    (0, $ffjl9.assert)('.sv' in value, 'Unexpected leaf node or priority contents');
    if (typeof value['.sv'] === 'string') return $668b2310913a4fe8$var$resolveScalarDeferredValue(value['.sv'], existingVal, serverValues);
    else if (typeof value['.sv'] === 'object') return $668b2310913a4fe8$var$resolveComplexDeferredValue(value['.sv'], existingVal);
    else (0, $ffjl9.assert)(false, 'Unexpected server value: ' + JSON.stringify(value, null, 2));
};
const $668b2310913a4fe8$var$resolveScalarDeferredValue = function(op, existing, serverValues) {
    switch(op){
        case 'timestamp':
            return serverValues['timestamp'];
        default:
            (0, $ffjl9.assert)(false, 'Unexpected server value: ' + op);
    }
};
const $668b2310913a4fe8$var$resolveComplexDeferredValue = function(op, existing, unused) {
    if (!op.hasOwnProperty('increment')) (0, $ffjl9.assert)(false, 'Unexpected server value: ' + JSON.stringify(op, null, 2));
    const delta = op['increment'];
    if (typeof delta !== 'number') (0, $ffjl9.assert)(false, 'Unexpected increment value: ' + delta);
    const existingNode = existing.node();
    (0, $ffjl9.assert)(existingNode !== null && typeof existingNode !== 'undefined', 'Expected ChildrenNode.EMPTY_NODE for nulls');
    // Incrementing a non-number sets the value to the incremented amount
    if (!existingNode.isLeafNode()) return delta;
    const leaf = existingNode;
    const existingVal = leaf.getValue();
    if (typeof existingVal !== 'number') return delta;
    // No need to do over/underflow arithmetic here because JS only handles floats under the covers
    return existingVal + delta;
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param path - path to which write is relative
 * @param node - new data written at path
 * @param syncTree - current data
 */ const $668b2310913a4fe8$var$resolveDeferredValueTree = function(path, node, syncTree, serverValues) {
    return $668b2310913a4fe8$var$resolveDeferredValue(node, new $668b2310913a4fe8$var$DeferredValueProvider(syncTree, path), serverValues);
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 */ const $668b2310913a4fe8$var$resolveDeferredValueSnapshot = function(node, existing, serverValues) {
    return $668b2310913a4fe8$var$resolveDeferredValue(node, new $668b2310913a4fe8$var$ExistingValueProvider(existing), serverValues);
};
function $668b2310913a4fe8$var$resolveDeferredValue(node, existingVal, serverValues) {
    const rawPri = node.getPriority().val();
    const priority = $668b2310913a4fe8$var$resolveDeferredLeafValue(rawPri, existingVal.getImmediateChild('.priority'), serverValues);
    let newNode;
    if (node.isLeafNode()) {
        const leafNode = node;
        const value = $668b2310913a4fe8$var$resolveDeferredLeafValue(leafNode.getValue(), existingVal, serverValues);
        if (value !== leafNode.getValue() || priority !== leafNode.getPriority().val()) return new $668b2310913a4fe8$var$LeafNode(value, $668b2310913a4fe8$var$nodeFromJSON(priority));
        else return node;
    } else {
        const childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) newNode = newNode.updatePriority(new $668b2310913a4fe8$var$LeafNode(priority));
        childrenNode.forEachChild($668b2310913a4fe8$var$PRIORITY_INDEX, (childName, childNode)=>{
            const newChildNode = $668b2310913a4fe8$var$resolveDeferredValue(childNode, existingVal.getImmediateChild(childName), serverValues);
            if (newChildNode !== childNode) newNode = newNode.updateImmediateChild(childName, newChildNode);
        });
        return newNode;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */ class $668b2310913a4fe8$var$Tree {
    /**
     * @param name - Optional name of the node.
     * @param parent - Optional parent node.
     * @param node - Optional node to wrap.
     */ constructor(name = '', parent = null, node = {
        children: {},
        childCount: 0
    }){
        this.name = name;
        this.parent = parent;
        this.node = node;
    }
}
/**
 * Returns a sub-Tree for the given path.
 *
 * @param pathObj - Path to look up.
 * @returns Tree for path.
 */ function $668b2310913a4fe8$var$treeSubTree(tree, pathObj) {
    // TODO: Require pathObj to be Path?
    let path = pathObj instanceof $668b2310913a4fe8$var$Path ? pathObj : new $668b2310913a4fe8$var$Path(pathObj);
    let child = tree, next = $668b2310913a4fe8$var$pathGetFront(path);
    while(next !== null){
        const childNode = (0, $ffjl9.safeGet)(child.node.children, next) || {
            children: {},
            childCount: 0
        };
        child = new $668b2310913a4fe8$var$Tree(next, child, childNode);
        path = $668b2310913a4fe8$var$pathPopFront(path);
        next = $668b2310913a4fe8$var$pathGetFront(path);
    }
    return child;
}
/**
 * Returns the data associated with this tree node.
 *
 * @returns The data or null if no data exists.
 */ function $668b2310913a4fe8$var$treeGetValue(tree) {
    return tree.node.value;
}
/**
 * Sets data to this tree node.
 *
 * @param value - Value to set.
 */ function $668b2310913a4fe8$var$treeSetValue(tree, value) {
    tree.node.value = value;
    $668b2310913a4fe8$var$treeUpdateParents(tree);
}
/**
 * @returns Whether the tree has any children.
 */ function $668b2310913a4fe8$var$treeHasChildren(tree) {
    return tree.node.childCount > 0;
}
/**
 * @returns Whether the tree is empty (no value or children).
 */ function $668b2310913a4fe8$var$treeIsEmpty(tree) {
    return $668b2310913a4fe8$var$treeGetValue(tree) === undefined && !$668b2310913a4fe8$var$treeHasChildren(tree);
}
/**
 * Calls action for each child of this tree node.
 *
 * @param action - Action to be called for each child.
 */ function $668b2310913a4fe8$var$treeForEachChild(tree, action) {
    $668b2310913a4fe8$var$each(tree.node.children, (child, childTree)=>{
        action(new $668b2310913a4fe8$var$Tree(child, tree, childTree));
    });
}
/**
 * Does a depth-first traversal of this node's descendants, calling action for each one.
 *
 * @param action - Action to be called for each child.
 * @param includeSelf - Whether to call action on this node as well. Defaults to
 *   false.
 * @param childrenFirst - Whether to call action on children before calling it on
 *   parent.
 */ function $668b2310913a4fe8$var$treeForEachDescendant(tree, action, includeSelf, childrenFirst) {
    if (includeSelf && !childrenFirst) action(tree);
    $668b2310913a4fe8$var$treeForEachChild(tree, (child)=>{
        $668b2310913a4fe8$var$treeForEachDescendant(child, action, true, childrenFirst);
    });
    if (includeSelf && childrenFirst) action(tree);
}
/**
 * Calls action on each ancestor node.
 *
 * @param action - Action to be called on each parent; return
 *   true to abort.
 * @param includeSelf - Whether to call action on this node as well.
 * @returns true if the action callback returned true.
 */ function $668b2310913a4fe8$var$treeForEachAncestor(tree, action, includeSelf) {
    let node = includeSelf ? tree : tree.parent;
    while(node !== null){
        if (action(node)) return true;
        node = node.parent;
    }
    return false;
}
/**
 * @returns The path of this tree node, as a Path.
 */ function $668b2310913a4fe8$var$treeGetPath(tree) {
    return new $668b2310913a4fe8$var$Path(tree.parent === null ? tree.name : $668b2310913a4fe8$var$treeGetPath(tree.parent) + '/' + tree.name);
}
/**
 * Adds or removes this child from its parent based on whether it's empty or not.
 */ function $668b2310913a4fe8$var$treeUpdateParents(tree) {
    if (tree.parent !== null) $668b2310913a4fe8$var$treeUpdateChild(tree.parent, tree.name, tree);
}
/**
 * Adds or removes the passed child to this tree node, depending on whether it's empty.
 *
 * @param childName - The name of the child to update.
 * @param child - The child to update.
 */ function $668b2310913a4fe8$var$treeUpdateChild(tree, childName, child) {
    const childEmpty = $668b2310913a4fe8$var$treeIsEmpty(child);
    const childExists = (0, $ffjl9.contains)(tree.node.children, childName);
    if (childEmpty && childExists) {
        delete tree.node.children[childName];
        tree.node.childCount--;
        $668b2310913a4fe8$var$treeUpdateParents(tree);
    } else if (!childEmpty && !childExists) {
        tree.node.children[childName] = child.node;
        tree.node.childCount++;
        $668b2310913a4fe8$var$treeUpdateParents(tree);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * True for invalid Firebase keys
 */ const $668b2310913a4fe8$var$INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 */ const $668b2310913a4fe8$var$INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 */ const $668b2310913a4fe8$var$MAX_LEAF_SIZE_ = 10485760;
const $668b2310913a4fe8$var$isValidKey = function(key) {
    return typeof key === 'string' && key.length !== 0 && !$668b2310913a4fe8$var$INVALID_KEY_REGEX_.test(key);
};
const $668b2310913a4fe8$var$isValidPathString = function(pathString) {
    return typeof pathString === 'string' && pathString.length !== 0 && !$668b2310913a4fe8$var$INVALID_PATH_REGEX_.test(pathString);
};
const $668b2310913a4fe8$var$isValidRootPathString = function(pathString) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    return $668b2310913a4fe8$var$isValidPathString(pathString);
};
const $668b2310913a4fe8$var$isValidPriority = function(priority) {
    return priority === null || typeof priority === 'string' || typeof priority === 'number' && !$668b2310913a4fe8$var$isInvalidJSONNumber(priority) || priority && typeof priority === 'object' && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $ffjl9.contains)(priority, '.sv');
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 */ const $668b2310913a4fe8$var$validateFirebaseDataArg = function(fnName, value, path, optional) {
    if (optional && value === undefined) return;
    $668b2310913a4fe8$var$validateFirebaseData((0, $ffjl9.errorPrefix)(fnName, 'value'), value, path);
};
/**
 * Validate a data object client-side before sending to server.
 */ const $668b2310913a4fe8$var$validateFirebaseData = function(errorPrefix, data, path_) {
    const path = path_ instanceof $668b2310913a4fe8$var$Path ? new $668b2310913a4fe8$var$ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) throw new Error(errorPrefix + 'contains undefined ' + $668b2310913a4fe8$var$validationPathToErrorString(path));
    if (typeof data === 'function') throw new Error(errorPrefix + 'contains a function ' + $668b2310913a4fe8$var$validationPathToErrorString(path) + ' with contents = ' + data.toString());
    if ($668b2310913a4fe8$var$isInvalidJSONNumber(data)) throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + $668b2310913a4fe8$var$validationPathToErrorString(path));
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === 'string' && data.length > $668b2310913a4fe8$var$MAX_LEAF_SIZE_ / 3 && (0, $ffjl9.stringLength)(data) > $668b2310913a4fe8$var$MAX_LEAF_SIZE_) throw new Error(errorPrefix + 'contains a string greater than ' + $668b2310913a4fe8$var$MAX_LEAF_SIZE_ + ' utf8 bytes ' + $668b2310913a4fe8$var$validationPathToErrorString(path) + " ('" + data.substring(0, 50) + "...')");
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === 'object') {
        let hasDotValue = false;
        let hasActualChild = false;
        $668b2310913a4fe8$var$each(data, (key, value)=>{
            if (key === '.value') hasDotValue = true;
            else if (key !== '.priority' && key !== '.sv') {
                hasActualChild = true;
                if (!$668b2310913a4fe8$var$isValidKey(key)) throw new Error(errorPrefix + ' contains an invalid key (' + key + ') ' + $668b2310913a4fe8$var$validationPathToErrorString(path) + '.  Keys must be non-empty strings ' + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
            $668b2310913a4fe8$var$validationPathPush(path, key);
            $668b2310913a4fe8$var$validateFirebaseData(errorPrefix, value, path);
            $668b2310913a4fe8$var$validationPathPop(path);
        });
        if (hasDotValue && hasActualChild) throw new Error(errorPrefix + ' contains ".value" child ' + $668b2310913a4fe8$var$validationPathToErrorString(path) + ' in addition to actual children.');
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 */ const $668b2310913a4fe8$var$validateFirebaseMergePaths = function(errorPrefix, mergePaths) {
    let i, curPath;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        const keys = $668b2310913a4fe8$var$pathSlice(curPath);
        for(let j = 0; j < keys.length; j++){
            if (keys[j] === '.priority' && j === keys.length - 1) ;
            else if (!$668b2310913a4fe8$var$isValidKey(keys[j])) throw new Error(errorPrefix + 'contains an invalid key (' + keys[j] + ') in path ' + curPath.toString() + '. Keys must be non-empty strings ' + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort($668b2310913a4fe8$var$pathCompare);
    let prevPath = null;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        if (prevPath !== null && $668b2310913a4fe8$var$pathContains(prevPath, curPath)) throw new Error(errorPrefix + 'contains a path ' + prevPath.toString() + ' that is ancestor of another path ' + curPath.toString());
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 */ const $668b2310913a4fe8$var$validateFirebaseMergeDataArg = function(fnName, data, path, optional) {
    if (optional && data === undefined) return;
    const errorPrefix$1 = (0, $ffjl9.errorPrefix)(fnName, 'values');
    if (!(data && typeof data === 'object') || Array.isArray(data)) throw new Error(errorPrefix$1 + ' must be an object containing the children to replace.');
    const mergePaths = [];
    $668b2310913a4fe8$var$each(data, (key, value)=>{
        const curPath = new $668b2310913a4fe8$var$Path(key);
        $668b2310913a4fe8$var$validateFirebaseData(errorPrefix$1, value, $668b2310913a4fe8$var$pathChild(path, curPath));
        if ($668b2310913a4fe8$var$pathGetBack(curPath) === '.priority') {
            if (!$668b2310913a4fe8$var$isValidPriority(value)) throw new Error(errorPrefix$1 + "contains an invalid value for '" + curPath.toString() + "', which must be a valid " + 'Firebase priority (a string, finite number, server value, or null).');
        }
        mergePaths.push(curPath);
    });
    $668b2310913a4fe8$var$validateFirebaseMergePaths(errorPrefix$1, mergePaths);
};
const $668b2310913a4fe8$var$validatePriority = function(fnName, priority, optional) {
    if (optional && priority === undefined) return;
    if ($668b2310913a4fe8$var$isInvalidJSONNumber(priority)) throw new Error((0, $ffjl9.errorPrefix)(fnName, 'priority') + 'is ' + priority.toString() + ', but must be a valid Firebase priority (a string, finite number, ' + 'server value, or null).');
    // Special case to allow importing data with a .sv.
    if (!$668b2310913a4fe8$var$isValidPriority(priority)) throw new Error((0, $ffjl9.errorPrefix)(fnName, 'priority') + 'must be a valid Firebase priority ' + '(a string, finite number, server value, or null).');
};
const $668b2310913a4fe8$var$validateKey = function(fnName, argumentName, key, optional) {
    if (optional && key === undefined) return;
    if (!$668b2310913a4fe8$var$isValidKey(key)) throw new Error((0, $ffjl9.errorPrefix)(fnName, argumentName) + 'was an invalid key = "' + key + '".  Firebase keys must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
/**
 * @internal
 */ const $668b2310913a4fe8$export$8637b026ace8abb1 = function(fnName, argumentName, pathString, optional) {
    if (optional && pathString === undefined) return;
    if (!$668b2310913a4fe8$var$isValidPathString(pathString)) throw new Error((0, $ffjl9.errorPrefix)(fnName, argumentName) + 'was an invalid path = "' + pathString + '". Paths must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "[", or "]"');
};
const $668b2310913a4fe8$var$validateRootPathString = function(fnName, argumentName, pathString, optional) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    $668b2310913a4fe8$export$8637b026ace8abb1(fnName, argumentName, pathString, optional);
};
/**
 * @internal
 */ const $668b2310913a4fe8$export$8d83036122ae444e = function(fnName, path) {
    if ($668b2310913a4fe8$var$pathGetFront(path) === '.info') throw new Error(fnName + " failed = Can't modify data under /.info/");
};
const $668b2310913a4fe8$var$validateUrl = function(fnName, parsedUrl) {
    // TODO = Validate server better.
    const pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === 'string') || parsedUrl.repoInfo.host.length === 0 || !$668b2310913a4fe8$var$isValidKey(parsedUrl.repoInfo.namespace) && parsedUrl.repoInfo.host.split(':')[0] !== 'localhost' || pathString.length !== 0 && !$668b2310913a4fe8$var$isValidRootPathString(pathString)) throw new Error((0, $ffjl9.errorPrefix)(fnName, 'url') + 'must be a valid firebase URL and ' + 'the path can\'t contain ".", "#", "$", "[", or "]".');
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 */ class $668b2310913a4fe8$var$EventQueue {
    constructor(){
        this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         */ this.recursionDepth_ = 0;
    }
}
/**
 * @param eventDataList - The new events to queue.
 */ function $668b2310913a4fe8$var$eventQueueQueueEvents(eventQueue, eventDataList) {
    // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
    let currList = null;
    for(let i = 0; i < eventDataList.length; i++){
        const data = eventDataList[i];
        const path = data.getPath();
        if (currList !== null && !$668b2310913a4fe8$var$pathEquals(path, currList.path)) {
            eventQueue.eventLists_.push(currList);
            currList = null;
        }
        if (currList === null) currList = {
            events: [],
            path: path
        };
        currList.events.push(data);
    }
    if (currList) eventQueue.eventLists_.push(currList);
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones)
 * for the specified path.
 *
 * It is assumed that the new events are all for the specified path.
 *
 * @param path - The path to raise events for.
 * @param eventDataList - The new events to raise.
 */ function $668b2310913a4fe8$var$eventQueueRaiseEventsAtPath(eventQueue, path, eventDataList) {
    $668b2310913a4fe8$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $668b2310913a4fe8$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, (eventPath)=>$668b2310913a4fe8$var$pathEquals(eventPath, path));
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones) for
 * locations related to the specified change path (i.e. all ancestors and descendants).
 *
 * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
 *
 * @param changedPath - The path to raise events for.
 * @param eventDataList - The events to raise
 */ function $668b2310913a4fe8$var$eventQueueRaiseEventsForChangedPath(eventQueue, changedPath, eventDataList) {
    $668b2310913a4fe8$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $668b2310913a4fe8$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, (eventPath)=>$668b2310913a4fe8$var$pathContains(eventPath, changedPath) || $668b2310913a4fe8$var$pathContains(changedPath, eventPath));
}
function $668b2310913a4fe8$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, predicate) {
    eventQueue.recursionDepth_++;
    let sentAll = true;
    for(let i = 0; i < eventQueue.eventLists_.length; i++){
        const eventList = eventQueue.eventLists_[i];
        if (eventList) {
            const eventPath = eventList.path;
            if (predicate(eventPath)) {
                $668b2310913a4fe8$var$eventListRaise(eventQueue.eventLists_[i]);
                eventQueue.eventLists_[i] = null;
            } else sentAll = false;
        }
    }
    if (sentAll) eventQueue.eventLists_ = [];
    eventQueue.recursionDepth_--;
}
/**
 * Iterates through the list and raises each event
 */ function $668b2310913a4fe8$var$eventListRaise(eventList) {
    for(let i = 0; i < eventList.events.length; i++){
        const eventData = eventList.events[i];
        if (eventData !== null) {
            eventList.events[i] = null;
            const eventFn = eventData.getEventRunner();
            if ($668b2310913a4fe8$var$logger) $668b2310913a4fe8$var$log('event: ' + eventData.toString());
            $668b2310913a4fe8$var$exceptionGuard(eventFn);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $668b2310913a4fe8$var$INTERRUPT_REASON = 'repo_interrupt';
/**
 * If a transaction does not succeed after 25 retries, we abort it. Among other
 * things this ensure that if there's ever a bug causing a mismatch between
 * client / server hashes for some data, we won't retry indefinitely.
 */ const $668b2310913a4fe8$var$MAX_TRANSACTION_RETRIES = 25;
/**
 * A connection to a single data repository.
 */ class $668b2310913a4fe8$var$Repo {
    constructor(repoInfo_, forceRestClient_, authTokenProvider_, appCheckProvider_){
        this.repoInfo_ = repoInfo_;
        this.forceRestClient_ = forceRestClient_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckProvider_ = appCheckProvider_;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new $668b2310913a4fe8$var$EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        /** A list of data pieces and paths to be set when this client disconnects. */ this.onDisconnect_ = $668b2310913a4fe8$var$newSparseSnapshotTree();
        /** Stores queues of outstanding transactions for Firebase locations. */ this.transactionQueueTree_ = new $668b2310913a4fe8$var$Tree();
        // TODO: This should be @private but it's used by test_access.js and internal.js
        this.persistentConnection_ = null;
        // This key is intentionally not updated if RepoInfo is later changed or replaced
        this.key = this.repoInfo_.toURLString();
    }
    /**
     * @returns The URL corresponding to the root of this Firebase.
     */ toString() {
        return (this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host;
    }
}
function $668b2310913a4fe8$var$repoStart(repo, appId, authOverride) {
    repo.stats_ = $668b2310913a4fe8$var$statsManagerGetCollection(repo.repoInfo_);
    if (repo.forceRestClient_ || $668b2310913a4fe8$var$beingCrawled()) {
        repo.server_ = new $668b2310913a4fe8$var$ReadonlyRestClient(repo.repoInfo_, (pathString, data, isMerge, tag)=>{
            $668b2310913a4fe8$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, repo.authTokenProvider_, repo.appCheckProvider_);
        // Minor hack: Fire onConnect immediately, since there's no actual connection.
        setTimeout(()=>$668b2310913a4fe8$var$repoOnConnectStatus(repo, /* connectStatus= */ true), 0);
    } else {
        // Validate authOverride
        if (typeof authOverride !== 'undefined' && authOverride !== null) {
            if (typeof authOverride !== 'object') throw new Error('Only objects are supported for option databaseAuthVariableOverride');
            try {
                (0, $ffjl9.stringify)(authOverride);
            } catch (e) {
                throw new Error('Invalid authOverride provided: ' + e);
            }
        }
        repo.persistentConnection_ = new $668b2310913a4fe8$var$PersistentConnection(repo.repoInfo_, appId, (pathString, data, isMerge, tag)=>{
            $668b2310913a4fe8$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, (connectStatus)=>{
            $668b2310913a4fe8$var$repoOnConnectStatus(repo, connectStatus);
        }, (updates)=>{
            $668b2310913a4fe8$var$repoOnServerInfoUpdate(repo, updates);
        }, repo.authTokenProvider_, repo.appCheckProvider_, authOverride);
        repo.server_ = repo.persistentConnection_;
    }
    repo.authTokenProvider_.addTokenChangeListener((token)=>{
        repo.server_.refreshAuthToken(token);
    });
    repo.appCheckProvider_.addTokenChangeListener((result)=>{
        repo.server_.refreshAppCheckToken(result.token);
    });
    // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
    // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
    repo.statsReporter_ = $668b2310913a4fe8$var$statsManagerGetOrCreateReporter(repo.repoInfo_, ()=>new $668b2310913a4fe8$var$StatsReporter(repo.stats_, repo.server_));
    // Used for .info.
    repo.infoData_ = new $668b2310913a4fe8$var$SnapshotHolder();
    repo.infoSyncTree_ = new $668b2310913a4fe8$var$SyncTree({
        startListening: (query, tag, currentHashFn, onComplete)=>{
            let infoEvents = [];
            const node = repo.infoData_.getNode(query._path);
            // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
            // on initial data...
            if (!node.isEmpty()) {
                infoEvents = $668b2310913a4fe8$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, query._path, node);
                setTimeout(()=>{
                    onComplete('ok');
                }, 0);
            }
            return infoEvents;
        },
        stopListening: ()=>{}
    });
    $668b2310913a4fe8$var$repoUpdateInfo(repo, 'connected', false);
    repo.serverSyncTree_ = new $668b2310913a4fe8$var$SyncTree({
        startListening: (query, tag, currentHashFn, onComplete)=>{
            repo.server_.listen(query, currentHashFn, tag, (status, data)=>{
                const events = onComplete(status, data);
                $668b2310913a4fe8$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, query._path, events);
            });
            // No synchronous events for network-backed sync trees
            return [];
        },
        stopListening: (query, tag)=>{
            repo.server_.unlisten(query, tag);
        }
    });
}
/**
 * @returns The time in milliseconds, taking the server offset into account if we have one.
 */ function $668b2310913a4fe8$var$repoServerTime(repo) {
    const offsetNode = repo.infoData_.getNode(new $668b2310913a4fe8$var$Path('.info/serverTimeOffset'));
    const offset = offsetNode.val() || 0;
    return new Date().getTime() + offset;
}
/**
 * Generate ServerValues using some variables from the repo object.
 */ function $668b2310913a4fe8$var$repoGenerateServerValues(repo) {
    return $668b2310913a4fe8$var$generateWithValues({
        timestamp: $668b2310913a4fe8$var$repoServerTime(repo)
    });
}
/**
 * Called by realtime when we get new messages from the server.
 */ function $668b2310913a4fe8$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag) {
    // For testing.
    repo.dataUpdateCount++;
    const path = new $668b2310913a4fe8$var$Path(pathString);
    data = repo.interceptServerDataCallback_ ? repo.interceptServerDataCallback_(pathString, data) : data;
    let events = [];
    if (tag) {
        if (isMerge) {
            const taggedChildren = (0, $ffjl9.map)(data, (raw)=>$668b2310913a4fe8$var$nodeFromJSON(raw));
            events = $668b2310913a4fe8$var$syncTreeApplyTaggedQueryMerge(repo.serverSyncTree_, path, taggedChildren, tag);
        } else {
            const taggedSnap = $668b2310913a4fe8$var$nodeFromJSON(data);
            events = $668b2310913a4fe8$var$syncTreeApplyTaggedQueryOverwrite(repo.serverSyncTree_, path, taggedSnap, tag);
        }
    } else if (isMerge) {
        const changedChildren = (0, $ffjl9.map)(data, (raw)=>$668b2310913a4fe8$var$nodeFromJSON(raw));
        events = $668b2310913a4fe8$var$syncTreeApplyServerMerge(repo.serverSyncTree_, path, changedChildren);
    } else {
        const snap = $668b2310913a4fe8$var$nodeFromJSON(data);
        events = $668b2310913a4fe8$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap);
    }
    let affectedPath = path;
    if (events.length > 0) // Since we have a listener outstanding for each transaction, receiving any events
    // is a proxy for some change having occurred.
    affectedPath = $668b2310913a4fe8$var$repoRerunTransactions(repo, path);
    $668b2310913a4fe8$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, events);
}
function $668b2310913a4fe8$var$repoOnConnectStatus(repo, connectStatus) {
    $668b2310913a4fe8$var$repoUpdateInfo(repo, 'connected', connectStatus);
    if (connectStatus === false) $668b2310913a4fe8$var$repoRunOnDisconnectEvents(repo);
}
function $668b2310913a4fe8$var$repoOnServerInfoUpdate(repo, updates) {
    $668b2310913a4fe8$var$each(updates, (key, value)=>{
        $668b2310913a4fe8$var$repoUpdateInfo(repo, key, value);
    });
}
function $668b2310913a4fe8$var$repoUpdateInfo(repo, pathString, value) {
    const path = new $668b2310913a4fe8$var$Path('/.info/' + pathString);
    const newNode = $668b2310913a4fe8$var$nodeFromJSON(value);
    repo.infoData_.updateSnapshot(path, newNode);
    const events = $668b2310913a4fe8$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, path, newNode);
    $668b2310913a4fe8$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
}
function $668b2310913a4fe8$var$repoGetNextWriteId(repo) {
    return repo.nextWriteId_++;
}
/**
 * The purpose of `getValue` is to return the latest known value
 * satisfying `query`.
 *
 * This method will first check for in-memory cached values
 * belonging to active listeners. If they are found, such values
 * are considered to be the most up-to-date.
 *
 * If the client is not connected, this method will wait until the
 *  repo has established a connection and then request the value for `query`.
 * If the client is not able to retrieve the query result for another reason,
 * it reports an error.
 *
 * @param query - The query to surface a value for.
 */ function $668b2310913a4fe8$var$repoGetValue(repo, query, eventRegistration) {
    // Only active queries are cached. There is no persisted cache.
    const cached = $668b2310913a4fe8$var$syncTreeGetServerValue(repo.serverSyncTree_, query);
    if (cached != null) return Promise.resolve(cached);
    return repo.server_.get(query).then((payload)=>{
        const node = $668b2310913a4fe8$var$nodeFromJSON(payload).withIndex(query._queryParams.getIndex());
        /**
         * Below we simulate the actions of an `onlyOnce` `onValue()` event where:
         * Add an event registration,
         * Update data at the path,
         * Raise any events,
         * Cleanup the SyncTree
         */ $668b2310913a4fe8$var$syncTreeAddEventRegistration(repo.serverSyncTree_, query, eventRegistration, true);
        let events;
        if (query._queryParams.loadsAllData()) events = $668b2310913a4fe8$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, query._path, node);
        else {
            const tag = $668b2310913a4fe8$var$syncTreeTagForQuery(repo.serverSyncTree_, query);
            events = $668b2310913a4fe8$var$syncTreeApplyTaggedQueryOverwrite(repo.serverSyncTree_, query._path, node, tag);
        }
        /*
         * We need to raise events in the scenario where `get()` is called at a parent path, and
         * while the `get()` is pending, `onValue` is called at a child location. While get() is waiting
         * for the data, `onValue` will register a new event. Then, get() will come back, and update the syncTree
         * and its corresponding serverCache, including the child location where `onValue` is called. Then,
         * `onValue` will receive the event from the server, but look at the syncTree and see that the data received
         * from the server is already at the SyncPoint, and so the `onValue` callback will never get fired.
         * Calling `eventQueueRaiseEventsForChangedPath()` is the correct way to propagate the events and
         * ensure the corresponding child events will get fired.
         */ $668b2310913a4fe8$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, query._path, events);
        $668b2310913a4fe8$var$syncTreeRemoveEventRegistration(repo.serverSyncTree_, query, eventRegistration, null, true);
        return node;
    }, (err)=>{
        $668b2310913a4fe8$var$repoLog(repo, 'get for query ' + (0, $ffjl9.stringify)(query) + ' failed: ' + err);
        return Promise.reject(new Error(err));
    });
}
function $668b2310913a4fe8$var$repoSetWithPriority(repo, path, newVal, newPriority, onComplete) {
    $668b2310913a4fe8$var$repoLog(repo, 'set', {
        path: path.toString(),
        value: newVal,
        priority: newPriority
    });
    // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
    // (b) store unresolved paths on JSON parse
    const serverValues = $668b2310913a4fe8$var$repoGenerateServerValues(repo);
    const newNodeUnresolved = $668b2310913a4fe8$var$nodeFromJSON(newVal, newPriority);
    const existing = $668b2310913a4fe8$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path);
    const newNode = $668b2310913a4fe8$var$resolveDeferredValueSnapshot(newNodeUnresolved, existing, serverValues);
    const writeId = $668b2310913a4fe8$var$repoGetNextWriteId(repo);
    const events = $668b2310913a4fe8$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, writeId, true);
    $668b2310913a4fe8$var$eventQueueQueueEvents(repo.eventQueue_, events);
    repo.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), (status, errorReason)=>{
        const success = status === 'ok';
        if (!success) $668b2310913a4fe8$var$warn('set at ' + path + ' failed: ' + status);
        const clearEvents = $668b2310913a4fe8$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
        $668b2310913a4fe8$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, clearEvents);
        $668b2310913a4fe8$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
    const affectedPath = $668b2310913a4fe8$var$repoAbortTransactions(repo, path);
    $668b2310913a4fe8$var$repoRerunTransactions(repo, affectedPath);
    // We queued the events above, so just flush the queue here
    $668b2310913a4fe8$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, []);
}
function $668b2310913a4fe8$var$repoUpdate(repo, path, childrenToMerge, onComplete) {
    $668b2310913a4fe8$var$repoLog(repo, 'update', {
        path: path.toString(),
        value: childrenToMerge
    });
    // Start with our existing data and merge each child into it.
    let empty = true;
    const serverValues = $668b2310913a4fe8$var$repoGenerateServerValues(repo);
    const changedChildren = {};
    $668b2310913a4fe8$var$each(childrenToMerge, (changedKey, changedValue)=>{
        empty = false;
        changedChildren[changedKey] = $668b2310913a4fe8$var$resolveDeferredValueTree($668b2310913a4fe8$var$pathChild(path, changedKey), $668b2310913a4fe8$var$nodeFromJSON(changedValue), repo.serverSyncTree_, serverValues);
    });
    if (!empty) {
        const writeId = $668b2310913a4fe8$var$repoGetNextWriteId(repo);
        const events = $668b2310913a4fe8$var$syncTreeApplyUserMerge(repo.serverSyncTree_, path, changedChildren, writeId);
        $668b2310913a4fe8$var$eventQueueQueueEvents(repo.eventQueue_, events);
        repo.server_.merge(path.toString(), childrenToMerge, (status, errorReason)=>{
            const success = status === 'ok';
            if (!success) $668b2310913a4fe8$var$warn('update at ' + path + ' failed: ' + status);
            const clearEvents = $668b2310913a4fe8$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
            const affectedPath = clearEvents.length > 0 ? $668b2310913a4fe8$var$repoRerunTransactions(repo, path) : path;
            $668b2310913a4fe8$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, clearEvents);
            $668b2310913a4fe8$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
        });
        $668b2310913a4fe8$var$each(childrenToMerge, (changedPath)=>{
            const affectedPath = $668b2310913a4fe8$var$repoAbortTransactions(repo, $668b2310913a4fe8$var$pathChild(path, changedPath));
            $668b2310913a4fe8$var$repoRerunTransactions(repo, affectedPath);
        });
        // We queued the events above, so just flush the queue here
        $668b2310913a4fe8$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, []);
    } else {
        $668b2310913a4fe8$var$log("update() called with empty data.  Don't do anything.");
        $668b2310913a4fe8$var$repoCallOnCompleteCallback(repo, onComplete, 'ok', undefined);
    }
}
/**
 * Applies all of the changes stored up in the onDisconnect_ tree.
 */ function $668b2310913a4fe8$var$repoRunOnDisconnectEvents(repo) {
    $668b2310913a4fe8$var$repoLog(repo, 'onDisconnectEvents');
    const serverValues = $668b2310913a4fe8$var$repoGenerateServerValues(repo);
    const resolvedOnDisconnectTree = $668b2310913a4fe8$var$newSparseSnapshotTree();
    $668b2310913a4fe8$var$sparseSnapshotTreeForEachTree(repo.onDisconnect_, $668b2310913a4fe8$var$newEmptyPath(), (path, node)=>{
        const resolved = $668b2310913a4fe8$var$resolveDeferredValueTree(path, node, repo.serverSyncTree_, serverValues);
        $668b2310913a4fe8$var$sparseSnapshotTreeRemember(resolvedOnDisconnectTree, path, resolved);
    });
    let events = [];
    $668b2310913a4fe8$var$sparseSnapshotTreeForEachTree(resolvedOnDisconnectTree, $668b2310913a4fe8$var$newEmptyPath(), (path, snap)=>{
        events = events.concat($668b2310913a4fe8$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap));
        const affectedPath = $668b2310913a4fe8$var$repoAbortTransactions(repo, path);
        $668b2310913a4fe8$var$repoRerunTransactions(repo, affectedPath);
    });
    repo.onDisconnect_ = $668b2310913a4fe8$var$newSparseSnapshotTree();
    $668b2310913a4fe8$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $668b2310913a4fe8$var$newEmptyPath(), events);
}
function $668b2310913a4fe8$var$repoOnDisconnectCancel(repo, path, onComplete) {
    repo.server_.onDisconnectCancel(path.toString(), (status, errorReason)=>{
        if (status === 'ok') $668b2310913a4fe8$var$sparseSnapshotTreeForget(repo.onDisconnect_, path);
        $668b2310913a4fe8$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $668b2310913a4fe8$var$repoOnDisconnectSet(repo, path, value, onComplete) {
    const newNode = $668b2310913a4fe8$var$nodeFromJSON(value);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), (status, errorReason)=>{
        if (status === 'ok') $668b2310913a4fe8$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $668b2310913a4fe8$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $668b2310913a4fe8$var$repoOnDisconnectSetWithPriority(repo, path, value, priority, onComplete) {
    const newNode = $668b2310913a4fe8$var$nodeFromJSON(value, priority);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), (status, errorReason)=>{
        if (status === 'ok') $668b2310913a4fe8$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $668b2310913a4fe8$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $668b2310913a4fe8$var$repoOnDisconnectUpdate(repo, path, childrenToMerge, onComplete) {
    if ((0, $ffjl9.isEmpty)(childrenToMerge)) {
        $668b2310913a4fe8$var$log("onDisconnect().update() called with empty data.  Don't do anything.");
        $668b2310913a4fe8$var$repoCallOnCompleteCallback(repo, onComplete, 'ok', undefined);
        return;
    }
    repo.server_.onDisconnectMerge(path.toString(), childrenToMerge, (status, errorReason)=>{
        if (status === 'ok') $668b2310913a4fe8$var$each(childrenToMerge, (childName, childNode)=>{
            const newChildNode = $668b2310913a4fe8$var$nodeFromJSON(childNode);
            $668b2310913a4fe8$var$sparseSnapshotTreeRemember(repo.onDisconnect_, $668b2310913a4fe8$var$pathChild(path, childName), newChildNode);
        });
        $668b2310913a4fe8$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $668b2310913a4fe8$var$repoAddEventCallbackForQuery(repo, query, eventRegistration) {
    let events;
    if ($668b2310913a4fe8$var$pathGetFront(query._path) === '.info') events = $668b2310913a4fe8$var$syncTreeAddEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $668b2310913a4fe8$var$syncTreeAddEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $668b2310913a4fe8$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $668b2310913a4fe8$var$repoRemoveEventCallbackForQuery(repo, query, eventRegistration) {
    // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
    // a little bit by handling the return values anyways.
    let events;
    if ($668b2310913a4fe8$var$pathGetFront(query._path) === '.info') events = $668b2310913a4fe8$var$syncTreeRemoveEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $668b2310913a4fe8$var$syncTreeRemoveEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $668b2310913a4fe8$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $668b2310913a4fe8$var$repoInterrupt(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.interrupt($668b2310913a4fe8$var$INTERRUPT_REASON);
}
function $668b2310913a4fe8$var$repoResume(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.resume($668b2310913a4fe8$var$INTERRUPT_REASON);
}
function $668b2310913a4fe8$var$repoLog(repo, ...varArgs) {
    let prefix = '';
    if (repo.persistentConnection_) prefix = repo.persistentConnection_.id + ':';
    $668b2310913a4fe8$var$log(prefix, ...varArgs);
}
function $668b2310913a4fe8$var$repoCallOnCompleteCallback(repo, callback, status, errorReason) {
    if (callback) $668b2310913a4fe8$var$exceptionGuard(()=>{
        if (status === 'ok') callback(null);
        else {
            const code = (status || 'error').toUpperCase();
            let message = code;
            if (errorReason) message += ': ' + errorReason;
            const error = new Error(message);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            error.code = code;
            callback(error);
        }
    });
}
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and
 * sends it to the server if possible.
 *
 * @param path - Path at which to do transaction.
 * @param transactionUpdate - Update callback.
 * @param onComplete - Completion callback.
 * @param unwatcher - Function that will be called when the transaction no longer
 * need data updates for `path`.
 * @param applyLocally - Whether or not to make intermediate results visible
 */ function $668b2310913a4fe8$var$repoStartTransaction(repo, path, transactionUpdate, onComplete, unwatcher, applyLocally) {
    $668b2310913a4fe8$var$repoLog(repo, 'transaction on ' + path);
    // Initialize transaction.
    const transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out
        // which one goes first.
        order: $668b2310913a4fe8$var$LUIDGenerator(),
        applyLocally: // Whether to raise local events for this transaction.
        applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        unwatcher: // Function to call to clean up our .on() listener.
        unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    const currentState = $668b2310913a4fe8$var$repoGetLatestState(repo, path, undefined);
    transaction.currentInputSnapshot = currentState;
    const newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) transaction.onComplete(null, false, transaction.currentInputSnapshot);
    } else {
        $668b2310913a4fe8$var$validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = 0 /* TransactionStatus.RUN */ ;
        const queueNode = $668b2310913a4fe8$var$treeSubTree(repo.transactionQueueTree_, path);
        const nodeQueue = $668b2310913a4fe8$var$treeGetValue(queueNode) || [];
        nodeQueue.push(transaction);
        $668b2310913a4fe8$var$treeSetValue(queueNode, nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our
        // transaction state, since the user could start new transactions from the
        // event callbacks.
        let priorityForNode;
        if (typeof newVal === 'object' && newVal !== null && (0, $ffjl9.contains)(newVal, '.priority')) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            priorityForNode = (0, $ffjl9.safeGet)(newVal, '.priority');
            (0, $ffjl9.assert)($668b2310913a4fe8$var$isValidPriority(priorityForNode), "Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.");
        } else {
            const currentNode = $668b2310913a4fe8$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path) || $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        const serverValues = $668b2310913a4fe8$var$repoGenerateServerValues(repo);
        const newNodeUnresolved = $668b2310913a4fe8$var$nodeFromJSON(newVal, priorityForNode);
        const newNode = $668b2310913a4fe8$var$resolveDeferredValueSnapshot(newNodeUnresolved, currentState, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = $668b2310913a4fe8$var$repoGetNextWriteId(repo);
        const events = $668b2310913a4fe8$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, transaction.currentWriteId, transaction.applyLocally);
        $668b2310913a4fe8$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        $668b2310913a4fe8$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
    }
}
/**
 * @param excludeSets - A specific set to exclude
 */ function $668b2310913a4fe8$var$repoGetLatestState(repo, path, excludeSets) {
    return $668b2310913a4fe8$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path, excludeSets) || $668b2310913a4fe8$var$ChildrenNode.EMPTY_NODE;
}
/**
 * Sends any already-run transactions that aren't waiting for outstanding
 * transactions to complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively
 * with a particular transactionQueueTree node to recurse through the tree.
 *
 * @param node - transactionQueueTree node to start at.
 */ function $668b2310913a4fe8$var$repoSendReadyTransactions(repo, node = repo.transactionQueueTree_) {
    // Before recursing, make sure any completed transactions are removed.
    if (!node) $668b2310913a4fe8$var$repoPruneCompletedTransactionsBelowNode(repo, node);
    if ($668b2310913a4fe8$var$treeGetValue(node)) {
        const queue = $668b2310913a4fe8$var$repoBuildTransactionQueue(repo, node);
        (0, $ffjl9.assert)(queue.length > 0, 'Sending zero length transaction queue');
        const allRun = queue.every((transaction)=>transaction.status === 0 /* TransactionStatus.RUN */ );
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) $668b2310913a4fe8$var$repoSendTransactionQueue(repo, $668b2310913a4fe8$var$treeGetPath(node), queue);
    } else if ($668b2310913a4fe8$var$treeHasChildren(node)) $668b2310913a4fe8$var$treeForEachChild(node, (childNode)=>{
        $668b2310913a4fe8$var$repoSendReadyTransactions(repo, childNode);
    });
}
/**
 * Given a list of run transactions, send them to the server and then handle
 * the result (success or failure).
 *
 * @param path - The location of the queue.
 * @param queue - Queue of transactions under the specified location.
 */ function $668b2310913a4fe8$var$repoSendTransactionQueue(repo, path, queue) {
    // Mark transactions as sent and increment retry count!
    const setsToIgnore = queue.map((txn)=>{
        return txn.currentWriteId;
    });
    const latestState = $668b2310913a4fe8$var$repoGetLatestState(repo, path, setsToIgnore);
    let snapToSend = latestState;
    const latestHash = latestState.hash();
    for(let i = 0; i < queue.length; i++){
        const txn = queue[i];
        (0, $ffjl9.assert)(txn.status === 0 /* TransactionStatus.RUN */ , 'tryToSendTransactionQueue_: items in queue should all be run.');
        txn.status = 1 /* TransactionStatus.SENT */ ;
        txn.retryCount++;
        const relativePath = $668b2310913a4fe8$var$newRelativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /** @type {!Node} */ , txn.currentOutputSnapshotRaw);
    }
    const dataToSend = snapToSend.val(true);
    const pathToSend = path;
    // Send the put.
    repo.server_.put(pathToSend.toString(), dataToSend, (status)=>{
        $668b2310913a4fe8$var$repoLog(repo, 'transaction put response', {
            path: pathToSend.toString(),
            status: status
        });
        let events = [];
        if (status === 'ok') {
            // Queue up the callbacks and fire them after cleaning up all of our
            // transaction state, since the callback could trigger more
            // transactions or sets.
            const callbacks = [];
            for(let i = 0; i < queue.length; i++){
                queue[i].status = 2 /* TransactionStatus.COMPLETED */ ;
                events = events.concat($668b2310913a4fe8$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId));
                if (queue[i].onComplete) // We never unset the output snapshot, and given that this
                // transaction is complete, it should be set
                callbacks.push(()=>queue[i].onComplete(null, true, queue[i].currentOutputSnapshotResolved));
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            $668b2310913a4fe8$var$repoPruneCompletedTransactionsBelowNode(repo, $668b2310913a4fe8$var$treeSubTree(repo.transactionQueueTree_, path));
            // There may be pending transactions that we can now send.
            $668b2310913a4fe8$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
            $668b2310913a4fe8$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
            // Finally, trigger onComplete callbacks.
            for(let i = 0; i < callbacks.length; i++)$668b2310913a4fe8$var$exceptionGuard(callbacks[i]);
        } else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === 'datastale') {
                for(let i = 0; i < queue.length; i++)if (queue[i].status === 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ) queue[i].status = 4 /* TransactionStatus.NEEDS_ABORT */ ;
                else queue[i].status = 0 /* TransactionStatus.RUN */ ;
            } else {
                $668b2310913a4fe8$var$warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
                for(let i = 0; i < queue.length; i++){
                    queue[i].status = 4 /* TransactionStatus.NEEDS_ABORT */ ;
                    queue[i].abortReason = status;
                }
            }
            $668b2310913a4fe8$var$repoRerunTransactions(repo, path);
        }
    }, latestHash);
}
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions. This
 * is the path at which events need to be raised for.
 *
 * @param changedPath - The path in mergedData that changed.
 * @returns The rootmost path that was affected by rerunning transactions.
 */ function $668b2310913a4fe8$var$repoRerunTransactions(repo, changedPath) {
    const rootMostTransactionNode = $668b2310913a4fe8$var$repoGetAncestorTransactionNode(repo, changedPath);
    const path = $668b2310913a4fe8$var$treeGetPath(rootMostTransactionNode);
    const queue = $668b2310913a4fe8$var$repoBuildTransactionQueue(repo, rootMostTransactionNode);
    $668b2310913a4fe8$var$repoRerunTransactionQueue(repo, queue, path);
    return path;
}
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted
 * transactions and whatnot).
 *
 * @param queue - The queue of transactions to run.
 * @param path - The path the queue is for.
 */ function $668b2310913a4fe8$var$repoRerunTransactionQueue(repo, queue, path) {
    if (queue.length === 0) return; // Nothing to do!
    // Queue up the callbacks and fire them after cleaning up all of our
    // transaction state, since the callback could trigger more transactions or
    // sets.
    const callbacks = [];
    let events = [];
    // Ignore all of the sets we're going to re-run.
    const txnsToRerun = queue.filter((q)=>{
        return q.status === 0 /* TransactionStatus.RUN */ ;
    });
    const setsToIgnore = txnsToRerun.map((q)=>{
        return q.currentWriteId;
    });
    for(let i = 0; i < queue.length; i++){
        const transaction = queue[i];
        const relativePath = $668b2310913a4fe8$var$newRelativePath(path, transaction.path);
        let abortTransaction = false, abortReason;
        (0, $ffjl9.assert)(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
        if (transaction.status === 4 /* TransactionStatus.NEEDS_ABORT */ ) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat($668b2310913a4fe8$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
        } else if (transaction.status === 0 /* TransactionStatus.RUN */ ) {
            if (transaction.retryCount >= $668b2310913a4fe8$var$MAX_TRANSACTION_RETRIES) {
                abortTransaction = true;
                abortReason = 'maxretry';
                events = events.concat($668b2310913a4fe8$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
            } else {
                // This code reruns a transaction
                const currentNode = $668b2310913a4fe8$var$repoGetLatestState(repo, transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                const newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    $668b2310913a4fe8$var$validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
                    let newDataNode = $668b2310913a4fe8$var$nodeFromJSON(newData);
                    const hasExplicitPriority = typeof newData === 'object' && newData != null && (0, $ffjl9.contains)(newData, '.priority');
                    if (!hasExplicitPriority) // Keep the old priority if there wasn't a priority explicitly specified.
                    newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    const oldWriteId = transaction.currentWriteId;
                    const serverValues = $668b2310913a4fe8$var$repoGenerateServerValues(repo);
                    const newNodeResolved = $668b2310913a4fe8$var$resolveDeferredValueSnapshot(newDataNode, currentNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = $668b2310913a4fe8$var$repoGetNextWriteId(repo);
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat($668b2310913a4fe8$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat($668b2310913a4fe8$var$syncTreeAckUserWrite(repo.serverSyncTree_, oldWriteId, true));
                } else {
                    abortTransaction = true;
                    abortReason = 'nodata';
                    events = events.concat($668b2310913a4fe8$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
                }
            }
        }
        $668b2310913a4fe8$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = 2 /* TransactionStatus.COMPLETED */ ;
            // Removing a listener can trigger pruning which can muck with
            // mergedData/visibleData (as it prunes data). So defer the unwatcher
            // until we're done.
            (function(unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === 'nodata') callbacks.push(()=>queue[i].onComplete(null, false, queue[i].currentInputSnapshot));
                else callbacks.push(()=>queue[i].onComplete(new Error(abortReason), false, null));
            }
        }
    }
    // Clean up completed transactions.
    $668b2310913a4fe8$var$repoPruneCompletedTransactionsBelowNode(repo, repo.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for(let i = 0; i < callbacks.length; i++)$668b2310913a4fe8$var$exceptionGuard(callbacks[i]);
    // Try to send the transaction result to the server.
    $668b2310913a4fe8$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
}
/**
 * Returns the rootmost ancestor node of the specified path that has a pending
 * transaction on it, or just returns the node for the given path if there are
 * no pending transactions on any ancestor.
 *
 * @param path - The location to start at.
 * @returns The rootmost node with a transaction.
 */ function $668b2310913a4fe8$var$repoGetAncestorTransactionNode(repo, path) {
    let front;
    // Start at the root and walk deeper into the tree towards path until we
    // find a node with pending transactions.
    let transactionNode = repo.transactionQueueTree_;
    front = $668b2310913a4fe8$var$pathGetFront(path);
    while(front !== null && $668b2310913a4fe8$var$treeGetValue(transactionNode) === undefined){
        transactionNode = $668b2310913a4fe8$var$treeSubTree(transactionNode, front);
        path = $668b2310913a4fe8$var$pathPopFront(path);
        front = $668b2310913a4fe8$var$pathGetFront(path);
    }
    return transactionNode;
}
/**
 * Builds the queue of all transactions at or below the specified
 * transactionNode.
 *
 * @param transactionNode
 * @returns The generated queue.
 */ function $668b2310913a4fe8$var$repoBuildTransactionQueue(repo, transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    const transactionQueue = [];
    $668b2310913a4fe8$var$repoAggregateTransactionQueuesForNode(repo, transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort((a, b)=>a.order - b.order);
    return transactionQueue;
}
function $668b2310913a4fe8$var$repoAggregateTransactionQueuesForNode(repo, node, queue) {
    const nodeQueue = $668b2310913a4fe8$var$treeGetValue(node);
    if (nodeQueue) for(let i = 0; i < nodeQueue.length; i++)queue.push(nodeQueue[i]);
    $668b2310913a4fe8$var$treeForEachChild(node, (child)=>{
        $668b2310913a4fe8$var$repoAggregateTransactionQueuesForNode(repo, child, queue);
    });
}
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 */ function $668b2310913a4fe8$var$repoPruneCompletedTransactionsBelowNode(repo, node) {
    const queue = $668b2310913a4fe8$var$treeGetValue(node);
    if (queue) {
        let to = 0;
        for(let from = 0; from < queue.length; from++)if (queue[from].status !== 2 /* TransactionStatus.COMPLETED */ ) {
            queue[to] = queue[from];
            to++;
        }
        queue.length = to;
        $668b2310913a4fe8$var$treeSetValue(node, queue.length > 0 ? queue : undefined);
    }
    $668b2310913a4fe8$var$treeForEachChild(node, (childNode)=>{
        $668b2310913a4fe8$var$repoPruneCompletedTransactionsBelowNode(repo, childNode);
    });
}
/**
 * Aborts all transactions on ancestors or descendants of the specified path.
 * Called when doing a set() or update() since we consider them incompatible
 * with transactions.
 *
 * @param path - Path for which we want to abort related transactions.
 */ function $668b2310913a4fe8$var$repoAbortTransactions(repo, path) {
    const affectedPath = $668b2310913a4fe8$var$treeGetPath($668b2310913a4fe8$var$repoGetAncestorTransactionNode(repo, path));
    const transactionNode = $668b2310913a4fe8$var$treeSubTree(repo.transactionQueueTree_, path);
    $668b2310913a4fe8$var$treeForEachAncestor(transactionNode, (node)=>{
        $668b2310913a4fe8$var$repoAbortTransactionsOnNode(repo, node);
    });
    $668b2310913a4fe8$var$repoAbortTransactionsOnNode(repo, transactionNode);
    $668b2310913a4fe8$var$treeForEachDescendant(transactionNode, (node)=>{
        $668b2310913a4fe8$var$repoAbortTransactionsOnNode(repo, node);
    });
    return affectedPath;
}
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param node - Node to abort transactions for.
 */ function $668b2310913a4fe8$var$repoAbortTransactionsOnNode(repo, node) {
    const queue = $668b2310913a4fe8$var$treeGetValue(node);
    if (queue) {
        // Queue up the callbacks and fire them after cleaning up all of our
        // transaction state, since the callback could trigger more transactions
        // or sets.
        const callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for
        // abort, while the unsent ones can be immediately aborted and removed.
        let events = [];
        let lastSent = -1;
        for(let i = 0; i < queue.length; i++){
            if (queue[i].status === 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ) ;
            else if (queue[i].status === 1 /* TransactionStatus.SENT */ ) {
                (0, $ffjl9.assert)(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ;
                queue[i].abortReason = 'set';
            } else {
                (0, $ffjl9.assert)(queue[i].status === 0 /* TransactionStatus.RUN */ , 'Unexpected transaction status in abort');
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat($668b2310913a4fe8$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId, true));
                if (queue[i].onComplete) callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, null));
            }
        }
        if (lastSent === -1) // We're not waiting for any sent transactions.  We can clear the queue.
        $668b2310913a4fe8$var$treeSetValue(node, undefined);
        else // Remove the transactions we aborted.
        queue.length = lastSent + 1;
        // Now fire the callbacks.
        $668b2310913a4fe8$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $668b2310913a4fe8$var$treeGetPath(node), events);
        for(let i = 0; i < callbacks.length; i++)$668b2310913a4fe8$var$exceptionGuard(callbacks[i]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $668b2310913a4fe8$var$decodePath(pathString) {
    let pathStringDecoded = '';
    const pieces = pathString.split('/');
    for(let i = 0; i < pieces.length; i++)if (pieces[i].length > 0) {
        let piece = pieces[i];
        try {
            piece = decodeURIComponent(piece.replace(/\+/g, ' '));
        } catch (e) {}
        pathStringDecoded += '/' + piece;
    }
    return pathStringDecoded;
}
/**
 * @returns key value hash
 */ function $668b2310913a4fe8$var$decodeQuery(queryString) {
    const results = {};
    if (queryString.charAt(0) === '?') queryString = queryString.substring(1);
    for (const segment of queryString.split('&')){
        if (segment.length === 0) continue;
        const kv = segment.split('=');
        if (kv.length === 2) results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
        else $668b2310913a4fe8$var$warn(`Invalid query segment '${segment}' in query '${queryString}'`);
    }
    return results;
}
const $668b2310913a4fe8$var$parseRepoInfo = function(dataURL, nodeAdmin) {
    const parsedUrl = $668b2310913a4fe8$var$parseDatabaseURL(dataURL), namespace = parsedUrl.namespace;
    if (parsedUrl.domain === 'firebase.com') $668b2310913a4fe8$var$fatal(parsedUrl.host + ' is no longer supported. ' + 'Please use <YOUR FIREBASE>.firebaseio.com instead');
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace === 'undefined') && parsedUrl.domain !== 'localhost') $668b2310913a4fe8$var$fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
    if (!parsedUrl.secure) $668b2310913a4fe8$var$warnIfPageIsSecure();
    const webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
    return {
        repoInfo: new $668b2310913a4fe8$var$RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly, nodeAdmin, /*persistenceKey=*/ '', /*includeNamespaceInQueryParams=*/ namespace !== parsedUrl.subdomain),
        path: new $668b2310913a4fe8$var$Path(parsedUrl.pathString)
    };
};
const $668b2310913a4fe8$var$parseDatabaseURL = function(dataURL) {
    // Default to empty strings in the event of a malformed string.
    let host = '', domain = '', subdomain = '', pathString = '', namespace = '';
    // Always default to SSL, unless otherwise specified.
    let secure = true, scheme = 'https', port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === 'string') {
        // Parse scheme.
        let colonInd = dataURL.indexOf('//');
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        let slashInd = dataURL.indexOf('/');
        if (slashInd === -1) slashInd = dataURL.length;
        let questionMarkInd = dataURL.indexOf('?');
        if (questionMarkInd === -1) questionMarkInd = dataURL.length;
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) // For pathString, questionMarkInd will always come after slashInd
        pathString = $668b2310913a4fe8$var$decodePath(dataURL.substring(slashInd, questionMarkInd));
        const queryParams = $668b2310913a4fe8$var$decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(':');
        if (colonInd >= 0) {
            secure = scheme === 'https' || scheme === 'wss';
            port = parseInt(host.substring(colonInd + 1), 10);
        } else colonInd = host.length;
        const hostWithoutPort = host.slice(0, colonInd);
        if (hostWithoutPort.toLowerCase() === 'localhost') domain = 'localhost';
        else if (hostWithoutPort.split('.').length <= 2) domain = hostWithoutPort;
        else {
            // Interpret the subdomain of a 3 or more component URL as the namespace name.
            const dotInd = host.indexOf('.');
            subdomain = host.substring(0, dotInd).toLowerCase();
            domain = host.substring(dotInd + 1);
            // Normalize namespaces to lowercase to share storage / connection.
            namespace = subdomain;
        }
        // Always treat the value of the `ns` as the namespace name if it is present.
        if ('ns' in queryParams) namespace = queryParams['ns'];
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString,
        namespace: namespace
    };
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Modeled after base64 web-safe chars, but ordered by ASCII.
const $668b2310913a4fe8$var$PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */ const $668b2310913a4fe8$var$nextPushId = function() {
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    let lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    const lastRandChars = [];
    return function(now) {
        const duplicateTime = now === lastPushTime;
        lastPushTime = now;
        let i;
        const timeStampChars = new Array(8);
        for(i = 7; i >= 0; i--){
            timeStampChars[i] = $668b2310913a4fe8$var$PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        (0, $ffjl9.assert)(now === 0, 'Cannot push at time == 0');
        let id = timeStampChars.join('');
        if (!duplicateTime) for(i = 0; i < 12; i++)lastRandChars[i] = Math.floor(Math.random() * 64);
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for(i = 11; i >= 0 && lastRandChars[i] === 63; i--)lastRandChars[i] = 0;
            lastRandChars[i]++;
        }
        for(i = 0; i < 12; i++)id += $668b2310913a4fe8$var$PUSH_CHARS.charAt(lastRandChars[i]);
        (0, $ffjl9.assert)(id.length === 20, 'nextPushId: Length should be 20.');
        return id;
    };
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encapsulates the data needed to raise an event
 */ class $668b2310913a4fe8$var$DataEvent {
    /**
     * @param eventType - One of: value, child_added, child_changed, child_moved, child_removed
     * @param eventRegistration - The function to call to with the event data. User provided
     * @param snapshot - The data backing the event
     * @param prevName - Optional, the name of the previous child for child_* events.
     */ constructor(eventType, eventRegistration, snapshot, prevName){
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    getPath() {
        const ref = this.snapshot.ref;
        if (this.eventType === 'value') return ref._path;
        else return ref.parent._path;
    }
    getEventType() {
        return this.eventType;
    }
    getEventRunner() {
        return this.eventRegistration.getEventRunner(this);
    }
    toString() {
        return this.getPath().toString() + ':' + this.eventType + ':' + (0, $ffjl9.stringify)(this.snapshot.exportVal());
    }
}
class $668b2310913a4fe8$var$CancelEvent {
    constructor(eventRegistration, error, path){
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    getPath() {
        return this.path;
    }
    getEventType() {
        return 'cancel';
    }
    getEventRunner() {
        return this.eventRegistration.getEventRunner(this);
    }
    toString() {
        return this.path.toString() + ':cancel';
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A wrapper class that converts events from the database@exp SDK to the legacy
 * Database SDK. Events are not converted directly as event registration relies
 * on reference comparison of the original user callback (see `matches()`) and
 * relies on equality of the legacy SDK's `context` object.
 */ class $668b2310913a4fe8$var$CallbackContext {
    constructor(snapshotCallback, cancelCallback){
        this.snapshotCallback = snapshotCallback;
        this.cancelCallback = cancelCallback;
    }
    onValue(expDataSnapshot, previousChildName) {
        this.snapshotCallback.call(null, expDataSnapshot, previousChildName);
    }
    onCancel(error) {
        (0, $ffjl9.assert)(this.hasCancelCallback, 'Raising a cancel event on a listener with no cancel callback');
        return this.cancelCallback.call(null, error);
    }
    get hasCancelCallback() {
        return !!this.cancelCallback;
    }
    matches(other) {
        return this.snapshotCallback === other.snapshotCallback || this.snapshotCallback.userCallback !== undefined && this.snapshotCallback.userCallback === other.snapshotCallback.userCallback && this.snapshotCallback.context === other.snapshotCallback.context;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The `onDisconnect` class allows you to write or clear data when your client
 * disconnects from the Database server. These updates occur whether your
 * client disconnects cleanly or not, so you can rely on them to clean up data
 * even if a connection is dropped or a client crashes.
 *
 * The `onDisconnect` class is most commonly used to manage presence in
 * applications where it is useful to detect how many clients are connected and
 * when other clients disconnect. See
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information.
 *
 * To avoid problems when a connection is dropped before the requests can be
 * transferred to the Database server, these functions should be called before
 * writing any data.
 *
 * Note that `onDisconnect` operations are only triggered once. If you want an
 * operation to occur each time a disconnect occurs, you'll need to re-establish
 * the `onDisconnect` operations each time you reconnect.
 */ class $668b2310913a4fe8$export$95b7818b4ee6c2af {
    /** @hideconstructor */ constructor(_repo, _path){
        this._repo = _repo;
        this._path = _path;
    }
    /**
     * Cancels all previously queued `onDisconnect()` set or update events for this
     * location and all children.
     *
     * If a write has been queued for this location via a `set()` or `update()` at a
     * parent location, the write at this location will be canceled, though writes
     * to sibling locations will still occur.
     *
     * @returns Resolves when synchronization to the server is complete.
     */ cancel() {
        const deferred = new (0, $ffjl9.Deferred)();
        $668b2310913a4fe8$var$repoOnDisconnectCancel(this._repo, this._path, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is deleted when the client is disconnected
     * (due to closing the browser, navigating to a new page, or network issues).
     *
     * @returns Resolves when synchronization to the server is complete.
     */ remove() {
        $668b2310913a4fe8$export$8d83036122ae444e('OnDisconnect.remove', this._path);
        const deferred = new (0, $ffjl9.Deferred)();
        $668b2310913a4fe8$var$repoOnDisconnectSet(this._repo, this._path, null, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is set to the specified value when the
     * client is disconnected (due to closing the browser, navigating to a new page,
     * or network issues).
     *
     * `set()` is especially useful for implementing "presence" systems, where a
     * value should be changed or cleared when a user disconnects so that they
     * appear "offline" to other users. See
     * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
     * for more information.
     *
     * Note that `onDisconnect` operations are only triggered once. If you want an
     * operation to occur each time a disconnect occurs, you'll need to re-establish
     * the `onDisconnect` operations each time.
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ set(value) {
        $668b2310913a4fe8$export$8d83036122ae444e('OnDisconnect.set', this._path);
        $668b2310913a4fe8$var$validateFirebaseDataArg('OnDisconnect.set', value, this._path, false);
        const deferred = new (0, $ffjl9.Deferred)();
        $668b2310913a4fe8$var$repoOnDisconnectSet(this._repo, this._path, value, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is set to the specified value and priority
     * when the client is disconnected (due to closing the browser, navigating to a
     * new page, or network issues).
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @param priority - The priority to be written (string, number, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ setWithPriority(value, priority) {
        $668b2310913a4fe8$export$8d83036122ae444e('OnDisconnect.setWithPriority', this._path);
        $668b2310913a4fe8$var$validateFirebaseDataArg('OnDisconnect.setWithPriority', value, this._path, false);
        $668b2310913a4fe8$var$validatePriority('OnDisconnect.setWithPriority', priority, false);
        const deferred = new (0, $ffjl9.Deferred)();
        $668b2310913a4fe8$var$repoOnDisconnectSetWithPriority(this._repo, this._path, value, priority, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Writes multiple values at this location when the client is disconnected (due
     * to closing the browser, navigating to a new page, or network issues).
     *
     * The `values` argument contains multiple property-value pairs that will be
     * written to the Database together. Each child property can either be a simple
     * property (for example, "name") or a relative path (for example, "name/first")
     * from the current location to the data to update.
     *
     * As opposed to the `set()` method, `update()` can be use to selectively update
     * only the referenced properties at the current location (instead of replacing
     * all the child properties at the current location).
     *
     * @param values - Object containing multiple values.
     * @returns Resolves when synchronization to the Database is complete.
     */ update(values) {
        $668b2310913a4fe8$export$8d83036122ae444e('OnDisconnect.update', this._path);
        $668b2310913a4fe8$var$validateFirebaseMergeDataArg('OnDisconnect.update', values, this._path, false);
        const deferred = new (0, $ffjl9.Deferred)();
        $668b2310913a4fe8$var$repoOnDisconnectUpdate(this._repo, this._path, values, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $668b2310913a4fe8$export$e79c8d837d2220a8 {
    /**
     * @hideconstructor
     */ constructor(_repo, _path, _queryParams, _orderByCalled){
        this._repo = _repo;
        this._path = _path;
        this._queryParams = _queryParams;
        this._orderByCalled = _orderByCalled;
    }
    get key() {
        if ($668b2310913a4fe8$var$pathIsEmpty(this._path)) return null;
        else return $668b2310913a4fe8$var$pathGetBack(this._path);
    }
    get ref() {
        return new $668b2310913a4fe8$export$35c3a5e7c9d1033c(this._repo, this._path);
    }
    get _queryIdentifier() {
        const obj = $668b2310913a4fe8$var$queryParamsGetQueryObject(this._queryParams);
        const id = $668b2310913a4fe8$var$ObjectToUniqueKey(obj);
        return id === '{}' ? 'default' : id;
    }
    /**
     * An object representation of the query parameters used by this Query.
     */ get _queryObject() {
        return $668b2310913a4fe8$var$queryParamsGetQueryObject(this._queryParams);
    }
    isEqual(other) {
        other = (0, $ffjl9.getModularInstance)(other);
        if (!(other instanceof $668b2310913a4fe8$export$e79c8d837d2220a8)) return false;
        const sameRepo = this._repo === other._repo;
        const samePath = $668b2310913a4fe8$var$pathEquals(this._path, other._path);
        const sameQueryIdentifier = this._queryIdentifier === other._queryIdentifier;
        return sameRepo && samePath && sameQueryIdentifier;
    }
    toJSON() {
        return this.toString();
    }
    toString() {
        return this._repo.toString() + $668b2310913a4fe8$var$pathToUrlEncodedString(this._path);
    }
}
/**
 * Validates that no other order by call has been made
 */ function $668b2310913a4fe8$var$validateNoPreviousOrderByCall(query, fnName) {
    if (query._orderByCalled === true) throw new Error(fnName + ": You can't combine multiple orderBy calls.");
}
/**
 * Validates start/end values for queries.
 */ function $668b2310913a4fe8$var$validateQueryEndpoints(params) {
    let startNode = null;
    let endNode = null;
    if (params.hasStart()) startNode = params.getIndexStartValue();
    if (params.hasEnd()) endNode = params.getIndexEndValue();
    if (params.getIndex() === $668b2310913a4fe8$var$KEY_INDEX) {
        const tooManyArgsError = "Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().";
        const wrongArgTypeError = "Query: When ordering by key, the argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() must be a string.";
        if (params.hasStart()) {
            const startName = params.getIndexStartName();
            if (startName !== $668b2310913a4fe8$var$MIN_NAME) throw new Error(tooManyArgsError);
            else if (typeof startNode !== 'string') throw new Error(wrongArgTypeError);
        }
        if (params.hasEnd()) {
            const endName = params.getIndexEndName();
            if (endName !== $668b2310913a4fe8$var$MAX_NAME) throw new Error(tooManyArgsError);
            else if (typeof endNode !== 'string') throw new Error(wrongArgTypeError);
        }
    } else if (params.getIndex() === $668b2310913a4fe8$var$PRIORITY_INDEX) {
        if (startNode != null && !$668b2310913a4fe8$var$isValidPriority(startNode) || endNode != null && !$668b2310913a4fe8$var$isValidPriority(endNode)) throw new Error("Query: When ordering by priority, the first argument passed to startAt(), startAfter() endAt(), endBefore(), or equalTo() must be a valid priority value (null, a number, or a string).");
    } else {
        (0, $ffjl9.assert)(params.getIndex() instanceof $668b2310913a4fe8$var$PathIndex || params.getIndex() === $668b2310913a4fe8$var$VALUE_INDEX, 'unknown index type.');
        if (startNode != null && typeof startNode === 'object' || endNode != null && typeof endNode === 'object') throw new Error("Query: First argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() cannot be an object.");
    }
}
/**
 * Validates that limit* has been called with the correct combination of parameters
 */ function $668b2310913a4fe8$var$validateLimit(params) {
    if (params.hasStart() && params.hasEnd() && params.hasLimit() && !params.hasAnchoredLimit()) throw new Error("Query: Can't combine startAt(), startAfter(), endAt(), endBefore(), and limit(). Use limitToFirst() or limitToLast() instead.");
}
/**
 * @internal
 */ class $668b2310913a4fe8$export$35c3a5e7c9d1033c extends $668b2310913a4fe8$export$e79c8d837d2220a8 {
    /** @hideconstructor */ constructor(repo, path){
        super(repo, path, new $668b2310913a4fe8$export$7ba287e361c94330(), false);
    }
    get parent() {
        const parentPath = $668b2310913a4fe8$var$pathParent(this._path);
        return parentPath === null ? null : new $668b2310913a4fe8$export$35c3a5e7c9d1033c(this._repo, parentPath);
    }
    get root() {
        let ref = this;
        while(ref.parent !== null)ref = ref.parent;
        return ref;
    }
}
/**
 * A `DataSnapshot` contains data from a Database location.
 *
 * Any time you read data from the Database, you receive the data as a
 * `DataSnapshot`. A `DataSnapshot` is passed to the event callbacks you attach
 * with `on()` or `once()`. You can extract the contents of the snapshot as a
 * JavaScript object by calling the `val()` method. Alternatively, you can
 * traverse into the snapshot by calling `child()` to return child snapshots
 * (which you could then call `val()` on).
 *
 * A `DataSnapshot` is an efficiently generated, immutable copy of the data at
 * a Database location. It cannot be modified and will never change (to modify
 * data, you always call the `set()` method on a `Reference` directly).
 */ class $668b2310913a4fe8$export$80b98bcbc246c942 {
    /**
     * @param _node - A SnapshotNode to wrap.
     * @param ref - The location this snapshot came from.
     * @param _index - The iteration order for this snapshot
     * @hideconstructor
     */ constructor(_node, /**
     * The location of this DataSnapshot.
     */ ref, _index){
        this._node = _node;
        this.ref = ref;
        this._index = _index;
    }
    /**
     * Gets the priority value of the data in this `DataSnapshot`.
     *
     * Applications need not use priority but can order collections by
     * ordinary properties (see
     * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data |Sorting and filtering data}
     * ).
     */ get priority() {
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this._node.getPriority().val();
    }
    /**
     * The key (last part of the path) of the location of this `DataSnapshot`.
     *
     * The last token in a Database location is considered its key. For example,
     * "ada" is the key for the /users/ada/ node. Accessing the key on any
     * `DataSnapshot` will return the key for the location that generated it.
     * However, accessing the key on the root URL of a Database will return
     * `null`.
     */ get key() {
        return this.ref.key;
    }
    /** Returns the number of child properties of this `DataSnapshot`. */ get size() {
        return this._node.numChildren();
    }
    /**
     * Gets another `DataSnapshot` for the location at the specified relative path.
     *
     * Passing a relative path to the `child()` method of a DataSnapshot returns
     * another `DataSnapshot` for the location at the specified relative path. The
     * relative path can either be a simple child name (for example, "ada") or a
     * deeper, slash-separated path (for example, "ada/name/first"). If the child
     * location has no data, an empty `DataSnapshot` (that is, a `DataSnapshot`
     * whose value is `null`) is returned.
     *
     * @param path - A relative path to the location of child data.
     */ child(path) {
        const childPath = new $668b2310913a4fe8$var$Path(path);
        const childRef = $668b2310913a4fe8$export$f9574b70e1d95d9d(this.ref, path);
        return new $668b2310913a4fe8$export$80b98bcbc246c942(this._node.getChild(childPath), childRef, $668b2310913a4fe8$var$PRIORITY_INDEX);
    }
    /**
     * Returns true if this `DataSnapshot` contains any data. It is slightly more
     * efficient than using `snapshot.val() !== null`.
     */ exists() {
        return !this._node.isEmpty();
    }
    /**
     * Exports the entire contents of the DataSnapshot as a JavaScript object.
     *
     * The `exportVal()` method is similar to `val()`, except priority information
     * is included (if available), making it suitable for backing up your data.
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    exportVal() {
        return this._node.val(true);
    }
    /**
     * Enumerates the top-level children in the `IteratedDataSnapshot`.
     *
     * Because of the way JavaScript objects work, the ordering of data in the
     * JavaScript object returned by `val()` is not guaranteed to match the
     * ordering on the server nor the ordering of `onChildAdded()` events. That is
     * where `forEach()` comes in handy. It guarantees the children of a
     * `DataSnapshot` will be iterated in their query order.
     *
     * If no explicit `orderBy*()` method is used, results are returned
     * ordered by key (unless priorities are used, in which case, results are
     * returned by priority).
     *
     * @param action - A function that will be called for each child DataSnapshot.
     * The callback can return true to cancel further enumeration.
     * @returns true if enumeration was canceled due to your callback returning
     * true.
     */ forEach(action) {
        if (this._node.isLeafNode()) return false;
        const childrenNode = this._node;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this._index, (key, node)=>{
            return action(new $668b2310913a4fe8$export$80b98bcbc246c942(node, $668b2310913a4fe8$export$f9574b70e1d95d9d(this.ref, key), $668b2310913a4fe8$var$PRIORITY_INDEX));
        });
    }
    /**
     * Returns true if the specified child path has (non-null) data.
     *
     * @param path - A relative path to the location of a potential child.
     * @returns `true` if data exists at the specified child path; else
     *  `false`.
     */ hasChild(path) {
        const childPath = new $668b2310913a4fe8$var$Path(path);
        return !this._node.getChild(childPath).isEmpty();
    }
    /**
     * Returns whether or not the `DataSnapshot` has any non-`null` child
     * properties.
     *
     * You can use `hasChildren()` to determine if a `DataSnapshot` has any
     * children. If it does, you can enumerate them using `forEach()`. If it
     * doesn't, then either this snapshot contains a primitive value (which can be
     * retrieved with `val()`) or it is empty (in which case, `val()` will return
     * `null`).
     *
     * @returns true if this snapshot has any children; else false.
     */ hasChildren() {
        if (this._node.isLeafNode()) return false;
        else return !this._node.isEmpty();
    }
    /**
     * Returns a JSON-serializable representation of this object.
     */ toJSON() {
        return this.exportVal();
    }
    /**
     * Extracts a JavaScript value from a `DataSnapshot`.
     *
     * Depending on the data in a `DataSnapshot`, the `val()` method may return a
     * scalar type (string, number, or boolean), an array, or an object. It may
     * also return null, indicating that the `DataSnapshot` is empty (contains no
     * data).
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    val() {
        return this._node.val();
    }
}
/**
 *
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided path. If no path is provided, the `Reference`
 * will point to the root of the Database.
 *
 * @param db - The database instance to obtain a reference for.
 * @param path - Optional path representing the location the returned
 *   `Reference` will point. If not provided, the returned `Reference` will
 *   point to the root of the Database.
 * @returns If a path is provided, a `Reference`
 *   pointing to the provided path. Otherwise, a `Reference` pointing to the
 *   root of the Database.
 */ function $668b2310913a4fe8$export$eff4d24c3ff7876e(db, path) {
    db = (0, $ffjl9.getModularInstance)(db);
    db._checkNotDeleted('ref');
    return path !== undefined ? $668b2310913a4fe8$export$f9574b70e1d95d9d(db._root, path) : db._root;
}
/**
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided Firebase URL.
 *
 * An exception is thrown if the URL is not a valid Firebase Database URL or it
 * has a different domain than the current `Database` instance.
 *
 * Note that all query parameters (`orderBy`, `limitToLast`, etc.) are ignored
 * and are not applied to the returned `Reference`.
 *
 * @param db - The database instance to obtain a reference for.
 * @param url - The Firebase URL at which the returned `Reference` will
 *   point.
 * @returns A `Reference` pointing to the provided
 *   Firebase URL.
 */ function $668b2310913a4fe8$export$291fc3c05735451(db, url) {
    db = (0, $ffjl9.getModularInstance)(db);
    db._checkNotDeleted('refFromURL');
    const parsedURL = $668b2310913a4fe8$var$parseRepoInfo(url, db._repo.repoInfo_.nodeAdmin);
    $668b2310913a4fe8$var$validateUrl('refFromURL', parsedURL);
    const repoInfo = parsedURL.repoInfo;
    if (!db._repo.repoInfo_.isCustomHost() && repoInfo.host !== db._repo.repoInfo_.host) $668b2310913a4fe8$var$fatal("refFromURL: Host name does not match the current database: (found " + repoInfo.host + ' but expected ' + db._repo.repoInfo_.host + ')');
    return $668b2310913a4fe8$export$eff4d24c3ff7876e(db, parsedURL.path.toString());
}
/**
 * Gets a `Reference` for the location at the specified relative path.
 *
 * The relative path can either be a simple child name (for example, "ada") or
 * a deeper slash-separated path (for example, "ada/name/first").
 *
 * @param parent - The parent location.
 * @param path - A relative path from this location to the desired child
 *   location.
 * @returns The specified child location.
 */ function $668b2310913a4fe8$export$f9574b70e1d95d9d(parent, path) {
    parent = (0, $ffjl9.getModularInstance)(parent);
    if ($668b2310913a4fe8$var$pathGetFront(parent._path) === null) $668b2310913a4fe8$var$validateRootPathString('child', 'path', path, false);
    else $668b2310913a4fe8$export$8637b026ace8abb1('child', 'path', path, false);
    return new $668b2310913a4fe8$export$35c3a5e7c9d1033c(parent._repo, $668b2310913a4fe8$var$pathChild(parent._path, path));
}
/**
 * Returns an `OnDisconnect` object - see
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information on how to use it.
 *
 * @param ref - The reference to add OnDisconnect triggers for.
 */ function $668b2310913a4fe8$export$b61bdcd0bdb4f86a(ref) {
    ref = (0, $ffjl9.getModularInstance)(ref);
    return new $668b2310913a4fe8$export$95b7818b4ee6c2af(ref._repo, ref._path);
}
/**
 * Generates a new child location using a unique key and returns its
 * `Reference`.
 *
 * This is the most common pattern for adding data to a collection of items.
 *
 * If you provide a value to `push()`, the value is written to the
 * generated location. If you don't pass a value, nothing is written to the
 * database and the child remains empty (but you can use the `Reference`
 * elsewhere).
 *
 * The unique keys generated by `push()` are ordered by the current time, so the
 * resulting list of items is chronologically sorted. The keys are also
 * designed to be unguessable (they contain 72 random bits of entropy).
 *
 * See {@link https://firebase.google.com/docs/database/web/lists-of-data#append_to_a_list_of_data | Append to a list of data}.
 * See {@link https://firebase.googleblog.com/2015/02/the-2120-ways-to-ensure-unique_68.html | The 2^120 Ways to Ensure Unique Identifiers}.
 *
 * @param parent - The parent location.
 * @param value - Optional value to be written at the generated location.
 * @returns Combined `Promise` and `Reference`; resolves when write is complete,
 * but can be used immediately as the `Reference` to the child location.
 */ function $668b2310913a4fe8$export$4cbf152802aa238(parent, value) {
    parent = (0, $ffjl9.getModularInstance)(parent);
    $668b2310913a4fe8$export$8d83036122ae444e('push', parent._path);
    $668b2310913a4fe8$var$validateFirebaseDataArg('push', value, parent._path, true);
    const now = $668b2310913a4fe8$var$repoServerTime(parent._repo);
    const name = $668b2310913a4fe8$var$nextPushId(now);
    // push() returns a ThennableReference whose promise is fulfilled with a
    // regular Reference. We use child() to create handles to two different
    // references. The first is turned into a ThennableReference below by adding
    // then() and catch() methods and is used as the return value of push(). The
    // second remains a regular Reference and is used as the fulfilled value of
    // the first ThennableReference.
    const thenablePushRef = $668b2310913a4fe8$export$f9574b70e1d95d9d(parent, name);
    const pushRef = $668b2310913a4fe8$export$f9574b70e1d95d9d(parent, name);
    let promise;
    if (value != null) promise = $668b2310913a4fe8$export$adaa4cf7ef1b65be(pushRef, value).then(()=>pushRef);
    else promise = Promise.resolve(pushRef);
    thenablePushRef.then = promise.then.bind(promise);
    thenablePushRef.catch = promise.then.bind(promise, undefined);
    return thenablePushRef;
}
/**
 * Removes the data at this Database location.
 *
 * Any data at child locations will also be deleted.
 *
 * The effect of the remove will be visible immediately and the corresponding
 * event 'value' will be triggered. Synchronization of the remove to the
 * Firebase servers will also be started, and the returned Promise will resolve
 * when complete. If provided, the onComplete callback will be called
 * asynchronously after synchronization has finished.
 *
 * @param ref - The location to remove.
 * @returns Resolves when remove on server is complete.
 */ function $668b2310913a4fe8$export$cd7f480d6b8286c3(ref) {
    $668b2310913a4fe8$export$8d83036122ae444e('remove', ref._path);
    return $668b2310913a4fe8$export$adaa4cf7ef1b65be(ref, null);
}
/**
 * Writes data to this Database location.
 *
 * This will overwrite any data at this location and all child locations.
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ("value", "child_added", etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * Passing `null` for the new value is equivalent to calling `remove()`; namely,
 * all data at this location and all child locations will be deleted.
 *
 * `set()` will remove any priority stored at this location, so if priority is
 * meant to be preserved, you need to use `setWithPriority()` instead.
 *
 * Note that modifying data with `set()` will cancel any pending transactions
 * at that location, so extreme care should be taken if mixing `set()` and
 * `transaction()` to modify the same data.
 *
 * A single `set()` will generate a single "value" event at the location where
 * the `set()` was performed.
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @returns Resolves when write to server is complete.
 */ function $668b2310913a4fe8$export$adaa4cf7ef1b65be(ref, value) {
    ref = (0, $ffjl9.getModularInstance)(ref);
    $668b2310913a4fe8$export$8d83036122ae444e('set', ref._path);
    $668b2310913a4fe8$var$validateFirebaseDataArg('set', value, ref._path, false);
    const deferred = new (0, $ffjl9.Deferred)();
    $668b2310913a4fe8$var$repoSetWithPriority(ref._repo, ref._path, value, /*priority=*/ null, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Sets a priority for the data at this Database location.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $668b2310913a4fe8$export$313bf5dbe7a1196e(ref, priority) {
    ref = (0, $ffjl9.getModularInstance)(ref);
    $668b2310913a4fe8$export$8d83036122ae444e('setPriority', ref._path);
    $668b2310913a4fe8$var$validatePriority('setPriority', priority, false);
    const deferred = new (0, $ffjl9.Deferred)();
    $668b2310913a4fe8$var$repoSetWithPriority(ref._repo, $668b2310913a4fe8$var$pathChild(ref._path, '.priority'), priority, null, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Writes data the Database location. Like `set()` but also specifies the
 * priority for that data.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $668b2310913a4fe8$export$1fa5d5bf488088f3(ref, value, priority) {
    $668b2310913a4fe8$export$8d83036122ae444e('setWithPriority', ref._path);
    $668b2310913a4fe8$var$validateFirebaseDataArg('setWithPriority', value, ref._path, false);
    $668b2310913a4fe8$var$validatePriority('setWithPriority', priority, false);
    if (ref.key === '.length' || ref.key === '.keys') throw 'setWithPriority failed: ' + ref.key + ' is a read-only object.';
    const deferred = new (0, $ffjl9.Deferred)();
    $668b2310913a4fe8$var$repoSetWithPriority(ref._repo, ref._path, value, priority, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Writes multiple values to the Database at once.
 *
 * The `values` argument contains multiple property-value pairs that will be
 * written to the Database together. Each child property can either be a simple
 * property (for example, "name") or a relative path (for example,
 * "name/first") from the current location to the data to update.
 *
 * As opposed to the `set()` method, `update()` can be use to selectively update
 * only the referenced properties at the current location (instead of replacing
 * all the child properties at the current location).
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ('value', 'child_added', etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * A single `update()` will generate a single "value" event at the location
 * where the `update()` was performed, regardless of how many children were
 * modified.
 *
 * Note that modifying data with `update()` will cancel any pending
 * transactions at that location, so extreme care should be taken if mixing
 * `update()` and `transaction()` to modify the same data.
 *
 * Passing `null` to `update()` will remove the data at this location.
 *
 * See
 * {@link https://firebase.googleblog.com/2015/09/introducing-multi-location-updates-and_86.html | Introducing multi-location updates and more}.
 *
 * @param ref - The location to write to.
 * @param values - Object containing multiple values.
 * @returns Resolves when update on server is complete.
 */ function $668b2310913a4fe8$export$722fbec263ad908a(ref, values) {
    $668b2310913a4fe8$var$validateFirebaseMergeDataArg('update', values, ref._path, false);
    const deferred = new (0, $ffjl9.Deferred)();
    $668b2310913a4fe8$var$repoUpdate(ref._repo, ref._path, values, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Gets the most up-to-date result for this query.
 *
 * @param query - The query to run.
 * @returns A `Promise` which resolves to the resulting DataSnapshot if a value is
 * available, or rejects if the client is unable to return a value (e.g., if the
 * server is unreachable and there is nothing cached).
 */ function $668b2310913a4fe8$export$3988ae62b71be9a3(query) {
    query = (0, $ffjl9.getModularInstance)(query);
    const callbackContext = new $668b2310913a4fe8$var$CallbackContext(()=>{});
    const container = new $668b2310913a4fe8$var$ValueEventRegistration(callbackContext);
    return $668b2310913a4fe8$var$repoGetValue(query._repo, query, container).then((node)=>{
        return new $668b2310913a4fe8$export$80b98bcbc246c942(node, new $668b2310913a4fe8$export$35c3a5e7c9d1033c(query._repo, query._path), query._queryParams.getIndex());
    });
}
/**
 * Represents registration for 'value' events.
 */ class $668b2310913a4fe8$var$ValueEventRegistration {
    constructor(callbackContext){
        this.callbackContext = callbackContext;
    }
    respondsTo(eventType) {
        return eventType === 'value';
    }
    createEvent(change, query) {
        const index = query._queryParams.getIndex();
        return new $668b2310913a4fe8$var$DataEvent('value', this, new $668b2310913a4fe8$export$80b98bcbc246c942(change.snapshotNode, new $668b2310913a4fe8$export$35c3a5e7c9d1033c(query._repo, query._path), index));
    }
    getEventRunner(eventData) {
        if (eventData.getEventType() === 'cancel') return ()=>this.callbackContext.onCancel(eventData.error);
        else return ()=>this.callbackContext.onValue(eventData.snapshot, null);
    }
    createCancelEvent(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $668b2310913a4fe8$var$CancelEvent(this, error, path);
        else return null;
    }
    matches(other) {
        if (!(other instanceof $668b2310913a4fe8$var$ValueEventRegistration)) return false;
        else if (!other.callbackContext || !this.callbackContext) // If no callback specified, we consider it to match any callback.
        return true;
        else return other.callbackContext.matches(this.callbackContext);
    }
    hasAnyCallback() {
        return this.callbackContext !== null;
    }
}
/**
 * Represents the registration of a child_x event.
 */ class $668b2310913a4fe8$var$ChildEventRegistration {
    constructor(eventType, callbackContext){
        this.eventType = eventType;
        this.callbackContext = callbackContext;
    }
    respondsTo(eventType) {
        let eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
        eventToCheck = eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
        return this.eventType === eventToCheck;
    }
    createCancelEvent(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $668b2310913a4fe8$var$CancelEvent(this, error, path);
        else return null;
    }
    createEvent(change, query) {
        (0, $ffjl9.assert)(change.childName != null, 'Child events should have a childName.');
        const childRef = $668b2310913a4fe8$export$f9574b70e1d95d9d(new $668b2310913a4fe8$export$35c3a5e7c9d1033c(query._repo, query._path), change.childName);
        const index = query._queryParams.getIndex();
        return new $668b2310913a4fe8$var$DataEvent(change.type, this, new $668b2310913a4fe8$export$80b98bcbc246c942(change.snapshotNode, childRef, index), change.prevName);
    }
    getEventRunner(eventData) {
        if (eventData.getEventType() === 'cancel') return ()=>this.callbackContext.onCancel(eventData.error);
        else return ()=>this.callbackContext.onValue(eventData.snapshot, eventData.prevName);
    }
    matches(other) {
        if (other instanceof $668b2310913a4fe8$var$ChildEventRegistration) return this.eventType === other.eventType && (!this.callbackContext || !other.callbackContext || this.callbackContext.matches(other.callbackContext));
        return false;
    }
    hasAnyCallback() {
        return !!this.callbackContext;
    }
}
function $668b2310913a4fe8$var$addEventListener(query, eventType, callback, cancelCallbackOrListenOptions, options) {
    let cancelCallback;
    if (typeof cancelCallbackOrListenOptions === 'object') {
        cancelCallback = undefined;
        options = cancelCallbackOrListenOptions;
    }
    if (typeof cancelCallbackOrListenOptions === 'function') cancelCallback = cancelCallbackOrListenOptions;
    if (options && options.onlyOnce) {
        const userCallback = callback;
        const onceCallback = (dataSnapshot, previousChildName)=>{
            $668b2310913a4fe8$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
            userCallback(dataSnapshot, previousChildName);
        };
        onceCallback.userCallback = callback.userCallback;
        onceCallback.context = callback.context;
        callback = onceCallback;
    }
    const callbackContext = new $668b2310913a4fe8$var$CallbackContext(callback, cancelCallback || undefined);
    const container = eventType === 'value' ? new $668b2310913a4fe8$var$ValueEventRegistration(callbackContext) : new $668b2310913a4fe8$var$ChildEventRegistration(eventType, callbackContext);
    $668b2310913a4fe8$var$repoAddEventCallbackForQuery(query._repo, query, container);
    return ()=>$668b2310913a4fe8$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
function $668b2310913a4fe8$export$ad30f661f41f4d90(query, callback, cancelCallbackOrListenOptions, options) {
    return $668b2310913a4fe8$var$addEventListener(query, 'value', callback, cancelCallbackOrListenOptions, options);
}
function $668b2310913a4fe8$export$fdc3e67b2775c753(query, callback, cancelCallbackOrListenOptions, options) {
    return $668b2310913a4fe8$var$addEventListener(query, 'child_added', callback, cancelCallbackOrListenOptions, options);
}
function $668b2310913a4fe8$export$a3fdf31223dcb03(query, callback, cancelCallbackOrListenOptions, options) {
    return $668b2310913a4fe8$var$addEventListener(query, 'child_changed', callback, cancelCallbackOrListenOptions, options);
}
function $668b2310913a4fe8$export$1b001b15904d2a7f(query, callback, cancelCallbackOrListenOptions, options) {
    return $668b2310913a4fe8$var$addEventListener(query, 'child_moved', callback, cancelCallbackOrListenOptions, options);
}
function $668b2310913a4fe8$export$8362b530316d1aba(query, callback, cancelCallbackOrListenOptions, options) {
    return $668b2310913a4fe8$var$addEventListener(query, 'child_removed', callback, cancelCallbackOrListenOptions, options);
}
/**
 * Detaches a callback previously attached with the corresponding `on*()` (`onValue`, `onChildAdded`) listener.
 * Note: This is not the recommended way to remove a listener. Instead, please use the returned callback function from
 * the respective `on*` callbacks.
 *
 * Detach a callback previously attached with `on*()`. Calling `off()` on a parent listener
 * will not automatically remove listeners registered on child nodes, `off()`
 * must also be called on any child listeners to remove the callback.
 *
 * If a callback is not specified, all callbacks for the specified eventType
 * will be removed. Similarly, if no eventType is specified, all callbacks
 * for the `Reference` will be removed.
 *
 * Individual listeners can also be removed by invoking their unsubscribe
 * callbacks.
 *
 * @param query - The query that the listener was registered with.
 * @param eventType - One of the following strings: "value", "child_added",
 * "child_changed", "child_removed", or "child_moved." If omitted, all callbacks
 * for the `Reference` will be removed.
 * @param callback - The callback function that was passed to `on()` or
 * `undefined` to remove all callbacks.
 */ function $668b2310913a4fe8$export$8c8705df4a2dcec9(query, eventType, callback) {
    let container = null;
    const expCallback = callback ? new $668b2310913a4fe8$var$CallbackContext(callback) : null;
    if (eventType === 'value') container = new $668b2310913a4fe8$var$ValueEventRegistration(expCallback);
    else if (eventType) container = new $668b2310913a4fe8$var$ChildEventRegistration(eventType, expCallback);
    $668b2310913a4fe8$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Database query. `QueryConstraint`s are created by invoking {@link endAt},
 * {@link endBefore}, {@link startAt}, {@link startAfter}, {@link
 * limitToFirst}, {@link limitToLast}, {@link orderByChild},
 * {@link orderByChild}, {@link orderByKey} , {@link orderByPriority} ,
 * {@link orderByValue}  or {@link equalTo} and
 * can then be passed to {@link query} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $668b2310913a4fe8$export$b0e86f2c7431df4e {
}
class $668b2310913a4fe8$var$QueryEndAtConstraint extends $668b2310913a4fe8$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'endAt';
    }
    _apply(query) {
        $668b2310913a4fe8$var$validateFirebaseDataArg('endAt', this._value, query._path, true);
        const newParams = $668b2310913a4fe8$var$queryParamsEndAt(query._queryParams, this._value, this._key);
        $668b2310913a4fe8$var$validateLimit(newParams);
        $668b2310913a4fe8$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endAt: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $668b2310913a4fe8$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified ending point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name less than or equal
 * to the specified key.
 *
 * You can read more about `endAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to end at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end at, among the children with the previously
 * specified priority. This argument is only allowed if ordering by child,
 * value, or priority.
 */ function $668b2310913a4fe8$export$28ec54a8428bdb3f(value, key) {
    $668b2310913a4fe8$var$validateKey('endAt', 'key', key, true);
    return new $668b2310913a4fe8$var$QueryEndAtConstraint(value, key);
}
class $668b2310913a4fe8$var$QueryEndBeforeConstraint extends $668b2310913a4fe8$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'endBefore';
    }
    _apply(query) {
        $668b2310913a4fe8$var$validateFirebaseDataArg('endBefore', this._value, query._path, false);
        const newParams = $668b2310913a4fe8$var$queryParamsEndBefore(query._queryParams, this._value, this._key);
        $668b2310913a4fe8$var$validateLimit(newParams);
        $668b2310913a4fe8$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endBefore: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $668b2310913a4fe8$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified ending point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is exclusive. If only a value is provided, children
 * with a value less than the specified value will be included in the query.
 * If a key is specified, then children must have a value less than or equal
 * to the specified value and a key name less than the specified key.
 *
 * @param value - The value to end before. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end before, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $668b2310913a4fe8$export$57203950645b8b11(value, key) {
    $668b2310913a4fe8$var$validateKey('endBefore', 'key', key, true);
    return new $668b2310913a4fe8$var$QueryEndBeforeConstraint(value, key);
}
class $668b2310913a4fe8$var$QueryStartAtConstraint extends $668b2310913a4fe8$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'startAt';
    }
    _apply(query) {
        $668b2310913a4fe8$var$validateFirebaseDataArg('startAt', this._value, query._path, true);
        const newParams = $668b2310913a4fe8$var$queryParamsStartAt(query._queryParams, this._value, this._key);
        $668b2310913a4fe8$var$validateLimit(newParams);
        $668b2310913a4fe8$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAt: Starting point was already set (by another call to startAt, startBefore or equalTo).");
        return new $668b2310913a4fe8$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified starting point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name greater than or
 * equal to the specified key.
 *
 * You can read more about `startAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to start at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $668b2310913a4fe8$export$859941c5fc8eba6b(value = null, key) {
    $668b2310913a4fe8$var$validateKey('startAt', 'key', key, true);
    return new $668b2310913a4fe8$var$QueryStartAtConstraint(value, key);
}
class $668b2310913a4fe8$var$QueryStartAfterConstraint extends $668b2310913a4fe8$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'startAfter';
    }
    _apply(query) {
        $668b2310913a4fe8$var$validateFirebaseDataArg('startAfter', this._value, query._path, false);
        const newParams = $668b2310913a4fe8$var$queryParamsStartAfter(query._queryParams, this._value, this._key);
        $668b2310913a4fe8$var$validateLimit(newParams);
        $668b2310913a4fe8$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAfter: Starting point was already set (by another call to startAt, startAfter, or equalTo).");
        return new $668b2310913a4fe8$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified starting point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is exclusive. If only a value is provided, children
 * with a value greater than the specified value will be included in the query.
 * If a key is specified, then children must have a value greater than or equal
 * to the specified value and a a key name greater than the specified key.
 *
 * @param value - The value to start after. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start after. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $668b2310913a4fe8$export$dd8dee5f7b804673(value, key) {
    $668b2310913a4fe8$var$validateKey('startAfter', 'key', key, true);
    return new $668b2310913a4fe8$var$QueryStartAfterConstraint(value, key);
}
class $668b2310913a4fe8$var$QueryLimitToFirstConstraint extends $668b2310913a4fe8$export$b0e86f2c7431df4e {
    constructor(_limit){
        super();
        this._limit = _limit;
        this.type = 'limitToFirst';
    }
    _apply(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToFirst: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $668b2310913a4fe8$export$e79c8d837d2220a8(query._repo, query._path, $668b2310913a4fe8$var$queryParamsLimitToFirst(query._queryParams, this._limit), query._orderByCalled);
    }
}
/**
 * Creates a new `QueryConstraint` that if limited to the first specific number
 * of children.
 *
 * The `limitToFirst()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the first 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToFirst()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $668b2310913a4fe8$export$9d02e839f813b99d(limit) {
    if (typeof limit !== 'number' || Math.floor(limit) !== limit || limit <= 0) throw new Error('limitToFirst: First argument must be a positive integer.');
    return new $668b2310913a4fe8$var$QueryLimitToFirstConstraint(limit);
}
class $668b2310913a4fe8$var$QueryLimitToLastConstraint extends $668b2310913a4fe8$export$b0e86f2c7431df4e {
    constructor(_limit){
        super();
        this._limit = _limit;
        this.type = 'limitToLast';
    }
    _apply(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToLast: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $668b2310913a4fe8$export$e79c8d837d2220a8(query._repo, query._path, $668b2310913a4fe8$var$queryParamsLimitToLast(query._queryParams, this._limit), query._orderByCalled);
    }
}
/**
 * Creates a new `QueryConstraint` that is limited to return only the last
 * specified number of children.
 *
 * The `limitToLast()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the last 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToLast()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $668b2310913a4fe8$export$f823b3589f69d3b8(limit) {
    if (typeof limit !== 'number' || Math.floor(limit) !== limit || limit <= 0) throw new Error('limitToLast: First argument must be a positive integer.');
    return new $668b2310913a4fe8$var$QueryLimitToLastConstraint(limit);
}
class $668b2310913a4fe8$var$QueryOrderByChildConstraint extends $668b2310913a4fe8$export$b0e86f2c7431df4e {
    constructor(_path){
        super();
        this._path = _path;
        this.type = 'orderByChild';
    }
    _apply(query) {
        $668b2310913a4fe8$var$validateNoPreviousOrderByCall(query, 'orderByChild');
        const parsedPath = new $668b2310913a4fe8$var$Path(this._path);
        if ($668b2310913a4fe8$var$pathIsEmpty(parsedPath)) throw new Error('orderByChild: cannot pass in empty path. Use orderByValue() instead.');
        const index = new $668b2310913a4fe8$var$PathIndex(parsedPath);
        const newParams = $668b2310913a4fe8$var$queryParamsOrderBy(query._queryParams, index);
        $668b2310913a4fe8$var$validateQueryEndpoints(newParams);
        return new $668b2310913a4fe8$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by the specified child key.
 *
 * Queries can only order by one key at a time. Calling `orderByChild()`
 * multiple times on the same query is an error.
 *
 * Firebase queries allow you to order your data by any child key on the fly.
 * However, if you know in advance what your indexes will be, you can define
 * them via the .indexOn rule in your Security Rules for better performance. See
 * the{@link https://firebase.google.com/docs/database/security/indexing-data}
 * rule for more information.
 *
 * You can read more about `orderByChild()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 *
 * @param path - The path to order by.
 */ function $668b2310913a4fe8$export$5162bd9025f8e144(path) {
    if (path === '$key') throw new Error('orderByChild: "$key" is invalid.  Use orderByKey() instead.');
    else if (path === '$priority') throw new Error('orderByChild: "$priority" is invalid.  Use orderByPriority() instead.');
    else if (path === '$value') throw new Error('orderByChild: "$value" is invalid.  Use orderByValue() instead.');
    $668b2310913a4fe8$export$8637b026ace8abb1('orderByChild', 'path', path, false);
    return new $668b2310913a4fe8$var$QueryOrderByChildConstraint(path);
}
class $668b2310913a4fe8$var$QueryOrderByKeyConstraint extends $668b2310913a4fe8$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByKey';
    }
    _apply(query) {
        $668b2310913a4fe8$var$validateNoPreviousOrderByCall(query, 'orderByKey');
        const newParams = $668b2310913a4fe8$var$queryParamsOrderBy(query._queryParams, $668b2310913a4fe8$var$KEY_INDEX);
        $668b2310913a4fe8$var$validateQueryEndpoints(newParams);
        return new $668b2310913a4fe8$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by the key.
 *
 * Sorts the results of a query by their (ascending) key values.
 *
 * You can read more about `orderByKey()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $668b2310913a4fe8$export$d5ab8b3bbd8afbf8() {
    return new $668b2310913a4fe8$var$QueryOrderByKeyConstraint();
}
class $668b2310913a4fe8$var$QueryOrderByPriorityConstraint extends $668b2310913a4fe8$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByPriority';
    }
    _apply(query) {
        $668b2310913a4fe8$var$validateNoPreviousOrderByCall(query, 'orderByPriority');
        const newParams = $668b2310913a4fe8$var$queryParamsOrderBy(query._queryParams, $668b2310913a4fe8$var$PRIORITY_INDEX);
        $668b2310913a4fe8$var$validateQueryEndpoints(newParams);
        return new $668b2310913a4fe8$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by priority.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}
 * for alternatives to priority.
 */ function $668b2310913a4fe8$export$19e8ae5500cf2e55() {
    return new $668b2310913a4fe8$var$QueryOrderByPriorityConstraint();
}
class $668b2310913a4fe8$var$QueryOrderByValueConstraint extends $668b2310913a4fe8$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByValue';
    }
    _apply(query) {
        $668b2310913a4fe8$var$validateNoPreviousOrderByCall(query, 'orderByValue');
        const newParams = $668b2310913a4fe8$var$queryParamsOrderBy(query._queryParams, $668b2310913a4fe8$var$VALUE_INDEX);
        $668b2310913a4fe8$var$validateQueryEndpoints(newParams);
        return new $668b2310913a4fe8$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by value.
 *
 * If the children of a query are all scalar values (string, number, or
 * boolean), you can order the results by their (ascending) values.
 *
 * You can read more about `orderByValue()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $668b2310913a4fe8$export$7f2f62793c39d0c0() {
    return new $668b2310913a4fe8$var$QueryOrderByValueConstraint();
}
class $668b2310913a4fe8$var$QueryEqualToValueConstraint extends $668b2310913a4fe8$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'equalTo';
    }
    _apply(query) {
        $668b2310913a4fe8$var$validateFirebaseDataArg('equalTo', this._value, query._path, false);
        if (query._queryParams.hasStart()) throw new Error("equalTo: Starting point was already set (by another call to startAt/startAfter or equalTo).");
        if (query._queryParams.hasEnd()) throw new Error("equalTo: Ending point was already set (by another call to endAt/endBefore or equalTo).");
        return new $668b2310913a4fe8$var$QueryEndAtConstraint(this._value, this._key)._apply(new $668b2310913a4fe8$var$QueryStartAtConstraint(this._value, this._key)._apply(query));
    }
}
/**
 * Creates a `QueryConstraint` that includes children that match the specified
 * value.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The optional key argument can be used to further limit the range of the
 * query. If it is specified, then children that have exactly the specified
 * value must also have exactly the specified key as their key name. This can be
 * used to filter result sets with many matches for the same value.
 *
 * You can read more about `equalTo()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to match for. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $668b2310913a4fe8$export$bdcdec1f91f16dff(value, key) {
    $668b2310913a4fe8$var$validateKey('equalTo', 'key', key, true);
    return new $668b2310913a4fe8$var$QueryEqualToValueConstraint(value, key);
}
/**
 * Creates a new immutable instance of `Query` that is extended to also include
 * additional query constraints.
 *
 * @param query - The Query instance to use as a base for the new constraints.
 * @param queryConstraints - The list of `QueryConstraint`s to apply.
 * @throws if any of the provided query constraints cannot be combined with the
 * existing or new constraints.
 */ function $668b2310913a4fe8$export$2fa187e846a241c4(query1, ...queryConstraints) {
    let queryImpl = (0, $ffjl9.getModularInstance)(query1);
    for (const constraint of queryConstraints)queryImpl = constraint._apply(queryImpl);
    return queryImpl;
}
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */ $668b2310913a4fe8$var$syncPointSetReferenceConstructor($668b2310913a4fe8$export$35c3a5e7c9d1033c);
$668b2310913a4fe8$var$syncTreeSetReferenceConstructor($668b2310913a4fe8$export$35c3a5e7c9d1033c);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This variable is also defined in the firebase Node.js Admin SDK. Before
 * modifying this definition, consult the definition in:
 *
 * https://github.com/firebase/firebase-admin-node
 *
 * and make sure the two are consistent.
 */ const $668b2310913a4fe8$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR = 'FIREBASE_DATABASE_EMULATOR_HOST';
/**
 * Creates and caches `Repo` instances.
 */ const $668b2310913a4fe8$var$repos = {};
/**
 * If true, any new `Repo` will be created to use `ReadonlyRestClient` (for testing purposes).
 */ let $668b2310913a4fe8$var$useRestClient = false;
/**
 * Update an existing `Repo` in place to point to a new host/port.
 */ function $668b2310913a4fe8$var$repoManagerApplyEmulatorSettings(repo, host, port, tokenProvider) {
    repo.repoInfo_ = new $668b2310913a4fe8$var$RepoInfo(`${host}:${port}`, /* secure= */ false, repo.repoInfo_.namespace, repo.repoInfo_.webSocketOnly, repo.repoInfo_.nodeAdmin, repo.repoInfo_.persistenceKey, repo.repoInfo_.includeNamespaceInQueryParams, /*isUsingEmulator=*/ true);
    if (tokenProvider) repo.authTokenProvider_ = tokenProvider;
}
/**
 * This function should only ever be called to CREATE a new database instance.
 * @internal
 */ function $668b2310913a4fe8$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url, nodeAdmin) {
    let dbUrl = url || app.options.databaseURL;
    if (dbUrl === undefined) {
        if (!app.options.projectId) $668b2310913a4fe8$var$fatal("Can't determine Firebase Database URL. Be sure to include  a Project ID when calling firebase.initializeApp().");
        $668b2310913a4fe8$var$log('Using default host for project ', app.options.projectId);
        dbUrl = `${app.options.projectId}-default-rtdb.firebaseio.com`;
    }
    let parsedUrl = $668b2310913a4fe8$var$parseRepoInfo(dbUrl, nodeAdmin);
    let repoInfo = parsedUrl.repoInfo;
    let isEmulator;
    let dbEmulatorHost = undefined;
    if (dbEmulatorHost) {
        isEmulator = true;
        dbUrl = `http://${dbEmulatorHost}?ns=${repoInfo.namespace}`;
        parsedUrl = $668b2310913a4fe8$var$parseRepoInfo(dbUrl, nodeAdmin);
        repoInfo = parsedUrl.repoInfo;
    } else isEmulator = !parsedUrl.repoInfo.secure;
    const authTokenProvider = nodeAdmin && isEmulator ? new $668b2310913a4fe8$var$EmulatorTokenProvider($668b2310913a4fe8$var$EmulatorTokenProvider.OWNER) : new $668b2310913a4fe8$var$FirebaseAuthTokenProvider(app.name, app.options, authProvider);
    $668b2310913a4fe8$var$validateUrl('Invalid Firebase Database URL', parsedUrl);
    if (!$668b2310913a4fe8$var$pathIsEmpty(parsedUrl.path)) $668b2310913a4fe8$var$fatal("Database URL must point to the root of a Firebase Database (not including a child path).");
    const repo = $668b2310913a4fe8$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, new $668b2310913a4fe8$var$AppCheckTokenProvider(app.name, appCheckProvider));
    return new $668b2310913a4fe8$export$6feb5ea51a7b0b47(repo, app);
}
/**
 * Remove the repo and make sure it is disconnected.
 *
 */ function $668b2310913a4fe8$var$repoManagerDeleteRepo(repo, appName) {
    const appRepos = $668b2310913a4fe8$var$repos[appName];
    // This should never happen...
    if (!appRepos || appRepos[repo.key] !== repo) $668b2310913a4fe8$var$fatal(`Database ${appName}(${repo.repoInfo_}) has already been deleted.`);
    $668b2310913a4fe8$var$repoInterrupt(repo);
    delete appRepos[repo.key];
}
/**
 * Ensures a repo doesn't already exist and then creates one using the
 * provided app.
 *
 * @param repoInfo - The metadata about the Repo
 * @returns The Repo object for the specified server / repoName.
 */ function $668b2310913a4fe8$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, appCheckProvider) {
    let appRepos = $668b2310913a4fe8$var$repos[app.name];
    if (!appRepos) {
        appRepos = {};
        $668b2310913a4fe8$var$repos[app.name] = appRepos;
    }
    let repo = appRepos[repoInfo.toURLString()];
    if (repo) $668b2310913a4fe8$var$fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
    repo = new $668b2310913a4fe8$var$Repo(repoInfo, $668b2310913a4fe8$var$useRestClient, authTokenProvider, appCheckProvider);
    appRepos[repoInfo.toURLString()] = repo;
    return repo;
}
/**
 * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
 */ function $668b2310913a4fe8$var$repoManagerForceRestClient(forceRestClient) {
    $668b2310913a4fe8$var$useRestClient = forceRestClient;
}
/**
 * Class representing a Firebase Realtime Database.
 */ class $668b2310913a4fe8$export$6feb5ea51a7b0b47 {
    /** @hideconstructor */ constructor(_repoInternal, /** The {@link @firebase/app#FirebaseApp} associated with this Realtime Database instance. */ app){
        this._repoInternal = _repoInternal;
        this.app = app;
        /** Represents a `Database` instance. */ this['type'] = 'database';
        /** Track if the instance has been used (root or repo accessed) */ this._instanceStarted = false;
    }
    get _repo() {
        if (!this._instanceStarted) {
            $668b2310913a4fe8$var$repoStart(this._repoInternal, this.app.options.appId, this.app.options['databaseAuthVariableOverride']);
            this._instanceStarted = true;
        }
        return this._repoInternal;
    }
    get _root() {
        if (!this._rootInternal) this._rootInternal = new $668b2310913a4fe8$export$35c3a5e7c9d1033c(this._repo, $668b2310913a4fe8$var$newEmptyPath());
        return this._rootInternal;
    }
    _delete() {
        if (this._rootInternal !== null) {
            $668b2310913a4fe8$var$repoManagerDeleteRepo(this._repo, this.app.name);
            this._repoInternal = null;
            this._rootInternal = null;
        }
        return Promise.resolve();
    }
    _checkNotDeleted(apiName) {
        if (this._rootInternal === null) $668b2310913a4fe8$var$fatal('Cannot call ' + apiName + ' on a deleted database.');
    }
}
function $668b2310913a4fe8$var$checkTransportInit() {
    if ($668b2310913a4fe8$var$TransportManager.IS_TRANSPORT_INITIALIZED) $668b2310913a4fe8$var$warn('Transport has already been initialized. Please call this function before calling ref or setting up a listener');
}
/**
 * Force the use of websockets instead of longPolling.
 */ function $668b2310913a4fe8$export$752b38c15a5377b6() {
    $668b2310913a4fe8$var$checkTransportInit();
    $668b2310913a4fe8$var$BrowserPollConnection.forceDisallow();
}
/**
 * Force the use of longPolling instead of websockets. This will be ignored if websocket protocol is used in databaseURL.
 */ function $668b2310913a4fe8$export$387cff57f2608869() {
    $668b2310913a4fe8$var$checkTransportInit();
    $668b2310913a4fe8$var$WebSocketConnection.forceDisallow();
    $668b2310913a4fe8$var$BrowserPollConnection.forceAllow();
}
/**
 * Returns the instance of the Realtime Database SDK that is associated with the provided
 * {@link @firebase/app#FirebaseApp}. Initializes a new instance with default settings if
 * no instance exists or if the existing instance uses a custom database URL.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} instance that the returned Realtime
 * Database instance is associated with.
 * @param url - The URL of the Realtime Database instance to connect to. If not
 * provided, the SDK connects to the default instance of the Firebase App.
 * @returns The `Database` instance of the provided app.
 */ function $668b2310913a4fe8$export$d0dd861204d0bf72(app = (0, $ix4Jr.getApp)(), url) {
    const db = (0, $ix4Jr._getProvider)(app, 'database').getImmediate({
        identifier: url
    });
    if (!db._instanceStarted) {
        const emulator = (0, $ffjl9.getDefaultEmulatorHostnameAndPort)('database');
        if (emulator) $668b2310913a4fe8$export$87f3cfc4a2e3958d(db, ...emulator);
    }
    return db;
}
/**
 * Modify the provided instance to communicate with the Realtime Database
 * emulator.
 *
 * <p>Note: This method must be called before performing any other operation.
 *
 * @param db - The instance to modify.
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 8080)
 * @param options.mockUserToken - the mock auth token to use for unit testing Security Rules
 */ function $668b2310913a4fe8$export$87f3cfc4a2e3958d(db, host, port, options = {}) {
    db = (0, $ffjl9.getModularInstance)(db);
    db._checkNotDeleted('useEmulator');
    if (db._instanceStarted) $668b2310913a4fe8$var$fatal('Cannot call useEmulator() after instance has already been initialized.');
    const repo = db._repoInternal;
    let tokenProvider = undefined;
    if (repo.repoInfo_.nodeAdmin) {
        if (options.mockUserToken) $668b2310913a4fe8$var$fatal('mockUserToken is not supported by the Admin SDK. For client access with mock users, please use the "firebase" package instead of "firebase-admin".');
        tokenProvider = new $668b2310913a4fe8$var$EmulatorTokenProvider($668b2310913a4fe8$var$EmulatorTokenProvider.OWNER);
    } else if (options.mockUserToken) {
        const token = typeof options.mockUserToken === 'string' ? options.mockUserToken : (0, $ffjl9.createMockUserToken)(options.mockUserToken, db.app.options.projectId);
        tokenProvider = new $668b2310913a4fe8$var$EmulatorTokenProvider(token);
    }
    // Modify the repo to apply emulator settings
    $668b2310913a4fe8$var$repoManagerApplyEmulatorSettings(repo, host, port, tokenProvider);
}
/**
 * Disconnects from the server (all Database operations will be completed
 * offline).
 *
 * The client automatically maintains a persistent connection to the Database
 * server, which will remain active indefinitely and reconnect when
 * disconnected. However, the `goOffline()` and `goOnline()` methods may be used
 * to control the client connection in cases where a persistent connection is
 * undesirable.
 *
 * While offline, the client will no longer receive data updates from the
 * Database. However, all Database operations performed locally will continue to
 * immediately fire events, allowing your application to continue behaving
 * normally. Additionally, each operation performed locally will automatically
 * be queued and retried upon reconnection to the Database server.
 *
 * To reconnect to the Database and begin receiving remote events, see
 * `goOnline()`.
 *
 * @param db - The instance to disconnect.
 */ function $668b2310913a4fe8$export$bee838355d017f0a(db) {
    db = (0, $ffjl9.getModularInstance)(db);
    db._checkNotDeleted('goOffline');
    $668b2310913a4fe8$var$repoInterrupt(db._repo);
}
/**
 * Reconnects to the server and synchronizes the offline Database state
 * with the server state.
 *
 * This method should be used after disabling the active connection with
 * `goOffline()`. Once reconnected, the client will transmit the proper data
 * and fire the appropriate events so that your client "catches up"
 * automatically.
 *
 * @param db - The instance to reconnect.
 */ function $668b2310913a4fe8$export$e0eecaabee32dd(db) {
    db = (0, $ffjl9.getModularInstance)(db);
    db._checkNotDeleted('goOnline');
    $668b2310913a4fe8$var$repoResume(db._repo);
}
function $668b2310913a4fe8$export$4e1d237eb9e560af(logger, persistent) {
    $668b2310913a4fe8$var$enableLogging$1(logger, persistent);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $668b2310913a4fe8$var$registerDatabase(variant) {
    $668b2310913a4fe8$export$c9fb972242fcb3c4((0, $ix4Jr.SDK_VERSION));
    (0, $ix4Jr._registerComponent)(new (0, $4a6xH.Component)('database', (container, { instanceIdentifier: url })=>{
        const app = container.getProvider('app').getImmediate();
        const authProvider = container.getProvider('auth-internal');
        const appCheckProvider = container.getProvider('app-check-internal');
        return $668b2310913a4fe8$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    (0, $ix4Jr.registerVersion)($668b2310913a4fe8$var$name, $668b2310913a4fe8$var$version, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $ix4Jr.registerVersion)($668b2310913a4fe8$var$name, $668b2310913a4fe8$var$version, 'esm2017');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $668b2310913a4fe8$var$SERVER_TIMESTAMP = {
    '.sv': 'timestamp'
};
/**
 * Returns a placeholder value for auto-populating the current timestamp (time
 * since the Unix epoch, in milliseconds) as determined by the Firebase
 * servers.
 */ function $668b2310913a4fe8$export$3ff8e7e00c3264b7() {
    return $668b2310913a4fe8$var$SERVER_TIMESTAMP;
}
/**
 * Returns a placeholder value that can be used to atomically increment the
 * current database value by the provided delta.
 *
 * @param delta - the amount to modify the current value atomically.
 * @returns A placeholder value for modifying data atomically server-side.
 */ function $668b2310913a4fe8$export$a2647aa13413c947(delta) {
    return {
        '.sv': {
            'increment': delta
        }
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A type for the resolve value of {@link runTransaction}.
 */ class $668b2310913a4fe8$export$7a6f238067628c6b {
    /** @hideconstructor */ constructor(/** Whether the transaction was successfully committed. */ committed, /** The resulting data snapshot. */ snapshot){
        this.committed = committed;
        this.snapshot = snapshot;
    }
    /** Returns a JSON-serializable representation of this object. */ toJSON() {
        return {
            committed: this.committed,
            snapshot: this.snapshot.toJSON()
        };
    }
}
/**
 * Atomically modifies the data at this location.
 *
 * Atomically modify the data at this location. Unlike a normal `set()`, which
 * just overwrites the data regardless of its previous value, `runTransaction()` is
 * used to modify the existing value to a new value, ensuring there are no
 * conflicts with other clients writing to the same location at the same time.
 *
 * To accomplish this, you pass `runTransaction()` an update function which is
 * used to transform the current value into a new value. If another client
 * writes to the location before your new value is successfully written, your
 * update function will be called again with the new current value, and the
 * write will be retried. This will happen repeatedly until your write succeeds
 * without conflict or you abort the transaction by not returning a value from
 * your update function.
 *
 * Note: Modifying data with `set()` will cancel any pending transactions at
 * that location, so extreme care should be taken if mixing `set()` and
 * `runTransaction()` to update the same data.
 *
 * Note: When using transactions with Security and Firebase Rules in place, be
 * aware that a client needs `.read` access in addition to `.write` access in
 * order to perform a transaction. This is because the client-side nature of
 * transactions requires the client to read the data in order to transactionally
 * update it.
 *
 * @param ref - The location to atomically modify.
 * @param transactionUpdate - A developer-supplied function which will be passed
 * the current data stored at this location (as a JavaScript object). The
 * function should return the new value it would like written (as a JavaScript
 * object). If `undefined` is returned (i.e. you return with no arguments) the
 * transaction will be aborted and the data at this location will not be
 * modified.
 * @param options - An options object to configure transactions.
 * @returns A `Promise` that can optionally be used instead of the `onComplete`
 * callback to handle success and failure.
 */ function $668b2310913a4fe8$export$3c54e006bf9c93b7(ref, // eslint-disable-next-line @typescript-eslint/no-explicit-any
transactionUpdate, options) {
    var _a;
    ref = (0, $ffjl9.getModularInstance)(ref);
    $668b2310913a4fe8$export$8d83036122ae444e('Reference.transaction', ref._path);
    if (ref.key === '.length' || ref.key === '.keys') throw 'Reference.transaction failed: ' + ref.key + ' is a read-only object.';
    const applyLocally = (_a = options === null || options === void 0 ? void 0 : options.applyLocally) !== null && _a !== void 0 ? _a : true;
    const deferred = new (0, $ffjl9.Deferred)();
    const promiseComplete = (error, committed, node)=>{
        let dataSnapshot = null;
        if (error) deferred.reject(error);
        else {
            dataSnapshot = new $668b2310913a4fe8$export$80b98bcbc246c942(node, new $668b2310913a4fe8$export$35c3a5e7c9d1033c(ref._repo, ref._path), $668b2310913a4fe8$var$PRIORITY_INDEX);
            deferred.resolve(new $668b2310913a4fe8$export$7a6f238067628c6b(committed, dataSnapshot));
        }
    };
    // Add a watch to make sure we get server updates.
    const unwatcher = $668b2310913a4fe8$export$ad30f661f41f4d90(ref, ()=>{});
    $668b2310913a4fe8$var$repoStartTransaction(ref._repo, ref._path, transactionUpdate, promiseComplete, unwatcher, applyLocally);
    return deferred.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $668b2310913a4fe8$var$PersistentConnection;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$668b2310913a4fe8$var$PersistentConnection.prototype.simpleListen = function(pathString, onComplete) {
    this.sendRequest('q', {
        p: pathString
    }, onComplete);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$668b2310913a4fe8$var$PersistentConnection.prototype.echo = function(data, onEcho) {
    this.sendRequest('echo', {
        d: data
    }, onEcho);
};
// RealTimeConnection properties that we use in tests.
$668b2310913a4fe8$var$Connection;
/**
 * @internal
 */ const $668b2310913a4fe8$export$3f9782a4529ff160 = function(newHash) {
    const oldPut = $668b2310913a4fe8$var$PersistentConnection.prototype.put;
    $668b2310913a4fe8$var$PersistentConnection.prototype.put = function(pathString, data, onComplete, hash) {
        if (hash !== undefined) hash = newHash();
        oldPut.call(this, pathString, data, onComplete, hash);
    };
    return function() {
        $668b2310913a4fe8$var$PersistentConnection.prototype.put = oldPut;
    };
};
$668b2310913a4fe8$var$RepoInfo;
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 * @internal
 */ const $668b2310913a4fe8$export$868c9f20a76f0839 = function(forceRestClient) {
    $668b2310913a4fe8$var$repoManagerForceRestClient(forceRestClient);
};
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Used by console to create a database based on the app,
 * passed database URL and a custom auth implementation.
 * @internal
 * @param app - A valid FirebaseApp-like object
 * @param url - A valid Firebase databaseURL
 * @param version - custom version e.g. firebase-admin version
 * @param customAppCheckImpl - custom app check implementation
 * @param customAuthImpl - custom auth implementation
 */ function $668b2310913a4fe8$export$8efb8ed30f837963({ app: app, url: url, version: version, customAuthImpl: customAuthImpl, customAppCheckImpl: customAppCheckImpl, nodeAdmin: nodeAdmin = false }) {
    $668b2310913a4fe8$export$c9fb972242fcb3c4(version);
    /**
     * ComponentContainer('database-standalone') is just a placeholder that doesn't perform
     * any actual function.
     */ const componentContainer = new (0, $4a6xH.ComponentContainer)('database-standalone');
    const authProvider = new (0, $4a6xH.Provider)('auth-internal', componentContainer);
    let appCheckProvider;
    if (customAppCheckImpl) {
        appCheckProvider = new (0, $4a6xH.Provider)('app-check-internal', componentContainer);
        appCheckProvider.setComponent(new (0, $4a6xH.Component)('app-check-internal', ()=>customAppCheckImpl, "PRIVATE" /* ComponentType.PRIVATE */ ));
    }
    authProvider.setComponent(new (0, $4a6xH.Component)('auth-internal', ()=>customAuthImpl, "PRIVATE" /* ComponentType.PRIVATE */ ));
    return $668b2310913a4fe8$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url, nodeAdmin);
}
/**
 * Firebase Realtime Database
 *
 * @packageDocumentation
 */ $668b2310913a4fe8$var$registerDatabase();

});
parcelRegister("4TNnu", function(module, exports) {
// shim for using process in browser
var $391299e0893a3dfa$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = 'browser';
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ''; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$391299e0893a3dfa$var$process.cwd = function() {
    return '/';
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};

});





//# sourceMappingURL=hub.739376fa.js.map
